<template>
     
    <div class="block-layout questionnaire" id="scrollableques" :class="{'padt20':!checkCurrentUrl}">
        <div class="vx-col w-full wizard-container form_section  questionnairesection pad0 case-form-v2">
            <div class="questionnaire_page" id="questionnaire_page" v-if="petition && questionnaireDetails!=null">
                <div class="questionnaire_sec">

                    <div class="questionnaire_titles" v-if="petition && questionnaireDetails!=null">
                        <div class="questionnaire_titles_info">
                            <h2  v-if="getCaseName" v-html="getCaseName">
                               
                            </h2>
                            <h2 v-else>
                                Questionnaire for {{petition.typeDetails.name}}
                                <small v-if="petition.subTypeDetails">{{petition.subTypeDetails.name}}</small>
                               
    
                            </h2>
                            <p>
                                Please take a few moments to complete this short registration form
                                
                            </p>
                            <ul>
                                <template v-for="(item,index) in tabslist">
                                    <li :key="index" :class="{'active':currentTab==item.key || (index<=checkActiveTab && currentTab!=item.key)} " @click="setActiveTab(item.key,true)">
                                        <span>{{index+1}}</span><a>{{item.name}}</a>
                                    </li>
    
                                </template>
    
                            </ul>
                            <ul v-if="checkProperty($route ,'name') !='fill-questionnaire' && [4].indexOf(checkProperty(petition, 'typeDetails', 'id')) >-1 &&
                                [18].indexOf(checkProperty(petition, 'subTypeDetails', 'id')) >-1 
                                && ([51].indexOf(getUserRoleId)<=-1 || IsSponsorLogin)">
                                <vs-button color="primary" type="border" class="primary_btn delete_btn light-blue-btn assign_bulk_btn"
                                    @click="reloadSponsorQues()"> Go to Sponsor Questionnaire
                                </vs-button>  

                            </ul>
                            <ul v-if=" checkProperty($route ,'name') !='fill-questionnaire' && [5].indexOf(checkProperty(petition, 'typeDetails', 'id')) >-1 
                                && [51].indexOf(getUserRoleId)<=-1 ">
                                <vs-button color="primary" type="border" class="primary_btn delete_btn light-blue-btn assign_bulk_btn"
                                    @click="reloadPetitionerQues()"> Go to Petitioner Questionnaire
                                </vs-button>  

                            </ul>
                        </div>
                        <figure><img src="@/assets/images/main/content-bottom-image.svg" /></figure>
                    </div>
                    <div class="questionnaire_form">
                        <vs-col class="w-full p-0" v-if="beneFiciaryDeytailsExists == false">
                                    <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                        Note: You can enter certain beneficiary information which is different from the profile information or new information in the case application.
                                        However, you can decide at the time of application submission if you want those change information to be updated in the beneficiary profile.
                                    </vs-alert>
                                </vs-col>
    
                        <div v-if="currentTab=='casedetails'" id="case_details_dt">
                            <form data-vv-scope="casedetailsform" @submit.prevent="" @keydown.enter.prevent="">
                                <vs-col class="w-full p-0">
                                    <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                        NOTE: This questionnaire should be filled out completely and
                                        accurately. Kindly read the instructions carefully.
                                    </vs-alert>
    
                                </vs-col>
    
                                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container pt-10 form-container-questionnaire">
                                        <div class="vx-row">
    
    
                                            <template v-if="checkProperty(petition ,'subTypeDetails' ,'id') ==16">
    
    
                                            <div class="vx-col w-full" v-if="canRenderField('adjustmentOfI485Status',questionnaireDetails,false ,'beneficiaryInfo') || canRenderField('consularProcessing',questionnaireDetails,false ,'beneficiaryInfo') ">
                                                <label class="switch-label">Would you like to apply for adjustment of status (I-485) or consular processing? </label>
                                            </div>
                                                  <div class="vs-col " v-if="canRenderField('adjustmentOfI485Status',questionnaireDetails,false ,'beneficiaryInfo')" >
    
                                                    <div class="form_group custom-form-label custom-cx-box">
                                             
                                                    <vs-checkbox :tplsection="'beneficiaryInfo'" :fieldName="'adjustmentOfI485Status'"  
                                                    v-model="petition.beneficiaryInfo.adjustmentOfI485Status"
                                                    data-vv-as="adjustmentOfI485Status"
                                                    name="adjustmentOfI485Status"
                                                    @change="changedAdjustmentOfI485Status"
                                                >Adjustment of Status (I-485)
                                            
                                                <p>When your Priority Date is current, and you have a valid status in the U.S. by then, you may file I-485 to get your Green&nbsp;Card</p>
    
                                            </vs-checkbox>
    
                                                  </div>
    
                                               </div>
                                               <div class="vs-col " v-if="canRenderField('consularProcessing',questionnaireDetails,false ,'beneficiaryInfo')" >
                                                    <div class="form_group custom-form-label custom-cx-box">
                                                       <vs-checkbox v-model="petition.beneficiaryInfo.consularProcessing" :tplsection="'beneficiaryInfo'" :fieldName="'consularProcessing'"  data-vv-as="consularProcessing"  name="consularProcessing"  @change="changedConsularProcessing"
                                                        >Consular Processing
                                                    
                                                        <p>When your Priority Date is current, and you would like to go to a U.S. consulate 
                                                            abroad to apply for an immigrant visa to get your Green Card</p>
                                                        </vs-checkbox>
                                                    
                                                        <input type="hidden" v-if="!petition.beneficiaryInfo.consularProcessing && !petition.beneficiaryInfo.adjustmentOfI485Status " :name="'benconsularProcessing'" v-validate="'required'" :tplsection="'beneficiaryInfo'" :fieldName="'consularProcessingValidator'"  v-model="consularProcessingValidator">
                                                        <span v-if="!petition.beneficiaryInfo.consularProcessing || !petition.beneficiaryInfo.adjustmentOfI485Status "  class="text-danger text-sm" v-show="errors.has('casedetailsform.benconsularProcessing')">* Adjustment of Status (I-485)/Consular Processing is required</span>
                                                
                                                    </div>
                                                
                                               </div>
                                               
    
                                              <immiswitchyesno wrapclass=" mt-10" :required="checkFieldIsRequired({'key':'areYouUnderRemoveOfIndOrUscis','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })"  :display="false" :fieldsArray="questionnaireDetails" :cid="'areYouUnderRemoveOfIndOrUscis'"  formscope="casedetailsform" v-model="petition.beneficiaryInfo.areYouUnderRemoveOfIndOrUscis"  :fieldName="'areYouUnderRemoveOfIndOrUscis'" :tplkey="'areYouUnderRemoveOfIndOrUscis'" :tplsection="'beneficiaryInfo'"  label="Are you currently under removal proceedings by the INS/USCIS?" placeHolder="" />
    
                                               </template>
                                                <template v-if="checkProperty(petition ,'subTypeDetails' ,'id') ==16">
                                                 <immiswitchyesno :required="checkFieldIsRequired({'key':'anyImmPetitionFiled','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })"  wrapclass=" " @input="clearImmiputFields" :display="false" :fieldsArray="questionnaireDetails" :cid="'ben_anyImmPetitionFiled'" formscope="casedetailsform" v-model="petition.beneficiaryInfo.anyImmPetitionFiled"  :tplsection="'beneficiaryInfo'" :tplkey="'anyImmPetitionFiled'" :fieldName="'anyImmPetitionFiled'" label="Has any Immigrant Visa Petition ever been filed on your behalf? " placeHolder="" />
                                                <template v-if="canRenderField('immPetitionPriorityDate',questionnaireDetails,false ,'beneficiaryInfo') && petition.beneficiaryInfo.anyImmPetitionFiled && false"  >
                                                    <div class="vs-col " >
                                                    <div class="form_group custom-form-label">
                                                    <label class="switch-label">Your priority date obtained from your previous immigrant petition<em>*</em></label>
                                                     
                                                        <datepicker
                                                            :tplkey="'immPetitionPriorityDate'"
                                                             :tplsection="'beneficiaryInfo'"  
                                                              :fieldName="'immPetitionPriorityDate'"   
                                                            :typeable="true"
                                                            icon-pack="IntakePortal"
                                                            icon-after
                                                            name="immPetitionPriorityDate"
                                                            v-model="petition.beneficiaryInfo.immPetitionPriorityDate"
                                                            v-validate="'required'"
                                                            icon="IP-calendar-1"
                                                            data-vv-as="Priority Date"
                                                            placeholder="MM/DD/YYYY"
                                                            :disabled-dates="{to: new Date()}"
                                                        ></datepicker>
                                                  
                                                    <span
                                                        class="text-danger text-sm"
                                                        v-show="errors.has('casedetailsform.immPetitionPriorityDate')"
                                                    ><em>* </em> Priority Date is required</span>
                                                    </div>
                                                    </div>
                                                </template>
                                                <datepickerField v-if="checkProperty(petition, 'beneficiaryInfo', 'anyImmPetitionFiled')" :fieldsArray="questionnaireDetails" :display="false" :tplkey="'immPetitionPriorityDate'" :dateEnableFrom="new Date()" :validationRequired="true"
                                               v-model="petition.beneficiaryInfo.immPetitionPriorityDate" formscope="casedetailsform" :fieldName="'immPetitionPriorityDate'" label="Your priority date obtained from your previous immigrant petition" :tplsection="'beneficiaryInfo'" />

                                               
                                              <!-- <immiswitchyesno wrapclass=" " :display="true" :fieldsArray="questionnaireDetails" :cid="'applyI485AdjOrConsuProcess'"  formscope="casedetailsform" v-model="petition.beneficiaryInfo.applyI485AdjOrConsuProcess" :tplsection="'beneficiaryInfo'" :fieldName="'applyI485AdjOrConsuProcess '"   label="Would you like to apply for adjustment of status (I-485) or consular processing?" placeHolder="" /> -->
                                              <!-- <immiswitchyesno wrapclass=" " :display="true" :fieldsArray="questionnaireDetails" :cid="'consularProcessing'"  formscope="casedetailsform" v-model="petition.beneficiaryInfo.consularProcessing" :tplsection="'beneficiaryInfo'" :fieldName="'consularProcessing '" label="Consular Processing" placeHolder="" /> -->
    
                                            </template>
                                            <immiswitchyesno @input="chnageMailingAddress()" wrapclass=" " :required="checkFieldIsRequired({'key':'currentlyInUS','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false" :fieldsArray="questionnaireDetails" :cid="'cidben_currentlyInUS'"  :formscope="'casedetailsform'" v-model="petition.beneficiaryInfo.currentlyInUS"  :fieldName="'currentlyInUS'" :tplkey="'currentlyInUS'" :tplsection="'beneficiaryInfo'" label="Are you currently in USA?" placeHolder="" />
                                          
                                            <immiswitchyesno wrapclass=" " :required="checkFieldIsRequired({'key':'haveOwnershipInterest','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false" :fieldsArray="questionnaireDetails" :cid="'ben_haveOwnershipInterest'" :formscope="'casedetailsform'" v-model="petition.beneficiaryInfo.haveOwnershipInterest" :fieldName="'haveOwnershipInterest'" :tplkey="'haveOwnershipInterest'" :tplsection="'beneficiaryInfo'"  label="Do you have ownership interest in this Company?" placeHolder="" />
                                            <!-- <immitextarea :fieldsArray="questionnaireDetails" :display="false" wrapclass=" " v-if="petition.beneficiaryInfo.haveOwnershipInterest" formscope="casedetailsform" v-model="petition.beneficiaryInfo.ownershipInterestDesc" :tplsection="'beneficiaryInfo'" :tplkey="'ownershipInterestDesc'" :fieldName="'ownershipInterestDesc'" :required="true"  label="Ownership Details" placeHolder="Ownership Details"></immitextarea> -->
                                            <div class="vx-col w-full mb-10 ownership_editor" v-if="canRenderField('ownershipInterestDesc',questionnaireDetails,false ,'beneficiaryInfo') && petition.beneficiaryInfo.haveOwnershipInterest">
                                                <div class="form_group">
                                                    <!-- <label class="form_label">Ownership Details</label> -->
                                                    <!-- <ckeditor :fieldsArray="questionnaireDetails" :display="false" wrapclass=" " formscope="casedetailsform" v-model="petition.beneficiaryInfo.ownershipInterestDesc" 
                                                    :tplsection="'beneficiaryInfo'" :tplkey="'ownershipInterestDesc'" :fieldName="'ownershipInterestDesc'" :required="true"  label="Ownership Details" placeHolder="Ownership Details" 
                                                     :editor="editor" :config="editorConfig"></ckeditor> -->
                                                    <quillTextEditor  :wrapclass="'md:w-1/1 mb-0'" v-model="petition.beneficiaryInfo.ownershipInterestDesc" :label="'Ownership Details'" :formscope="'casedetailsform'" :canSpellCheck="true"
                                                      :fieldName="'ownershipInterestDesc'" :required="false" :cid="'ownershipInterestDesc'" :placeHolder="'Ownership Details'" :customValidNotRequire="true" :fieldsArray="questionnaireDetails"/> 
                                                </div>
                                            </div>

                                            <immiswitchyesno wrapclass=" " :required="checkFieldIsRequired({'key':'haveYouEverAppliedH1bCase','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false" :fieldsArray="questionnaireDetails" :cid="'ben_haveYouEverAppliedH1bCase'" :formscope="'casedetailsform'" v-model="petition.beneficiaryInfo.haveYouEverAppliedH1bCase" :fieldName="'haveYouEverAppliedH1bCase'" :tplkey="'haveYouEverAppliedH1bCase'" :tplsection="'beneficiaryInfo'"  label="Have you ever applied for a H1B petition earlier?" placeHolder="" />

                                            <selectField v-if="petition.beneficiaryInfo.haveYouEverAppliedH1bCase" :fieldsArray="questionnaireDetails" :display="false" :tplkey="'prevH1bCaseStatus'" 
                                             :required="true" :optionslist="prevH1bCaseStatusList" v-model="petition.beneficiaryInfo.prevH1bCaseStatus" formscope="casedetailsform" 
                                            :tplsection="'beneficiaryInfo'" :fieldName="'prevH1bCaseStatus'" label="Select the H1B petition status" placeHolder="H1B petition status" />

                                            <div class="vx-col w-full mb-10 ownership_editor" v-if="canRenderField('prevH1bCaseDesc',questionnaireDetails,false ,'beneficiaryInfo') && petition.beneficiaryInfo.haveYouEverAppliedH1bCase">
                                                <div class="form_group">
                                                     <!-- <label class="form_label">Please mention Receipt Number and other information</label>
                                                     <ckeditor :fieldsArray="questionnaireDetails" :display="false" wrapclass=" " formscope="casedetailsform" v-model="petition.beneficiaryInfo.prevH1bCaseDesc" :tplsection="'beneficiaryInfo'" :tplkey="'prevH1bCaseDesc'" :fieldName="'prevH1bCaseDesc'" :required="true"  label="Please mention Receipt Number, whether Approved, Denied or not Used." placeHolder="Please mention Receipt Number, whether Approved, Denied or not Used."  :editor="editor" :config="editorConfig"></ckeditor>  -->
                                                    <quillTextEditor :fieldsArray="questionnaireDetails" :display="false" :wrapclass="''" :formscope="'casedetailsform'" v-model="petition.beneficiaryInfo.prevH1bCaseDesc" :tplsection="'beneficiaryInfo'" :tplkey="'prevH1bCaseDesc'" :fieldName="'prevH1bCaseDesc'"  :required="true"  :customValidNotRequire="true" :label="'Please mention Receipt Number and other information'" :placeHolder="'Please mention Receipt Number and other information'"  :canSpellCheck="true"/>
                                                </div>
                                            </div>
                                            
                                            <div class="vx-col w-full mb-10 ownership_editor" v-if="canRenderField('anyImmPetitionFiledDesc',questionnaireDetails,false ,'beneficiaryInfo') && petition.beneficiaryInfo.anyImmPetitionFiled && false">
                                                <div class="form_group">
                                                    <label class="form_label">Immigrant Visa Petition Details</label>
                                                    <ckeditor :fieldsArray="questionnaireDetails" :display="false" wrapclass=" " formscope="casedetailsform" v-model="petition.beneficiaryInfo.anyImmPetitionFiledDesc" :tplsection="'beneficiaryInfo'" :tplkey="'anyImmPetitionFiledDesc'" :fieldName="'anyImmPetitionFiledDesc'" :required="true"  label="Immigrant Visa Petition Details" placeHolder="Immigrant Visa Petition Details"  :editor="editor" :config="editorConfig"></ckeditor>
                                                </div>
                                            </div>
                                            <immiInput :maxCharacters="20" :fieldsArray="questionnaireDetails" :display="false" :tplkey="'beneficiaryCnfmNumber'" cid="beneficiaryCnfmNumber" formscope="casedetailsform" v-model="petition.beneficiaryInfo.beneficiaryCnfmNumber" :required="true"  :fieldName="'beneficiaryCnfmNumber'" label="CAP Confirmation Number" placeHolder="CAP Confirmation Number" :tplsection="'beneficiaryInfo'" />
                                            
                                          <!-- <div class="divider full-divider mb-10"></div> -->
                                            <genderField :required="true" :display="false" formScope="casedetailsform" :fieldsArray="questionnaireDetails" :gender="petition.beneficiaryInfo.gender" v-model="petition.beneficiaryInfo.gender" :tplsection="'beneficiaryInfo'" :tplkey="'gender'" :fieldName="'gender'" />
                                            <div class="divider full-divider mb-10"></div>
                                            
                                            <div class="vx-col w-full">
                                                <vx-input-group class="form-input-group FML">
                                                    <immiInput :display="false" :fieldsArray="questionnaireDetails" cid="benf" formscope="casedetailsform" v-model="petition.beneficiaryInfo.firstName" :tplsection="'beneficiaryInfo'" :tplkey="'firstName'"  :required="true" :fieldName="'firstName'" label="First Name" placeHolder="First Name" />
                                                    <immiInput :display="false" :fieldsArray="questionnaireDetails" cid="benm" formscope="casedetailsform" v-model="petition.beneficiaryInfo.middleName" :tplsection="'beneficiaryInfo'"  :tplkey="'middleName'" :required="false" :fieldName="'middleName'" label="Middle Name" placeHolder="Middle Name" />
                                                    <immiInput :display="false" :allowUpperCase="petition.tenantDetails && checkProperty(petition,'tenantDetails','slug') &&  checkProperty(petition,'tenantDetails','slug') == 'slg'" :fieldsArray="questionnaireDetails" cid="benl" formscope="casedetailsform" v-model="petition.beneficiaryInfo.lastName" :tplsection="'beneficiaryInfo'" :tplkey="'lastName'"  :required="true" :fieldName="'lastName'" label="Last Name" placeHolder="Last Name" />
                                                </vx-input-group>
                                            </div>

                                            <div class="vx-col w-full mb-5 yesno-v2" v-if="canRenderField('otherNames',questionnaireDetails, false, 'beneficiaryInfo' )">
                                                <div class="d-block align-center">
                                                    <a class="switch-label">
                                                        Have you ever used any other names previously?
                                                    </a><em v-if="checkFieldIsRequired({'key':'otherNames','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" >*</em>
                                                    <!-- <vs-switch v-model="petition.beneficiaryInfo.hasOtherNames" :tplsection="'beneficiaryInfo'"  @input="resetOtherNames(petition.beneficiaryInfo.hasOtherNames)">
                                                        <span slot="on">Yes</span>
                                                        <span slot="off">No</span>
                                                    </vs-switch> -->
                                                    <ul class="custom-radio custom-radio_v2">
                                                        <li>
                                                            <vs-radio ref="yes" v-model="petition.beneficiaryInfo.hasOtherNames" vs-name="beneficiaryInfo.hasOtherNames" :vs-value="true"  @input="resetOtherNames(petition.beneficiaryInfo.hasOtherNames)">Yes</vs-radio>
                                                        </li>
                                                        <li>
                                                            <vs-radio ref="no" v-model="petition.beneficiaryInfo.hasOtherNames" vs-name="beneficiaryInfo.hasOtherNames" :vs-value="false"  @input="resetOtherNames(petition.beneficiaryInfo.hasOtherNames)" >No</vs-radio>
                                                        </li> 
                                                    </ul>
                                                    <div class="form_group" v-if="checkFieldIsRequired({'key':'otherNames','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })">
                                                        <input type="hidden" :name="'otherNames_beneficiaryInfo'" v-validate="'required'"  data-vv-as="Field"  v-model="petition.beneficiaryInfo.hasOtherNames">
                                                        <span v-show="errors.has( 'casedetailsform.otherNames_beneficiaryInfo')" class="text-danger text-sm" style="">*Field is required</span>
                                                    </div>
                                                </div>
                                                <span class="inline_note pt-4">(NOTE: Please enter the name if you have a different name in the educational document other than passport.)</span>
                                            </div>
                                            <template v-if="petition.beneficiaryInfo && petition.beneficiaryInfo.hasOtherNames && canRenderField('otherNames',questionnaireDetails, false, 'beneficiaryInfo' )">
                                               <div class="vx-col w-full" v-for="(item, ind) in petition.beneficiaryInfo['otherNames']" :key="ind">
                                                    <vx-input-group class="form-input-group delete-rows-cst FML">
                                                        <immiInput formscope="casedetailsform" :cid="'benf'+ind" v-model="item.firstName" :display="false" :tplkey="''" :tplsection="'beneficiaryInfo.otherNames'"   :required="false" :fieldName="'firstName'" label="First Name" placeHolder="First Name" />
                                                        <immiInput formscope="casedetailsform" :cid="'benm'+ind" v-model="item.middleName" :display="false" :tplkey="''" :tplsection="'beneficiaryInfo.otherNames'"   :required="false" :fieldName="'middleName'" label="Middle Name" placeHolder="Middle Name" />
                                                        <immiInput formscope="casedetailsform" :allowUpperCase="petition.tenantDetails && checkProperty(petition,'tenantDetails','slug') &&  checkProperty(petition,'tenantDetails','slug') == 'slg'" :cid="'benl'+ind" v-model="item.lastName" :display="false" :tplkey="''" :tplsection="'beneficiaryInfo.otherNames'"  :required="false" :fieldName="'lastName'" label="Last Name" placeHolder="Last Name" />
                                                        <div class="delete" v-if="ind > 0" @click="removeOtherName(ind)">
                                                            <a>
                                                                <img src="@/assets/images/main/delete-row-img.svg">
                                                            </a>
                                                        </div>
                                                    </vx-input-group>
                                                    <a class="add-more add-more-names ml-0 mt-0" v-if="petition.beneficiaryInfo['otherNames'].length - 1 ==ind" @click="addOtherNames()"><span>+</span>Add</a>
                                                </div>
                                            </template>
                                            
                                            <immiInput :wrapclass="''" :fieldsArray="questionnaireDetails" :display="false" :tplkey="'email'" datatype="email" cid="benfemail" formscope="casedetailsform" v-model="petition.beneficiaryInfo.email" :required="true" :tplsection="'beneficiaryInfo'"  :fieldName="'email'"  label="Email" placeHolder="Email" />
                                            <immiPhone :fieldsArray="questionnaireDetails" :display="false" :tplkey="'cellPhoneNumber'" @updatephoneCountryCode="updatecellPhoneCountryCode" :countrycode="petition.beneficiaryInfo.cellPhoneCountryCode.countryCode" cid="bencellPhoneNumber" formscope="casedetailsform" v-model="petition.beneficiaryInfo.cellPhoneNumber" :tplsection="'beneficiaryInfo'"  :fieldName="'cellPhoneNumber'" :required="true" label="Phone Number" placeHolder="Phone Number" />
                                            <immiPhone :fieldsArray="questionnaireDetails" :display="false" :tplkey="'homePhoneNumber'" @updatephoneCountryCode="updatehomePhoneCountryCode" :countrycode="petition.beneficiaryInfo.homePhoneCountryCode.countryCode" cid="benhomePhoneNumber" formscope="casedetailsform" v-model="petition.beneficiaryInfo.homePhoneNumber" :tplsection="'beneficiaryInfo'"  :fieldName="'homePhoneNumber'" label="Home Phone Number" placeHolder="Home Phone Number" />

                                            <datepickerField :fieldsArray="questionnaireDetails" :display="false" :tplkey="'dateOfBirth'" :dateEnableTo="new Date()" :validationRequired="true" v-model="petition.beneficiaryInfo.dateOfBirth" formscope="casedetailsform" :fieldName="'dateOfBirth'" label="Date of Birth" :tplsection="'beneficiaryInfo'" />
                                            <selectField :fieldsArray="questionnaireDetails" :display="false" :tplkey="'countryOfBirth'" @input="changeBfProvince" :required="true" :optionslist="countries" v-model="petition.beneficiaryInfo.countryOfBirthDetails" formscope="casedetailsform" :fieldName="'countryOfBirth'" label="Country of Birth" placeHolder="Country of Birth" :tplsection="'beneficiaryInfo'" />
                                            <selectField :fieldsArray="questionnaireDetails" :display="false" :tplkey="'provinceOfBirth'" @input="petition.beneficiaryInfo.provinceOfBirth = petition.beneficiaryInfo.provinceOfBirthDetails.id" :required="true" :optionslist="bfeprovinceStates" v-model="petition.beneficiaryInfo.provinceOfBirthDetails" formscope="casedetailsform" :tplsection="'beneficiaryInfo'"  :fieldName="'provinceOfBirth'" label="Province of Birth" placeHolder="Province of Birth" />
                                            <immiInput :fieldsArray="questionnaireDetails" :display="false" :tplkey="'locationOfBirth'" cid="benflocationOfBirth" formscope="casedetailsform" v-model="petition.beneficiaryInfo.locationOfBirth" :required="true"  :fieldName="'locationOfBirth'" label="Location of Birth" placeHolder="Location of Birth" :tplsection="'beneficiaryInfo'" />
                                            <selectField :fieldsArray="questionnaireDetails" :display="false" :tplkey="'countryOfCitizenship'" @input="petition.beneficiaryInfo.countryOfCitizenship = petition.beneficiaryInfo.countryOfCitizenshipDetails.id" :required="true" :optionslist="countriesWithoutUS" v-model="petition.beneficiaryInfo.countryOfCitizenshipDetails" formscope="casedetailsform" :tplsection="'beneficiaryInfo'" :fieldName="'countryOfCitizenship'" label="Country of Citizenship" placeHolder="Country of Citizenship" />
                                            <selectField :display="false" :tplkey="'highestDegree'" :fieldsArray="questionnaireDetails" @input="petition.beneficiaryInfo.education.highestDegree = petition.beneficiaryInfo.education.highestDegreeDetails.id"  :tplsection="'beneficiaryInfo.education'"  :fieldName="'highestDegree'"  :required="true" :optionslist="petition.highestDegreeList" v-model="petition.beneficiaryInfo.education.highestDegreeDetails" formscope="casedetailsform" placeHolder="Highest Degree" label="Highest Degree" />
                                                <immiInput :display="false" :tplkey="'majorFieldOfStudy'" :fieldsArray="questionnaireDetails" cid="benmajorFieldOfStudy" formscope="casedetailsform" v-model="petition.beneficiaryInfo.education.majorFieldOfStudy"  :tplsection="'beneficiaryInfo.education'"  :fieldName="'majorFieldOfStudy'"  :required="true" label="Major Field of Study" placeHolder="Major Field of Study" /> 
                                            <selectField :fieldsArray="questionnaireDetails" :display="false" :tplkey="'maritalStatus'" @input="petition.beneficiaryInfo.maritalStatus = petition.beneficiaryInfo.maritalStatusDetails.id;updateTablist()" :required="true" v-if="marital_statuses.length > 0" :optionslist="marital_statuses" v-model="petition.beneficiaryInfo.maritalStatusDetails" formscope="casedetailsform" :tplsection="'beneficiaryInfo'" :fieldName="'maritalStatus'" label="Marital Status" placeHolder="Marital Status" />
                                                <immiInput  :onlyNumbers="true" :allowFloatingPoint="false"  :tplkey="'noOfTimesMarriedBeneficiary'"  :display="false" :fieldsArray="questionnaireDetails"  cid="noOfTimesMarriedBeneficiary" formscope="casedetailsform" v-model="petition.beneficiaryInfo.noOfTimesMarriedBeneficiary" :required="true"  :tplsection="'beneficiaryInfo'"  :fieldName="'noOfTimesMarriedBeneficiary'"  label="How many times has the beneficiary been married?" placeHolder="How many times has the beneficiary been married?" />                                           
                                                <!----485 Start    &&-->
                                            <template v-if="checkProperty(petition ,'beneficiaryInfo','maritalStatus') && checkProperty(petition ,'beneficiaryInfo','maritalStatus')!=1 "  >   
                                                <immiInput  :onlyNumbers="true" :allowFloatingPoint="false" :maxLength="2" :tplkey="'noOfChildrens'"  :display="false" :fieldsArray="questionnaireDetails"  cid="noOfChildrens" formscope="casedetailsform" v-model="petition.beneficiaryInfo.noOfChildrens" :required="true"  :tplsection="'beneficiaryInfo'"  :fieldName="'noOfChildrens'"  label="No of Childrens" placeHolder="No of Childrens" />
                                                <datepickerField  :display="false" :fieldsArray="questionnaireDetails" :tplkey="'dateOfMarriage'"  :validationRequired="true" v-model="petition.beneficiaryInfo.dateOfMarriage" formscope="casedetailsform" :dateEnableTo="new Date()"  :tplsection="'beneficiaryInfo'"  :fieldName="'dateOfMarriage'"  label="Date of Marriage" />
                                                <selectField   :display="false" :fieldsArray="questionnaireDetails" :tplkey="'countryOfMarriage'"   @input="changeCountryMarriage" :required="true" :optionslist="countries" v-model="petition.beneficiaryInfo.countryOfMarriageDetails" formscope="casedetailsform"  :tplsection="'beneficiaryInfo'"  :fieldName="'countryOfMarriage'"  label="Country of Marriage" placeHolder="Country of Marriage" />
                                                <selectField  :display="false" :fieldsArray="questionnaireDetails" :tplkey="'provinceOfMarriage'"  @input="petition.beneficiaryInfo.provinceOfMarriage = petition.beneficiaryInfo.provinceOfMarriageDetails.id" :required="true" :optionslist="statesOfMarriage" v-model="petition.beneficiaryInfo.provinceOfMarriageDetails" formscope="casedetailsform"  :tplsection="'beneficiaryInfo'"  :fieldName="'provinceOfMarriage'"  label="Province of Marriage" placeHolder="Province of Marriage" />
                                                <immiInput   :display="false" :fieldsArray="questionnaireDetails" :tplkey="'locationOfMarriage'"  cid="locationOfMarriage" formscope="casedetailsform" v-model="petition.beneficiaryInfo.locationOfMarriage" :required="true"  :tplsection="'beneficiaryInfo'"  :fieldName="'locationOfMarriage'"  label="Location of Marriage" placeHolder="Location of Marriage" />
                                                <immiyesorno formscope="casedetailsform" :cid="'doYouHaveMarriageCert'" :required="checkFieldIsRequired({'key':'doYouHaveMarriageCert','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })"   :display="false" :fieldsArray="questionnaireDetails" :tplkey="'doYouHaveMarriageCert'"  v-model="petition.beneficiaryInfo.doYouHaveMarriageCert"  :tplsection="'beneficiaryInfo'"  :fieldName="'doYouHaveMarriageCert'"  label="Do you have a Marriage Certificate?"></immiyesorno>
                                                <immiyesorno formscope="casedetailsform" :cid="'have2AffidavitsAttestingToMarriage'" :required="checkFieldIsRequired({'key':'have2AffidavitsAttestingToMarriage','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" v-if="!petition.beneficiaryInfo.doYouHaveMarriageCert" :tplkey="'have2AffidavitsAttestingToMarriage'" :display="false" :fieldsArray="questionnaireDetails" v-model="petition.beneficiaryInfo.have2AffidavitsAttestingToMarriage"  :tplsection="'beneficiaryInfo'"  :fieldName="'have2AffidavitsAttestingToMarriage'"  label="Do you have Two (2) Affidavits attesting to the Marriage?"></immiyesorno>
                                                
                                                <template v-if="petition.beneficiaryInfo.doYouHaveMarriageCert">
                                                    <div class="vx-col w-full quest_485_v2">
                                                        <casedocumentslist :showTitle="false" :tplsection="'beneficiaryInfo'" :docslist="marriageCertDocsList" formscope="casedetailsform" :fieldsArray="questionnaireDetails" v-model="petition.beneficiaryInfo" :fieldName="'marriageCertDocs'"></casedocumentslist>
                                                    </div>
                                                </template> 
                                            </template>  
                                                <!-- <selectField :display="true" :fieldsArray="questionnaireDetails"  :required="true" :optionslist="countries" v-model="petition.beneficiaryInfo.nationality" :tplsection="'beneficiaryInfo'"  :fieldName="'nationality'"  formscope="casedetailsform"  label="Nationality" placeHolder="Nationality" /> -->
                                                <immiyesorno  :required="checkFieldIsRequired({'key':'nameDiffFromBirthCert','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })"  wrapclass=" "    :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="nameDiffFromBirthCert" :tplkey="'nameDiffFromBirthCert'"   v-model="petition.beneficiaryInfo.nameDiffFromBirthCert" :tplsection="'beneficiaryInfo'"  :fieldName="'nameDiffFromBirthCert'"   label="If your name is different from that stated on your birth certificate, have you had it legally changes?"></immiyesorno>
                                                <immiyesorno :required="checkFieldIsRequired({'key':'birthCertHaveNamePobDob','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass="yesno-v2_wrap" :tplkey="'birthCertHaveNamePobDob'"   :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="birthCertHaveNamePobDob"  v-model="petition.beneficiaryInfo.birthCertHaveNamePobDob" :tplsection="'beneficiaryInfo'"  :fieldName="'birthCertHaveNamePobDob'"  label="Does the birth certificate have your name, place of birth, date of birth, parent's names mentioned, and the birth was registered around the time you were born?"></immiyesorno>
                                                <immiyesorno :required="checkFieldIsRequired({'key':'have2AffidavitsOfBirthFamily','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass=" " :tplkey="'have2AffidavitsOfBirthFamily'"   :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="have2AffidavitsOfBirthFamily"  v-model="petition.beneficiaryInfo.have2AffidavitsOfBirthFamily"  :tplsection="'beneficiaryInfo'"  :fieldName="'have2AffidavitsOfBirthFamily'" label="Do you have Two (2) Affidavits of Birth from family members?"></immiyesorno>                                                                                                                                                   
                                                
                                                                                 
                                                <immiInput :allowFloatingPoint="false" :maxLength="3" :onlyNumbers="true" :display="false" :fieldsArray="questionnaireDetails" :tplkey="'weight'"  cid="weight" formscope="casedetailsform" v-model="petition.beneficiaryInfo.weight" :tplsection="'beneficiaryInfo'"  :fieldName="'weight'"  :required="true"  label="Weight (LBS)" placeHolder="Weight" />
                                                <selectField :display="false" :closeOnSelect="false" :multiple="true" :fieldsArray="questionnaireDetails"  :required="true"  :tplkey="'race'"  cid="race" :optionslist="races_list" v-model="petition.beneficiaryInfo.race" :tplsection="'beneficiaryInfo'"  :fieldName="'race'"  formscope="casedetailsform"  label="Ethnicity/Race" placeHolder="Ethnicity/Race" />
                                                <selectField :display="false" :fieldsArray="questionnaireDetails"  :required="true"  :tplkey="'hairColor'" cid="hairColor" :optionslist="hair_colorsList" v-model="petition.beneficiaryInfo.hairColor" :tplsection="'beneficiaryInfo'"  :fieldName="'hairColor'"  formscope="casedetailsform"  label="Hair Color" placeHolder="Hair Color" />
                                                <div class="vx-col  w-full md:w-1/2" v-if="canRenderField('inches',questionnaireDetails, false, 'beneficiaryInfo.height' ) || canRenderField('feet',questionnaireDetails, false, 'beneficiaryInfo.height' )">
                                                    <div class="form_group">
                                                        <label class="form_label">Height</label>
                                                        <div class="height_field">
                                                            <selectField :display="false" :fieldsArray="questionnaireDetails"  :required="true"  :tplkey="'feet'" cid="feet" :optionslist="feetList" v-model="petition.beneficiaryInfo.height.feet"  :tplsection="'beneficiaryInfo.height'"  :fieldName="'feet'" :listContainsId="false" formscope="casedetailsform"  label="" placeHolder="Feet" />
                                                            <selectField :display="false" :fieldsArray="questionnaireDetails"  :required="true"  :tplkey="'inches'" cid="inches" :optionslist="inchesList" v-model="petition.beneficiaryInfo.height.inches" :tplsection="'beneficiaryInfo.height'"  :fieldName="'inches'" :listContainsId="false"  formscope="casedetailsform"  label="" placeHolder="Inches" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <selectField :display="false" :fieldsArray="questionnaireDetails"  :required="true" :optionslist="eye_colorList" v-model="petition.beneficiaryInfo.eyeColor" :tplsection="'beneficiaryInfo'"  :fieldName="'eyeColor'" :tplkey="'eyeColor'"  formscope="casedetailsform"  label="Eye Color" placeHolder="Eye Color" />
                                                
                                                <immiyesorno wrapclass=" " :required="checkFieldIsRequired({'key':'enterInUSUnderCaseWaiverProgram','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :tplkey="'enterInUSUnderCaseWaiverProgram'" :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="enterInUSUnderCaseWaiverProgram"  v-model="petition.beneficiaryInfo.enterInUSUnderCaseWaiverProgram" :tplsection="'beneficiaryInfo'"  :fieldName="'enterInUSUnderCaseWaiverProgram'"  label="Did you enter the U.S. under the Visa waiver program?"></immiyesorno>
                                                
                                                <template v-if="false">
                                                    <selectField :tplkey="'stateOfLastEntryInUS'" :display="false" :fieldsArray="questionnaireDetails" @input="petition.beneficiaryInfo.stateOfLastEntryInUS = petition.beneficiaryInfo.stateDetailsOfLastEntryInUS.id" :required="true" :optionslist="usastates" v-model="petition.beneficiaryInfo.stateDetailsOfLastEntryInUS" :tplsection="'beneficiaryInfo'"  :fieldName="'stateOfLastEntryInUS'"  formscope="casedetailsform"  label="State of recent entry into the USA" placeHolder="State of recent entry into the USA" />                         
                                                    <immiInput :tplkey="'placeOfLastEntryInUS'" :display="false" :fieldsArray="questionnaireDetails"  cid="placeOfLastEntryInUS" formscope="casedetailsform" v-model="petition.beneficiaryInfo.placeOfLastEntryInUS" :tplsection="'beneficiaryInfo'"  :fieldName="'placeOfLastEntryInUS'"  :required="true"  label="Place of recent entry into the USA" placeHolder="Place of recent entry into the USA" />
                                                    <datepickerField  :display="false" :fieldsArray="questionnaireDetails" :tplkey="'lastArrivalDate'"  :validationRequired="true" v-model="petition.beneficiaryInfo.lastArrivalDate" formscope="casedetailsform" :dateEnableTo="featureDates"  :tplsection="'beneficiaryInfo'" :cid="'lastArrivalDate'"  :fieldName="'lastArrivalDate'"  label="Date of most recent entry into the USA" />
                                                </template>

                                                <immiyesorno wrapclass=" " :required="checkFieldIsRequired({'key':'inspectedByAnyImmOfficer','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :tplkey="'inspectedByAnyImmOfficer'"  :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="inspectedByAnyImmOfficer"  v-model="petition.beneficiaryInfo.inspectedByAnyImmOfficer" :tplsection="'beneficiaryInfo'"  :fieldName="'inspectedByAnyImmOfficer'"  label="Were you inspected by an immigration officer?"></immiyesorno>
                                                <immiyesorno wrapclass="" :required="checkFieldIsRequired({'key':'issuedAnyEADFromUSCIS','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :tplkey="'issuedAnyEADFromUSCIS'"  :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="issuedAnyEADFromUSCIS"  v-model="petition.beneficiaryInfo.issuedAnyEADFromUSCIS" :tplsection="'beneficiaryInfo'"  :fieldName="'issuedAnyEADFromUSCIS'"  label=" Have you ever been issued an Employement Authorization Document (EAD) from the USCIS?"></immiyesorno>
                                                <template v-if="petition.beneficiaryInfo.issuedAnyEADFromUSCIS">
                                                    <div class="vx-col w-full quest_485_v2">
                                                        <casedocumentslist :wrapclass="'mart0'" :showTitle="false" :tplsection="'documents'" :docslist="eadCardList" formscope="casedetailsform" :fieldsArray="questionnaireDetails" v-model="petition.documents" :fieldName="'eadCard'"></casedocumentslist>
                                                    </div>
                                                </template>
                                                <datepickerField  :display="false" :fieldsArray="questionnaireDetails" :tplkey="'i140PriorityDate'"  :validationRequired="true" v-model="petition.beneficiaryInfo.i140PriorityDate" formscope="casedetailsform" :dateEnableTo="featureDates"  :tplsection="'beneficiaryInfo'"  :fieldName="'i140PriorityDate'"  label="Priority Date of I-140" />
                                                <selectField :tplkey="'classification'"  :listContainsId="false" :display="false" :fieldsArray="questionnaireDetails"  :required="true" :optionslist="classificationList" v-model="petition.beneficiaryInfo.classification" :tplsection="'beneficiaryInfo'"  :fieldName="'classification'"  formscope="casedetailsform"  label="Classificaton/Category" placeHolder="Classificaton/Category" />    
                                                <immiyesorno  wrapclass=" " :required="checkFieldIsRequired({'key':'hasPermResidencyInOtherCountry','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :tplkey="'hasPermResidencyInOtherCountry'" :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="hasPermResidencyInOtherCountry"  v-model="petition.beneficiaryInfo.hasPermResidencyInOtherCountry" :tplsection="'beneficiaryInfo'"  :fieldName="'hasPermResidencyInOtherCountry'"  label="Do you hold Permanent residence in any other country?"></immiyesorno>             
                                                <selectField :tplkey="'permResidencyCountryDetails'" v-if="petition.beneficiaryInfo.hasPermResidencyInOtherCountry" :display="false" :fieldsArray="questionnaireDetails" @input="petition.beneficiaryInfo.permResidencyCountryId = petition.beneficiaryInfo.permResidencyCountryDetails.id" :required="true" :optionslist="countriesWithoutUS" v-model="petition.beneficiaryInfo.permResidencyCountryDetails" :tplsection="'beneficiaryInfo'"  :fieldName="'permResidencyCountryDetails'"  formscope="casedetailsform"  label="Permanent Residency Country" placeHolder="Permanent Residency Country" />                                              
                                                <immiyesorno wrapclass=" " :required="checkFieldIsRequired({'key':'haveYouArrestedBefore','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :tplkey="'haveYouArrestedBefore'"  :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="haveYouArrestedBefore"  v-model="petition.beneficiaryInfo.haveYouArrestedBefore" :tplsection="'beneficiaryInfo'"  :fieldName="'haveYouArrestedBefore'"  label=" Have you ever been arrested, cited, charged or detained for any reason by an law enforcement official?"></immiyesorno>
                                                <template v-if="petition.beneficiaryInfo.haveYouArrestedBefore">
                                                    <div class="vx-col w-full quest_485_v2"> 
                                                        <casedocumentslist :wrapclass="'mart0'" :showTitle="false" :tplsection="'beneficiaryInfo'" :docslist="haveYouArrestedBeforeDocsList" formscope="casedetailsform" :fieldsArray="questionnaireDetails" v-model="petition.beneficiaryInfo" :fieldName="'haveYouArrestedBeforeDocs'"></casedocumentslist>
                                                    </div>
                                                </template>
                                                <immiyesorno :required="checkFieldIsRequired({'key':'everAppliedAOSInUS','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :tplkey="'everAppliedAOSInUS'"   wrapclass="yesno-v2_wrap" :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="everAppliedAOSInUS"  v-model="petition.beneficiaryInfo.everAppliedAOSInUS" :tplsection="'beneficiaryInfo'"  :fieldName="'everAppliedAOSInUS'"  label="Have you ever applied AOS in the united states or an immigrant visa at the US Embassy/Consulate to obtain permanent resident status before?"></immiyesorno>
                                                <template v-if="petition.beneficiaryInfo.everAppliedAOSInUS">
                                                    <div class="vx-col w-full quest_485_v2">
                                                        <casedocumentslist :wrapclass="'mart0'" :showTitle="false" :tplsection="'beneficiaryInfo'" :docslist="appliedAOSInUSDocsList" formscope="casedetailsform" :fieldsArray="questionnaireDetails" v-model="petition.beneficiaryInfo" :fieldName="'appliedAOSInUSDocs'"></casedocumentslist> 
                                                    </div>
                                                </template>
                                                <immiyesorno :required="checkFieldIsRequired({'key':'haveYouEverReceivedPublicAssistendeInUS','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass="yesno-v2_wrap" :tplkey="'haveYouEverReceivedPublicAssistendeInUS'" :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="haveYouEverReceivedPublicAssistendeInUS"  v-model="petition.beneficiaryInfo.haveYouEverReceivedPublicAssistendeInUS" :tplsection="'beneficiaryInfo'"  :fieldName="'haveYouEverReceivedPublicAssistendeInUS'"  label="Have you ever received public assistance in the united states from any source, including the US government or any state, country, city or muncipality (other than emergency medical treatment)?"></immiyesorno>
                                                <immiyesorno :required="checkFieldIsRequired({'key':'haveYouEverlikelyReceivePublicAssistendeInUS','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass="yesno-v2_wrap" :tplkey="'haveYouEverlikelyReceivePublicAssistendeInUS'" :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="haveYouEverlikelyReceivePublicAssistendeInUS"  v-model="petition.beneficiaryInfo.haveYouEverlikelyReceivePublicAssistendeInUS" :tplsection="'beneficiaryInfo'"  :fieldName="'haveYouEverlikelyReceivePublicAssistendeInUS'"  label="Have you ever likely to receive public assistance in the united states from any source, including the US government or any state, country, city or muncipality (other than emergency medical treatment)?"></immiyesorno>
                                                <immiyesorno :required="checkFieldIsRequired({'key':'isVisaDenieedTOUS','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass=" " :tplkey="'isVisaDenieedTOUS'" :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="isVisaDenieedTOUS"  v-model="petition.beneficiaryInfo.isVisaDenieedTOUS" :tplsection="'beneficiaryInfo'"  :fieldName="'isVisaDenieedTOUS'"  label="Have you ever been denied a visa to the United States?"></immiyesorno>
                                                <immiInput v-if="petition.beneficiaryInfo.isVisaDenieedTOUS" :tplkey="'visaDeniedReason'" :display="false" :fieldsArray="questionnaireDetails"  cid="visaDeniedReason" formscope="casedetailsform" v-model="petition.beneficiaryInfo.visaDeniedReason" :tplsection="'beneficiaryInfo'"  :fieldName="'visaDeniedReason'"  :required="true"  label="Reason" placeHolder="Reason" />
                                                <immiyesorno :required="checkFieldIsRequired({'key':'haveYoueverPresntUnlawfully','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" wrapclass=" " :tplkey="'haveYoueverPresntUnlawfully'"  :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="haveYoueverPresntUnlawfully"  v-model="petition.beneficiaryInfo.haveYoueverPresntUnlawfully" :tplsection="'beneficiaryInfo'"  :fieldName="'haveYoueverPresntUnlawfully'"  label="Have you ever been present in the United States unlawfully for more than 180 days?"></immiyesorno>
                                                <immiInput v-if="petition.beneficiaryInfo.haveYoueverPresntUnlawfully" :tplkey="'presntUnlawfullyReason'" :display="false" :fieldsArray="questionnaireDetails"  cid="presntUnlawfullyReason" formscope="casedetailsform" v-model="petition.beneficiaryInfo.presntUnlawfullyReason" :tplsection="'beneficiaryInfo'"  :fieldName="'presntUnlawfullyReason'"  :required="true"  label="Reason" placeHolder="Reason" /> 
                                                <template>
                                                    <div class="vx-col w-full">
                                                        <div class="form_group w-full">
                                                            <label class="form_label"><h3 class="small-header">Passport</h3>
                                                            <div class="IB_tooltip H1-140">
                                                                <span ><info-icon size="1.5x" class="custom-class"></info-icon ></span>
                                                                    <div class="tooltip_cnt">
                                                                        <p>Make sure you input the most recent passport information. Also, note that the passport must have more than 6 months validity.</p>
                                                                    </div>
                                                            </div>
                                                        </label>
                                                        </div>
                                                    </div>
                                                </template>
                                            
                                            
                                            <immiInput :allowUpperCase="true" :display="false" :tplkey="'passportNumber'" :fieldsArray="questionnaireDetails" datatype="alpha_num|max:15" cid="benfpassportNumber" formscope="casedetailsform" v-model="petition.beneficiaryInfo.passportNumber" :tplsection="'beneficiaryInfo'"  :fieldName="'passportNumber'"  :required="true"  label="Passport Number" placeHolder="Passport Number" />
                                            <datepickerField :display="false" :tplkey="'passportIssuedDate'" :fieldsArray="questionnaireDetails" :validationRequired="true" v-model="petition.beneficiaryInfo.passportIssuedDate" :tplsection="'beneficiaryInfo'"  :fieldName="'passportIssuedDate'"  formscope="casedetailsform"  :dateEnableTo="new Date()" label="Passport Issued Date" />
                                            <datepickerField :display="false" :tplkey="'passportExpiryDate'" :fieldsArray="questionnaireDetails" :dateEnableFrom="featureDates" :validationRequired="true" v-model="petition.beneficiaryInfo.passportExpiryDate" :tplsection="'beneficiaryInfo'"  :fieldName="'passportExpiryDate'"  formscope="casedetailsform"  label="Passport Expiry Date" />
                                            <selectField   :display="false" :tplkey="'passportIssuedCountry'" :fieldsArray="questionnaireDetails" @input="petition.beneficiaryInfo.passportIssuedCountry = petition.beneficiaryInfo.passportIssuedCountryDetails.id" :required="true" :optionslist="countries" v-model="petition.beneficiaryInfo.passportIssuedCountryDetails"  :tplsection="'beneficiaryInfo'"  :fieldName="'passportIssuedCountry'" cid="passportIssuedCountry" formscope="casedetailsform"  label="Country of Passport Issued" placeHolder="Country of Passport Issued" />
                                            <immiInput :onlyNumbers="true" :tplkey="'curNonImmigrantVisaNumber'" :allowFloatingPoint="false" :maxLength="8" :display="false" :fieldsArray="questionnaireDetails"  :cid="'curNonImmigrantVisaNumber'" formscope="casedetailsform" v-model="petition.beneficiaryInfo.curNonImmigrantVisaNumber" :tplsection="'beneficiaryInfo'"  :fieldName="'curNonImmigrantVisaNumber'"  :required="true"  label="Current Non-Immigrant Visa Number" placeHolder="Current Non-Immigrant Visa Number" />
                                           <!-- As per requirement Status in USA and current Address is Mandatory for I-140 -->
                                            <template v-if="(!isI140Case && canRenderField('currentlyInUS',questionnaireDetails, false, 'beneficiaryInfo' ) && checkProperty(petition,'beneficiaryInfo','currentlyInUS')) || !canRenderField('currentlyInUS',questionnaireDetails, false, 'beneficiaryInfo' ) || isI140Case ">
                                                <div class="vx-col w-full" v-if="canRenderField('curNonImmigrantVisaStatus',questionnaireDetails, false, 'beneficiaryInfo' )||
                                                canRenderField('curVisaExpiryDate',questionnaireDetails, false, 'beneficiaryInfo' ) || canRenderField('I94',questionnaireDetails, false, 'beneficiaryInfo' )||
                                                canRenderField('I94ExpiryDate',questionnaireDetails, false, 'beneficiaryInfo' )||canRenderField('sevisNumber',questionnaireDetails, false, 'beneficiaryInfo' )||
                                                canRenderField('eadNumber',questionnaireDetails, false, 'beneficiaryInfo' )">
                                                    <div class="form_group w-full"> 
                                                        <label class="form_label"><h3 class="small-header">Status in USA</h3>
                                                    
                                                    </label>
                                                    </div>
                                                </div>
                                                <selectField :display="false" :tplkey="'curNonImmigrantVisaStatus'" :fieldsArray="questionnaireDetails" @input="petition.beneficiaryInfo.curNonImmigrantVisaStatus = petition.beneficiaryInfo.curNonImmigrantVisaStatusDetails.id ;mamageVisaStatusDocuments();checkDSExpireFields()" :required="petition.beneficiaryInfo.currentlyInUS" :optionslist="petition.visaStatusList" v-model="petition.beneficiaryInfo.curNonImmigrantVisaStatusDetails" :tplsection="'beneficiaryInfo'"  :fieldName="'curNonImmigrantVisaStatus'"  formscope="casedetailsform"  label="Current Non-Immigrant Status" vvas="Current Non-Immigrant Status" placeholder="Current Non-Immigrant Status" />
                                                <div class="vx-col w-full md:w-1/2 relative" v-if="(canRenderField('isDSExpiryDate',questionnaireDetails, false, 'beneficiaryInfo' )&& checkProperty(petition['beneficiaryInfo'],'curNonImmigrantVisaStatusDetails')&& checkProperty(petition['beneficiaryInfo'],'curNonImmigrantVisaStatusDetails','id')  ) || canRenderField('curVisaExpiryDate',questionnaireDetails, false, 'beneficiaryInfo' ) ">
                                                    <div class="vs-col w-1/2 ds_check" v-if="canRenderField('isDSExpiryDate',questionnaireDetails, false, 'beneficiaryInfo' )&& checkProperty(petition['beneficiaryInfo'],'curNonImmigrantVisaStatusDetails')&& checkProperty(petition['beneficiaryInfo'],'curNonImmigrantVisaStatusDetails','id')  "  >
                                                        <div class="form_group custom-form-label custom-cx-box">
                                                        <vs-checkbox v-model="petition.beneficiaryInfo.isDSExpiryDate" :tplsection="'beneficiaryInfo'" :fieldName="'consularProcessing'"  data-vv-as="consularProcessing"  name="isDSExpiryDate" @input="clearCurrentStatusField"
                                                            >Check here if D/S
                                                            </vs-checkbox>
                                                        </div>
                                                    </div>
                                                    <datepickerField :wrapclass="'md:w-full'" :isDisabled="(canRenderField('isDSExpiryDate',questionnaireDetails, false, 'beneficiaryInfo' ) && petition.beneficiaryInfo.isDSExpiryDate) || !petition.beneficiaryInfo.curNonImmigrantVisaStatus" 
                                                    :display="false" :notRequired="canRenderField('isDSExpiryDate',questionnaireDetails, false, 'beneficiaryInfo' ) && petition.beneficiaryInfo.isDSExpiryDate " :tplkey="'curVisaExpiryDate'" :fieldsArray="questionnaireDetails" :dateEnableFrom="featureDates" :validationRequired="checkProperty(petition.beneficiaryInfo, 'curNonImmigrantVisaStatusDetails')?true:false" v-model="petition.beneficiaryInfo.curVisaExpiryDate" :tplsection="'beneficiaryInfo'"  :fieldName="'curVisaExpiryDate'"  formscope="casedetailsform"  label="Current Status Expiry Date" />
                                                </div>
                                                <immiInput :allowUpperCase="true" :display="false" :tplkey="'I94'" :fieldsArray="questionnaireDetails" cid="benI94" datatype="max:15" formscope="casedetailsform" v-model="petition.beneficiaryInfo.I94"  :tplsection="'beneficiaryInfo'" @input="I94ValueCheck(petition.beneficiaryInfo.I94)" :fieldName="'I94'"  :required="true"  label="I-94 Number" placeHolder="I-94 Number" />                                                <div class="vx-col w-full md:w-1/2 relative" v-if="(canRenderField('isI94DSExpiryDate',questionnaireDetails, false, 'beneficiaryInfo' ) && checkProperty(petition,'beneficiaryInfo') && checkProperty(petition['beneficiaryInfo'],'I94')  ) || canRenderField('I94ExpiryDate',questionnaireDetails, false, 'beneficiaryInfo' ) ">
                                                    <div class="vs-col w-1/2 ds_check" v-if="canRenderField('isI94DSExpiryDate',questionnaireDetails, false, 'beneficiaryInfo' )&& checkProperty(petition,'beneficiaryInfo') && checkProperty(petition['beneficiaryInfo'],'I94')  "  >
                                                        <div class="form_group custom-form-label custom-cx-box">
                                                        <vs-checkbox v-model="petition.beneficiaryInfo.isI94DSExpiryDate" :tplsection="'beneficiaryInfo'" :fieldName="'isI94DSExpiryDate'"  data-vv-as="consularProcessing"  name="isI94DSExpiryDate" @input="clearI94Field"
                                                            >Check here if D/S
                                                            </vs-checkbox>
                                                        </div>
                                                    </div>
                                                    <datepickerField :wrapclass="'md:w-full'" :display="false" :notRequired="canRenderField('isI94DSExpiryDate',questionnaireDetails, false, 'beneficiaryInfo' ) && petition.beneficiaryInfo.isI94DSExpiryDate " :isDisabled="(canRenderField('isI94DSExpiryDate',questionnaireDetails, false, 'beneficiaryInfo' ) && petition.beneficiaryInfo.isI94DSExpiryDate && petition.beneficiaryInfo.I94) || !petition.beneficiaryInfo.I94  " :tplkey="'I94ExpiryDate'" :fieldsArray="questionnaireDetails" :validationRequired="petition.beneficiaryInfo.I94?true:false" v-model="petition.beneficiaryInfo.I94ExpiryDate"  :tplsection="'beneficiaryInfo'"  :fieldName="'I94ExpiryDate'"  formscope="casedetailsform" :dateEnableFrom="featureDates"  label="I-94 Expiry Date" />
                                                </div>
                                                <!-- (petition.beneficiaryInfo.I94=='' && disablefield) -->
                                                <immiInput :allowUpperCase="true" :display="false" :mRequired="[1,2].indexOf(checkProperty(petition['beneficiaryInfo'],'curNonImmigrantVisaStatusDetails','id'))>-1?true:false" :tplkey="'sevisNumber'" :fieldsArray="questionnaireDetails" datatype="alpha_num|max:15" cid="benfsevisNumber" formscope="casedetailsform" v-model="petition.beneficiaryInfo.sevisNumber" :tplsection="'beneficiaryInfo'"  :fieldName="'sevisNumber'"    label="SEVIS  Number" placeHolder="SEVIS  Number" />
                                                <immiInput :allowUpperCase="true" :display="false" :tplkey="'eadNumber'"  :fieldsArray="questionnaireDetails" datatype="alpha_num|min:9|max:20" cid="benfeadNumber" formscope="casedetailsform" v-model="petition.beneficiaryInfo.eadNumber" :maxCharacters="20" :tplsection="'beneficiaryInfo'"  :fieldName="'eadNumber'"   label="EAD  Number" placeHolder="EAD  Number" />
                                            </template>
                                            <div class="vx-col w-full">
                                                <template v-if="(!isI140Case && canRenderField('currentlyInUS',questionnaireDetails, false, 'beneficiaryInfo' ) && checkProperty(petition,'beneficiaryInfo','currentlyInUS')) || !canRenderField('currentlyInUS',questionnaireDetails, false, 'beneficiaryInfo' ) || isI140Case ">
                                                    <div v-if="canRenderField('address',questionnaireDetails, false, 'beneficiaryInfo' )">
                                                        <h3 class="small-header">Current Address</h3>
                                                        <addressField 
                                                        :prefiilAddress="prefillCountryInQuestionnaire == false||([10,8].indexOf(checkProperty(petition,'subTypeDetails','id'))>-1 && checkProperty(petition,'typeDetails','id')==1 )?false:true" 
                                                        :fieldsArray="questionnaireDetails" :disableCountry="petition.beneficiaryInfo.currentlyInUS" formscope="casedetailsform" :showaptType="true" :addFormContainerCls="false" :validationRequired="checkFieldIsRequired({'key':'address','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :countries="countries" v-model="petition.beneficiaryInfo.address" :tplsection="'beneficiaryInfo'"  :fieldName="'address'"  :cid="'beneficiaryInfoaddress'" />
        
                                                    </div>
                                                </template>
                                                <div v-if="(canRenderField('mailingAddressIsSameAsAddress',questionnaireDetails, false, 'beneficiaryInfo' ) && canRenderField('currentAddress',questionnaireDetails, false, 'beneficiaryInfo' ) )" >
    
                                                                                                    
                                                    <div class="vx-col w-full d-flex">
                                                        <h3 class="small-header">Mailing Address</h3>
                                                        <template v-if="(canRenderField('currentlyInUS',questionnaireDetails, false, 'beneficiaryInfo' ) && checkProperty(petition,'beneficiaryInfo','currentlyInUS')  )">
                                                            <vs-checkbox @change="setSameaddress()"  v-model="petition.beneficiaryInfo.mailingAddressIsSameAsAddress" :tplsection="'beneficiaryInfo'"  :fieldName="'mailingAddressIsSameAsAddress'" 
                                                            style="margin-left: 15px; margin-bottom:12px;">Same as Current Address </vs-checkbox
                                                            >
                                                        </template>
                                                    </div>
                                                    <!-- petition.beneficiaryInfo.mailingAddressIsSameAsAddress!=true && -->
                                                    <template v-if=" countries.length>0">
                                                        
                                                      
                                                    <addressField :ref="'mailingAddresscomponent'"  :prefiilAddress="prefillCountryInQuestionnaire == false?false:true"  :display="true" :fieldsArray="questionnaireDetails" :disableCountry="petition.beneficiaryInfo.currentlyInUS && checkProperty(petition,'beneficiaryInfo','currentAddress') && checkProperty(petition['beneficiaryInfo'],'currentAddress','countryDetails')
                                                     && checkProperty(petition['beneficiaryInfo'],'currentAddress','countryId') && petition.beneficiaryInfo.mailingAddressIsSameAsAddress"
                                                     formscope="casedetailsform" :showaptType="true" :addFormContainerCls="false" :validationRequired="checkFieldIsRequired({'key':'currentAddress','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :countries="countries" v-model="petition.beneficiaryInfo.currentAddress" :tplsection="'beneficiaryInfo'"  :fieldName="'currentAddress'"  :cid="'beneficiarymailInfoaddress'" />
                                                    </template>
                                                </div>
                                                <div v-if="canRenderField('addressOutsideUS',questionnaireDetails, false, 'beneficiaryInfo' )">
                                                    <h3 class="small-header">Address Outside the U.S</h3>
                                                    <addressField :stateLabel="'State/Provience'" :prefiilAddress="prefillCountryInQuestionnaire == false?false:true" :hideusa="true" :validationRequired="checkFieldIsRequired({'key':'addressOutsideUS','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :fieldsArray="questionnaireDetails" :disableCountry="false" formscope="casedetailsform" :showaptType="true" :addFormContainerCls="false" :countries="countries" v-model="petition.beneficiaryInfo.addressOutsideUS" :tplsection="'beneficiaryInfo'"  :fieldName="'addressOutsideUS'"  :cid="'addressOutsideUS'" />
    
                                                </div>
                                            </div>
                                            <div class="vx-col w-full mb-5 yesno-v2" v-if="canRenderField('typeOfOffice',questionnaireDetails, false, 'beneficiaryInfo' )">
                                                <div class="custom-radio_sec">
                                                    <a class="switch-label">Type of Office
                                                    </a><em v-if="checkFieldIsRequired({'key':'typeOfOffice','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" >*</em>
                                                    <ul class="custom-radio custom-radio_v2">
                                                        <li>
                                                            <vs-radio ref="Consulate" v-model="petition.beneficiaryInfo.typeOfOffice" vs-name="Consulate" :vs-value="'Consulate'"  >Consulate</vs-radio>
                                                        </li>
                                                        <li>
                                                            <vs-radio ref="_Pre-flight_inspection" v-model="petition.beneficiaryInfo.typeOfOffice" vs-name="Pre-flight inspection" :vs-value="'Pre-flight inspection'" >Pre-flight inspection</vs-radio>
                                                        </li> 
                                                        <li>
                                                            <vs-radio ref="_Port_of_Entry" v-model="petition.beneficiaryInfo.typeOfOffice" vs-name="Port of Entry" :vs-value="'Port of Entry'" >Port of Entry</vs-radio>
                                                        </li> 
                                                    </ul>
                                                    <div class="form_group" v-if="checkFieldIsRequired({'key':'typeOfOffice','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })">
                                                        <input type="hidden" :name="'otherNames_typeOfOffice'" v-validate="'required'"  data-vv-as="Field"  v-model="petition.beneficiaryInfo.typeOfOffice">
                                                        <span v-show="errors.has( 'casedetailsform.otherNames_typeOfOffice')" class="text-danger text-sm" style="">*Field is required</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="vx-col w-full">
                                                <div v-if="canRenderField('officeAddress',questionnaireDetails, false, 'beneficiaryInfo' )">
                                                    <h3 class="small-header">Office Address</h3>
                                                    <addressField  :prefiilAddress="prefillCountryInQuestionnaire == false?false:true" :hideusa="false" :validationRequired="checkFieldIsRequired({'key':'officeAddress','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :fieldsArray="questionnaireDetails" :disableCountry="false" formscope="casedetailsform" :showaptType="true" :addFormContainerCls="false" :countries="countries" v-model="petition.beneficiaryInfo.officeAddress" :tplsection="'beneficiaryInfo'"  :fieldName="'officeAddress'"  :cid="'officeAddress'" />
                                                </div>
                                            </div>
                                            <template v-if="canRenderField('addressOfLastNYears',questionnaireDetails, false, 'beneficiaryInfo') || canRenderField('addressOutsideUSMoreThanYear',questionnaireDetails, false, 'beneficiaryInfo') ">
                                                <div class="vx-col w-full" v-if="canRenderField('addressOfLastNYears',questionnaireDetails, false, 'beneficiaryInfo' ) &&  checkProperty(petition.beneficiaryInfo,'addressOfLastNYears') && checkProperty(petition.beneficiaryInfo,'addressOfLastNYears' ,'length')>0">                                      
                                                    <template v-if="canRenderField('addressOfLastNYears',questionnaireDetails, false, 'beneficiaryInfo' ) &&  checkProperty(petition.beneficiaryInfo,'addressOfLastNYears') && checkProperty(petition.beneficiaryInfo,'addressOfLastNYears' ,'length')>0">
                                                        <h3 class="small-header" style="margin-bottom:0 !important;padding-bottom:0 !important">Your Residence starting with most current for the Past Five Years in the U.S and Abroad </h3>
                                                        <div class="I-485-wrapper">
                                                            <div class="vx-row delete-row I-485-bg" v-for="(lyearItem, index) in petition.beneficiaryInfo['addressOfLastNYears']" :key="index">
                                                            <addressField :fieldsArray="questionnaireDetails" :disableCountry="false" formscope="casedetailsform" :showaptType="true" :addFormContainerCls="false" :validationRequired="checkFieldIsRequired({'key':'addressOfLastNYears','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :countries="countries" v-model="petition.beneficiaryInfo['addressOfLastNYears'][index]" :tplsection="'beneficiaryInfo'"  :fieldName="'addressOfLastNYears'+index"  :cid="'addressOfLastNYears'+index" />
                                                            <div class="w-full">
                                                                <div class="vx-row">
                                                                    <datepickerField  @input="clearStartandEnddate($event,'addressOfLastNYears',index,'start')" :display="false" :fieldsArray="questionnaireDetails" :tplkey="'startDate'"  :validationRequired="true" v-model="lyearItem.startDate" formscope="casedetailsform" :dateEnableTo="featureDates"  :tplsection="'beneficiaryInfo.addressOfLastNYears'"  :fieldName="'residenceStartDate'+index" :cid="'residenceStartDate'+index"  label="Start Date" />
                                                                    <datepickerField @input="clearStartandEnddate($event,'addressOfLastNYears',index,'end')"   :display="false" :fieldsArray="questionnaireDetails" :tplkey="'endDate'" :isDisabled="!lyearItem.startDate"  :validationRequired="true" v-model="lyearItem.endDate" :dateEnableFrom="lyearItem.startDate" formscope="casedetailsform" :dateEnableTo="featureDates"  :tplsection="'beneficiaryInfo.addressOfLastNYears'" :cid="'residenceEndDate'+index"  :fieldName="'residenceEndDate'+index"  label="End Date" />
                                                                </div>
                                                            </div>
                                                                <div class="delete" v-if="petition.beneficiaryInfo['addressOfLastNYears'].length > 1">
                                                                    <a @click="removeNyears(index)">
                                                                    <img src="@/assets/images/main/delete-row-img-white.svg" />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                     <div class="m-auto" vs-type="flex" vs-align="center" vs-lg="2" vs-sm="2">
                                                         <a @click="addNyears()" class="add-more ml-0 mt-4" style="display:inline-block" type="filled">
                                                       <span>+</span> More</a>
                                                    </div>
                                           </div>
                                           <div class="vx-col w-full" v-if=" canRenderField('addressOutsideUSMoreThanYear',questionnaireDetails, false, 'beneficiaryInfo' ) && checkProperty(petition.beneficiaryInfo,'addressOutsideUSMoreThanYear') && checkProperty(petition.beneficiaryInfo,'addressOutsideUSMoreThanYear' ,'length')>0">
                                                <template v-if="canRenderField('addressOutsideUSMoreThanYear',questionnaireDetails, false, 'beneficiaryInfo' )  &&  checkProperty(petition.beneficiaryInfo,'addressOutsideUSMoreThanYear') && checkProperty(petition.beneficiaryInfo,'addressOutsideUSMoreThanYear','length')>0">
                                                    <h3 class="small-header" style="margin-top: 40px !important;
                                                            padding-bottom: 0 !important;"> Last Address outside Of the United States for more than one year</h3>
                                                    <div class="vx-row delete-row" v-for="(lastYearItem, ind) in petition.beneficiaryInfo['addressOutsideUSMoreThanYear']" :key="ind">
                                                        <addressField :hideusa="true" :wrapclass="'px-4'" :fieldsArray="questionnaireDetails"  formscope="casedetailsform" :showaptType="true" :addFormContainerCls="false" :validationRequired="checkFieldIsRequired({'key':'addressOutsideUSMoreThanYear','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :countries="countries" v-model="petition.beneficiaryInfo['addressOutsideUSMoreThanYear'][ind]" :tplsection="'beneficiaryInfo'"  :fieldName="'addressOutsideUSMoreThanYear'+ind"  :cid="'addressOutsideUSMoreThanYear'+ind" />
                                                        <datepickerField   @input="clearStartandEnddate($event,'addressOutsideUSMoreThanYear',ind,'start')" :display="false" :fieldsArray="questionnaireDetails" :tplkey="'startDate'"  :validationRequired="true" v-model="lastYearItem.startDate" formscope="casedetailsform" :dateEnableTo="featureDates"  :tplsection="'beneficiaryInfo.addressOutsideUSMoreThanYear'"  :fieldName="'outSideStartDate'+ind" :cid="'outSideStartDate'+ind"  label="Start Date" />
                                                        <datepickerField @input="clearStartandEnddate($event,'addressOutsideUSMoreThanYear',ind,'end')" :display="false" :fieldsArray="questionnaireDetails" :tplkey="'endDate'" :isDisabled="!lastYearItem.startDate"  :validationRequired="true" v-model="lastYearItem.endDate" :dateEnableFrom="lastYearItem.startDate"  formscope="casedetailsform" :dateEnableTo="featureDates"  :tplsection="'beneficiaryInfo.addressOutsideUSMoreThanYear'"  :fieldName="'outSideEndDate'+ind" :cid="'outSideStartDate'+ind" label="End Date" /> 
                                                        <div class="delete" v-if="petition.beneficiaryInfo['addressOutsideUSMoreThanYear'].length > 1">
                                                                <a @click="removeLastYearItem(ind)">
                                                                <img src="@/assets/images/main/delete-row-img-white.svg" />
                                                                </a>
                                                            </div>
                                                    </div> 
                                                </template>
                                                <!-- <div class="m-auto" vs-type="flex" vs-align="center" vs-lg="2" vs-sm="2">
                                                         <a @click="addLastYearItem()" class="add-more ml-0" style="display:inline-block" type="filled">
                                                       <span>+</span> More</a>
                                                </div> -->
                                            </div> 
                                            <!-- <div class="vx-col w-full" v-if="canRenderField('addressOfLastNYears',questionnaireDetails, false, 'beneficiaryInfo' ) &&  checkProperty(petition.beneficiaryInfo,'addressOfLastNYears') && checkProperty(petition.beneficiaryInfo,'addressOfLastNYears' ,'length')>0">
                                                <div>
                                                    <template v-if="canRenderField('addressOfLastNYears',questionnaireDetails, false, 'beneficiaryInfo' )">
                                                        <h3 class="small-header">Your Residence starting with most current for the Past Five Years in the U.S and Abroad </h3>
                                                        <addressField :fieldsArray="questionnaireDetails" :disableCountry="false" formscope="casedetailsform" :showaptType="true" :addFormContainerCls="false" :validationRequired="checkFieldIsRequired({'key':'addressOfLastNYears','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :countries="countries" v-model="petition.beneficiaryInfo['addressOfLastNYears'][0]" :tplsection="'beneficiaryInfo'"  :fieldName="'addressOfLastNYears'"  :cid="'addressOfLastNYears'" />
                                                    </template>
                                                     
                                                </div>
                                            </div>
                                            <template v-if="canRenderField('addressOfLastNYears',questionnaireDetails, false, 'beneficiaryInfo' ) &&  checkProperty(petition.beneficiaryInfo,'addressOfLastNYears') && checkProperty(petition.beneficiaryInfo,'addressOfLastNYears' ,'length')>0">
                                                <datepickerField  :display="false" :fieldsArray="questionnaireDetails" :tplkey="'startDate'"  :validationRequired="true" v-model="petition.beneficiaryInfo['addressOfLastNYears'][0].startDate" formscope="casedetailsform" :dateEnableTo="featureDates"  :tplsection="'beneficiaryInfo.addressOfLastNYears'"  :fieldName="'residenceStartDate'"  label="Start Date" />
                                                <datepickerField   :display="false" :fieldsArray="questionnaireDetails" :tplkey="'endDate'" :isDisabled="!petition.beneficiaryInfo['addressOfLastNYears'][0].startDate"  :validationRequired="true" v-model="petition.beneficiaryInfo['addressOfLastNYears'][0].endDate" :dateEnableFrom="petition.beneficiaryInfo['addressOfLastNYears'][0].startDate" formscope="casedetailsform" :dateEnableTo="featureDates"  :tplsection="'beneficiaryInfo.addressOfLastNYears'"  :fieldName="'residenceEndDate'"  label="End Date" /> 
                                            </template> -->


                                            <!-- <div class="vx-col w-full" v-if=" canRenderField('addressOutsideUSMoreThanYear',questionnaireDetails, false, 'beneficiaryInfo' ) && checkProperty(petition.beneficiaryInfo,'addressOutsideUSMoreThanYear') && checkProperty(petition.beneficiaryInfo,'addressOutsideUSMoreThanYear' ,'length')>0">
                                                <div>
                                                    <template v-if="canRenderField('addressOutsideUSMoreThanYear',questionnaireDetails, false, 'beneficiaryInfo' )">
                                                        <h3 class="small-header"> Last Address outside Of the United States for more than one year</h3>
                                                        <addressField :hideusa="true" :fieldsArray="questionnaireDetails"  formscope="casedetailsform" :showaptType="true" :addFormContainerCls="false" :validationRequired="checkFieldIsRequired({'key':'addressOutsideUSMoreThanYear','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :countries="countries" v-model="petition.beneficiaryInfo['addressOutsideUSMoreThanYear'][0]" :tplsection="'beneficiaryInfo'"  :fieldName="'addressOutsideUSMoreThanYear'"  :cid="'addressOutsideUSMoreThanYear'" />
                                                    </template>
                                                </div>
                                            </div> 
                                            <template v-if=" canRenderField('addressOutsideUSMoreThanYear',questionnaireDetails, false, 'beneficiaryInfo' ) && checkProperty(petition.beneficiaryInfo,'addressOutsideUSMoreThanYear') && checkProperty(petition.beneficiaryInfo,'addressOutsideUSMoreThanYear' ,'length')>0">
                                                <datepickerField  :display="false" :fieldsArray="questionnaireDetails" :tplkey="'startDate'"  :validationRequired="true" v-model="petition.beneficiaryInfo['addressOutsideUSMoreThanYear'][0].startDate" formscope="casedetailsform" :dateEnableTo="featureDates"  :tplsection="'beneficiaryInfo.addressOutsideUSMoreThanYear'"  :fieldName="'outSideStartDate'"  label="Start Date" />
                                                <datepickerField  :display="false" :fieldsArray="questionnaireDetails" :tplkey="'endDate'" :isDisabled="!petition.beneficiaryInfo['addressOutsideUSMoreThanYear'][0].startDate"  :validationRequired="true" v-model="petition.beneficiaryInfo['addressOutsideUSMoreThanYear'][0].endDate" :dateEnableFrom="petition.beneficiaryInfo['addressOutsideUSMoreThanYear'][0].startDate"  formscope="casedetailsform" :dateEnableTo="featureDates"  :tplsection="'beneficiaryInfo.addressOutsideUSMoreThanYear'"  :fieldName="'outSideEndDate'"  label="End Date" /> 
                                            </template> -->
                                            
                                            </template>
                                            <template v-if="canRenderField('associations',questionnaireDetails, false, 'beneficiaryInfo.associations' )">
                                                <div class="vx-col w-full" >
                                                    <div class="form_group w-full"> 
                                                        <label class="form_label">
                                                            <!-- ASSOCIATIONS/GROUPS -->
                                                            <h3 class="small-header">Associations/Groups</h3>
                                                            <div class="IB_tooltip H1-140">
                                                                <span ><info-icon size="1.5x" class="custom-class"></info-icon ></span>
                                                                    <div class="tooltip_cnt">
                                                                        <p>All associations and groups of which you are or have been a member, including political organizations, if you do not belong to any organizations, please write "None".</p>
                                                                    </div>
                                                            </div>
                                                        </label>
                                                    </div>
                                                </div> 
                                                <immiInput :display="false" :tplkey="'name'" :fieldsArray="questionnaireDetails"  cid="benfname" formscope="casedetailsform" v-model="petition.beneficiaryInfo['associations'][0].name" :tplsection="'beneficiaryInfo.associations'"  :fieldName="'name'"  :required="true"  label="Name of the associations and groups" placeHolder="Name of the associations and groups" />
                                                <immiInput :display="false" :tplkey="'natureofAssociations'" :fieldsArray="questionnaireDetails"  cid="benfnatureofAssociations" formscope="casedetailsform" v-model="petition.beneficiaryInfo['associations'][0].natureofAssociations" :tplsection="'beneficiaryInfo.associations'"  :fieldName="'natureofAssociations'"  :required="true"  label="Nature of associations and groups" placeHolder="Nature of associations and groups" /> 
                                                <datepickerField :display="false" @input="clearDependentField(petition.beneficiaryInfo['associations'][0])" :tplkey="'startDate'" :fieldsArray="questionnaireDetails" :validationRequired="true" v-model="petition.beneficiaryInfo['associations'][0].startDate" :tplsection="'beneficiaryInfo.associations'"  :fieldName="'assosicationsStartDate'"  formscope="casedetailsform"  :dateEnableTo="featureDates" label="Start Date" />
                                                <datepickerField :display="false" :tplkey="'endDate'" :isDisabled="!petition.beneficiaryInfo['associations'][0].startDate"  :fieldsArray="questionnaireDetails" :dateEnableFrom="petition.beneficiaryInfo['associations'][0].startDate" :validationRequired="true" v-model="petition.beneficiaryInfo['associations'][0].endDate" :tplsection="'beneficiaryInfo.associations'"  :fieldName="'assosicationsEndDate'"  formscope="casedetailsform"  label="End Date" /> 
                                                <div class="vx-col w-full" v-if="canRenderField('address',questionnaireDetails, false, 'beneficiaryInfo.associations' )">
                                                    <h3 class="small-header"> Address</h3>
                                                    <addressField :validationRequired="checkFieldIsRequired({'key':'address','section':'beneficiaryInfo.associations', 'fieldsArray':questionnaireDetails, 'required':true })"  :fieldsArray="questionnaireDetails" :showLane1="false" :showLane2="false" :disableCountry="false" :showZip="false" formscope="casedetailsform" :showaptType="false" :addFormContainerCls="false" :countries="countries" v-model="petition.beneficiaryInfo['associations'][0].address" :tplsection="'beneficiaryInfo.associations'"  :fieldName="'address'"  :cid="'address'" />
                                                </div>   
                                            </template>
                                            <div class="vx-col w-full" v-if="canRenderField('consulateInfo',questionnaireDetails, false, 'beneficiaryInfo' )">
                                                <h3 class="small-header">Consulate you want to attend the visa interview</h3>
    
                                                <consulateAddress :prefiilAddress="prefillCountryInQuestionnaire == false?false:true" :validationRequired="checkFieldIsRequired({'key':'consulateInfo','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })"  :fieldsArray="questionnaireDetails" :disableCountry="false" 
                                                formscope="casedetailsform" :addFormContainerCls="false" :countries="countries" v-model="petition.beneficiaryInfo.consulateInfo" :tplsection="'beneficiaryInfo'"  :fieldName="'consulateInfo'"  :cid="'consulateInfo'" :hideusa="true"/>
    
                                            </div>
    
                                            <immiMask :display="false" :tplkey="'SSN'" :fieldsArray="questionnaireDetails" :patren="['### - ## - ####']" datatype="min:9|max:9" :wrapclass="canRenderField('ben_alienNumber',questionnaireDetails)?'md:w-1/2':' '" cid="benfSSN" formscope="casedetailsform" v-model="petition.beneficiaryInfo.SSN" :tplsection="'beneficiaryInfo'"  :fieldName="'SSN'"  :required="false"  label="Social Security number (if applicable)" vvas="Social Security number" placeHolder="123 - 45 - 6789" />
                                            <immiInput :display="false" :tplkey="'alienNumber'" :fieldsArray="questionnaireDetails" datatype="alpha_num|max:9" cid="benfalienNumber_alienNumber" formscope="casedetailsform" v-model="petition.beneficiaryInfo.alienNumber" :tplsection="'beneficiaryInfo'"  :fieldName="'alienNumber'"   label="Your Alien Number (if applicable)" placeHolder="Alien Number " />
    
                                            <immiInput :display="false" :tplkey="'consulateNotifyAddress'" :fieldsArray="questionnaireDetails" v-if="!petition.beneficiaryInfo.currentlyInUS" wrapclass=" " cid="benfconsulateNotifyAddress" formscope="casedetailsform" v-model="petition.beneficiaryInfo.consulateNotifyAddress" :tplsection="'beneficiaryInfo'"  :fieldName="'consulateNotifyAddress'"  :required="true"  label="Consulate to Notify upon Approval of your petition (if outside the USA)" vvas="Consulate Details" placeHolder="Consulate to Notify upon Approval of your petition" />
    
                                            <immiyesorno formscope="casedetailsform" :cid="'hasI140ImmPetitionFiled'" :required="checkFieldIsRequired({'key':'hasI140ImmPetitionFiled','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false" :tplkey="'hasI140ImmPetitionFiled'"  :fieldsArray="questionnaireDetails" v-model="petition.beneficiaryInfo.hasI140ImmPetitionFiled" :tplsection="'beneficiaryInfo'"  :fieldName="'hasI140ImmPetitionFiled'" :wrapclass="'yesno-v2'"   label="Has I-140 immigrant petition been filed on your behalf?"></immiyesorno>
                                            <immiuploader :display="false" :tplkey="'I140ApprovalNotice'" :fieldsArray="questionnaireDetails" v-if="petition.beneficiaryInfo.hasI140ImmPetitionFiled" formscope="casedetailsform" :required="petition.beneficiaryInfo.hasI140ImmPetitionFiled" v-model="petition.documents.I140ApprovalNotice" :wrapclass="'mb-5'" :tplsection="'documents'"  :fieldName="'I140ApprovalNotice'"  label="I-140 Approval Notice, if any" vvas="I-140 Approval Notice"></immiuploader>
    
    
                                            
                                            <template v-if="canRenderField('nonImmPetitionsInfo', questionnaireDetails ,false,'beneficiaryInfo')">
                                                <petitionsinformation :fieldsArray="questionnaireDetails" formscope="casedetailsform"  v-if="petition.beneficiaryInfo.haveYouEverTravelledToUS || (petition && petition.visaStatusList && petition.visaStatusList.length > 0)"   :petition="petition" v-model="petition.beneficiaryInfo.nonImmPetitionsInfo" :tplsection="'beneficiaryInfo.nonImmPetitionsInfo'"  :fieldName="'nonImmPetitionsInfo'" ></petitionsinformation>
                                            </template>
                                            <template v-if="checkProperty(petition ,'subTypeDetails' ,'id') !=16">
                                            <immiyesorno formscope="casedetailsform" :cid="'anyImmPetitionFiled'" :required="checkFieldIsRequired({'key':'anyImmPetitionFiled','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false" :tplkey="'anyImmPetitionFiled'"  :fieldsArray="questionnaireDetails" v-model="petition.beneficiaryInfo.anyImmPetitionFiled" :tplsection="'beneficiaryInfo'"  :fieldName="'anyImmPetitionFiled'" :wrapclass="'yesno-v2'"   label="Has any immigrant Visa petition I-140 ever been filed on your behalf?"></immiyesorno>
                                           </template>
                                            <!-- <immiswitchyesno wrapclass=" " :required="checkFieldIsRequired({'key':'anyImmPetitionFiled','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" @input="clearImmiputFields" :display="false" :fieldsArray="questionnaireDetails" :cid="'ben_anyImmPetitionFiled'" formscope="casedetailsform" v-model="petition.beneficiaryInfo.anyImmPetitionFiled"  :tplsection="'beneficiaryInfo'" :tplkey="'anyImmPetitionFiled'" :fieldName="'anyImmPetitionFiled'" label="Has any immigrant Visa petition (PERM, I-140, I-485) ever been filed on your behalf?" placeHolder="" /> -->
                                            <template v-if="( canRenderField('h1bImmPetitionsInfo',questionnaireDetails,false ,'beneficiaryInfo')&& canRenderField('anyImmPetitionFiled',questionnaireDetails,false ,'beneficiaryInfo') && petition.beneficiaryInfo && petition.beneficiaryInfo.anyImmPetitionFiled) || (!canRenderField('anyImmPetitionFiled',questionnaireDetails,false ,'beneficiaryInfo') && canRenderField('h1bImmPetitionsInfo',questionnaireDetails,false ,'beneficiaryInfo')) ">
                                                <petitionImmigranInfo :fieldsArray="questionnaireDetails" formscope="casedetailsform"    :petition="petition" v-model="petition.beneficiaryInfo.h1bImmPetitionsInfo" :tplsection="'beneficiaryInfo.h1bImmPetitionsInfo'"  :fieldName="'h1bImmPetitionsInfo'" ></petitionImmigranInfo>
                                            </template>
         
                                            <immiyesorno :cid="'haveYouEverTravelledToUS'" formscope="casedetailsform" :required="checkFieldIsRequired({'key':'haveYouEverTravelledToUS','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :wrapclass="'swicth-label_v2 yesno-v2'" :display="false" :tplkey="'haveYouEverTravelledToUS'" :fieldsArray="questionnaireDetails"   v-model="petition.beneficiaryInfo.haveYouEverTravelledToUS" :tplsection="'beneficiaryInfo'"  :fieldName="'haveYouEverTravelledToUS'"   label="Have you ever travelled to the United States?"></immiyesorno>
                                           <!-- this condition is to enable the Date of most recent entry into the USA field with out selecting the haveYouEverTravelledToUS -->
                                            <template v-if="(canRenderField('haveYouEverTravelledToUS',questionnaireDetails,false ,'beneficiaryInfo') && petition.beneficiaryInfo && petition.beneficiaryInfo.haveYouEverTravelledToUS)
                                            || !canRenderField('haveYouEverTravelledToUS',questionnaireDetails,false ,'beneficiaryInfo') ">
                                                <span class="vx-col  w-full mart10"></span>
                                                <template v-if="canRenderField('stateOfLastEntryInUS',questionnaireDetails,false ,'beneficiaryInfo')  ">

                                                    <selectField :display="false" :fieldsArray="questionnaireDetails"  @input="petition.beneficiaryInfo.stateOfLastEntryInUS = petition.beneficiaryInfo.stateDetailsOfLastEntryInUS.id"  :optionslist="usastates" v-model="petition.beneficiaryInfo.stateDetailsOfLastEntryInUS" :tplsection="'beneficiaryInfo'"  :tplkey="'stateOfLastEntryInUS'" :fieldName="'stateOfLastEntryInUS'"  :formscope="'casedetailsform'"  label="State of recent entry into the USA" placeHolder="State of recent entry into the USA" />
                                                </template>
                                                <template v-if="canRenderField('placeOfLastEntryInUS',questionnaireDetails,false ,'beneficiaryInfo')  ">
                                                    <immiInput :display="false" :fieldsArray="questionnaireDetails"  cid="placeOfLastEntryInUS" :formscope="'casedetailsform'" v-model="petition.beneficiaryInfo.placeOfLastEntryInUS" :tplsection="'beneficiaryInfo'" :tplkey="'placeOfLastEntryInUS'" :fieldName="'placeOfLastEntryInUS'"    label="Place of recent entry into the USA" placeHolder="Place of recent entry into the USA" />
                                                </template>
                                                <template v-if="canRenderField('lastArrivalDate',questionnaireDetails,false ,'beneficiaryInfo')  ">
                                                    <datepickerField :validationRequired="true"  :display="false" :fieldsArray="questionnaireDetails" :tplkey="'lastArrivalDate'"   v-model="petition.beneficiaryInfo.lastArrivalDate" :formscope="'casedetailsform'" :dateEnableTo="featureDates"  :tplsection="'beneficiaryInfo'"  :fieldName="'lastArrivalDate'"  label="Date of most recent entry into the USA" />
                                                </template>
                                            </template>
                                           
                                            <template v-if="(canRenderField('haveYouEverTravelledToUS',questionnaireDetails,false ,'beneficiaryInfo') && petition.beneficiaryInfo && petition.beneficiaryInfo.haveYouEverTravelledToUS && canRenderField('priorPeriodOfStayInUS', questionnaireDetails ,false,'beneficiaryInfo' )) || (!canRenderField('haveYouEverTravelledToUS',questionnaireDetails,false ,'beneficiaryInfo') && canRenderField('priorPeriodOfStayInUS', questionnaireDetails ,false,'beneficiaryInfo' )) ">
                                             <immipriorstay :fieldsArray="questionnaireDetails" formscope="casedetailsform" v-if="canRenderField('priorPeriodOfStayInUS', questionnaireDetails ,false,'beneficiaryInfo' ) && petition && petition.visaStatusList && petition.visaStatusList.length > 0"  :petition="petition" v-model="petition.beneficiaryInfo.priorPeriodOfStayInUS" :tplsection="'beneficiaryInfo'"  :fieldName="'priorPeriodOfStayInUS'" ></immipriorstay>
                                            </template>                                         
                                                 <!------------------------------------------------------------------------>
                                            <template v-if="canRenderField('anyOtherAlienFiled', questionnaireDetails ,false,'beneficiaryInfo.immPetitionInfo' )  && petition.beneficiaryInfo.anyImmPetitionFiled">
                                                <div class="vx-col w-full" >
    
                                                <h3 class="small-header">Immigrant Petition Information</h3>
                                            </div>
                                                <immiswitchyesno v-if="canRenderField('anyOtherAlienFiled', questionnaireDetails ,false,'beneficiaryInfo.immPetitionInfo' )" :required="checkFieldIsRequired({'key':'anyOtherAlienFiled','section':'beneficiaryInfo.immPetitionInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false" wrapclass=" " :fieldsArray="questionnaireDetails" :cid="'ben_anyImmPetitionFiled'" formscope="casedetailsform" v-model="petition.beneficiaryInfo.immPetitionInfo.anyOtherAlienFiled" :tplsection="'beneficiaryInfo.immPetitionInfo'"  :fieldName="'anyOtherAlienFiled'"   label="Has any other Alien Employment Certification, a.k.a Labor Certification been filed on your behalf? " placeHolder="" />
                                               
                                                <template v-if="petition.beneficiaryInfo.immPetitionInfo.anyOtherAlienFiled"> 
                                                    <datepickerField :validationRequired="true" v-if="canRenderField('filedDate', questionnaireDetails ,false,'beneficiaryInfo.immPetitionInfo' )" wrapclass="md:w-1/2"  :display="false" :tplkey="'filedDate'" :fieldsArray="questionnaireDetails" v-model="petition.beneficiaryInfo.immPetitionInfo.filedDate"  :tplsection="'beneficiaryInfo.immPetitionInfo'"  :fieldName="'filedDate'"  formscope="casedetailsform"  :dateEnableTo="featureDates" label="Date Filed" />
                                                <immiInput v-if="canRenderField('employerName', questionnaireDetails ,false,'beneficiaryInfo.immPetitionInfo' )" wrapclass="md:w-1/2"  :display="false" :tplkey="'employerName'" :fieldsArray="questionnaireDetails"  cid="benfalienNumber" formscope="casedetailsform" v-model="petition.beneficiaryInfo.immPetitionInfo.employerName" :tplsection="'beneficiaryInfo.immPetitionInfo'"  :fieldName="'employerName'"   label="Name of the Employer" placeHolder="Name of the Employer" />
                                                <immiswitchyesno v-if="canRenderField('rirOrRegularProcessing', questionnaireDetails ,false,'beneficiaryInfo.immPetitionInfo' )" :required="checkFieldIsRequired({'key':'rirOrRegularProcessing','section':'beneficiaryInfo.immPetitionInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false" :tplkey="'rirOrRegularProcessing'" wrapclass=" " :fieldsArray="questionnaireDetails" :cid="'ben_rirOrRegularProcessing'" formscope="casedetailsform" v-model="petition.beneficiaryInfo.immPetitionInfo.rirOrRegularProcessing" :tplsection="'beneficiaryInfo.immPetitionInfo'"  :fieldName="'rirOrRegularProcessing'"   label="RIR or Regular Processing" placeHolder="" />
    
                                                <selectField v-if="canRenderField('filedStateId', questionnaireDetails ,false,'beneficiaryInfo.immPetitionInfo' )" :display="false" :tplkey="'filedStateId'"  :fieldsArray="questionnaireDetails" @input="petition.beneficiaryInfo.immPetitionInfo.filedStateId = petition.beneficiaryInfo.immPetitionInfo.filedStateDetails.id"  :optionslist="usastates" v-model="petition.beneficiaryInfo.immPetitionInfo.filedStateDetails" :tplsection="'beneficiaryInfo.immPetitionInfo'"  :fieldName="'filedStateId'"  formscope="casedetailsform"  label="State where it was filed" placeHolder="State where it was filed" />
                                                <immiInput v-if="canRenderField('applCurStatus', questionnaireDetails ,false,'beneficiaryInfo.immPetitionInfo' )" wrapclass="md:w-1/2"  :display="false" :tplkey="'applCurStatus'" :fieldsArray="questionnaireDetails"  cid="applCurStatus" formscope="casedetailsform" v-model="petition.beneficiaryInfo.immPetitionInfo.applCurStatus" :tplsection="'beneficiaryInfo.immPetitionInfo'"  :fieldName="'applCurStatus'"   label="Current Status of the Application" placeHolder="Current Status of the Application"/>
    
                                                
                                                
                                                </template>
    
    
    
                                                <immiswitchyesno :required="checkFieldIsRequired({'key':'seekingFiledDateforETA750','section':'beneficiaryInfo.immPetitionInfo', 'fieldsArray':questionnaireDetails, 'required':true })" v-if="canRenderField('seekingFiledDateforETA750', questionnaireDetails ,false,'beneficiaryInfo.immPetitionInfo' )" :display="false" :tplkey="'seekingFiledDateforETA750'" wrapclass=" " :fieldsArray="questionnaireDetails" :cid="'ben_seekingFiledDateforETA750'" formscope="casedetailsform" v-model="petition.beneficiaryInfo.immPetitionInfo.seekingFiledDateforETA750" :tplsection="'beneficiaryInfo.immPetitionInfo'"  :fieldName="'seekingFiledDateforETA750'" :wrapclass="'yesno-v1'"    label="Are you seeking to utilize the filing date from a previously submitted Application for Alien Employment Certification (ETA 750)?" placeHolder="" />
                                                <immiswitchyesno :required="checkFieldIsRequired({'key':'anyI140Filed','section':'beneficiaryInfo.immPetitionInfo', 'fieldsArray':questionnaireDetails, 'required':true })"  v-if="canRenderField('anyI140Filed', questionnaireDetails ,false,'beneficiaryInfo.immPetitionInfo' )" :display="false" :tplkey="'anyI140Filed'" wrapclass=" " :fieldsArray="questionnaireDetails" :cid="'ben_anyI140Filed'" formscope="casedetailsform" v-model="petition.beneficiaryInfo.immPetitionInfo.anyI140Filed" :tplsection="'beneficiaryInfo.immPetitionInfo'"  :fieldName="'anyI140Filed'"   label="Has any I-140 Petition been filed on your behalf? " placeHolder="" />
    
                                                <template v-if="petition.beneficiaryInfo.immPetitionInfo.anyI140Filed"> 
    
                                                <datepickerField :validationRequired="true" v-if="canRenderField('fieldDate', questionnaireDetails ,false,'beneficiaryInfo.immPetitionInfo.i140Info' )" wrapclass="md:w-1/2"  :display="false" :tplkey="'fieldDate'" :fieldsArray="questionnaireDetails"  v-model="petition.beneficiaryInfo.immPetitionInfo.i140Info.fieldDate" :tplsection="'beneficiaryInfo.immPetitionInfo.i140Info'"  :fieldName="'fieldDate'"  formscope="casedetailsform"  :dateEnableTo="featureDates" label="Date Filed" />
                                                <immiInput v-if="canRenderField('employerName', questionnaireDetails ,false,'beneficiaryInfo.immPetitionInfo.i140Info' )" wrapclass="md:w-1/2"  :display="false" :tplkey="'employerName'" :fieldsArray="questionnaireDetails"  cid="benfalienNumber" formscope="casedetailsform" v-model="petition.beneficiaryInfo.immPetitionInfo.i140Info.employerName"  :tplsection="'beneficiaryInfo.immPetitionInfo.i140Info'"  :fieldName="'employerName'"  label="Name of the Employer" placeHolder="Name of the Employer" />
                                                <datepickerField :validationRequired="true"  v-if="canRenderField('priorityDate', questionnaireDetails ,false,'beneficiaryInfo.immPetitionInfo.i140Info' )" wrapclass="md:w-1/2"  :display="false" :tplkey="'priorityDate'" :fieldsArray="questionnaireDetails"  v-model="petition.beneficiaryInfo.immPetitionInfo.i140Info.priorityDate" :tplsection="'beneficiaryInfo.immPetitionInfo.i140Info'"  :fieldName="'priorityDate'"  formscope="casedetailsform"  :dateEnableTo="featureDates" label="Priority Date" />
                                                <immiInput v-if="canRenderField('currentStatus', questionnaireDetails ,false,'beneficiaryInfo.immPetitionInfo.i140Info' )" wrapclass="md:w-1/2"  :display="false" :tplkey="'currentStatus'" :fieldsArray="questionnaireDetails"  cid="applCurStatus" formscope="casedetailsform" v-model="petition.beneficiaryInfo.immPetitionInfo.i140Info.currentStatus" :tplsection="'beneficiaryInfo.immPetitionInfo.i140Info'"  :fieldName="'currentStatus'"   label="Current Status of the I-140" placeHolder="Current Status of the I-140"/>
    
                                                <immiInput v-if="canRenderField('eb2orEb3', questionnaireDetails ,false,'beneficiaryInfo.immPetitionInfo.i140Info' )" wrapclass="md:w-1/2"  :display="false" :tplkey="'eb2orEb3'" :fieldsArray="questionnaireDetails"  cid="applCurStatus" formscope="casedetailsform" v-model="petition.beneficiaryInfo.immPetitionInfo.i140Info.eb2orEb3" :tplsection="'beneficiaryInfo.immPetitionInfo.i140Info'"  :fieldName="'eb2orEb3'"   label="EB2/EB3" placeHolder="EB2/EB3"/>
                                            </template>
                                            </template>
                                            <!-------------------------------------->
                                            <template v-if="gettotalDays > 1095 && canRenderField('confirmDaysStayInUS', questionnaireDetails ,false,'beneficiaryInfo' )">
                                                <div class="vx-col  w-full rspace-bottom">
                                                    <div class="form_group pt-10" v-if="canRenderField('confirmDaysStayInUS', questionnaireDetails ,false,'beneficiaryInfo' )">
                                                        <label class="form_label">It appears that you have spent {{gettotalDays}} of days in the US in H/L status. Please confirm if this is correct.?
                                                        </label>
                                                        <label class="form_label" for="confirmDaysStayInUS">
                                                            <input name="confirmDaysStayInUS" v-validate="'required'" type="checkbox" v-model="petition.beneficiaryInfo.confirmDaysStayInUS" :tplsection="'beneficiaryInfo'"  :fieldName="'confirmDaysStayInUS'" >
    
                                                            Yes</label>
                                                        <p v-show="errors.has('casedetailsform.confirmDaysStayInUS')" class="text-danger text-sm">Please confirm if this is correct.</p>
    
                                                    </div>
    
                                                    <div class="form_group mb-10" v-if="canRenderField('hasApprovedI140', questionnaireDetails ,false,'beneficiaryInfo' ) || canRenderField('hasPermPendingForMorethan365Days', questionnaireDetails ,false,'beneficiaryInfo' )">
                                                        <template v-if="gettotalDays > 2185">
    
                                                            <label class="form_label pb-5 pt-5">Note: Please note that you are allowed a maximum period of 6 years on your H-1B. To receive H-1B approval past 6 years you need to either have an approved I-140 or PERM application pending for more than 364 days. Please confirm if you have the following:</label>
    
                                                            <immiswitchyesno :required="checkFieldIsRequired({'key':'hasApprovedI140','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false" :tplkey="'hasApprovedI140'"  wrapclass=" " :fieldsArray="questionnaireDetails" :cid="'hasApprovedI140'" formscope="casedetailsform" v-model="petition.beneficiaryInfo.hasApprovedI140" :tplsection="'beneficiaryInfo'"  :fieldName="'hasApprovedI140'"   label="Approved I-140 (from any employer that has not been revoked within 180 days of its approval)" placeHolder="" />
    
                                                            <immiswitchyesno :required="checkFieldIsRequired({'key':'hasPermPendingForMorethan365Days','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false" :tplkey="'hasPermPendingForMorethan365Days'"  wrapclass=" " :fieldsArray="questionnaireDetails" :cid="'hasPermPendingForMorethan365Days'" formscope="casedetailsform" v-model="petition.beneficiaryInfo.hasPermPendingForMorethan365Days" :tplsection="'beneficiaryInfo'"  :fieldName="'hasPermPendingForMorethan365Days'"   label="PERM application pending for more than 365 days" placeHolder="" />
    
                                                        </template>
    
                                                    </div>
    
                                                </div>
    
                                            </template>
                                            <immiyesorno :required="checkFieldIsRequired({'key':'previouslyMarried','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" v-if="checkProperty(petition ,'beneficiaryInfo','maritalStatus') && checkProperty(petition ,'beneficiaryInfo','maritalStatus') !=1" wrapclass=" "  :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="previouslyMarried"  v-model="petition.beneficiaryInfo.previouslyMarried" :tplkey="'previouslyMarried'" :tplsection="'beneficiaryInfo'"  :fieldName="'previouslyMarried'"   label="Were you married previously?"></immiyesorno>
                                            <template v-if="petition.beneficiaryInfo.previouslyMarried  && checkProperty(petition ,'beneficiaryInfo','maritalStatus') !=1 && canRenderField('previousSpouse',questionnaireDetails, false, 'beneficiaryInfo.previousSpouse' ) && canRenderField('previouslyMarried',questionnaireDetails, false, 'beneficiaryInfo' )">
                                                <previousSpouseForm  :tplsection="'beneficiaryInfo.previousSpouse'" cid="ben_previousSpouse" formscope="casedetailsform" :countries="countries" :petition="petition" :fieldName="'previousSpouse'" :fieldsArray="questionnaireDetails" v-model="petition.beneficiaryInfo.previousSpouse"    />
                                            </template> 

                                            <template v-if="canRenderField('inadmissibility',questionnaireDetails,false ,'beneficiaryInfo')" >
                                                <div class="vx-col w-full">
                                                    <div class="form_group w-full"> 
                                                        <label class="form_label"><h3 class="small-header">Public Charge</h3>
                                                    </label>
                                                    </div>
                                                </div>
                                                <immiyesorno wrapclass=" " @input="updateHouseHoldTab" :required="checkFieldIsRequired({'key':'inadmissibility','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :tplkey="'inadmissibility'" :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="inadmissibility"  v-model="petition.beneficiaryInfo.inadmissibility" :tplsection="'beneficiaryInfo'"  :fieldName="'inadmissibility'"  label="Are you subject to the public charge ground of inadmissibility under INA section 212(a)(4)?"></immiyesorno>
                                                <template v-if="canRenderField('inadmissibility',questionnaireDetails,false ,'beneficiaryInfo') && checkProperty(petition, 'beneficiaryInfo', 'inadmissibility')">
                                                    <selectField wrapclass="formgroupv2" :tplkey="'highestDegreeCompleted'" :display="false" :fieldsArray="questionnaireDetails"  :required="true" :optionslist="highestEduList" v-model="petition.beneficiaryInfo.highestDegreeCompleted" :tplsection="'beneficiaryInfo'"  :fieldName="'highestDegreeCompleted'"  formscope="casedetailsform"  label="What is the highest degree or level of school you have completed?" placeHolder="Select Highest Degree" />
                                                    <div class="vx-col w-full mb-0 ownership_editor" v-if="canRenderField('listOfCertifications',questionnaireDetails,false ,'beneficiaryInfo')">
                                                        <div class="form_group">
                                                            <quillTextEditor :fieldsArray="questionnaireDetails" :display="false" :wrapclass="''" :formscope="'casedetailsform'" v-model="petition.beneficiaryInfo.listOfCertifications" :tplsection="'beneficiaryInfo'" :tplkey="'listOfCertifications'" :fieldName="'listOfCertifications'"  :required="true"  :customValidNotRequire="true"
                                                                :label="'List your certifications, licenses, skills obtained through work experience, and educational certificates'" :placeHolder="'List your certifications, licenses, skills obtained through work experience, and educational certificates'"  :canSpellCheck="true"/>
                                                        </div>
                                                    </div>
                                                    <immiyesorno wrapclass=" " :required="checkFieldIsRequired({'key':'SSI','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :tplkey="'SSI'" :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="SSI"  v-model="petition.beneficiaryInfo.SSI" :tplsection="'beneficiaryInfo'"  :fieldName="'SSI'" 
                                                    label="Have you ever received Supplemental Security Income (SSI), Temporary Assistance for Needy Families (TANF), or State, Tribal, territorial, or local, cash benefit programs for income maintenance (often called 
“General Assistance” in the State context, but which also exist under other names)?"></immiyesorno>

                                                    <template v-if="canRenderField('SSI',questionnaireDetails,false ,'beneficiaryInfo') && checkProperty(petition, 'beneficiaryInfo', 'SSI')
                                                        && checkProperty(petition, 'beneficiaryInfo', 'benefitsRecAmounts') && checkProperty(petition['beneficiaryInfo'], 'benefitsRecAmounts', 'length')>0">
                                                        <div class="vx-col  w-full mb-5">
                                                            <div class="form-container "> 
                                                                <div class="vx-row">
                                                                    <div class="vx-col w-full prior-stay-list immigration_prior_list">
                                                                        <div class="vx-row delete-row" v-for="(benefit, index) in petition['beneficiaryInfo']['benefitsRecAmounts']" :key="index">
                                                                            <immiInput :fieldsArray="questionnaireDetails"  :tplsection="'beneficiaryInfo.benefitsRecAmounts'" :tplkey="'benefitReceived'" :dispaly="false" wrapclass="md:w-1/2" :cid="'benefitReceived'+index" :formscope="'casedetailsform'" v-model="benefit.benefitReceived" :required="true" :fieldName="'benefitReceived'+index" label="Benefit Received" placeHolder="Benefit Received"/>
                                                                            <datepickerField :fieldsArray="questionnaireDetails" :display="false" :tplkey="'startDate'" wrapclass="md:w-1/2" :tplsection="'beneficiaryInfo.benefitsRecAmounts'"  v-model="benefit.startDate" :required="true" :dateEnableTo="new Date()" @input="clearBenefitDateField(benefit, index)"  :formscope="'casedetailsform'"   :fieldName="'startDate' + index" label="Start Date" :validationRequired="true" />
                                                                            <datepickerField :fieldsArray="questionnaireDetails"  :display="false" :tplkey="'endDate'" wrapclass="md:w-1/2" :tplsection="'beneficiaryInfo.benefitsRecAmounts'"   v-model="benefit.endDate" :isDisabled="!benefit.startDate" :dateEnableFrom="benefit.startDate" :formscope="'casedetailsform'" :required="false" :fieldName="'endDate'+index" label="End Date" :validationRequired="true"/>
                                                                            <immiInput :fieldsArray="questionnaireDetails" :onlyNumbers="true" :allowFloatingPoint="true" :maxLength="10" :tplsection="'beneficiaryInfo.benefitsRecAmounts'" :tplkey="'amount'" :dispaly="false" wrapclass="md:w-1/2" :cid="'amount'+index" :formscope="'casedetailsform'" v-model="benefit.amount" :required="true" :fieldName="'amount'+index" label="Amount($)" placeHolder="Amount"/>
                                                                            <div class="delete" v-if="checkProperty(petition['beneficiaryInfo'], 'benefitsRecAmounts', 'length')>1" @click="removeBenefitItem(index)">
                                                                                <a><img src="@/assets/images/main/delete-row-img.svg" /></a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="m-auto" vs-type="flex" vs-align="center" vs-lg="2" vs-sm="2">
                                                                <a @click="addBenefitItem()" class="add-more ml-0 mt-4" style="display:inline-block" type="filled">
                                                                    <span>+</span> More
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <immiyesorno wrapclass=" " :required="checkFieldIsRequired({'key':'longTermInstiAtGovtExpense','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :tplkey="'longTermInstiAtGovtExpense'" :display="false" :fieldsArray="questionnaireDetails" formscope="casedetailsform" cid="longTermInstiAtGovtExpense"  v-model="petition.beneficiaryInfo.longTermInstiAtGovtExpense" :tplsection="'beneficiaryInfo'"  :fieldName="'longTermInstiAtGovtExpense'" 
                                                    label="Have you ever received long-term institutionalization at government expense?"></immiyesorno>




                                                    <!-- <template v-if="canRenderField('longTermInstiAtGovtExpense',questionnaireDetails,false ,'beneficiaryInfo') && checkProperty(petition, 'beneficiaryInfo', 'longTermInstiAtGovtExpense')
                                                        && checkProperty(petition, 'beneficiaryInfo', 'periodOfInstutions') && checkProperty(petition['beneficiaryInfo'], 'periodOfInstutions', 'length')>0">
                                                        <div class="vx-col  w-full mb-5">
                                                            <div class="form-container "> 
                                                                <div class="vx-row">
                                                                    <div class="vx-col w-full prior-stay-list immigration_prior_list">
                                                                        <div class="vx-row delete-row" v-for="(institute, index) in petition['beneficiaryInfo']['periodOfInstutions']" :key="index">
                                                                            <immiInput :fieldsArray="questionnaireDetails"  :required="true" :tplsection="'beneficiaryInfo.periodOfInstutions'" :tplkey="'institutionName'" :dispaly="false" wrapclass="md:w-1/2" :cid="'institutionName'+index" :formscope="'casedetailsform'" v-model="institute.institutionName" :fieldName="'institutionName'+index" label="Institution Name" placeHolder="Institution Name"/>
                                                                                <selectField :tplkey="'stateDetails'" :display="false" :fieldsArray="questionnaireDetails"  :required="true" :optionslist="instituteStates" @input="searchLocations(index);institute.stateId = checkProperty(institute, 'stateDetails', 'id')" v-model="institute.stateDetails" :tplsection="'beneficiaryInfo.periodOfInstutions'"  :fieldName="'stateDetails'"  formscope="casedetailsform"  label="State" placeHolder="State" />
                                                                                <selectField :tplkey="'locationDetails'" :display="false" :fieldsArray="questionnaireDetails" :disabled="checkProperty(instituteLocations, 'length')<=0" :required="true" :optionslist="institute.instituteLocations" @input="institute.locationId = checkProperty(institute, 'locationDetails', 'id')" v-model="institute.locationDetails" :tplsection="'beneficiaryInfo.periodOfInstutions'"  :fieldName="'locationDetails'"  formscope="casedetailsform"  label="Location" placeHolder="Location" />

                                                                                
                                                                                
                                                                                <datepickerField :fieldsArray="questionnaireDetails"  :display="false" :tplkey="'dateFrom'" wrapclass="md:w-1/2" :tplsection="'beneficiaryInfo.periodOfInstutions'"  v-model="institute.dateFrom" :required="true" :dateEnableTo="new Date()"  :formscope="'casedetailsform'" @input="clearDependentField()"  :fieldName="'dateFrom' + index" label="Date From" :validationRequired="true" />
                                                                                <datepickerField :fieldsArray="questionnaireDetails"  :display="false" :tplkey="'dateTo'" wrapclass="md:w-1/2" :tplsection="'beneficiaryInfo.periodOfInstutions'"   v-model="institute.dateTo" :dateEnableFrom="institute.dateFrom" :formscope="'casedetailsform'" :required="true" :fieldName="'dateTo' + index" label="Date To" :validationRequired="true"/>
                                                                                <immiInput :fieldsArray="questionnaireDetails"  :required="true" :tplsection="'beneficiaryInfo.periodOfInstutions'" :tplkey="'reason'" :dispaly="false" wrapclass="md:w-1/2" :cid="'reason'+index" :formscope="'casedetailsform'" v-model="institute.reason"  :fieldName="'reason'+index" label="Reason" placeHolder="Reason"/>
                                                                            <div class="delete" v-if="checkProperty(petition['beneficiaryInfo'], 'periodOfInstutions', 'length')>1" @click="removeInstituteItem(index)">
                                                                                <a><img src="@/assets/images/main/delete-row-img.svg" /></a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="m-auto" vs-type="flex" vs-align="center" vs-lg="2" vs-sm="2">
                                                                <a @click="addInstituteItem()" class="add-more ml-0 mt-4" style="display:inline-block" type="filled">
                                                                    <span>+</span> More
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </template> -->
                                                    
                                                    <template v-if="canRenderField('longTermInstiAtGovtExpense',questionnaireDetails,false ,'beneficiaryInfo') && checkProperty(petition, 'beneficiaryInfo', 'longTermInstiAtGovtExpense')
                                                        && checkProperty(petition, 'beneficiaryInfo', 'periodOfInstutions') && checkProperty(petition['beneficiaryInfo'], 'periodOfInstutions', 'length')>0">
                                                        <div class="vx-col  w-full mb-5">
                                                            <div class="form-container "> 
                                                                <div class="vx-row">
                                                                    <div class="vx-col w-full prior-stay-list immigration_prior_list">
                                                                        <div class="delete-row" v-for="(institute, index) in petition['beneficiaryInfo']['periodOfInstutions']" :key="index">
                                                                            <periodOfInstituteForm :ref="'ben_periodOfInstutions'+index" :formscope="'casedetailsform'" :instituteStates="instituteStates" v-model="petition['beneficiaryInfo']['periodOfInstutions'][index]" :questionnaireDetails="questionnaireDetails" :tplsection="'beneficiaryInfo.periodOfInstutions'" :index="index"/>

                                                                            <div class="delete" v-if="checkProperty(petition['beneficiaryInfo'], 'periodOfInstutions', 'length')>1" @click="removeInstituteItem(index)">
                                                                                <a><img src="@/assets/images/main/delete-row-img.svg" /></a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="m-auto" vs-type="flex" vs-align="center" vs-lg="2" vs-sm="2">
                                                                <a @click="addInstituteItem()" class="add-more ml-0 mt-4" style="display:inline-block" type="filled">
                                                                    <span>+</span> More
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </template>














                                                </template>
                                            </template>

    
                                        </div>
                                    </div>
                                </vs-col>
                            </form>
                        </div>         
                        <div v-if="currentTab=='additional'" id="additional_dt">
                            <form data-vv-scope="additionalform" @submit.prevent="" @keydown.enter.prevent="">
                                <vs-col class="w-full p-0">
                                    <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                        NOTE: This questionnaire should be filled out completely and
                                        accurately. Kindly read the instructions carefully.
                                    </vs-alert>
    
                                </vs-col>
    
                                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container pt-10 form-container-questionnaire">
                                        <div class="vx-row">
                                            <i485AdditionalInformation  :tplsection="'beneficiaryInfo'" cid="ben_additionalInfo" formscope="additionalform" :countries="countries" :petition="petition" :fieldName="'additionalInfo'" :fieldsArray="questionnaireDetails" v-model="petition.beneficiaryInfo"    />
                                        </div>
                                    </div>
                                </vs-col>
                            </form>
                        </div>
                        <div v-if="currentTab=='household'" id="household_dt">
                            <form data-vv-scope="householdform" @submit.prevent="" @keydown.enter.prevent="">
                                <vs-col class="w-full p-0">
                                    <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                        NOTE: This questionnaire should be filled out completely and
                                        accurately. Kindly read the instructions carefully.
                                    </vs-alert>
                                </vs-col>
                                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container pt-10 form-container-questionnaire">
                                        <div class="vx-row">
                                            <immiInput :onlyNumbers="true" :allowFloatingPoint="true" :maxLength="10" :fieldsArray="questionnaireDetails" :display="false" :tplkey="'houseHoldNumber'" cid="houseHoldNumber" formscope="householdform" v-model="petition.beneficiaryInfo.houseHoldNumber" :required="true"  :fieldName="'houseHoldNumber'" label="What is the size of your household" placeHolder="What is the size of your household" :tplsection="'beneficiaryInfo'" />
                                           
                                           
                                           
                                            <div class="vx-col w-full mb-5 yesno-v2" v-if="canRenderField('houseHoldAnnualIncome',questionnaireDetails, false, 'beneficiaryInfo' )">
                                                <div class="custom-radio_sec">
                                                    <a class="switch-label">Indicate your annual household income.
                                                    </a><em v-if="checkFieldIsRequired({'key':'houseHoldAnnualIncome','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" >*</em>
                                                    <ul class="custom-radio custom-radio_v2">
                                                        <li>
                                                            <vs-radio ref="1Consulate" v-model="petition.beneficiaryInfo.houseHoldAnnualIncome" vs-name="$0-27,000" :vs-value="'1'"  >$0-27,000</vs-radio>
                                                        </li>
                                                        <li>
                                                            <vs-radio ref="Pre-flight_inspection" v-model="petition.beneficiaryInfo.houseHoldAnnualIncome" vs-name="$27,001-52,000" :vs-value="'2'" >$27,001-52,000</vs-radio>
                                                        </li> 
                                                        <li>
                                                            <vs-radio ref="_Preflight_inspection" v-model="petition.beneficiaryInfo.houseHoldAnnualIncome" vs-name="$52,001-85,000" :vs-value="'3'" >$52,001-85,000</vs-radio>
                                                        </li> 
                                                        <li>
                                                            <vs-radio ref="_Pre-flightinspection" v-model="petition.beneficiaryInfo.houseHoldAnnualIncome" vs-name="$85,001-141,000" :vs-value="'4'" >$85,001-141,000</vs-radio>
                                                        </li> 
                                                        <li>
                                                            <vs-radio ref="_Port_of_Entrys" v-model="petition.beneficiaryInfo.houseHoldAnnualIncome" vs-name="Over $141,000" :vs-value="'5'" >Over $141,000</vs-radio>
                                                        </li> 
                                                    </ul>
                                                    <div class="form_group" v-if="checkFieldIsRequired({'key':'houseHoldAnnualIncome','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })">
                                                        <input type="hidden" :name="'otherNames_houseHoldAnnualIncome'" v-validate="'required'"  data-vv-as="Field"  v-model="petition.beneficiaryInfo.houseHoldAnnualIncome">
                                                        <span v-show="errors.has( 'householdform.otherNames_houseHoldAnnualIncome')" class="text-danger text-sm" style="">*Field is required</span>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="vx-col w-full mb-5 yesno-v2" v-if="canRenderField('houseHoldAnnualAssets',questionnaireDetails, false, 'beneficiaryInfo' )">
                                                <div class="custom-radio_sec">
                                                    <a class="switch-label">Identify the total value of your household assets.
                                                    </a><em v-if="checkFieldIsRequired({'key':'houseHoldAnnualAssets','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" >*</em>
                                                    <ul class="custom-radio custom-radio_v2">
                                                        <li>
                                                            <vs-radio ref="11Consulate" v-model="petition.beneficiaryInfo.houseHoldAnnualAssets" vs-name="$0-18,400" :vs-value="'1'"  >$0-18,400</vs-radio>
                                                        </li>
                                                        <li>
                                                            <vs-radio ref="1Pre-flight_inspection" v-model="petition.beneficiaryInfo.houseHoldAnnualAssets" vs-name="$18,401-136,000" :vs-value="'2'" >$18,401-136,000</vs-radio>
                                                        </li> 
                                                        <li>
                                                            <vs-radio ref="_1Preflight_inspection" v-model="petition.beneficiaryInfo.houseHoldAnnualAssets" vs-name="$136,001-321,400" :vs-value="'3'" >$136,001-321,400</vs-radio>
                                                        </li> 
                                                        <li>
                                                            <vs-radio ref="_1Pre-flightinspection" v-model="petition.beneficiaryInfo.houseHoldAnnualAssets" vs-name="$321,401-707,100" :vs-value="'4'" >$321,401-707,100</vs-radio>
                                                        </li> 
                                                        <li>
                                                            <vs-radio ref="_1Port_of_Entrys" v-model="petition.beneficiaryInfo.houseHoldAnnualAssets" vs-name="Over $707,100" :vs-value="'5'" >Over $707,100</vs-radio>
                                                        </li> 
                                                    </ul>
                                                    <div class="form_group" v-if="checkFieldIsRequired({'key':'houseHoldAnnualAssets','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })">
                                                        <input type="hidden" :name="'otherNames_houseHoldAnnualAssets'" v-validate="'required'"  data-vv-as="Field"  v-model="petition.beneficiaryInfo.houseHoldAnnualAssets">
                                                        <span v-show="errors.has( 'householdform.otherNames_houseHoldAnnualAssets')" class="text-danger text-sm" style="">*Field is required</span>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="vx-col w-full mb-5 yesno-v2" v-if="canRenderField('houseHoldAnnualliabilities',questionnaireDetails, false, 'beneficiaryInfo' )">
                                                <div class="custom-radio_sec">
                                                    <a class="switch-label"> Identify the total value of your household liabilities (including both secured and unsecured liabilities).
                                                    </a><em v-if="checkFieldIsRequired({'key':'houseHoldAnnualliabilities','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" >*</em>
                                                    <ul class="custom-radio custom-radio_v2">
                                                        <li>
                                                            <vs-radio ref="211Consulate" v-model="petition.beneficiaryInfo.houseHoldAnnualliabilities" vs-name="$0" :vs-value="'1'"  >$0</vs-radio>
                                                        </li>
                                                        <li>
                                                            <vs-radio ref="12Pre-flight_inspection" v-model="petition.beneficiaryInfo.houseHoldAnnualliabilities" vs-name="$1-10,100" :vs-value="'2'" >$1-10,100</vs-radio> 
                                                        </li> 
                                                        <li>
                                                            <vs-radio ref="_12Preflight_inspection" v-model="petition.beneficiaryInfo.houseHoldAnnualliabilities" vs-name="$10,101-57,700" :vs-value="'3'" >$10,101-57,700</vs-radio>
                                                        </li> 
                                                        <li>
                                                            <vs-radio ref="_12Preflight_inspection" v-model="petition.beneficiaryInfo.houseHoldAnnualliabilities" vs-name="$57,701-186,800" :vs-value="'4'" >$57,701-186,800</vs-radio>
                                                        </li> 
                                                        <li>
                                                            <vs-radio ref="_12Port_of_Entrys" v-model="petition.beneficiaryInfo.houseHoldAnnualliabilities" vs-name="Over $186,800" :vs-value="'5'" >Over $186,800</vs-radio>
                                                        </li> 
                                                    </ul>
                                                    <div class="form_group" v-if="checkFieldIsRequired({'key':'houseHoldAnnualliabilities','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })">
                                                        <input type="hidden" :name="'otherNames_houseHoldAnnualliabilities'" v-validate="'required'"  data-vv-as="Field"  v-model="petition.beneficiaryInfo.houseHoldAnnualliabilities">
                                                        <span v-show="errors.has( 'householdform.otherNames_houseHoldAnnualliabilities')" class="text-danger text-sm" style="">*Field is required</span>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </vs-col>
                            </form>
                        </div>       
    <!-------------------------------------------------------------------------------->
                        <div v-if="currentTab=='education' && canRenderField('educations', questionnaireDetails ,false,'beneficiaryInfo.educations')" id="education_details">
                            <form data-vv-scope="educationform" @submit.prevent="" @keydown.enter.prevent="">
                                <vs-col class="w-full p-0">
                                    <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                        After your 12th grade – Starting from the most recent degree first
    
                                    </vs-alert>
    
                                </vs-col>
    
                                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container pt-10 form-container-questionnaire">
                                        <div class="vx-row">
                                            <!-- @input="updateEducationDegree" -->
                                            <immiyesorno @input="disableCountryUsa();removeCOuntryUSA()" :cid="'hasMasterDegreeInUS'" formscope="educationform" :required="checkFieldIsRequired({'key':'hasMasterDegreeInUS','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false"  :tplkey="'hasMasterDegreeInUS'" :fieldsArray="questionnaireDetails"   v-model="petition.beneficiaryInfo.hasMasterDegreeInUS" :tplsection="'beneficiaryInfo'"  :fieldName="'hasMasterDegreeInUS'"   label="Do you have Masters degree in United States?"></immiyesorno>
                                            <immieducations  ref="beneficairy_education" :prefillCountryInQuestionnaire="prefillCountryInQuestionnaire" :tplsection="'beneficiaryInfo.educations'" :petition="petition" :countries="countries" :fieldsArray="questionnaireDetails"  cid="ben_educations" formscope="educationform" v-model="petition.beneficiaryInfo.educations" :fieldName="'educations'"  />
    
                                        </div>
    
                                    </div>
                                </vs-col>
                            </form>
                        </div>
                                    
                        <div v-if="currentTab=='employment'" id="employment_details">
                            <form data-vv-scope="employmentform" @submit.prevent="" @keydown.enter.prevent="">
                                <template v-if="canRenderField('anyOtherPersonEmployedInUS', questionnaireDetails ,false,'beneficiaryInfo' ) || canRenderField('prevEmploymentInfo', questionnaireDetails ,false,'beneficiaryInfo.prevEmploymentInfo') ">
                                    <vs-col class="w-full p-0">
                                        <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                            Provide your current and previous employment details, starting from the most recent first.
                                        </vs-alert>
        
                                    </vs-col>
                                        
                                    <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                        <div class="form-container form-container-questionnaire form-container-employment">
                                            <div class="vx-row">
                                                <!-- <h3 class="small-header emp_det_header">Employment Details</h3> -->
                                                <div class="empyes_no">
                                                    <immiyesorno :wrapclass="'yesnomar'" :cid="'anyOtherPersonEmployedInUS'" formscope="employmentform" :required="checkFieldIsRequired({'key':'anyOtherPersonEmployedInUS','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false" :tplkey="'anyOtherPersonEmployedInUS'" :fieldsArray="questionnaireDetails"   v-model="petition.beneficiaryInfo.anyOtherPersonEmployedInUS" :tplsection="'beneficiaryInfo'"  :fieldName="'anyOtherPersonEmployedInUS'"   label="Have you ever been employed?"></immiyesorno>
                                                </div>
                                                <template v-if="(petition.beneficiaryInfo && petition.beneficiaryInfo.anyOtherPersonEmployedInUS && canRenderField('anyOtherPersonEmployedInUS', questionnaireDetails ,false,'beneficiaryInfo' ) && canRenderField('prevEmploymentInfo', questionnaireDetails ,false,'beneficiaryInfo.prevEmploymentInfo')) || (!canRenderField('anyOtherPersonEmployedInUS',questionnaireDetails,false ,'beneficiaryInfo')&& canRenderField('prevEmploymentInfo', questionnaireDetails ,false,'beneficiaryInfo.prevEmploymentInfo'))  ">
                                                    <immiemployment :prefillCountryInQuestionnaire="prefillCountryInQuestionnaire" :petition="petition" :countries="countries" :fieldsArray="questionnaireDetails"  cid="ben_prevEmploymentInfo" formscope="employmentform" v-model="petition.beneficiaryInfo.prevEmploymentInfo" :tplsection="'beneficiaryInfo.prevEmploymentInfo'"  :fieldName="'prevEmploymentInfo'"  />
                                                </template>
                                            </div>
        
                                        </div>
                                    </vs-col>
                                </template>
                                <template v-if=" canRenderField('prevEmploymentOutsideUS', questionnaireDetails ,false,'beneficiaryInfo.prevEmploymentOutsideUS') || canRenderField('haveYouEverEmployed', questionnaireDetails ,false,'beneficiaryInfo')">
                                    <vs-col class="w-full p-0 mart30">
                                        <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                            Last Employer outside of the United States for more than one year.
                                        </vs-alert>
        
                                    </vs-col>
                                    <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                        <div class="form-container form-container-questionnaire form-container-employment">
                                            <div class="vx-row">
                                                <div class="empyes_no">
                                                    <immiyesorno :wrapclass="'yesnomar'" :cid="'haveYouEverEmployed'" formscope="employmentform" :required="checkFieldIsRequired({'key':'haveYouEverEmployed','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false" :tplkey="'haveYouEverEmployed'" :fieldsArray="questionnaireDetails"   v-model="petition.beneficiaryInfo.haveYouEverEmployed" :tplsection="'beneficiaryInfo'"  :fieldName="'haveYouEverEmployed'"   label="Have you ever been employed Outside US?"></immiyesorno>
                                                </div>
                                                <template v-if="petition.beneficiaryInfo.haveYouEverEmployed">
                                                    <immiemployment :prefillCountryInQuestionnaire="prefillCountryInQuestionnaire" :petition="petition" :countries="countries" :fieldsArray="questionnaireDetails"  cid="ben_prevEmploymentOutsideUS" formscope="employmentform" v-model="petition.beneficiaryInfo.prevEmploymentOutsideUS" :tplsection="'beneficiaryInfo.prevEmploymentOutsideUS'"  :fieldName="'prevEmploymentOutsideUS'"  />
                                                </template>
                                            </div>
                                        </div>
                                    </vs-col>  
                                </template>
                            </form>
    
                        </div>
                        <div v-if="currentTab=='parent' && (canRenderField('motherInfo', questionnaireDetails ,false,'motherInfo') || canRenderField('fatherInfo', questionnaireDetails ,false,'fatherInfo'))" id="parent_details">
                            <form data-vv-scope="parentform" @submit.prevent="" @keydown.enter.prevent="">
                                <template v-if=" canRenderField('fatherInfo', questionnaireDetails ,false,'fatherInfo')">
                                    <vs-col class="w-full p-0">
                                        <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                            Provide your father details, starting from the most recent first.
                                        </vs-alert>
                                    </vs-col>
                                    <vs-col class="m-auto float-none p-0" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                        <div class="form-container form-container-questionnaire form_container_485">
                                            <div class="vx-row">
                                                <div class="vx-col w-full">
                                                    <parentForm :countriesWithoutUS="countriesWithoutUS"  :petition="petition" :countries="countries" :fieldsArray="questionnaireDetails" cid="ben_fatherInfo"  formscope="parentform"  v-model="petition.fatherInfo" :tplsection="'fatherInfo'"  :fieldName="'fatherInfo'"   />
                                                </div>
                                            </div>
                                        </div>
                                    </vs-col>
                                </template>
                                <template v-if=" canRenderField('motherInfo', questionnaireDetails ,false,'motherInfo')">
                                    <vs-col class="w-full p-0 mart20" >
                                        <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                            Provide your mother details, starting from the most recent first.
                                        </vs-alert>
                                    </vs-col>
                                    <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" >
                                        <div class="form-container form-container-questionnaire form_container_485">
                                            <div class="vx-row">
                                                <div class="vx-col w-full">
                                                    <parentForm :countriesWithoutUS="countriesWithoutUS" :countries="countries" :fieldsArray="questionnaireDetails" :petition="petition" v-model="petition.motherInfo" :parentType="'Mother Information'" cid="ben_motherInfo"  :tplsection="'motherInfo'"  :fieldName="'motherInfo'"  formscope="parentform"  />
                                                </div>    
                                            </div>
                                        </div>
                                    </vs-col>
                                </template>
                                </form>
                        </div> 
                        <div v-if="currentTab=='financial' && (canRenderField('benfAssets', questionnaireDetails ,false,'beneficiaryInfo.benfAssets') || canRenderField('benfIncome', questionnaireDetails ,false,'beneficiaryInfo.benfIncome'))" 
                        id="financial_info">
                            <form data-vv-scope="financialform" @submit.prevent="" @keydown.enter.prevent="">
                                <template v-if="canRenderField('benfAssets', questionnaireDetails ,false,'beneficiaryInfo.benfAssets') || canRenderField('benfIncome', questionnaireDetails ,false,'beneficiaryInfo.benfIncome')">
                                    <vs-col class="w-full p-0">
                                        <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                            Provide your Financial details.
                                        </vs-alert>
                                    </vs-col>
                                    <vs-col class="m-auto float-none p-0" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                        <div class="form-container form-container-questionnaire form_container_485">
                                            <div class="vx-row">
                                                <div class="vx-col w-full">
                                                    <financialInfoForm :countriesWithoutUS="countriesWithoutUS"  :petition="petition" :countries="countries" :fieldsArray="questionnaireDetails" cid="ben_financialInfo"  formscope="financialform"  v-model="petition"/>
                                                </div>
                                            </div>
                                        </div>
                                    </vs-col>
                                </template>
                            </form>
                        </div> 
    
                        <div v-if="currentTab=='dependentsinfo' " id="dependentsinfo_details">
                            <form data-vv-scope="dependentsinfoform" @submit.prevent="" @keydown.enter.prevent="">
                                <!-- hasAnyDependetsinUStoFileH4 -->
                                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container pt-10 form-container-questionnaire">
                                        <div class="vx-row">
                                            <immiyesorno :cid="'hasAnyDependetsinUStoFileH4'"  formscope="dependentsinfoform" :required="checkFieldIsRequired({'key':'hasAnyDependetsinUStoFileH4','section':'beneficiaryInfo', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false" :tplkey="'hasAnyDependetsinUStoFileH4'" :fieldsArray="questionnaireDetails" v-model="petition.beneficiaryInfo.hasAnyDependetsinUStoFileH4"  :tplsection="'beneficiaryInfo'"  :fieldName="'hasAnyDependetsinUStoFileH4'"  label="Do you have any dependents currently in USA for whom you wish to file H4 Visa?"></immiyesorno>
                                            <template v-if="(petition.beneficiaryInfo && petition.beneficiaryInfo.hasAnyDependetsinUStoFileH4 && canRenderField('hasAnyDependetsinUStoFileH4', questionnaireDetails ,false,'beneficiaryInfo' ) ) || !canRenderField('hasAnyDependetsinUStoFileH4',questionnaireDetails,false ,'beneficiaryInfo')  ">
                                                
                                                <immiyesorno :cid="'h4Required'" formscope="dependentsinfoform" :required="checkFieldIsRequired({'key':'h4Required','section':'dependentsInfo.spouse', 'fieldsArray':questionnaireDetails, 'required':true })" :wrapclass="'h4_ead_label'" @input="spouseH4();checkMarriageCerti()" :display="false" :tplkey="'h4Required'" :fieldsArray="questionnaireDetails" v-model="petition.dependentsInfo.spouse.h4Required"  :tplsection="'dependentsInfo.spouse'"  :fieldName="'h4Required'"  label="H4 required for spouse?"></immiyesorno>
                                                
                                                <immiyesorno :cid="'hasSpouse'" formscope="dependentsinfoform" :required="checkFieldIsRequired({'key':'hasSpouse','section':'dependentsInfo.spouse', 'fieldsArray':questionnaireDetails, 'required':true })" :wrapclass="'h4_ead_label'" @input="spouseH4();checkMarriageCerti()" :display="false" :tplkey="'hasSpouse'" :fieldsArray="questionnaireDetails" v-model="petition.dependentsInfo.spouse.hasSpouse"  :tplsection="'dependentsInfo.spouse'"  :fieldName="'hasSpouse'"  label="Do you want to fill spouse information?"></immiyesorno>
                                                <immiyesorno :cid="'l2Required'" formscope="dependentsinfoform" :required="checkFieldIsRequired({'key':'l2Required','section':'dependentsInfo.spouse', 'fieldsArray':questionnaireDetails, 'required':true })" :wrapclass="'h4_ead_label'" @input="spouseH4();checkMarriageCerti()" :display="false" :tplkey="'l2Required'" :fieldsArray="questionnaireDetails" v-model="petition.dependentsInfo.spouse.l2Required"  :tplsection="'dependentsInfo.spouse'"  :fieldName="'l2Required'"  label="L2 required for spouse?"></immiyesorno>

                                                <div class="vx-col w-full">
                                                    <div class="dependent-block_wrap" v-if="checkProperty(petition ,'dependentsInfo' ,'spouse' ) && petition.dependentsInfo && petition.dependentsInfo.spouse && petition.dependentsInfo.spouse.firstName!='' && petition.dependentsInfo.spouse.firstName!=null &&
                                                     (checkProperty(petition.dependentsInfo ,'spouse' ,'h4Required') || checkProperty(petition.dependentsInfo ,'spouse' ,'hasSpouse') || checkProperty(petition.dependentsInfo ,'spouse' ,'l2Required'))">
                                                        <div class="dependent-block">
                                                            <div class="dependent-title">
                                                                <h3>
                                                                    <!-- {{petition.dependentsInfo.spouse | formatFullname}} -->
                                                                    {{ formatFullname(petition.dependentsInfo.spouse) }}
                                                                </h3>
                                                                <ul>
                                                                    <li @click="editSpouse(petition.dependentsInfo.spouse)">
                                                                        <a><img src="@/assets/images/main/edit_icon.svg" />
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div class="dependent_details">
                                                                <ul>
                                                                    <li v-if="petition.dependentsInfo.spouse.dateOfBirth"> Date of Birth <span>{{petition.dependentsInfo.spouse.dateOfBirth | formatDate}}</span></li>
                                                                    <li v-if="petition.dependentsInfo.spouse.physicalAddress && petition.dependentsInfo.spouse.physicalAddress.countryDetails && petition.dependentsInfo.spouse.physicalAddress.countryDetails.name"> Country <span>{{petition.dependentsInfo.spouse.physicalAddress.countryDetails.name}}</span></li>
            
                                                                </ul>
            
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <immiyesorno :cid="'h4Required_h4Required'" formscope="dependentsinfoform" :required="checkFieldIsRequired({'key':'h4Required','section':'dependentsInfo.childrens', 'fieldsArray':questionnaireDetails, 'required':true })" @input="childH4(petition.h4RequiredForChild)" :wrapclass="'h4_ead_label'" :display="false" :tplkey="'h4Required'" :fieldsArray="questionnaireDetails" v-model="petition.h4RequiredForChild" :tplsection="'dependentsInfo.childrens'"  :fieldName="'h4Required'"    label="H4 required for children?"></immiyesorno>
                                                <immiyesorno :cid="'hasChildren_hasChildren'" formscope="dependentsinfoform" :required="checkFieldIsRequired({'key':'hasChildren','section':'dependentsInfo.childrens', 'fieldsArray':questionnaireDetails, 'required':true })" @input="childH4(petition.hasChildren)" :wrapclass="'h4_ead_label'" :display="false" :tplkey="'hasChildren'" :fieldsArray="questionnaireDetails" v-model="petition.hasChildren" :tplsection="'dependentsInfo.childrens'"  :fieldName="'hasChildren'"    label="Do you want to fill children information?"></immiyesorno>
                                                <immiyesorno :cid="'hasChildren_l2Required'" formscope="dependentsinfoform" :required="checkFieldIsRequired({'key':'l2Required','section':'dependentsInfo.childrens', 'fieldsArray':questionnaireDetails, 'required':true })" @input="childH4(petition.l2Required)" :wrapclass="'h4_ead_label'" :display="false" :tplkey="'l2Required'" :fieldsArray="questionnaireDetails" v-model="petition.l2Required" :tplsection="'dependentsInfo.childrens'"  :fieldName="'l2Required'"    label="L2 required for children?"></immiyesorno>

                                                <template v-if="petition.dependentsInfo.childrens && petition.dependentsInfo.childrens.length > 0 && petition.dependentsInfo.childrens[0].firstName!='' && petition.dependentsInfo.childrens[0].firstName!=null">
                                                    <div class="vx-col w-full">
        
                                                        <div class="dependent-block_wrap">
        
                                                            <template v-for="(children, index) in petition.dependentsInfo.childrens">
                                                                <div class="dependent-block" v-if="children.saved" :key="index">
                                                                    <div class="dependent-title" :key="index">
                                                                        <h3>
                                                                            {{ formatFullname(children) }}
                                                                            <!-- {{ children.name }} -->
                                                                            <!-- {{children | formatFullname}}  physicalAddress -->
                                                                        </h3>
                                                                        <ul>
                                                                            <li @click="editChildren(children,index)">
                                                                                <a><img src="@/assets/images/main/edit_icon.svg" />
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
        
                                                                    <div class="dependent_details">
                                                                        <ul>
                                                                            <li v-if="children.dateOfBirth"> Date of Birth <span>{{children.dateOfBirth | formatDate}}</span></li>
                                                                            <li v-if="
                                                                            children.physicalAddress.countryDetails && children.physicalAddress.countryDetails.name
                                                                            
                                                                            "> Country <span>{{children.physicalAddress.countryDetails.name}}</span></li>
        
                                                                        </ul>
        
                                                                    </div>
                                                                </div>
        
                                                            </template>
        
                                                        </div>
        
                                                    </div>
        
                                                </template>
                                                <div style="margin-left:1rem;" vs-type="flex" vs-align="left" vs-lg="2" vs-sm="2" v-if="petition.h4RequiredForChild || petition.hasChildren || petition.l2Required ">
                                                    <a @click="addchildren" class="add-more ml-0" style="display:inline-block" type="filled">
                                                        <span>+</span> Add Child
                                                    </a>
                                                </div>
                                            </template>
    
                                        </div>
    
                                    </div>
                                </vs-col>
                            </form>
    
                        </div>
    
                        <div v-if="currentTab=='documents'" id="documents_details">
                           
                            <form data-vv-scope="documentsform" @submit.prevent="" @keydown.enter.prevent="">


                                <vs-col class="w-full p-0">
                                    <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                        NOTE: This questionnaire should be filled out completely and
                                        accurately. Kindly read the instructions carefully.
                                    </vs-alert>
                                    <fileUploadNote :fileNote="true" />
                                </vs-col>
                                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container pt-10 form-container-questionnaire">
                                        <div class="vx-row">
                                        <casedocumentslist @emitUploadingAction="emitUploadingAction" :docMainCategory="'bendocslist'" :docslist="bendocslist" :petition="petition" formscope="documentsform" :fieldsArray="questionnaireDetails" v-model="petition.documents" :tplsection="'documents'"  :fieldName="''" ></casedocumentslist>
                                        </div>
                                    </div>
                                    
                                </vs-col>

    
                            </form>
    
                        </div>
                        <div v-if="currentTab=='wageInfo'" id="parent_details">
                            <form data-vv-scope="wageInfoform" @submit.prevent="" @keydown.enter.prevent="">
                                <template >
                                    <vs-col class="w-full p-0">
                                        <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                            Provide your Wages as per W2.
                                        </vs-alert>
                                    </vs-col>
                                    <vs-col class="m-auto float-none p-0" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                        <div class="form-container form-container-questionnaire pad0">
                                            <div class="vx-row">
                                                <div class="vx-col w-full">
                                                    <w2Information formscope="wageInfoform"   v-model="wageInformationArray" />
                                                </div>
                                            </div>
                                        </div>
                                    </vs-col>
                                </template>
                                </form>
                        </div> 
    
                        <!-------------485 Tabs-------------->
    
                        <div v-if="currentTab=='immigration' " id="immigration_details">
                            <!-- {{ canRenderField('curNonImmigrantVisaStatus', questionnaireDetails ,false,'beneficiaryInfo') }} -->
                            <form data-vv-scope="immigrationform" @submit.prevent="" @keydown.enter.prevent="">
                                <immigrationForm  v-model="petition.beneficiaryInfo" :tplsection="'beneficiaryInfo'"  :fieldName="''"   :formscope="'immigrationform'" :countries="countries" :fieldsArray="questionnaireDetails" :petition="petition" > </immigrationForm>
                            </form>
                        </div>
                        
                      <div v-if="currentTab=='assets&financials' " id="assetsFinancials_details">
                            <form data-vv-scope="assetsfinaform" @submit.prevent="" @keydown.enter.prevent="">
                                <!-----financialForm,
         assestsForm,
         liabilitiesForm,
         publicBenefitsForm,-->
                               
                                <assestsForm  v-model="petition['beneficiaryInfo']['assets']" :tplsection="'beneficiaryInfo'"  :fieldName="'assets'"  :assestsList="assestsList"  :formscope="'assetsfinaform'" :countries="countries" :fieldsArray="questionnaireDetails" :petition="petition" />
                                <financialForm  v-model="petition['beneficiaryInfo']['financials']"  :tplsection="'beneficiaryInfo'"  :fieldName="'financials'"  :formscope="'assetsfinaform'" :countries="countries" :fieldsArray="questionnaireDetails" :petition="petition" />
                                 
                                <liabilitiesForm  v-model="petition['beneficiaryInfo']['liabilitiesDebts']" :tplsection="'beneficiaryInfo'"  :fieldName="'liabilitiesDebts'"  :liability_list="liability_list" :formscope="'assetsfinaform'" :countries="countries" :fieldsArray="questionnaireDetails" :petition="petition" />
                                <publicBenefitsForm  v-model="petition['beneficiaryInfo']['financials']" :tplsection="'beneficiaryInfo'"  :fieldName="'publicBenefits'"  :public_benefits="public_benefits"  :formscope="'assetsfinaform'" :countries="countries" :fieldsArray="questionnaireDetails" :petition="petition" />
                                 
                                </form>
                        </div>
                         
                        <div v-if="['Update', 'Review & Submit', 'Submit'].indexOf(actiontype)>-1 && [50,51].indexOf(getUserRoleId)>-1&&checkProperty(configDetails ,'acceptConsentAndTAndC')!=false">
                            <form data-vv-scope="consentTermsForm" @submit.prevent="" @keydown.enter.prevent="">
                                <div class="m-auto float-none" :class="{'pl-5':currentTab != 'documents'}" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container pt-0 form-container-questionnaire">
                                        <div class="vx-row">
                                            <div class="vx-col w-full">
                                                <label class="switch-label"> 
                                                    <span @click="openConsentContent('termsAndConditions')" class="terms_n_cond_lbl">Terms and Conditions</span> and <span @click="openConsentContent('consent')" class="terms_n_cond_lbl">Consent </span>to the collection and processing of my personal data for immigration case(s), including any applicable necessary filings.</label>
                                            </div>
                                            <div class="vs-col">
                                                <div class="form_group custom-form-label custom-cx-box">
                                                    <vs-checkbox
                                                    v-model="consentChecked"
                                                    data-vv-as="adjustmentOfI485Status"
                                                    name="consentChecked">I have read and understand the above
                                                    </vs-checkbox>
                                                </div>
                                                <input type="hidden" :name="'select_PrimaryH1BHolder'" v-validate="'required'" data-vv-as="Field"
                                                v-model="getConsentVal">
                                                <span class="text-danger text-sm pt-5" style="top:46px"
                                                v-show="errors.has('consentTermsForm.select_PrimaryH1BHolder')">*You must read and understand the above</span>
                                            </div>
                                            <div class="vs-col">
                                                <div class="form_group custom-form-label custom-cx-box">
                                                    <vs-checkbox
                                                    v-model="termsAndConditionsChecked"
                                                    data-vv-as="adjustmentOfI485Status"
                                                    name="termsAndConditionsChecked">I agree to the above
                                                    </vs-checkbox>
                                                </div>
                                                <input type="hidden" :name="'select_PrimaryH1BHoer'" v-validate="'required'" data-vv-as="Field"
                                                v-model="getTermsVal">
                                                <span class="text-danger text-sm pt-5" style="top:46px"
                                                v-show="errors.has('consentTermsForm.select_PrimaryH1BHoer')">*You must agree to the above</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="questionnaire_footer">
                    <div class="d-flex">
                        <vs-button v-if="getIndexOfActivetab!=1" @click="goBack()" class="questionnaire_btn" type="filled">Back</vs-button>
                    </div>
                    <div class="d-flex">
                        <vs-button @click="saveCase(true);" :disabled="documentUploading" class="questionnaire_btn" type="filled">Save</vs-button>
                        <vs-button color="success" @click="submitCase();" :disabled="documentUploading" class="save questionnaire_btn" type="filled">{{actiontype}}</vs-button>
    
                    </div>
                </div>
            </div>
    
        </div>
    
        <div class="custom_modal_sec preview_questionarie" :class="{ modalopen: questionnairePreview }">
            <div class="custom_modal_overlay" ></div>
    
            <div class="custom_modal_cnt">
                <div class="modal_title">
                    <h2>Questionnaire Review</h2>
                    <span @click="questionnairePreview = false">
                        <x-icon size="1.5x" class="close"></x-icon>
                    </span>
                </div>
                <div class="modal_cnt preview_content new_questionnaire_review">
                    
                    
              
                    
                    <VuePerfectScrollbar ref="mainSidebarPs1" :settings="settings">
                        
                        <PetitionDetails v-if="questionnairePreview" :loadedFromPreview="true" :fieldsArrayDetails="questionnaireDetails" :previewData="questionnairePreviewData" />
                    </VuePerfectScrollbar>
                
                </div>
                <div class="questionnaire_footer">
                    <div class="d-flex">
                        <vs-button @click="questionnairePreview = false" class="cancel questionnaire_btn" type="filled">Cancel
                        </vs-button>
                        <vs-button v-if="false" @click="saveCase(false,false);" class="save questionnaire_btn" type="filled">Submit </vs-button>
                        <vs-button  @click="tempSave =false;showMessage = false; tempSave =false;showMessage = false; toggleBenProfileCOnformPopUp(true)" class="save questionnaire_btn" type="filled">Submit </vs-button>
                        
                    </div>
                </div>
            </div>
        </div>
    
        <vs-popup class="holamundo success-popups" title="Your registration is complete." :active.sync="SuccessQuestionnaire">
            <figure>
                <img src="@/assets/images/main/icon-note.svg" alt="login" class="mx-auto" />
            </figure>
            <h2 class="title">Questionnaire submitted successfully!</h2>
            <template v-if="checkProperty($route ,'name') !='fill-questionnaire' && checkProperty($route ,'name') !='fill-perm-questionnaire' ">
            <p v-if="getUserData && checkProperty(getUserData['tenantDetails']['typeDetails'],'id') == 2">
                It will be reviewed by the Admin and appropriate actions will be
                taken soon. 
            </p>
            <p v-if="getUserData && (checkProperty(getUserData['tenantDetails']['typeDetails'],'id') == 1)">
                It will be reviewed by the petitioner and appropriate actions will be
                taken soon. 
            </p>
        </template>
        </vs-popup>
        <vs-popup class="holamundo main-popup qcomment" title="Comment" :active.sync="commentPopUp">
            <form data-vv-scope="commentForm" @submit.prevent="" @keydown.enter.prevent="">
                <div class="form-container" @click="formerrors.msg = ''">
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <div class="form_group">
                                <label class="form_label">Comments </label>
                                <!-- <vs-textarea data-vv-as="Comments" v-validate="'required'" v-model="comments" name="comments" class="w-full" /> -->
                                <ckeditor data-vv-as="Comments" v-validate="'required'" v-model="comments" name="comments" class="w-full"   :editor="editor" :config="editorConfig"></ckeditor>
                                <span class="text-danger text-sm" v-show="errors.has('commentForm.comments')">{{ errors.first("commentForm.comments") }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="text-danger text-sm formerrors" v-show="formerrors.msg">
                        <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal" icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
                    </div>
                </div>
                <div class="popup-footer relative">
                    <span class="loader" v-if="submiTing"><img src="@/assets/images/main/loader.gif" /></span>
    
                    <vs-button :disabled="comments == '' || comments.trim() == '' || submiTing" color="success" @click="formSubmitted(false)" class="save" type="filled">Submit</vs-button>
                </div>
            </form>
        </vs-popup>
    
        <div class="custom_modal_sec spouse_doc documents__modal" :class="{ modalopen: spouseModalForm }">
            <div class="custom_modal_overlay"></div>
            <!-- v-if="spouseModalForm" -->
            <div class="custom_modal_cnt">
                <div class="modal_title">
                    <h2>Spouse Information</h2>
                    <span class="close" v-if="!documentUploading" @click="toggleSpouseForm(false)">
                        <em class="material-icons">close</em>
                    </span>
                </div>
                <div class="modal_cnt">
                    <VuePerfectScrollbar ref="mainSidebarPs" :settings="settings">
                        <form data-vv-scope="dependentsInfoformmodal" @submit.prevent="" @keydown.enter.prevent="" >
                            <personalinfo :instituteStates="instituteStates" :tplsection="'dependentsInfo.spouse'" :countriesWithoutUS="countriesWithoutUS" :eye_colorList="eye_colorList" :marital_statuses="fileredMartialList"  :races_list="races_list"  :hair_colorsList="hair_colorsList" :feetList="feetList" :inchesList="inchesList"  :visastatuses="visastatuses" :countries="countries" formscope="dependentsInfoformmodal" :petition="petition" :fieldsArray="questionnaireDetails" v-model="spouse"></personalinfo>
                            <template  v-if="(canRenderField('prevEmploymentInfo', questionnaireDetails ,false,'dependentsInfo.spouse.prevEmploymentInfo') || canRenderField('anyOtherPersonEmployedInUS', questionnaireDetails ,false,'dependentsInfo.spouse'))">
                               
                                <vs-col class="w-full p-0 mart20">
                                    <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true" v-if="spouse && spouse.h4EADRequired">
                                        Provide your current and previous employment details, starting from the most recent first.
                                    </vs-alert>
                                </vs-col>
                                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container form-container-questionnaire form-container-employment form_container_485_v2 cstm_mdl_485_spouce_emp">
                                        <div class="vx-row">
                                            <immiyesorno v-if="spouse && spouse.h4EADRequired" :cid="'anyOtherPersonEmployedInUS'" formscope="dependentsInfoformmodal" :required="checkFieldIsRequired({'key':'anyOtherPersonEmployedInUS','section':'dependentsInfo.spouse', 'fieldsArray':questionnaireDetails, 'required':true })" 
                                             :display="false" :tplkey="'anyOtherPersonEmployedInUS'" :tplsection="'dependentsInfo.spouse'"  @input="updateEmployementUs('Spouse')"
                                              :wrapclass="'mt-6 mb-0 yesnomar formgroup-mb0'" :fieldsArray="questionnaireDetails" v-model="spouse.anyOtherPersonEmployedInUS" fieldName="anyOtherPersonEmployedInUS"
                                               label="Have you been employed in the United States since last admitted or granted an extension or change of status?"></immiyesorno>    
                                            <template v-if="spouse.anyOtherPersonEmployedInUS && spouse.h4EADRequired">
                                                <immiemployment ref="spouseEmploymentRef" :prefillCountryInQuestionnaire="prefillCountryInQuestionnaire" :petition="petition" :callFromSpouse="true" :countries="countries" :fieldsArray="questionnaireDetails"  cid="dep_prevEmploymentInfo" formscope="dependentsInfoformmodal" v-model="spouse.prevEmploymentInfo" :tplsection="'dependentsInfo.spouse.prevEmploymentInfo'"  :fieldName="'prevEmploymentInfo'"  />  
                                            </template>
        
                                        </div>
                                    </div>
                                </vs-col>
                             </template>
                             <template v-if="(canRenderField('prevEmploymentOutsideUS', questionnaireDetails ,false,'dependentsInfo.spouse.prevEmploymentOutsideUS') || canRenderField('haveYouEverEmployed', questionnaireDetails ,false,'dependentsInfo.spouse')) ">
                                <vs-col class="w-full p-0">
                                    <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true" v-if="spouse && spouse.h4EADRequired">
                                        Last Employer outside of the United States for more than one year.
                                    </vs-alert>
                                </vs-col>
                                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container form-container-questionnaire form-container-employment form_container_485_v2 cstm_mdl_485_spouce_emp">
                                        <div class="vx-row">
                                            <immiyesorno v-if="spouse && spouse.h4EADRequired" :cid="'haveYouEverEmployed'" formscope="dependentsInfoformmodal" :required="checkFieldIsRequired({'key':'haveYouEverEmployed','section':'dependentsInfo.spouse', 'fieldsArray':questionnaireDetails, 'required':true })" :display="false" :tplkey="'haveYouEverEmployed'" :fieldsArray="questionnaireDetails"   v-model="spouse.haveYouEverEmployed" :tplsection="'dependentsInfo.spouse'" :wrapclass="'mt-6 mb-0 yesnomar formgroup-mb0'" :fieldName="'haveYouEverEmployed'"   label="Have you ever been employed Outside US?"></immiyesorno>
                                            <template v-if="spouse && spouse.haveYouEverEmployed && spouse.h4EADRequired">
                                                <immiemployment :petition="petition" :countries="countries" :fieldsArray="questionnaireDetails"  cid="dep_prevEmploymentOutsideUS" formscope="dependentsInfoformmodal"  v-model="spouse.prevEmploymentOutsideUS" :tplsection="'dependentsInfo.spouse.prevEmploymentOutsideUS'"  :fieldName="'prevEmploymentOutsideUS'"  />   
                                            </template>
                                        </div>
                                    </div>
                                </vs-col>
                            </template>
                            
                           
                            <template v-if="canRenderField('fatherInfo', questionnaireDetails ,false,'dependentsInfo.spouse.fatherInfo')">
                               
                                <vs-col class="w-full p-0">
                                    <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true" >
                                        Provide your father details, starting from the most recent first.
                                    </vs-alert>
                                </vs-col>
                                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container form-container-questionnaire form-container-employment form_container_485 pad_485_set">
                                        <div class="vx-row">
                                            <div class="vx-col w-full p-0">
                                                <parentForm :countriesWithoutUS="countriesWithoutUS"  v-model="spouse.fatherInfo"  cid="dep_fatherInfo" :tplsection="'dependentsInfo.spouse.fatherInfo'"  :fieldName="'dep_fatherInfo'"  formscope="dependentsInfoformmodal" :countries="countries" :fieldsArray="questionnaireDetails" :petition="petition" />
                                            </div>
                                        </div>
                                    </div>
                                </vs-col>
                            </template>
                            <template v-if="canRenderField('motherInfo', questionnaireDetails ,false,'dependentsInfo.spouse.motherInfo')">
                                <vs-col class="w-full p-0 mart30">
                                    <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                        Provide your mother details, starting from the most recent first.
                                    </vs-alert>
                                </vs-col>
                                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container form-container-questionnaire form-container-employment form_container_485 pad_485_set">
                                        <div class="vx-row">
                                            <div class="vx-col w-full p-0">
                                                <parentForm :countriesWithoutUS="countriesWithoutUS" v-model="spouse.motherInfo" :parentType="'Mother Information'"  cid="dep_motherInfo" :tplsection="'dependentsInfo.spouse.motherInfo'"  :fieldName="'motherInfo'"  formscope="dependentsInfoformmodal" :countries="countries" :fieldsArray="questionnaireDetails" :petition="petition" />
                                            </div>
                                        </div>
                                    </div>
                                </vs-col>
                            </template>
                            <template v-if="checkProperty(spouse, 'associations') && checkProperty(spouse, 'associations', 'length')>0 && canRenderField('associations', questionnaireDetails ,false,'dependentsInfo.spouse.associations') ">
                                <vs-col class="w-full p-0 mart10">
                                    <vs-alert color="warning" class="warning-alert top-warning-alert" icon-pack="IntakePortal" icon="IP-information-button" active="true">
                                        All associations and groups of which you are or have been a member, including political organizations, if you do not belong to any organizations, please write "None"
                                    </vs-alert>
                                </vs-col>
                                <vs-col class="m-auto float-none pt-6" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container form-container-questionnaire form-container-employment">
                                        <h3 class="small-header">Associations/Groups</h3>
                                            <div class="vx-row">
                                                
                                                <immiInput :display="false" :tplkey="'name'" :fieldsArray="questionnaireDetails"  cid="deffname" formscope="dependentsInfoformmodal" v-model="spouse['associations'][0].name" :tplsection="'dependentsInfo.spouse.associations'"  :fieldName="'name'"  :required="true"  label="Name of the associations and groups" placeHolder="Name of the associations and groups" />
                                                
                                                <immiInput :display="false" :tplkey="'natureofAssociations'" :fieldsArray="questionnaireDetails"  cid="defbenfnatureofAssociations" formscope="dependentsInfoformmodal" v-model="spouse['associations'][0].natureofAssociations" :tplsection="'dependentsInfo.spouse.associations'"  :fieldName="'natureofAssociations'"  :required="true"  label="Nature of associations and groups" placeHolder="Nature of associations and groups" />
                                                <datepickerField :display="false" :tplkey="'startDate'" :fieldsArray="questionnaireDetails" :validationRequired="true" v-model="spouse['associations'][0].startDate" @input="clearEndDate(spouse['associations'])" :tplsection="'dependentsInfo.spouse.associations'"  :fieldName="'startDate_associations'"  formscope="dependentsInfoformmodal"  :dateEnableTo="featureDates" label="Start Date" />
                                                <datepickerField :display="false" :tplkey="'endDate'" :isDisabled="!spouse['associations'][0].startDate" :fieldsArray="questionnaireDetails"  :dateEnableFrom="spouse['associations'][0].startDate" :validationRequired="true" v-model="spouse['associations'][0].endDate" :tplsection="'dependentsInfo.spouse.associations'"  :fieldName="'endDate_associations'"  formscope="dependentsInfoformmodal"  label="End Date" /> 
                                                <div class="vx-col w-full">
                                                    <div >
                                                        <h3 class="small-header"> Address</h3>
                                                        <addressField :validationRequired="checkFieldIsRequired({'key':'address','section':'dependentsInfo.spouse.associations', 'fieldsArray':questionnaireDetails, 'required':true })"  :fieldsArray="questionnaireDetails" :showLane1="false" :showLane2="false" :disableCountry="false" :showZip="false" formscope="dependentsInfoformmodal" :showaptType="false" :addFormContainerCls="false" :countries="countries" v-model="spouse['associations'][0].address" :tplsection="'dependentsInfo.spouse.associations'"  :fieldName="'address'"  :cid="'daddress'" />

                                                    </div>
                                                </div>
                                            </div>
                                        
                                    </div>
                                </vs-col>
                            </template>
                            <template v-if="canRenderField('previousSpouse', questionnaireDetails ,false,'dependentsInfo.spouse.previousSpouse')">
                                <vs-col>
                                    <previousSpouseForm :display="false" :countries="countries"  :cid="'previousSpouse'+'cid'" :formscope="'dependentsInfoformmodal'" v-model="spouse.previousSpouse"  :tplsection="'dependentsInfo.spouse.previousSpouse'" :fieldsArray="questionnaireDetails" :tplkey="'previousSpouse'" :validationRequired="true" :fieldName="'previousSpouse'"  />
                                </vs-col>
                            </template>
                            <template v-if="checkProperty(petition, 'subTypeDetails','id') != 16 && 
                            (canRenderField('passport', questionnaireDetails ,false,'dependentsInfo.spouse.documents') || canRenderField('slgApprovalNoticeOfPrevH4', questionnaireDetails ,false,'dependentsInfo.spouse.documents')
                            || canRenderField('visa', questionnaireDetails ,false,'dependentsInfo.spouse.documents') || canRenderField('formI94', questionnaireDetails ,false,'dependentsInfo.spouse.documents')
                            || canRenderField('formI797', questionnaireDetails ,false,'dependentsInfo.spouse.documents') || canRenderField('formI20', questionnaireDetails ,false,'dependentsInfo.spouse.documents')
                            || canRenderField('payStubs', questionnaireDetails ,false,'dependentsInfo.spouse.documents') || canRenderField('marriageCertificate', questionnaireDetails ,false,'dependentsInfo.spouse.documents')
                            || canRenderField('other', questionnaireDetails ,false,'dependentsInfo.spouse.documents'))">
                                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" >
                                    <div class="form-container">
                                        <fileUploadNote :fileNote="true" />
                                        <casedocumentslist  @emitUploadingAction="emitUploadingAction" :docMainCategory="'spousedoclist'" :tplsection="'dependentsInfo.spouse.documents'" :docslist="spousedoclist" formscope="dependentsInfoformmodal" :fieldsArray="questionnaireDetails" v-model="spouse.documents"></casedocumentslist>
                                    </div>
                                </vs-col>
                            </template>

                        </form>
                    </VuePerfectScrollbar>
                </div>
                <!-- :disabled="submiTing"  -->
                <div class="popup-footer relative">
                    <vs-button color="dark" :disabled="documentUploading" @click="toggleSpouseForm(false)" class="cancel" type="filled">Cancel</vs-button> 
                    <vs-button color="success" :disabled="documentUploading" @click="submitSpouse()" class="save" type="filled">Save
                    </vs-button>
                </div>
                <div></div>
            </div>
        </div>
    
        <div class="custom_modal_sec child_doc documents__modal"  :class="{ modalopen: childModalForm }">
            <!-- v-if="childModalForm" -->
            <div class="custom_modal_overlay"></div>
            <div class="custom_modal_cnt">
                <div class="modal_title">
                    <h2>Child Information</h2>
                    <span class="close" @click="toggleChildForm(false)">
                        <em class="material-icons">close</em>
                    </span>
                </div>
                <div class="modal_cnt">
                    <VuePerfectScrollbar ref="mainSidebarPschild" :settings="settings">
                        <form data-vv-scope="childInfoformmodal" @submit.prevent="" @keydown.enter.prevent="">
                            <childpersonalinfo :instituteStates="instituteStates" :countriesWithoutUS="countriesWithoutUS"  :marital_statuses="marital_statuses"  :tplsection="'dependentsInfo.childrens'" :countries="countries" formscope="childInfoformmodal" :petition="petition" :fieldsArray="questionnaireDetails" v-model="petition.dependentsInfo.childrens[selectedchild]"></childpersonalinfo>
                            
                            <vs-col class="float-none employment_yesno mt-0" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" v-if="canRenderField('prevEmploymentInfo', questionnaireDetails ,false,'dependentsInfo.childrens.prevEmploymentInfo') && petition.dependentsInfo.childrens && petition.dependentsInfo.childrens[selectedchild]  && petition.dependentsInfo.childrens[selectedchild].h4EADRequired">
                                <div class="form-container">
                                    <div class="vx-row">
                                        <immiyesorno :cid="'anyOtherPersonEmployedInUS'" formscope="childInfoformmodal" :required="checkFieldIsRequired({'key':'anyOtherPersonEmployedInUS','section':'dependentsInfo.childrens', 'fieldsArray':questionnaireDetails, 'required':true })"  :display="false" :tplkey="'anyOtherPersonEmployedInUS'" :tplsection="'dependentsInfo.childrens'"  :wrapclass="'yesnomar'" :fieldsArray="questionnaireDetails" v-model="petition.dependentsInfo.childrens[selectedchild].anyOtherPersonEmployedInUS" 
                                        fieldName="anyOtherPersonEmployedInUS" label="Have you been employed in the United States since last admitted or granted an extension or change of status?" @input="updateEmployementUs('Child')"></immiyesorno>
                                    </div>
                                </div>
                            </vs-col>
                           
                            <template v-if="petition.dependentsInfo.childrens && petition.dependentsInfo.childrens[selectedchild] && petition.dependentsInfo.childrens[selectedchild].anyOtherPersonEmployedInUS && petition.dependentsInfo.childrens[selectedchild].h4EADRequired && canRenderField('prevEmploymentInfo', questionnaireDetails ,false,'dependentsInfo.childrens.prevEmploymentInfo')"  >
                                
                                <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12">
                                    <div class="form-container form-container-questionnaire form-container-employment spouse_immi_employment questionnairesection">
                                        <div class="vx-row">
                                        <immiemployment ref='childEducationForm'  :petition="petition" :callFromSpouse="true" :countries="countries" :fieldsArray="questionnaireDetails"  cid="dep_prevEmploymentInfo" formscope="childInfoformmodal" v-model="petition.dependentsInfo.childrens[selectedchild].prevEmploymentInfo" :tplsection="'dependentsInfo.childrens.prevEmploymentInfo'"  :fieldName="'prevEmploymentInfo'"  />
                                        </div>
                                    </div>
                                </vs-col> 
                            </template>
                         <template v-if="checkProperty(petition, 'subTypeDetails','id') != 16 && 
                            (canRenderField('passport', questionnaireDetails ,false,'dependentsInfo.childrens.documents') || canRenderField('visa', questionnaireDetails ,false,'dependentsInfo.childrens.documents')
                            || canRenderField('formI94', questionnaireDetails ,false,'dependentsInfo.childrens.documents') || canRenderField('approvalNotice', questionnaireDetails ,false,'dependentsInfo.childrens.documents')
                            || canRenderField('birthCertificate', questionnaireDetails ,false,'dependentsInfo.childrens.documents') || canRenderField('slgApprovalNoticeOfPrevH4', questionnaireDetails ,false,'dependentsInfo.childrens.documents')
                            || canRenderField('other', questionnaireDetails ,false,'dependentsInfo.childrens.documents'))">

                            <vs-col class="m-auto float-none" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" >
                                <div class="form-container padt20 child_case_docs_v2">
                                    <fileUploadNote :fileNote="true" />
                                    <casedocumentslist  @emitUploadingAction="emitUploadingAction" :docMainCategory="'childdoclist'" :tplsection="'dependentsInfo.childrens.documents'" :docslist="childdoclist" formscope="childInfoformmodal" :fieldsArray="questionnaireDetails" v-model="petition.dependentsInfo.childrens[selectedchild].documents"></casedocumentslist>
                            </div>
                            </vs-col>
                              </template>   
                        </form>
                    </VuePerfectScrollbar>
                </div>
                <!-- :disabled="submiTing"  -->
                <div class="popup-footer relative">  
                    <vs-button color="dark" :disabled="documentUploading" @click="toggleChildForm(false)" class="cancel" type="filled">Cancel</vs-button>
                    <vs-button color="success" :disabled="documentUploading" @click="submitChild()" class="save" type="filled">Save
                    </vs-button>
                </div>
                <div></div>
            </div>
        </div>
    
        <vs-popup class="holamundo main-popup cls-btn" title="Case Details" :active.sync="showPrefillPopup">
            <div class="form-container"> 
                <div class="vx-row">
                    <div class="vx-col w-full" v-if="beneFiciaryDeytailsExists">
                        <p style="line-height: 20px">
                            Do you want to pre-fill the basic information from the Beneficiary Profile?
                        </p>
                    </div>
                    <div class="vx-col w-full" v-else>
                        <p style="line-height: 20px">
                            Do you want to pre-fill the basic information from the previous
                            case details?
                        </p>
                    </div>
                </div>
            </div>
            <div class="popup-footer">
                <vs-button color="dark" class="cancel" type="filled" @click="setBasicData();removeFields();showPrefillPopup = false">Cancel</vs-button>
                <vs-button color="success" class="save" type="filled" @click="
                prefilltheDetails();prefillAction = true;
                showPrefillPopup = false;
              ">Yes</vs-button>
            </div>
        </vs-popup>
        <vs-popup class="holamundo main-popup cls-btn" title="Confirmation" :active.sync="showBenProfileSyncPopup">
            <div class="form-container">
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <p style="line-height: 20px">
                            Beneficiary Profile with the new/change information entered in this case will be updated
                        </p>
                    </div>
                </div>
            </div>
            <div class="popup-footer">
                <!-- <vs-button color="dark" class="cancel" type="filled" @click="conformBenProfile(false)">Cancel</vs-button> -->
                <vs-button @click="conformBenProfile(true);" class="save questionnaire_btn" type="filled">Okay</vs-button>
            </div>
        </vs-popup>

        <template v-if="!checkCurrentUrl">
            <generatePin v-if="openGeneratePinPopUp" 
              @updateVerificationStatus="updateVerificationStatus"
              @hideMe="openGeneratePinPopUp = false"  
              :petitionDetails="petition" />
        
        </template>
        <!-- <vs-popup class="holamundo main-popup cls-btn terms_n_conditions" :title="getLabelContent" :active.sync="showConsentContentPopup">
            <i class="manual_close" @click="showConsentContentPopup=false"></i>
            <div class="form-container"> 
                <div class="vx-row">  
                    <div class="vx-col w-full" v-if="contentCategory == 'consent'">
                        <p class="ownership_details" v-html="consentData" ></p>
                    </div>
                    <div class="vx-col w-full" v-if="contentCategory == 'termsAndConditions'">
                        <p class="ownership_details" v-html="termsAndConditionsData" ></p>
                    </div>
                </div>
            </div>
        </vs-popup> -->
       
        <modal
        name="showConsentContentPopup"
        classes="v-modal-sec"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="600px"
        height="auto"
        >
            <div class="v-modal profile_details_modal terms_n_conditions">
            <div class="popup-header fromDetailsPage">
                <h2 class="popup-title">{{getLabelContent}}</h2>
                <span  @click="$modal.hide('showConsentContentPopup')">
                <em class="material-icons">close</em>
                </span>
            </div>

            <div class="form-container"> 
                <div class="vx-row">
                    <div class="vx-col w-full" v-if="contentCategory == 'consent'">
                        <p class="ownership_details" v-html="consentData" ></p>
                    </div>
                    <div class="vx-col w-full" v-if="contentCategory == 'termsAndConditions'">
                        <p class="ownership_details" v-html="termsAndConditionsData" ></p>
                    </div>
                </div>
            </div>
            <!-- ;agreeTerms(contentCategory) -->
            <div class="popup-footer relative">
                <vs-button color="success"
                    @click="$modal.hide('showConsentContentPopup')"
                    class="save"
                    type="filled"
                    >Okay
                </vs-button>
            </div>

            </div>
        </modal>
    
    </div>
    </template>
    
    <script>
    import periodOfInstituteForm from "@/views/forms/fields/periodOfInstituteForm.vue";
    import generatePin from "@/views/actionpopups/generatePin.vue";
     import { InfoIcon } from "vue-feather-icons";
    import { EyeIcon } from "vue-feather-icons";
    import genderField from './fields/gender.vue'
    import immiInput from "@/views/forms/fields/simpleinput.vue";
    import i485AdditionalInformation from "@/views/forms/i485AdditionalInformation.vue";
    import {
        Trash2Icon
    } from "vue-feather-icons";
    import fileUploadNote from "@/views/common/fileUploadNote.vue";
    import consulateAddress from "@/views/forms/fields/consulateAddress.vue"; 
    import w2Information from "@/views/forms/fields/w2Information.vue";
    import addressField from "@/views/forms/fields/address.vue";
    import datepickerField from "@/views/forms/fields/datepicker.vue";
    import selectField from "@/views/forms/fields/simpleselect.vue";
    import monthAndYear from "@/views/forms/fields/monthAndYear.vue";
    import immiPhone from "@/views/forms/fields/phonenumber.vue";
    import immiMask from "@/views/forms/fields/maskinput.vue";
    import immiyesorno from "@/views/forms/fields/yesorno.vue";
    import immiuploader from "@/views/forms/fields/fileupload.vue";
    import immipriorstay from "@/views/forms/fields/priorstay.vue";
    import immitextarea from "@/views/forms/fields/simpletextarea.vue";
    import immieducations from "@/views/forms/fields/educations.vue";
    import immiswitchyesno from "@/views/forms/fields/switchyesno.vue";
    import Datepicker from "vuejs-datepicker-inv";
    import casedocumentslist from "@/views/common/casedocuments.vue";
    import immiemployment from "@/views/forms/fields/employment.vue";
    import moment from "moment";
    import petitionsinformation from "@/views/forms/fields/petitionsinformation.vue";
    import petitionImmigranInfo from "@/views/forms/fields/petitionImmigranInfo.vue";
    import personalinfo from "@/views/forms/fields/personalinfo.vue";
    import childpersonalinfo from "@/views/forms/fields/childpersonalinfo.vue";
    import { XIcon } from 'vue-feather-icons'
    import JQuery from 'jquery';
    // import FileUpload from "vue-upload-component/src";
    import FileUpload from "@/views/FileUpload.vue";
    import _ from "lodash";
    import PetitionDetails from "@/views/PetitionDetails.vue";
    import VuePerfectScrollbar from "vue-perfect-scrollbar";
    
    import immitextfield from "@/views/forms/fields/simpleTextField.vue";
    
    //485 Components
    import Vue from 'vue';
    Vue.use( CKEditor );
    import CKEditor from '@ckeditor/ckeditor5-vue2';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import previousSpouseForm from "@/views/petition/gc/previousSpouseForm.vue";
    import immigrationForm from "@/views/petition/gc/immigrationForm.vue";
    import financialForm from "@/views/petition/gc/financialForm.vue";
    import assestsForm from "@/views/petition/gc/assestsForm.vue";
    import liabilitiesForm  from "@/views/petition/gc/liabilitiesForm.vue";
    import publicBenefitsForm  from "@/views/petition/gc/publicBenefitsForm.vue";
    import financialInfoForm from "@/views/petition/gc/financialInfoForm.vue";
    import parentForm from "@/views/petition/gc/parentForm.vue";
    import quillTextEditor from "./fields/quillTextEditor.vue";
    
    export default {
        props: {
    
        },
        provide() {
            return {
                parentValidator: this.$validator,
            };
        },
        data() {
            return {
                consentData:'',
                termsAndConditionsData:'',
                contentCategory:'',
                // showConsentContentPopup:false,
                consentTermsAndCondition:false, 
                termsAndConditionsChecked:false, 
                consentChecked:false,
                debounce:null,
                highestEduList:[
                    {id:1,name:'Grades 1 through 11'},
                    {id:2,name:'12th grade - no diploma'},
                    {id:3,name:'High school diploma, GED, or alternative credential'},
                    {id:4,name:'1 or more years of college credit, no degree'},
                    {id:5,name:"Associate's degree"},
                    {id:6,name:"Bachelor's degree"},
                    {id:7,name:"Master's degree"},
                    {id:8,name:"Professional degree (JD, MD, DMD, etc.)"},
                    {id:9,name:"Doctorate degree"},
                ],
                // wage Information Data start
                uploadMainDocuments:[],
                wageStartingYear: 2015,
                currentYear: moment().format('YYYY')-1,
                wageInformationArray:[],
                /// wage Information Data end
                firstTimeLoading:false,
                prevH1bCaseStatusList:[
                    {id:'approved','name':'Approved'},
                    {id:'denied','name':'Denied'},
                    {id:'not_used','name':'Not Used'}
                ],
                openGeneratePinPopUp:false,
                tokenVerified:false,
                newDocs:[],
                tempSave:false,
                showMessage:true,
                documentUploading:false,
                disablefield:false, 
                editor: ClassicEditor,
                editorConfig: {
                    toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
                },
                consularProcessingValidator:'',
                public_benefits:[],
                liability_list:[],
                assestsList:[],
                eye_colorList:[],
                feetList:[1,2,3,4,5,6,7,8,9,10,11,12],
                inchesList:[0,1,2,3,4,5,6,7,8,9,10,11],
                classificationList:[ "EB-1","EB-2","EB-3" ],
                hair_colorsList:[],
                races_list:[],
                uploading:false,
                value:[],
                payFrequencyList:[ "Hour","Week","Month","Year" ],
                settings: { 
                    swipeEasing: true,
                },
                commentPopUp:false,
                benProfileDetails:null,
                petition: {
                    tenantId: null,
                    petitionerId: null,
                    companyId: null,
                    branchId: null,
                    workflowId: null,
                    customId: '',
                    caseNo: '',
                    caseNoOld: '',
                    caseNoRef: '',
                    caseNoSNo: 0,
                    allowCustomCaseNo: false,
                    caseNumber: null,
                    type: null,
                    subType: null,
                    masterSocList:[], 
                   // We need to ask above job details in case we don't have the beneficiary PERM info in our system
                    jobDetails: {
                        socCode:'',
                        socDetails:null,
                        
    
                        jobTitle: '',
    
                        workAddresses: [
                        {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            }
                        ],
    
                        fullTimePosition: false,
    
                        hoursPerWeek: '',
    
                        wageRate: '',
    
                        payFrequency: 'Month', // Year, Month, Bi-Weekly, Week, Hour
    
                        description: '',
    
                        permanentPosition: false,
    
                        newPosition: false
    
                    },
                    beneficiaryInfo: { 
                        houseHoldNumber:'',
                        houseHoldAnnualIncome:'',
                        houseHoldAnnualAssets:'',
                        houseHoldAnnualliabilities:'', 
                        // public charge keys start
                        inadmissibility:null,
                        highestDegreeCompleted:null,
                        listOfCertifications:'',
                        SSI:null,
                        benefitsRecAmounts:[{
                            benefitReceived: '',
                            startDate: null,
                            endDate: null,
                            amount: ''
                        }],
                        longTermInstiAtGovtExpense:null,
                        periodOfInstutions:[{
                            institutionName:'',
                            stateId:'',
                            stateDetails:null,
                            locationId:'',
                            locationDetails:null,
                            dateFrom:null,
                            dateTo:null,
                            reason:'',
                            instituteLocations:[]
                        }],
                        // public charge keys end
                        // L1 visa starts
                        typeOfOffice:'',
                        officeAddress:{
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        // L1 visa Ends
                        everDeniedAdmissionInUS: null, // 14.Have you EVER been denied admission to the United States?
                        isVisaDenieedTOUS: null, /// 15.HAVE YOU EVER BEEN DENIED A VISA TO THE UNITED STATES?
                        everWorkedInUSWithoutAuth: null, // 16. Have you EVER worked in the United States without authorization?
                        everViolatedTandCofYourNonImmStatus: null, // 17. Have you EVER violated the terms or conditions of your nonimmigrant status?
                        everBeenInRemovalExcl: null, // 18. Are you presently or have you EVER been in removal, exclusion, rescission, or deportation proceedings?
                        everBeenIssuedOrderExclRemoval: null, // 19. Have you EVER been issued a final order of exclusion, deportation, or removal?
                        everHadPriorOrderExclDeport: null, // 20. Have you EVER had a prior final order of exclusion, deportation, or removal reinstated?
                        
                        everHeldPermResidentStatus: null, //21.Have you EVER held lawful permanent resident status which was later rescinded?
                        everGrantedVolDepartimmgOfficer: null,//22.Have you EVER been granted voluntary departure by an immigration officer or an immigration judge but failed todepart within the allotted time?
                        everAppliedReliefOrExclDeport: null,//23.Have you EVER applied for any kind of relief or protection from removal, exclusion, or deportation?
                        everJNonImmmExchangeVistor: null,//24.a. Have you EVER been a J nonimmigrant exchange visitor who was subject to the two-year foreign residencerequirement?
                        //if 24.a yes
                        everCompailedForeignResi: null, //24.b Have you complied with the foreign residence requirement?
                        everGrantedWavierRecomndLtr: null, //24.c Have you been granted a waiver or has Department of State issued a favorable waiver recommendation letter for you? 
                        
                        //Criminal Acts and Violations
                        everArrested: null, //25. Have you EVER been arrested, cited, charged, or detained for any reason by any law enforcement official(including but not limited to any U.S. immigrationofficial or any official of the U.S. armed forces or U.S.Coast Guard)?
                        everCommittedCrime: null, //26.Have you EVER committed a crime of any kind (even if you were not arrested, cited, charged with, or tried for thatcrime)? 
                        everPledGuilty: null, //27.Have you EVER pled guilty to or been convicted of a crime or offense (even if the violation was subsequently expunged or sealed by a court, or if you were granted apardon, amnesty, a rehabilitation decree, or other act ofclemency)?
                        everPunishedByJudge: null, //28.Have you EVER been ordered punished by a judge or had conditions imposed on you that restrained your liberty(such as a prison sentence, suspended sentence, housearrst, parole, alternative sentencing, drug or alcoholtreatment, rehabilitative programs or classes, probation, orcommunity service)?
                        everAccusedCrimProc: null, //29.Have you EVER been a defendant or the accused in acriminal proceeding (including pre-trial diversion,deferred prosecution, deferred adjudication, or any withheld adjudication)? 
                        everViolated: null, //30.Have you EVER violated (or attempted or conspired toviolate) any controlled substance law or regulation of astate, the United States, or a foreign country?
                        everConvictedTwoOrMoreOffens: null,//31.Have you EVER been convicted of two or more offenses(other than purely political offenses) for which thecombined sentences to confinement were five years ormore?
                        everIlleglTraf: null, //32.Have you EVER illicitly (illegally) trafficked or benefitedfrom the trafficking of any controlled substances, such aschemicals, illegal drugs, or narcotics?
                        everKnowinglyIlleglTraf: null, //33.Have you EVER knowingly aided, abetted, assisted,conspired, or colluded in the illicit trafficking of anyillegal narcotic or other controlled substances?
                        everSpouseSondaughterIlleglTraf: null,//34. Are you the spouse, son, or daughter of a foreign nationalwho illicitly trafficked or aided (or otherwise abetted,assisted, conspired, or colluded) in the illicit trafficking ofa controlled substance, such as chemicals, illegal drugs, ornarcotics and you obtained, within the last five years, anyfinancial or other benefit from the illegal activity of yourspouse or parent, although you knew or reasonably shouldhave known that the financial or other benefit resultedfrom the illicit activity of your spouse or parent?
                        everEngageProst: null,//35.Have you EVER engaged in prostitution or are you coming to the United States to engage in prostitution?
                        everdirOrIndirectProst: null, //36.Have you EVER directly or indirectly procured (or attempted to procure) or imported  prostitutes or persons for the purpose of prostitution?
                        everReceiveMoneyFronProst: null, //37.Have you EVER received any proceeds or money fromprostitution?
                        everIntentIllegalGamblUS: null, //38.Do you intend to engage in illegal gambling or any other form of commercialized vice, such as prostitution,bootlegging, or the sale of child pornography, while in the United States?
                        everImmunityCriminalOffensedInUS: null, //39.Have you EVER exercised immunity (diplomatic or otherwise) to avoid being prosecuted for a criminaloffense in the United States?
                        everViolateReliFreedomAsForeignGovOffi: null,//40. Have you EVER, while serving as a foreign governmentofficial, been responsible for or directly carried outviolations of religious freedoms?
                        everForceFraudCommercialSexActs: null,//41.Have you EVER induced by force, fraud, or coercion (orotherwise been involved in) the trafficking of persons forcommercial sex acts?
                        everTraffPersonIntoInvolSlavery: null, //42.Have you EVER trafficked a person into involuntary servitude, peonage, debt bondage, or slavery? Trafficking includes recruiting, harboring, transporting, providing, or obtaining a person for labor or services through the use offorce, fraud, or coercion.
                        everKnowWithTraffPersonCommSexAct: null, //43.Have you EVER knowingly aided, abetted, assisted, conspired, or colluded with others in trafficking persons for commercial sex acts or involuntary servitude, peonage, debt bondage, or slavery?
                        everSpouseSonDughterEngTraffAnyFinBef: null,//44.Are you the spouse, son or daughter of a foreign national who engaged in the trafficking of persons and have received or obtained, within the last five years, any financial or other benefits from the illicit activity of your spouse or your parent, although you knew or reasonably should have known that this benefit resulted from the illicit activity of your spouse or parent?
                        everEngMoneyLaundering: null,//45.Have you EVER engaged in money laundering or have you EVER knowingly aided, assisted, conspired, or colluded with others in money laundering or do you seek to enter the United States to engage in such activity?
                        
                        //Security and Related
                        everViolateEvidenceLawRelatedInUS: null,//46.a. Engage in any activity that violates or evades any law relating to espionage (including spying) or sabotage in theUnited States?
                        everViolateExpGoodsSensInfoTechInUS: null,//46.b. Engage in any activity in the United States that violates or evades any law prohibiting the export from the United States of goods, technology, or sensitive information? 
                        everOverthrowingUSGovtByForceViolence: null,//46.c. Engage in any activity whose purpose includes opposing,controlling, or overthrowing the U.S. Government byforce, violence, or other unlawful means while in theUnited States?
                        everActivityDangerScurityOfUs: null,//46.d.Engage in any activity that could endanger the welfare,safety, or security of the United States? 
                        everEngUnlawfulActivity: null,//46.e.Engage in any other unlawful activity?
                        everEngActSeriousForeignPolicyforUs: null,//47.Are you engaged in or, upon your entry into the United States, do you intend to engage in any activity that could have potentially serious adverse foreign policy consequences for the United States?
                        everCommitedKidnapHjkEtc: null,//48.a. Committed, threatened to commit, attempted to commit,conspired to commit, incited, endorsed, advocated,planned, or prepared any of the following: hijacking,sabotage, kidnapping, political assassination, or use of aweapon or explosive to harm another individual or causesubstantial damage to property? 
                        everCommMemberGrpOrgKidnapHjkEtc: null, //48.b. Participated in, or been a member of, a group ororganization that did any of the activities described in Item Number 48.a.? 
                        everAskMoneyRecruGrpKidnapHijackEtc: null, //48.c.Recruited members or asked for money or things of value for a group or organization that did any of the activitiesdescribed in Item Number 48.a.?
                        everProvideMoneyForAssiKidnapHjkEtc: null, //48.d.Provided money, a thing of value, services or labor, orany other assistance or support for any of the activitiesdescribed in Item Number 48.a.? 
                        everProvideMoneyForAssiIndiGrpKidnapHjkEtc: null,//48.e. Provided money, a thing of value, services or labor, or any other assistance or support for an individual, group,or organization who did any of the activities described inItem Number 48.a.?
                        everTraiParaOrMilataryWepons: null,//49.Have you EVER received any type of military,paramilitary, or weapons training? 
                        everEngKidnapHjkEtc: null,//50.Do you intend to engage in any of the activities listed in any part of Item Numbers 48.a. - 49.?
                        //if answered yes items b/w 46.a to 50
                        //Additional info
                        everSpoOrChiEngKidnapHjkEtc: null,//51.a. Committed, threatened to commit, attempted to commit,conspired to commit, incited, endorsed, advocated,planned, or prepared any of the following: hijacking,sabotage, kidnapping, political assassination, or use of a weapon or explosive to harm another individual or cause substantial damage to property? 
                        everHSpoOrChiPartMemberKidnapHjkEtc: null, //51.b. Participated in, or been a member or a representative of agroup or organization that did any of the activities described in Item Number 51.a.? 
                        everSpoOrChiRecrutKidnapHjkEtc: null, //51.c. Recruited members, or asked for money or things of value,for a group or organization that did any of the activities described in Item Number 51.a.? 
                        everSpoOrChiAskMoneyAssiKidnapHjkEtc: null,//51.d. Provided money, a thing of value, services or labor, or any other assistance or support for any of the activities described in Item Number 51.a.? 
                        everSpoOrChiForAssiIndiGrpKidnapHjkEtc: null,//51.e. Provided money, a thing of value, services or labor, or any other assistance or support to an individual, group, or ganization who did any of the activities described in Item Number 51.a.? 
                        everSpoOrChiTraiParaOrMilataryWeponKidnapHjkEtc: null,//51.f. Received any type of military, paramilitary, or weapons training from a group or organization that did any of the activities described in Item Number 51.a.? 
                        //if answered yes items of 51
                        //Additional info
                        everSellProvideTransWepon: null,//52. Have you EVER assisted or participated in selling,providing, or transporting weapons to any person who,to your knowledge, used them against another person?
                        everWorkedPrisionAndDetained: null,//53. Have you EVER worked, volunteered, or otherwiseserved in any prison, jail, prison camp, detention facility,labor camp, or any other situation that involved detainingpersons?
                        everUsingWeponPartGrpOrgThreatPerson: null,//54.Have you EVER been a member of, assisted, or participated in any group, unit, or organization of anykind in which you or other persons used any type ofweapon against any person or threatened to do so?
                        everServedParaOrMilataryEtc: null,//55.Have you EVER served in, been a member of, assisted,or participated in any military unit, paramilitary unit,police unit, self-defense unit, vigilante unit, rebel group,guerilla group, militia, insurgent organization, or anyother armed group?
                        everMemberCommPartyInUS: null,//56.Have you EVER been a member of, or in any way affiliated with, the Communist Party or any othertotalitarian party (in the United States or abroad)?
                        ever080545To230393AssoNaziGerGov: null,//57.During the period from March 23, 1933 to May 8, 1945,did you ever order, incite, assist, or otherwise participatein the persecution of any person because of race, religion,national origin, or political opinion, in association witheither the Nazi government of Germany or anyorganization or government associated or allied with theNazi government of Germany?
                        everInvolveTorture: null,//58.a. Acts involving torture or genocide?
                        everKillAnyPerson: null,//58.b.Killing any person?
                        everSeverInjuAnyPerson: null,//58.c.Intentionally and severely injuring any person?
                        everEngAnySexualContent: null,//58.d. Engaging in any kind of sexual contact or relations with any person who did not consent or was unable to consent, or was being forced or threatened?
                        everLimitReligBnf: null,//58.e. Limiting or denying any person's ability to exercise religious beliefs?
                        everUsedBelow15yrsPerson: null,//59.Have you EVER recruited, enlisted, conscripted, or usedany person under 15 years of age to serve in or help anarmed force or group?
                        everHelpUnder15yrsPerson: null,//60. Have you EVER used any person under 15 years of age to take part in hostilities, or to help or provide services to people in combat?
                        //if answered yes items b/w 52 to 60
                        //Public Assistance
                        everRcvPublicAssiInUS: null,//61.Have you received public assistance in the United Statesfrom any source, including the U.S. Government or anystate, county, city, or municipality (other than emergencymedical treatment)?
                        everFutureRcvPublicAssiInUs: null,//62.Are you likely to receive public assistance in the future inthe United States from any source, including the U.S.Government or any state, county, city, or municipality(other than emergency medical treatment)?
                        //Illegal Entries and Other Immigration Violations
                        everAttenRmvProcFiledAfter010497: null,//63.a. Have you EVER failed or refused to attend or to remain in attendance at any removal proceeding filed against youon or after April 1, 1997?
                        everRmvProcFiledReason: null,//63.b. If your answer to Item Number 63.a. is "Yes," do youbelieve you had reasonable cause?
                        rmvProcFiledResonWriteStmt: '',//63.c.If your answer to Item Number 63.b. is "Yes," attach a written statement explaining why you had reasonable cause.
                        everSubmitFraudDocUSGov: null,//64.Have you EVER submitted fraudulent or counterfeit documentation to any U.S. Government official to obtainor attempt to obtain any immigration benefit, including avisa or entry into the United States?
                        everLiedMisrepreInfoEnterUS: null,//65.Have you EVER lied about, concealed, or misrepresented any information on an application or petition to obtain avisa, other documentation required for entry into theUnited States, admission to the United States, or any otherkind of immigration benefit?
                        everClaimFlaslyUSCitizen: null,//66.Have you EVER falsely claimed to be a U.S. citizen (inwriting or any other way)?
                        everStowawayOnVessel: null,//67.Have you EVER been a stowaway on a vessel or aircraft arriving in the United States?
                        everTrytoEnterUsIllegaly: null,//68. Have you EVER knowingly encouraged, induced, assisted,abetted, or aided any foreign national to enter or to try toenter the United States illegally (alien smuggling)?
                        everFinalOrderCivilPenalty: null,//69. Are you under a final order of civil penalty for violating INA section 274C for use of fraudulent documents?
                        //Removal, Unlawful Presence, or Illegal Reentry After Previous Immigration Violations
                        everRemovedfromUs: null,//70. Have you EVER been excluded, deported, or removedfrom the United States or have you ever departed theUnited States on your own after having been ordered excluded, deported, or removed from the United States?
                        everEnterUSWithoutInspAdmit: null, //71.Have you EVER entered the United States without being inspected and admitted or paroled?
                        everSince010497More180DLessYrULFStayUS: null,//72.a. For more than 180 days but less than a year, and thendeparted the United States?
                        everSince010497YrOrMoreULFDepartUS: null,//72.b.For one year or more and then departed the United States?  
                        everSince010497ReEntMoreYrULFStayUS: null,//73.a.Having been unlawfully present in the United States for more than one year in the aggregate?
                        everSince010497RmvFromUS: null,//73.b.Having been deported, excluded, or removed from the United States?
                        //Miscellaneous Conduct
                        planForPractPolyInUS: null,//Do you plan to practice polygamy in the United States?
                        AreYouAccomOtherCountry: null,//75.Are you accompanying another foreign national who requires your protection or guardianship but who isinadmissible after being certified by a medical officer asbeing helpless from sickness, physical or mentaldisability, or infancy, as described in INA section 232(c)?
                        everAnyUsChildUnderCustody: null,//76. Have you EVER assisted in detaining, retaining, or withholding custody of a U.S. citizen child outside theUnited States from a U.S. citizen who has been grantedcustody of the child?
                        everVoilationAnyFedaral: null,//77.Have you EVER voted in violation of any Federal, state,or local constitutional provision, statute, ordinance, orregulation in the United States?
                        everUsCtzshipAvoidTax: null,//78.Have you EVER renounced U.S. citizenship to avoidbeing taxed by the United States?
                        everAppliedForExemptServiceUS: null,//79.a. Applied for exemption or discharge from training or service in the U.S. armed forces or in the U.S. NationalSecurity Training Corps on the ground that you are aforeign national?
                        everReliServTrainAreYouForeignNation: null,//79.b. Been relieved or discharged from such training or serviceon the ground that you are a foreign national?
                        everConvictDestUSArmedForce: null,//79.c. Been convicted of desertion from the U.S. armed forces?
                        everRemOutsideUSAviodTrainArmedForce: null,//80.a. Have you EVER left or remained outside the United States to avoid or evade training or service in the U.S.armed forces in time of war or a period declared by thePresident to be a national emergency?
                        nationImgrstaIfAviodTrainArmForcUS: '',//80.b. If your answer to Item Number 80.a. is “Yes,” what was your nationality or immigration status immediately beforeyou left (for example, U.S. citizen or national, lawfulpermanent resident, nonimmigrant, parolee, present without admission or parole, or any other status)?
        
                        hasMasterDegreeInUS:null,
                        isDSExpiryDate:false,
                        isI94DSExpiryDate:false,
                        anyOtherPersonEmployedInUS:null,
                        haveYouEverEmployed:null,
                        hasAnyDependetsinUStoFileH4 : null,
                        maritalStatusDetails:null,
                        haveYouEverTravelledToUS:null,
                        currentlyInUS: null,
                        haveOwnershipInterest: null,
                        ownershipInterestDesc: '',
                        haveYouEverAppliedH1bCase:null,
                        prevH1bCaseStatus:null,
                        prevH1bCaseDesc:'',
                        anyImmPetitionFiledDesc:'',
                        beneficiaryCnfmNumber:null,
                        capType:'',
                        serviceCenterName:'',
                        consulateInfo: {
                            locationId: null,
                            locationDetails: null,
                            // stateId: null,
                            // stateDetails: null,
                            countryId: null,
                            countryDetails: null
                        },
                        alienNumber: '',
                        lastArrivalNumber: null,
                        placeOfLastEntryInUS: '',
                        educations: [{
                            _id: 0,
                            name: null,
                            graduatedDate:null,
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            highestDegree: null,
                            highestDegreeDetails: null,
                            majorFieldOfStudy: null,
                            attendedFrom: null,
                            attendedTo: null,
                            graduatedYear: null,
                            degreereceived: null,
                            isAccredited: null,
                            isForProfit: null
                        }],
                        nonImmPetitionsInfo: [{
                            _id: 0,
                            visaStatus: null,
                            visaStatusDetails: null,
                            receiptNo: '',
                            petitionerName: '',
                            validFrom:null,
                            validTo:null
                        }],
                        h1bImmPetitionsInfo: [{
                            _id: 0,
                            typeId: null,
                            typeDetails: null,
                            receiptNo: '',
                            petitionerName: '',
                            validFrom:null,
                            validTo:null
                        }],
                        didThisPtnrFliedImmPetitionEarlier:null,
                        secOrSubSequentExtnWithPtnr:false,
                        firstExtnWithPtnr:false,
                        anyImmPetitionFiled: null,
                        immPetitionInfo: {
                            anyOtherAlienFiled: null,
                            filedNumber: null,
                            employerName: '',
                            rirOrRegularProcessing: null,
                            filedStateId: null,
                            filedStateDetails: null,
                            applCurStatus: '',
                            seekingFilednullforETA750: null,
                            anyI140Filed: null,
                            i140Info: {
                                fieldNumber: null,
                                employerName: '',
                                priorityNumber: null,
                                eb2orEb3: '',
                                currentStatus: ''
                            }
                        },
                        prevEmploymentInfo: [{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            currentEmployer: null,
                            salary:null,
                            payFrequency:null,
                        }],
                        prevEmploymentOutsideUS:[{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            currentEmployer: false  
                        }],
                        addressOutsideUS: {
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
    
                        name: '',
                        firstName: '',
                        middleName: '',
                        lastName: '',
                        hasOtherNames: null,
                        otherNames: [{
                            _id: 0,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                        }],
                        gender: '',
                        email: '',
                        education: {
                            highestDegree: null,
                            highestDegreeDetails: null,
                            majorFieldOfStudy: ''
                        },
                        maritalStatus: null,
                        // GC 485 fields start
                        noOfChildrens: '',
                        noOfTimesMarriedBeneficiary:null,
                        dateOfMarriage: '',
                        countryOfMarriage: '',
                        countryOfMarriageDetails: null,
                        provinceOfMarriage: '',
                        provinceOfMarriageDetails: null,
                        locationOfMarriage: '',
                        doYouHaveMarriageCert: false ,
                        marriageCertDocs: [],
                        have2AffidavitsAttestingToMarriage: false,
                        nameDiffFromBirthCert:null,
                        have2AffidavitsOfBirthFamily:null,
                        birthCertHaveNamePobDob:false,
                        previouslyMarried:false,
                        previousSpouse:{
                            hasOtherNames:false,
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            maidenName:'',
                            marriageEndedDueTo:null,
                            marriageEndedOtherInfo:'',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            dateOfBirth: null,
                            dateOfMarriage:null,
                            dateOfMarriageEnd:null,
                              //Place of Marriage
                            countryOfMarriage: '',
                            countryOfMarriageDetails: null,
                            provinceOfMarriage: '',
                            provinceOfMarriageDetails: null,
                            locationOfMarriage: '',
    
                            //Place of Termination
                            countryOfMarriageTermination: '',
                            countryOfMarriageTerminationDetails: null,
                            provinceOfMarriageTermination: '',
                            provinceOfMarriageTerminationDetails: null,
                            locationOfMarriageTermination: '',
                            obtainPermResidenceThroughSpouse:false  
                          
                        },
                        publicBenefits:[],
                        // GC 485 fields close
                        dateOfBirth: null,
                        countryOfBirth: null,
                        countryOfBirthDetails: null,
                        provinceOfBirth: null,
                        provinceOfBirthDetails: null,
                        locationOfBirth: null,
                        countryOfCitizenship: null,
                        countryOfCitizenshipDetails: null,
                        I94: null,
                        I94ExpiryDate: null,
                        I94StatusName:'',
                        //GC 485 fields start
                        height: {
                        feet: '',
                        inches: ''
                        },
                        weight: null,
                        race: [],
                        eyeColor: null,
                        hairColor: null,
                        firstArrivalDate: null,
                        lastArrivalDate: null,
                        reasonOfLastArrival: '',
                        stateOfLastEntryInUS: '',
                        stateDetailsOfLastEntryInUS: null,
                        placeOfLastEntryInUS: '',
                        caseIssuedDate: null,
                        caseExpiryDate: null,
                        placeOfCaseIssued: '',
                        i140PriorityDate:null,
                        classification:'',
                        // GC 485 fields end
                        homePhoneNumber: null,
                        homePhoneCountryCode: {
                            countryCode: '',
                            countryCallingCode: ''
                        },
                        cellPhoneNumber: null,
                        cellPhoneCountryCode: {
                            countryCode: '',
                            countryCallingCode: ''
                        },
                        // GC 485 fields start
                        allIssuedpassportData: [{
                            countryId: '',
                            countryDetails: null,
                            number: '',
                            issuedDate: null,
                            expiryDate: null 
                        }],
                        curVisaExpiryDate:null,
                        dateFromWhichResideInUs:null,
                        inspectedByAnyImmOfficer:false,
                        issuedAnyEADFromUSCIS:false,
                        enterInUSUnderCaseWaiverProgram:false,
                        curNonImmigrantVisaNumber:null,
                        hasPermResidencyInOtherCountry:false,
                        permResidencyCountryId:'',
                        haveYouArrestedBefore:null,
                        everAppliedAOSInUS:null,
                        haveYouEverReceivedPublicAssistendeInUS:null,
                        visaDeniedReason:null,
                        haveYouEverlikelyReceivePublicAssistendeInUS:null,
                        isVisaDenieedTOUS:null,
                        presntUnlawfullyReason:null,
                        haveYoueverPresntUnlawfully:null,
                        permResidencyCountryDetails:null,
                        addressOfLastNYears:[{
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                        }], 
                        addressOutsideUSMoreThanYear:[{
                        
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null,
                            startDate: null,
                            endDate: null,
                        }],
                        associations:[ {
                            name:'', 
                            address:{
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                            },
                            startDate: null,
                            endDate:null,
                            natureofAssociations:'',
                        }],
                        // GC 485 fields end
                        //GC 485 fields start
                        assets: [{ 
                            typeId: '', 
                            typeDetails: null, 
                            nameOfHolder: '', 
                            amount: '' 
                        }],
                        financials: { 
                            deppositsInUSBanks: '', 
                            valueOfRealEstate:'', 
                            caseSurrenderOfLifeInsurance: '', 
                            reasonalValOfPersonalProp: '', 
                            marketValOfStoks: '', 
                            sumOfLifeInsurence: '', 
                            healthInsurancePremium: '', 
                            HealthInsuranceRenewalDate: null, 
                            creditScore: '', 
                            amtOfMortgageOnProperty: '', 
                        }, 
                        liabilitiesDebts: [{ 
                            typeId: '',                    
                            typeDetails: null, 
                            amount: '' 
                        }], 
                        //GC 485 fields ends
                        iAmFromUS: null,
                        mailingAddressIsSameAsAddress:false,
                          mailingAddress: {
                              line1: null,
                              line2: null,
                              aptType: null,
                              locationId: null,
                              locationDetails: null,
                              stateId: null,
                              stateDetails: null,
                              countryId: null,
                              countryDetails: null,
                              zipcode: null
                          },
                          currentAddress:{
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        address: {
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        consulateNotifyAddress: null,
                        SSN: '',
                        hasI140ImmPetitionFiled: null,
                        I140ImmPetitionFiledDetails: null,
                        passportNumber: null,
                        passportIssuedNumber: null,
                        passportExpiryNumber: null,
                        curNonImmigrantVisaStatus: null,
                        curNonImmigrantVisaStatusDetails: null,
                        curVisaExpiryNumber: null,
                        sevisNumber: null,
                        eadNumber: null,
                        priorPeriodOfStayInUS: [{
                            _id: 0,
                            enteredNumber: null,
                            departedNumber: null,
                            visaStatus: null,
                            visaStatusDetails: null,
                            noOfDays: null,
                            dateerror: false
                        }],
                        noOfDaysStayInUS: null,
                        confirmDaysStayInUS: false,
                        hasApprovedI140: null,
                        hasPermPendingForMorethan365Days: null,
    
                         //i140
                         passportIssuedCountry:null,
                         passportIssuedCountryDetails:null,
                        immPetitionPriorityDate: null, // list your Priority Date obtained from your previous immigrant petition
                        applyI485AdjOrConsuProcess: true, // Would you like to apply for adjustment of status (I-485) or consular processing? { type: Boolean, default: false },
                        adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                        consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        areYouUnderRemoveOfIndOrUscis: null, // Are you currently under removal proceedings by the INS/USCIS? { type: Boolean, default: false },
                        anyImmPetitionFiled:null,
                        benfAssets: [
                            {
                                firstName: '',
                                lastName: '',
                                middleName: '',
                                typeOfAsset: '',
                                amount: '' 
                            }
                        ],
                        benfIncome: [
                            {
                                firstName: '',
                                lastName: '',
                                middleName: '',
                                dateOfBirth: null,
                                relToTheBenf: '',
                                amount: ''
                            }
                        ],
                        illegalGamblingOrDrug:null,
                        illegalActivityOrSource:null
                    },
                    //GC 485 fields starts
                    fatherInfo: { 
                                name: '', 
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: false, 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                                isUSCitizen: false, 
                                dateFromUSCitizen: null, //["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                    },
                    motherInfo: { 
                        name: '',                    
                        firstName: '', 
                        middleName: '', 
                        lastName: '', 
                        hasOtherNames: false , 
                        otherNames: [{ 
                            _id: 0, 
                            name: '', 
                            firstName: '', 
                            middleName: '', 
                            lastName: '', 
                        }], 
                        dateOfBirth: null, 
                        countryOfBirth: '', 
                        countryOfBirthDetails: null, 
                        provinceOfBirth: '', 
                        provinceOfBirthDetails: null, 
                        locationOfBirth: '', 
                        currentAddress: {
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: null,
                        zipcode: null
                        },
                        isUSCitizen: false, 
                        dateFromUSCitizen:null,// ["", ""],
                        nameAtBirth:{
                            firstName: '', 
                            middleName: '', 
                            lastName: '',
                        },
                        deceasedCity: '',
                        deceasedCityDetails:null,
                        deceasedDate: null,
                    },  
                     //GC 485 fields ends
                    dependentsInfo: {
                        spouse: {
                            // public charge keys start
                            inadmissibility:null,
                            highestDegreeCompleted:null,
                            listOfCertifications:'',
                            SSI:null,
                            benefitsRecAmounts:[{
                                benefitReceived: '',
                                startDate: null,
                                endDate: null,
                                amount: ''
                            }],
                            longTermInstiAtGovtExpense:null,
                            periodOfInstutions:[{
                                institutionName:'',
                                stateId:'',
                                stateDetails:null,
                                locationId:'',
                                locationDetails:null,
                                dateFrom:null,
                                dateTo:null,
                                reason:'',
                                instituteLocations:[]
                            }],
                            // public charge keys end
                            gender:'',
                            doYouWantTheSsaToIssueYouSS:false,
                            ssnFather:{
                                familyName:'',
                                givenName:''
                            },
                            ssnMother:{
                                familyName:'',
                                givenName:''
                            },
                            immigStatusLastArrival:'',
                            doYouAlreadyH4EAD:false,


                            sevisNumber: null,
                            eadNumber: null,
                            haveYouEverTravelledToUS:null,
                            isDSExpiryDate:false,
                            isI94DSExpiryDate:false,
                            relationship: '',
                            saved: false,
                            currentlyInUS: null,
                            hasOtherNames: null, 
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            passportIssuedNumber: null,
                            alienNumber: '',
                            prevEmploymentInfo: [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                payFrequency:null,
                                salary: null,
                                currentEmployer: null
                            }],
                            addressOutsideUS: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            priorPeriodOfStayInUS: [{
                                _id: 0,
                                enteredNumber: null,
                                departedNumber: null,
                                dateerror: false,
                                noOfDays: null,
                                visaStatus: null
                            }],
                            dateFromWhichResideInUs:null,
                            caseIssuedDate: null,
                            caseExpiryDate: null,
                            placeOfCaseIssued: '',
                            mailingAddressIsSameAsAddress:false,
                            stateOfLastEntryInUS: '',
                            stateDetailsOfLastEntryInUS: null,
                            placeOfLastEntryInUS: '',
                            firstArrivalDate: null,
                            lastArrivalDate: null,
                            allIssuedpassportData: [{
                                countryId: '',
                                countryDetails: null,
                                number: '',
                                issuedDate: null,
                                expiryDate: null 
                            }],
                            currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            height: {
                            feet: '',
                            inches: ''
                            },
                            weight: null,
                            race: [],
                            eyeColor:null,
                            hairColor: null,
                            educations: [{
                            _id: 0,
                            name: null,
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            highestDegree: null,
                            highestDegreeDetails: null,
                            majorFieldOfStudy: null,
                            attendedFrom: null,
                            attendedTo: null,
                            graduatedYear: null,
                            degreereceived: null,
                            isAccredited: null,
                            isForProfit: null
                            }],
                            prevEmploymentInfo: [{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            currentEmployer: false
                            }],
                            prevEmploymentOutsideUS:[{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                currentEmployer: false  
                            }],
                            previousSpouse:{
                            hasOtherNames:false,
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            maidenName:'',
                            marriageEndedDueTo:null,
                            marriageEndedOtherInfo:'',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            dateOfBirth: null,
                            dateOfMarriage:null,
                            dateOfMarriageEnd:null,
    
                              //Place of Marriage
                            countryOfMarriage: '',
                            countryOfMarriageDetails: null,
                            provinceOfMarriage: '',
                            provinceOfMarriageDetails: null,
                            locationOfMarriage: '',
    
                            //Place of Termination
                            countryOfMarriageTermination: '',
                            countryOfMarriageTerminationDetails: null,
                            provinceOfMarriageTermination: '',
                            provinceOfMarriageTerminationDetails: null,
                            locationOfMarriageTermination: '',
                            obtainPermResidenceThroughSpouse:false  
                          
                            },
                            addressOfLastNYears:[{
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                            }], 
                            addressOutsideUSMoreThanYear:[{
                            
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                            }],
                            dateOfLastEntryInUS:null,
                            dateOfMarriage: null, 
                            dateOfMarriageEnd: null, 
                            countryOfMarriage: '', 
                            countryOfMarriageDetails: null, 
                            provinceOfMarriage: '', 
                            provinceOfMarriageDetails: null, 
                            locationOfMarriage: '',
                            currentSpouseName: '',
                            maritalStatus : '', 
                            maritalStatusDetails: null,
                            curNonImmigrantVisaStatus: '', 
                            associations:[ {
                                name:'', 
                                address:{
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                },
                                startDate: null,
                                endDate:null,
                                natureofAssociations:'',
                            }],

                            isVisaDenieedTOUS:null,
                            visaDeniedReason:'',
                            haveYoueverPresntUnlawfully:false,
                            presntUnlawfullyReason:'',
                            haveYouEverReceivedPublicAssistendeInUS:false,
                            haveYouEverlikelyReceivePublicAssistendeInUS:false,
                            everAppliedAOSInUS: false, 
                            appliedAOSInUSDocs:[],
                            haveYouArrestedBefore:false,
                            haveYouArrestedBeforeDocs:[], 
                            doesBirthRegistered:false, 
                            curNonImmigrantVisaNumber:'',
                            enterInUSUnderCaseWaiverProgram: false,
                            inspectedByAnyImmOfficer: false, 
                            issuedAnyEADFromUSCIS: false, 
                            hasPermResidencyInOtherCountry: false, 
                            permResidencyCountryId: '', 
                            passportIssuedDate: null,
                            permResidencyCountryDetails: null,
                            

                            h4Required: null,
                            hasSpouse:null,
                            l2Required:null,
                            h4EADRequired: null,
                            l2EADRequired:null,
                            doYouAlreadyL2EAD:null,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            email: '',
                            phoneNumber: '',
                            phoneCountryCode: {
                                countryCode: '',
                                countryCallingCode: ''
                            },
                            dateOfBirth: null,
                            countryOfBirth: null,
                            countryOfBirthDetails: null,
                            provinceOfBirth: null,
                            provinceOfBirthDetails: null,
                            locationOfBirth: '',
                            locationOfBirthDetails: null,
                            countryOfCitizenship: null,
                            countryOfCitizenshipDetails: null,
                            passportNumber: '',
                            passportExpiryNumber: null,
                            passportIssuedCountry:null,
                            passportIssuedCountryDetails:null,
                            I94: '',
                            I94ExpiryNumber: null,
                            currentStatus: null,
                            currentStatusDetails: null,
                            statusExpiryNumber: null,
                            SSN: '',
                            lastArrivalNumber: null,
                            placeOfLastEntryInUS: '',
                            applyingWithYou:false,
                            classification:'',
                            nameDiffFromBirthCert:false,
                            i140PriorityDate:null,
                            physicalAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            fatherInfo: { 
                                name: '', 
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: false, 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                                isUSCitizen: false, 
                                dateFromUSCitizen: null, //["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                            },
                            motherInfo: { 
                                name: '',                    
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: false , 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                                },
                                isUSCitizen: false, 
                                dateFromUSCitizen:null,// ["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                            }, 
                            documents: {
                                eadCard:[],
                                passport: [],
                                visa: [],
                                formI94: [],
                                formI797: [],
                                formI20: [],
                                payStubs: [],
                                marriageCertificate: [],
                                noticeOfApprovalOfH1Status: [],
                                approvalNoticeOfPrevH4: [],
                                other: []
                            },
                            //i140
                            adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        
    
                        },
                        childrens: [{
                            // public charge keys start
                            inadmissibility:null,
                            highestDegreeCompleted:null,
                            listOfCertifications:'',
                            SSI:null,
                            benefitsRecAmounts:[{
                                benefitReceived: '',
                                startDate: null,
                                endDate: null,
                                amount: ''
                            }],
                            longTermInstiAtGovtExpense:null,
                            periodOfInstutions:[{
                                institutionName:'',
                                stateId:'',
                                stateDetails:null,
                                locationId:'',
                                locationDetails:null,
                                dateFrom:null,
                                dateTo:null,
                                reason:'',
                                instituteLocations:[]
                            }],
                            // public charge keys end
                            maritalStatusDetails:null,
                            maritalStatus:'',
                            gender:'',
                            doYouWantTheSsaToIssueYouSS:false,
                            ssnFather:{
                                familyName:'',
                                givenName:''
                            },
                            ssnMother:{
                                familyName:'',
                                givenName:''
                            },
                            immigStatusLastArrival:'',
                            doYouAlreadyH4EAD:false,
                            sevisNumber: null,
                            eadNumber: null,
                            haveYouEverTravelledToUS:null,
                            isDSExpiryDate:false,
                            isI94DSExpiryDate:false,
                            email: '',
                            phoneNumber: '',
                            phoneCountryCode: {
                            countryCode: '',
                            countryCallingCode: ''
                            },
                            saved: false,
                            relationship: '',
                            currentlyInUS: null,
                            hasOtherNames: null,
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            alienNumber: '',
                            lastArrivalNumber: null,
                            placeOfLastEntryInUS: '',
                            physicalAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: {
                                    id: null,
                                    name: null,
                                    stateId: null,
                                    countryId: null
                                },
                                stateId: null,
                                stateDetails: {
                                    id: null,
                                    name: null,
                                    countryId: null
                                },
                                countryId: null,
                                countryDetails: {
                                    id: null,
                                    name: null,
                                    shortName: null,
                                    phoneCode: null,
                                    countryId: null,
                                    currencySymbol: null,
                                    currencyCode: null,
                                    zipcodeLength: null
                                },
                                zipcode: null
                            },
                            addressOutsideUS: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: {
                                    id: null,
                                    name: null,
                                    stateId: null,
                                    countryId: null
                                },
                                stateId: null,
                                stateDetails: {
                                    id: null,
                                    name: null,
                                    countryId: null
                                },
                                countryId: null,
                                countryDetails: {
                                    id: null,
                                    name: null,
                                    shortName: null,
                                    phoneCode: null,
                                    countryId: null,
                                    currencySymbol: null,
                                    currencyCode: null,
                                    zipcodeLength: null
                                },
                                zipcode: null
                            },
                            passportIssuedNumber: null,
                            priorPeriodOfStayInUS: [{
                                _id: 0,
                                enteredNumber: null,
                                dateerror: false,
                                noOfDays: null,
                                departedNumber: null,
                                visaStatus: null
                            }],
                            prevEmploymentInfo: [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                salary: null,
                                payFrequency:null,
                                currentEmployer: null,
                            }],
                            anyOtherPersonEmployedInUS:null,
                            haveYouEverEmployed:null,
                            lastArrivalDate:null,
                            stateOfLastEntryInUS: '',
                            stateDetailsOfLastEntryInUS: null,
                            placeOfLastEntryInUS: '',
                            h4Required: null,
                            hasChildren:null,
                            l2Required:null,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            dateOfBirth: null,
                            countryOfBirth: null,
                            countryOfBirthDetails: null,
                            provinceOfBirth: null,
                            provinceOfBirthDetails: null,
                            locationOfBirth: '',
                            locationOfBirthDetails: null,
                            countryOfCitizenship: null,
                            countryOfCitizenshipDetails: null,
                            passportIssuedCountry:null,
                            passportIssuedCountryDetails:null,
                            passportNumber: '',
                            passportExpiryNumber: null,
                            I94: '',
                            I94ExpiryNumber: null,
                            currentStatus: null,
                            statusExpiryNumber: null,
                            documents: {
                                passport: [],
                                visa: [],
                                formI94: [],
                                birthCertificate: [],
                                approvalNotice: [],
                                approvalNoticeOfPrevH4: [],
                                other: []
                            },
    
                             //i140
                             adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        
                        }]
                    },
                    documents: {
                        eadCard:[],
                        marriageCertificate:[],
                        underlyingLaborApplications:[],
                        mostRecentTaxTranscrips:[],
                        empAuth:[],
                        permResidence:[],
                        recentCreditReport:[],
                        proofOfMedicalInsurence:[],
                        proofOfIncomeOrAsset:[],
                        evidenceOfFilePetitionBefore30Apr2001:[],
                        evidenceOfContinuVisaStatus:[],
                        bankStatements:[],
                        dependentTaxReturns:[],
                        dependentForI134:[],
                        medicalExamins:[],
                        photographs:[],
                        w2: [],

                        // added fields
                        resume: [],
                        education: [],
                        expLetters: [],
                        INSNotices: [],
                        I140ApprovalNotice: [],
                        passport: [],
                        passportVisaI94: [],
                        formI20: [],
                        socialSecurityCardAndProfLicense: [],
                        other: [],
                        payStubs: [],
                        offerLetter: [],
                        clientLetter: [],
                        vendorLetter: [],
                        msa: [],
                        po: [],
                        beneficiaryDocs: [],
                        h1bRegSelectionNotice: [],
                        employmentAgreement: [],
                        primeVendor: [],
                        formI94: [],
                        priorFormI797: [],
                        I797NoticeofApprovalforI140: [],
                        ead: [],
                        slgResume: [],
                        slgCollegeDegreesCert: [],
                        slgTransScripts: [],
                        slgExpLetters: [],
                        slgPassportAndVisa: [],
                        slgI94: [],
                        slgPrevNonimmApprovalNotices: [],
                        slgI140OrPermNoties: [],
                        slgPrevLaborApplications: [],
                        slgAckOfPrevLaborApplications: [],
                        slgPaystubs: [],
                        slgI20: [],
                        slgEad: [],
                        capSelectNotice:[],
                        bnfSpouseLatestI797:[],
                        bnfSpousePassport:[],
                        bnfSpouseRecentPayStubs:[],
                        bnfSpouseFormAllI20:[],
                        slgEvalOfEduCredentials:[],
                        slgEvalOfEduExpCredentials:[],
    
                        // case i140
                        // w2:[],
                        // slgEvalOfEduCredentials:[],
                        // slgPrevImmApprovalNotices:[],

                        // L1 case DOcs
                        last12MonthsPayslips: [], // Beneficiary’s Pay Slips (past 12 months)
                        proExecOrmanagerial: [], // Documents to prove executive or managerial functions (Ex. Email communication/Contracts Executed, etc.) (only for L1A)
                        copyOfVeriPoliBenfApproved: [], //Copies of various policies Beneficiary approved
                        copyOfContExecByBeneficiary: [], //Copies of Contracts executed by Beneficiary (only for L1A)
                        copyOfBoardMinBenfPlayRole: [], // Copies of Board Minutes where Beneficiary played a role (only for L1A)
                        payRevisionLetters: [], // Pay Revision Letters (Exhibit 14) (only for L1A)
                        leaveAppliForms: [], // Leave Application Forms (Exhibit 14) (only for L1A)
                        manageManPowerReq: [], // Manage Manpower Request (Exhibit 14) (only for L1A)
                        offerLetterFromUSComp: [], // Offer letter from the US Company
                        empAgreementFromUSComp: [], //Employment Agreement from the US Company,
                        offerLetterFromForeComp: [], // Offer letter from the Foreign Company
                        empAgreementFromForeComp: [], // Employment Agreement from the Foreign Company
                        trainingCert: [], // Training Certificate (only for L1B) optional
                        proofOfSpecKnowledge: [], // Proof of specialized knowledge (Note: Technical and functional knowledge) (only for L1B)
                    },
                    lcaRequested: false,
                    questionnaireFilled: false,
                    questionnaireFilled_temp: false,
                    lcaId: null,
                    statusId: 1,
                    status: 1,
                    questionnaireSent: true,
                    questionnaireInstructions: '',
                    assignOrSubmitRoleComment: '',
                    curWorkflowActivity: 'CREATE_PETITION',
                    nextWorkflowActivity: ['SUBMIT_BY_BENEFICIARY'],
                        //  relationships:[
                        //     {
                        //     "id":"Son",
                        //  "name":"Son"
                        //  },{
                        //     "id":"Daughter",
                        //  "name":"Daughter"
                        //  }
                        //  ]
                         relationships:['Son','Daughter']
    
                },
                tempPetition: {
                    tenantId: null,
                    petitionerId: null,
                    companyId: null,
                    branchId: null,
                    workflowId: null,
                    customId: '',
                    caseNo: '',
                    caseNoOld: '',
                    caseNoRef: '',
                    caseNoSNo: 0,
                    allowCustomCaseNo: false,
                    caseNumber: null,
                    type: null,
                    subType: null,
                    masterSocList:[], 
                   // We need to ask above job details in case we don't have the beneficiary PERM info in our system
                    jobDetails: {
                        socCode:'',
                        socDetails:null,
                        
    
                        jobTitle: '',
    
                        workAddresses: [
                        {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            }
                        ],
    
                        fullTimePosition: false,
    
                        hoursPerWeek: '',
    
                        wageRate: '',
    
                        payFrequency: 'Month', // Year, Month, Bi-Weekly, Week, Hour
    
                        description: '',
    
                        permanentPosition: false,
    
                        newPosition: false
    
                    },
                    beneficiaryInfo: {
                        houseHoldNumber:'',
                        houseHoldAnnualIncome:'',
                        houseHoldAnnualAssets:'',
                        houseHoldAnnualliabilities:'', 
                        // public charge keys start
                        inadmissibility:null,
                        highestDegreeCompleted:null,
                        listOfCertifications:'',
                        SSI:null,
                        benefitsRecAmounts:[{
                            benefitReceived: '',
                            startDate: null,
                            endDate: null,
                            amount: ''
                        }],
                        longTermInstiAtGovtExpense:null,
                        periodOfInstutions:[{
                            institutionName:'',
                            stateId:'',
                            stateDetails:null,
                            locationId:'',
                            locationDetails:null,
                            dateFrom:null,
                            dateTo:null,
                            reason:'',
                            instituteLocations:[]
                        }],
                        // public charge keys end
                        // L1 visa starts
                        typeOfOffice:'',
                        officeAddress:{
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        // L1 visa Ends
                        everDeniedAdmissionInUS: null, // 14.Have you EVER been denied admission to the United States?
                        isVisaDenieedTOUS: null, /// 15.HAVE YOU EVER BEEN DENIED A VISA TO THE UNITED STATES?
                        everWorkedInUSWithoutAuth: null, // 16. Have you EVER worked in the United States without authorization?
                        everViolatedTandCofYourNonImmStatus: null, // 17. Have you EVER violated the terms or conditions of your nonimmigrant status?
                        everBeenInRemovalExcl: null, // 18. Are you presently or have you EVER been in removal, exclusion, rescission, or deportation proceedings?
                        everBeenIssuedOrderExclRemoval: null, // 19. Have you EVER been issued a final order of exclusion, deportation, or removal?
                        everHadPriorOrderExclDeport: null, // 20. Have you EVER had a prior final order of exclusion, deportation, or removal reinstated?
                        
                        everHeldPermResidentStatus: null, //21.Have you EVER held lawful permanent resident status which was later rescinded?
                        everGrantedVolDepartimmgOfficer: null,//22.Have you EVER been granted voluntary departure by an immigration officer or an immigration judge but failed todepart within the allotted time?
                        everAppliedReliefOrExclDeport: null,//23.Have you EVER applied for any kind of relief or protection from removal, exclusion, or deportation?
                        everJNonImmmExchangeVistor: null,//24.a. Have you EVER been a J nonimmigrant exchange visitor who was subject to the two-year foreign residencerequirement?
                        //if 24.a yes
                        everCompailedForeignResi: null, //24.b Have you complied with the foreign residence requirement?
                        everGrantedWavierRecomndLtr: null, //24.c Have you been granted a waiver or has Department of State issued a favorable waiver recommendation letter for you? 
                        
                        //Criminal Acts and Violations
                        everArrested: null, //25. Have you EVER been arrested, cited, charged, or detained for any reason by any law enforcement official(including but not limited to any U.S. immigrationofficial or any official of the U.S. armed forces or U.S.Coast Guard)?
                        everCommittedCrime: null, //26.Have you EVER committed a crime of any kind (even if you were not arrested, cited, charged with, or tried for thatcrime)? 
                        everPledGuilty: null, //27.Have you EVER pled guilty to or been convicted of a crime or offense (even if the violation was subsequently expunged or sealed by a court, or if you were granted apardon, amnesty, a rehabilitation decree, or other act ofclemency)?
                        everPunishedByJudge: null, //28.Have you EVER been ordered punished by a judge or had conditions imposed on you that restrained your liberty(such as a prison sentence, suspended sentence, housearrst, parole, alternative sentencing, drug or alcoholtreatment, rehabilitative programs or classes, probation, orcommunity service)?
                        everAccusedCrimProc: null, //29.Have you EVER been a defendant or the accused in acriminal proceeding (including pre-trial diversion,deferred prosecution, deferred adjudication, or any withheld adjudication)? 
                        everViolated: null, //30.Have you EVER violated (or attempted or conspired toviolate) any controlled substance law or regulation of astate, the United States, or a foreign country?
                        everConvictedTwoOrMoreOffens: null,//31.Have you EVER been convicted of two or more offenses(other than purely political offenses) for which thecombined sentences to confinement were five years ormore?
                        everIlleglTraf: null, //32.Have you EVER illicitly (illegally) trafficked or benefitedfrom the trafficking of any controlled substances, such aschemicals, illegal drugs, or narcotics?
                        everKnowinglyIlleglTraf: null, //33.Have you EVER knowingly aided, abetted, assisted,conspired, or colluded in the illicit trafficking of anyillegal narcotic or other controlled substances?
                        everSpouseSondaughterIlleglTraf: null,//34. Are you the spouse, son, or daughter of a foreign nationalwho illicitly trafficked or aided (or otherwise abetted,assisted, conspired, or colluded) in the illicit trafficking ofa controlled substance, such as chemicals, illegal drugs, ornarcotics and you obtained, within the last five years, anyfinancial or other benefit from the illegal activity of yourspouse or parent, although you knew or reasonably shouldhave known that the financial or other benefit resultedfrom the illicit activity of your spouse or parent?
                        everEngageProst: null,//35.Have you EVER engaged in prostitution or are you coming to the United States to engage in prostitution?
                        everdirOrIndirectProst: null, //36.Have you EVER directly or indirectly procured (or attempted to procure) or imported  prostitutes or persons for the purpose of prostitution?
                        everReceiveMoneyFronProst: null, //37.Have you EVER received any proceeds or money fromprostitution?
                        everIntentIllegalGamblUS: null, //38.Do you intend to engage in illegal gambling or any other form of commercialized vice, such as prostitution,bootlegging, or the sale of child pornography, while in the United States?
                        everImmunityCriminalOffensedInUS: null, //39.Have you EVER exercised immunity (diplomatic or otherwise) to avoid being prosecuted for a criminaloffense in the United States?
                        everViolateReliFreedomAsForeignGovOffi: null,//40. Have you EVER, while serving as a foreign governmentofficial, been responsible for or directly carried outviolations of religious freedoms?
                        everForceFraudCommercialSexActs: null,//41.Have you EVER induced by force, fraud, or coercion (orotherwise been involved in) the trafficking of persons forcommercial sex acts?
                        everTraffPersonIntoInvolSlavery: null, //42.Have you EVER trafficked a person into involuntary servitude, peonage, debt bondage, or slavery? Trafficking includes recruiting, harboring, transporting, providing, or obtaining a person for labor or services through the use offorce, fraud, or coercion.
                        everKnowWithTraffPersonCommSexAct: null, //43.Have you EVER knowingly aided, abetted, assisted, conspired, or colluded with others in trafficking persons for commercial sex acts or involuntary servitude, peonage, debt bondage, or slavery?
                        everSpouseSonDughterEngTraffAnyFinBef: null,//44.Are you the spouse, son or daughter of a foreign national who engaged in the trafficking of persons and have received or obtained, within the last five years, any financial or other benefits from the illicit activity of your spouse or your parent, although you knew or reasonably should have known that this benefit resulted from the illicit activity of your spouse or parent?
                        everEngMoneyLaundering: null,//45.Have you EVER engaged in money laundering or have you EVER knowingly aided, assisted, conspired, or colluded with others in money laundering or do you seek to enter the United States to engage in such activity?
                        
                        //Security and Related
                        everViolateEvidenceLawRelatedInUS: null,//46.a. Engage in any activity that violates or evades any law relating to espionage (including spying) or sabotage in theUnited States?
                        everViolateExpGoodsSensInfoTechInUS: null,//46.b. Engage in any activity in the United States that violates or evades any law prohibiting the export from the United States of goods, technology, or sensitive information? 
                        everOverthrowingUSGovtByForceViolence: null,//46.c. Engage in any activity whose purpose includes opposing,controlling, or overthrowing the U.S. Government byforce, violence, or other unlawful means while in theUnited States?
                        everActivityDangerScurityOfUs: null,//46.d.Engage in any activity that could endanger the welfare,safety, or security of the United States? 
                        everEngUnlawfulActivity: null,//46.e.Engage in any other unlawful activity?
                        everEngActSeriousForeignPolicyforUs: null,//47.Are you engaged in or, upon your entry into the United States, do you intend to engage in any activity that could have potentially serious adverse foreign policy consequences for the United States?
                        everCommitedKidnapHjkEtc: null,//48.a. Committed, threatened to commit, attempted to commit,conspired to commit, incited, endorsed, advocated,planned, or prepared any of the following: hijacking,sabotage, kidnapping, political assassination, or use of aweapon or explosive to harm another individual or causesubstantial damage to property? 
                        everCommMemberGrpOrgKidnapHjkEtc: null, //48.b. Participated in, or been a member of, a group ororganization that did any of the activities described in Item Number 48.a.? 
                        everAskMoneyRecruGrpKidnapHijackEtc: null, //48.c.Recruited members or asked for money or things of value for a group or organization that did any of the activitiesdescribed in Item Number 48.a.?
                        everProvideMoneyForAssiKidnapHjkEtc: null, //48.d.Provided money, a thing of value, services or labor, orany other assistance or support for any of the activitiesdescribed in Item Number 48.a.? 
                        everProvideMoneyForAssiIndiGrpKidnapHjkEtc: null,//48.e. Provided money, a thing of value, services or labor, or any other assistance or support for an individual, group,or organization who did any of the activities described inItem Number 48.a.?
                        everTraiParaOrMilataryWepons: null,//49.Have you EVER received any type of military,paramilitary, or weapons training? 
                        everEngKidnapHjkEtc: null,//50.Do you intend to engage in any of the activities listed in any part of Item Numbers 48.a. - 49.?
                        //if answered yes items b/w 46.a to 50
                        //Additional info
                        everSpoOrChiEngKidnapHjkEtc: null,//51.a. Committed, threatened to commit, attempted to commit,conspired to commit, incited, endorsed, advocated,planned, or prepared any of the following: hijacking,sabotage, kidnapping, political assassination, or use of a weapon or explosive to harm another individual or cause substantial damage to property? 
                        everHSpoOrChiPartMemberKidnapHjkEtc: null, //51.b. Participated in, or been a member or a representative of agroup or organization that did any of the activities described in Item Number 51.a.? 
                        everSpoOrChiRecrutKidnapHjkEtc: null, //51.c. Recruited members, or asked for money or things of value,for a group or organization that did any of the activities described in Item Number 51.a.? 
                        everSpoOrChiAskMoneyAssiKidnapHjkEtc: null,//51.d. Provided money, a thing of value, services or labor, or any other assistance or support for any of the activities described in Item Number 51.a.? 
                        everSpoOrChiForAssiIndiGrpKidnapHjkEtc: null,//51.e. Provided money, a thing of value, services or labor, or any other assistance or support to an individual, group, or ganization who did any of the activities described in Item Number 51.a.? 
                        everSpoOrChiTraiParaOrMilataryWeponKidnapHjkEtc: null,//51.f. Received any type of military, paramilitary, or weapons training from a group or organization that did any of the activities described in Item Number 51.a.? 
                        //if answered yes items of 51
                        //Additional info
                        everSellProvideTransWepon: null,//52. Have you EVER assisted or participated in selling,providing, or transporting weapons to any person who,to your knowledge, used them against another person?
                        everWorkedPrisionAndDetained: null,//53. Have you EVER worked, volunteered, or otherwiseserved in any prison, jail, prison camp, detention facility,labor camp, or any other situation that involved detainingpersons?
                        everUsingWeponPartGrpOrgThreatPerson: null,//54.Have you EVER been a member of, assisted, or participated in any group, unit, or organization of anykind in which you or other persons used any type ofweapon against any person or threatened to do so?
                        everServedParaOrMilataryEtc: null,//55.Have you EVER served in, been a member of, assisted,or participated in any military unit, paramilitary unit,police unit, self-defense unit, vigilante unit, rebel group,guerilla group, militia, insurgent organization, or anyother armed group?
                        everMemberCommPartyInUS: null,//56.Have you EVER been a member of, or in any way affiliated with, the Communist Party or any othertotalitarian party (in the United States or abroad)?
                        ever080545To230393AssoNaziGerGov: null,//57.During the period from March 23, 1933 to May 8, 1945,did you ever order, incite, assist, or otherwise participatein the persecution of any person because of race, religion,national origin, or political opinion, in association witheither the Nazi government of Germany or anyorganization or government associated or allied with theNazi government of Germany?
                        everInvolveTorture: null,//58.a. Acts involving torture or genocide?
                        everKillAnyPerson: null,//58.b.Killing any person?
                        everSeverInjuAnyPerson: null,//58.c.Intentionally and severely injuring any person?
                        everEngAnySexualContent: null,//58.d. Engaging in any kind of sexual contact or relations with any person who did not consent or was unable to consent, or was being forced or threatened?
                        everLimitReligBnf: null,//58.e. Limiting or denying any person's ability to exercise religious beliefs?
                        everUsedBelow15yrsPerson: null,//59.Have you EVER recruited, enlisted, conscripted, or usedany person under 15 years of age to serve in or help anarmed force or group?
                        everHelpUnder15yrsPerson: null,//60. Have you EVER used any person under 15 years of age to take part in hostilities, or to help or provide services to people in combat?
                        //if answered yes items b/w 52 to 60
                        //Public Assistance
                        everRcvPublicAssiInUS: null,//61.Have you received public assistance in the United Statesfrom any source, including the U.S. Government or anystate, county, city, or municipality (other than emergencymedical treatment)?
                        everFutureRcvPublicAssiInUs: null,//62.Are you likely to receive public assistance in the future inthe United States from any source, including the U.S.Government or any state, county, city, or municipality(other than emergency medical treatment)?
                        //Illegal Entries and Other Immigration Violations
                        everAttenRmvProcFiledAfter010497: null,//63.a. Have you EVER failed or refused to attend or to remain in attendance at any removal proceeding filed against youon or after April 1, 1997?
                        everRmvProcFiledReason: null,//63.b. If your answer to Item Number 63.a. is "Yes," do youbelieve you had reasonable cause?
                        rmvProcFiledResonWriteStmt: '',//63.c.If your answer to Item Number 63.b. is "Yes," attach a written statement explaining why you had reasonable cause.
                        everSubmitFraudDocUSGov: null,//64.Have you EVER submitted fraudulent or counterfeit documentation to any U.S. Government official to obtainor attempt to obtain any immigration benefit, including avisa or entry into the United States?
                        everLiedMisrepreInfoEnterUS: null,//65.Have you EVER lied about, concealed, or misrepresented any information on an application or petition to obtain avisa, other documentation required for entry into theUnited States, admission to the United States, or any otherkind of immigration benefit?
                        everClaimFlaslyUSCitizen: null,//66.Have you EVER falsely claimed to be a U.S. citizen (inwriting or any other way)?
                        everStowawayOnVessel: null,//67.Have you EVER been a stowaway on a vessel or aircraft arriving in the United States?
                        everTrytoEnterUsIllegaly: null,//68. Have you EVER knowingly encouraged, induced, assisted,abetted, or aided any foreign national to enter or to try toenter the United States illegally (alien smuggling)?
                        everFinalOrderCivilPenalty: null,//69. Are you under a final order of civil penalty for violating INA section 274C for use of fraudulent documents?
                        //Removal, Unlawful Presence, or Illegal Reentry After Previous Immigration Violations
                        everRemovedfromUs: null,//70. Have you EVER been excluded, deported, or removedfrom the United States or have you ever departed theUnited States on your own after having been ordered excluded, deported, or removed from the United States?
                        everEnterUSWithoutInspAdmit: null, //71.Have you EVER entered the United States without being inspected and admitted or paroled?
                        everSince010497More180DLessYrULFStayUS: null,//72.a. For more than 180 days but less than a year, and thendeparted the United States?
                        everSince010497YrOrMoreULFDepartUS: null,//72.b.For one year or more and then departed the United States?  
                        everSince010497ReEntMoreYrULFStayUS: null,//73.a.Having been unlawfully present in the United States for more than one year in the aggregate?
                        everSince010497RmvFromUS: null,//73.b.Having been deported, excluded, or removed from the United States?
                        //Miscellaneous Conduct
                        planForPractPolyInUS: null,//Do you plan to practice polygamy in the United States?
                        AreYouAccomOtherCountry: null,//75.Are you accompanying another foreign national who requires your protection or guardianship but who isinadmissible after being certified by a medical officer asbeing helpless from sickness, physical or mentaldisability, or infancy, as described in INA section 232(c)?
                        everAnyUsChildUnderCustody: null,//76. Have you EVER assisted in detaining, retaining, or withholding custody of a U.S. citizen child outside theUnited States from a U.S. citizen who has been grantedcustody of the child?
                        everVoilationAnyFedaral: null,//77.Have you EVER voted in violation of any Federal, state,or local constitutional provision, statute, ordinance, orregulation in the United States?
                        everUsCtzshipAvoidTax: null,//78.Have you EVER renounced U.S. citizenship to avoidbeing taxed by the United States?
                        everAppliedForExemptServiceUS: null,//79.a. Applied for exemption or discharge from training or service in the U.S. armed forces or in the U.S. NationalSecurity Training Corps on the ground that you are aforeign national?
                        everReliServTrainAreYouForeignNation: null,//79.b. Been relieved or discharged from such training or serviceon the ground that you are a foreign national?
                        everConvictDestUSArmedForce: null,//79.c. Been convicted of desertion from the U.S. armed forces?
                        everRemOutsideUSAviodTrainArmedForce: null,//80.a. Have you EVER left or remained outside the United States to avoid or evade training or service in the U.S.armed forces in time of war or a period declared by thePresident to be a national emergency?
                        nationImgrstaIfAviodTrainArmForcUS: '',//80.b. If your answer to Item Number 80.a. is “Yes,” what was your nationality or immigration status immediately beforeyou left (for example, U.S. citizen or national, lawfulpermanent resident, nonimmigrant, parolee, present without admission or parole, or any other status)?
        
                        hasMasterDegreeInUS:null,
                        isDSExpiryDate:false,
                        isI94DSExpiryDate:false,
                        anyOtherPersonEmployedInUS:null,
                        haveYouEverEmployed:null,
                        hasAnyDependetsinUStoFileH4 : null,
                        maritalStatusDetails:null,
                        haveYouEverTravelledToUS:null,
                        currentlyInUS: null,
                        haveOwnershipInterest: null,
                        ownershipInterestDesc: '',
                        haveYouEverAppliedH1bCase:null,
                        prevH1bCaseStatus:null,
                        prevH1bCaseDesc:'',
                        anyImmPetitionFiledDesc:'',
                        beneficiaryCnfmNumber:null,
                        capType:'',
                        serviceCenterName:'',
                        consulateInfo: {
                            locationId: null,
                            locationDetails: null,
                            // stateId: null,
                            // stateDetails: null,
                            countryId: null,
                            countryDetails: null
                        },
                        alienNumber: '',
                        lastArrivalNumber: null,
                        placeOfLastEntryInUS: '',
                        educations: [{
                            _id: 0,
                            name: null,
                            graduatedDate:null,
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            highestDegree: null,
                            highestDegreeDetails: null,
                            majorFieldOfStudy: null,
                            attendedFrom: null,
                            attendedTo: null,
                            graduatedYear: null,
                            degreereceived: null,
                            isAccredited: null,
                            isForProfit: null
                        }],
                        nonImmPetitionsInfo: [{
                            _id: 0,
                            visaStatus: null,
                            visaStatusDetails: null,
                            receiptNo: '',
                            petitionerName: '',
                            validFrom:null, 
                            validTo:null
                        }],
                        h1bImmPetitionsInfo: [{
                            _id: 0,
                            typeId: null,
                            typeDetails: null,
                            receiptNo: '',
                            petitionerName: '',
                            validFrom:null,
                            validTo:null
                        }],
                        didThisPtnrFliedImmPetitionEarlier:null,
                        secOrSubSequentExtnWithPtnr:false,
                        firstExtnWithPtnr:false,
                        anyImmPetitionFiled: null,
                        immPetitionInfo: {
                            anyOtherAlienFiled: null,
                            filedNumber: null,
                            employerName: '',
                            rirOrRegularProcessing: null,
                            filedStateId: null,
                            filedStateDetails: null,
                            applCurStatus: '',
                            seekingFilednullforETA750: null,
                            anyI140Filed: null,
                            i140Info: {
                                fieldNumber: null,
                                employerName: '',
                                priorityNumber: null,
                                eb2orEb3: '',
                                currentStatus: ''
                            }
                        },
                        prevEmploymentInfo: [{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            salary:null,
                            payFrequency:null,
                            currentEmployer: null
                        }],
                        prevEmploymentOutsideUS:[{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            currentEmployer: false  
                        }],
                        addressOutsideUS: {
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
    
                        name: '',
                        firstName: '',
                        middleName: '',
                        lastName: '',
                        hasOtherNames: null, 
                        otherNames: [{
                            _id: 0,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                        }],
                        gender: '',
                        email: '',
                        education: {
                            highestDegree: null,
                            highestDegreeDetails: null,
                            majorFieldOfStudy: ''
                        },
                        maritalStatus: null,
                        // GC 485 fields start
                        noOfChildrens: '',
                        noOfTimesMarriedBeneficiary:null,
                        dateOfMarriage: '',
                        countryOfMarriage: '',
                        countryOfMarriageDetails: null,
                        provinceOfMarriage: '',
                        provinceOfMarriageDetails: null,
                        locationOfMarriage: '',
                        doYouHaveMarriageCert: false ,
                        marriageCertDocs: [],
                        have2AffidavitsAttestingToMarriage: false,
                        nameDiffFromBirthCert:null,
                        have2AffidavitsOfBirthFamily:null,
                        birthCertHaveNamePobDob:false,
                        previouslyMarried:false,
                        previousSpouse:{
                            hasOtherNames:false,
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            maidenName:'',
                            marriageEndedDueTo:null,
                            marriageEndedOtherInfo:'',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            dateOfBirth: null,
                            dateOfMarriage:null,
                            dateOfMarriageEnd:null,
                              //Place of Marriage
                            countryOfMarriage: '',
                            countryOfMarriageDetails: null,
                            provinceOfMarriage: '',
                            provinceOfMarriageDetails: null,
                            locationOfMarriage: '',
    
                            //Place of Termination
                            countryOfMarriageTermination: '',
                            countryOfMarriageTerminationDetails: null,
                            provinceOfMarriageTermination: '',
                            provinceOfMarriageTerminationDetails: null,
                            locationOfMarriageTermination: '',
                            obtainPermResidenceThroughSpouse:false  
                          
                        },
                        publicBenefits:[],
                        // GC 485 fields close
                        dateOfBirth: null,
                        countryOfBirth: null,
                        countryOfBirthDetails: null,
                        provinceOfBirth: null,
                        provinceOfBirthDetails: null,
                        locationOfBirth: null,
                        countryOfCitizenship: null,
                        countryOfCitizenshipDetails: null,
                        I94: null,
                        I94ExpiryDate: null,
                        I94StatusName:'',
                        //GC 485 fields start
                        height: {
                        feet: '',
                        inches: ''
                        },
                        weight: null,
                        race: [],
                        eyeColor: null,
                        hairColor: null,
                        firstArrivalDate: null,
                        lastArrivalDate: null,
                        reasonOfLastArrival: '',
                        stateOfLastEntryInUS: '',
                        stateDetailsOfLastEntryInUS: null,
                        placeOfLastEntryInUS: '',
                        caseIssuedDate: null,
                        caseExpiryDate: null,
                        placeOfCaseIssued: '',
                        i140PriorityDate:null,
                        classification:'',
                        // GC 485 fields end
                        homePhoneNumber: null,
                        homePhoneCountryCode: {
                            countryCode: '',
                            countryCallingCode: ''
                        },
                        cellPhoneNumber: null,
                        cellPhoneCountryCode: {
                            countryCode: '',
                            countryCallingCode: ''
                        },
                        // GC 485 fields start
                        allIssuedpassportData: [{
                            countryId: '',
                            countryDetails: null,
                            number: '',
                            issuedDate: null,
                            expiryDate: null 
                        }],
                        curVisaExpiryDate:null,
                        dateFromWhichResideInUs:null,
                        inspectedByAnyImmOfficer:false,
                        issuedAnyEADFromUSCIS:false,
                        enterInUSUnderCaseWaiverProgram:false,
                        curNonImmigrantVisaNumber:null,
                        hasPermResidencyInOtherCountry:false,
                        permResidencyCountryId:'',
                        haveYouArrestedBefore:null,
                        everAppliedAOSInUS:null,
                        haveYouEverReceivedPublicAssistendeInUS:null,
                        isVisaDenieedTOUS:null,
                        visaDeniedReason:null,
                        haveYoueverPresntUnlawfully:null,
                        presntUnlawfullyReason:null,
                        haveYouEverlikelyReceivePublicAssistendeInUS:null,
                        permResidencyCountryDetails:null,
                        addressOfLastNYears:[{
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                        }], 
                        addressOutsideUSMoreThanYear:[{
                        
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null,
                            startDate: null,
                            endDate: null,
                        }],
                        associations:[ {
                            name:'', 
                            address:{
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                            },
                            startDate: null,
                            endDate:null,
                            natureofAssociations:'',
                        }],
                        // GC 485 fields end
                        //GC 485 fields start
                        assets: [{ 
                            typeId: '', 
                            typeDetails: null, 
                            nameOfHolder: '', 
                            amount: '' 
                        }],
                        financials: { 
                            deppositsInUSBanks: '', 
                            valueOfRealEstate:'', 
                            caseSurrenderOfLifeInsurance: '', 
                            reasonalValOfPersonalProp: '', 
                            marketValOfStoks: '', 
                            sumOfLifeInsurence: '', 
                            healthInsurancePremium: '', 
                            HealthInsuranceRenewalDate: null, 
                            creditScore: '', 
                            amtOfMortgageOnProperty: '', 
                        }, 
                        liabilitiesDebts: [{ 
                            typeId: '',                    
                            typeDetails: null, 
                            amount: '' 
                        }], 
                        //GC 485 fields ends
                        iAmFromUS: null,
                        mailingAddressIsSameAsAddress:false,
                          mailingAddress: {
                              line1: null,
                              line2: null,
                              aptType: null,
                              locationId: null,
                              locationDetails: null,
                              stateId: null,
                              stateDetails: null,
                              countryId: null,
                              countryDetails: null,
                              zipcode: null
                          },
                          currentAddress:{
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        address: {
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        consulateNotifyAddress: null,
                        SSN: '',
                        hasI140ImmPetitionFiled: null,
                        I140ImmPetitionFiledDetails: null,
                        passportNumber: null,
                        passportIssuedNumber: null,
                        passportExpiryNumber: null,
                        curNonImmigrantVisaStatus: null,
                        curNonImmigrantVisaStatusDetails: null,
                        curVisaExpiryNumber: null,
                        sevisNumber: null,
                        eadNumber: null,
                        priorPeriodOfStayInUS: [{
                            _id: 0,
                            enteredNumber: null,
                            departedNumber: null,
                            visaStatus: null,
                            visaStatusDetails: null,
                            noOfDays: null,
                            dateerror: false
                        }],
                        noOfDaysStayInUS: null,
                        confirmDaysStayInUS: false,
                        hasApprovedI140: null,
                        hasPermPendingForMorethan365Days: null,
    
                         //i140
                         passportIssuedCountry:null,
                         passportIssuedCountryDetails:null,
                        immPetitionPriorityDate: null, // list your Priority Date obtained from your previous immigrant petition
                        applyI485AdjOrConsuProcess: true, // Would you like to apply for adjustment of status (I-485) or consular processing? { type: Boolean, default: false },
                        adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                        consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        areYouUnderRemoveOfIndOrUscis: null, // Are you currently under removal proceedings by the INS/USCIS? { type: Boolean, default: false },
                        benfAssets: [
                            {
                                firstName: '',
                                lastName: '',
                                middleName: '',
                                typeOfAsset: '',
                                amount: '' 
                            }
                        ],
                        benfIncome: [
                            {
                                firstName: '',
                                lastName: '',
                                middleName: '',
                                dateOfBirth: null,
                                relToTheBenf: '',
                                amount: ''
                            }
                        ],
                        illegalGamblingOrDrug:null,
                        illegalActivityOrSource:null
                    },
                    //GC 485 fields starts
                    fatherInfo: { 
                                name: '', 
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: false, 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                                isUSCitizen: false, 
                                dateFromUSCitizen: null, //["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                    },
                    motherInfo: { 
                        name: '',                    
                        firstName: '', 
                        middleName: '', 
                        lastName: '', 
                        hasOtherNames: false , 
                        otherNames: [{ 
                            _id: 0, 
                            name: '', 
                            firstName: '', 
                            middleName: '', 
                            lastName: '', 
                        }], 
                        dateOfBirth: null, 
                        countryOfBirth: '', 
                        countryOfBirthDetails: null, 
                        provinceOfBirth: '', 
                        provinceOfBirthDetails: null, 
                        locationOfBirth: '', 
                        currentAddress: {
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: null,
                        zipcode: null
                        },
                        isUSCitizen: false, 
                        dateFromUSCitizen:null,// ["", ""],
                        nameAtBirth:{
                            firstName: '', 
                            middleName: '', 
                            lastName: '',
                        },
                        deceasedCity: '',
                        deceasedCityDetails:null,
                        deceasedDate: null,
                    },   
                     //GC 485 fields ends
                    dependentsInfo: {
                        spouse: {
                            // public charge keys start
                            inadmissibility:null,
                            highestDegreeCompleted:null,
                            listOfCertifications:'',
                            SSI:null,
                            benefitsRecAmounts:[{
                                benefitReceived: '',
                                startDate: null,
                                endDate: null,
                                amount: ''
                            }],
                            longTermInstiAtGovtExpense:null,
                            periodOfInstutions:[{
                                institutionName:'',
                                stateId:'',
                                stateDetails:null,
                                locationId:'',
                                locationDetails:null,
                                dateFrom:null,
                                dateTo:null,
                                reason:'',
                                instituteLocations:[]
                            }],
                            // public charge keys end
                            gender:'',
                            doYouWantTheSsaToIssueYouSS:false,
                            ssnFather:{
                                familyName:'',
                                givenName:''
                            },
                            ssnMother:{
                                familyName:'',
                                givenName:''
                            },
                            immigStatusLastArrival:'',
                            doYouAlreadyH4EAD:false,
                            sevisNumber: null,
                            eadNumber: null,
                            haveYouEverTravelledToUS:null,
                            isDSExpiryDate:false,
                            isI94DSExpiryDate:false,
                            relationship: '',
                            saved: false,
                            currentlyInUS: null,
                            hasOtherNames: null, 
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            passportIssuedNumber: null,
                            alienNumber: '',
                            prevEmploymentInfo: [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                payFrequency:null,
                                salary: null,
                                currentEmployer: null
                            }],
                            addressOutsideUS: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            priorPeriodOfStayInUS: [{
                                _id: 0,
                                enteredNumber: null,
                                departedNumber: null,
                                dateerror: false,
                                noOfDays: null,
                                visaStatus: null
                            }],
                            dateFromWhichResideInUs:null,
                            caseIssuedDate: null,
                            caseExpiryDate: null,
                            placeOfCaseIssued: '',
                            mailingAddressIsSameAsAddress:false,
                            stateOfLastEntryInUS: '',
                            stateDetailsOfLastEntryInUS: null,
                            placeOfLastEntryInUS: '',
                            firstArrivalDate: null,
                            lastArrivalDate: null,
                            allIssuedpassportData: [{
                                countryId: '',
                                countryDetails: null,
                                number: '',
                                issuedDate: null,
                                expiryDate: null 
                            }],
                            currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            height: {
                            feet: '',
                            inches: ''
                            },
                            weight: null,
                            race: [],
                            eyeColor:null,
                            hairColor: null,
                            educations: [{
                            _id: 0,
                            name: null,
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            highestDegree: null,
                            highestDegreeDetails: null,
                            majorFieldOfStudy: null,
                            attendedFrom: null,
                            attendedTo: null,
                            graduatedYear: null,
                            degreereceived: null,
                            isAccredited: null,
                            isForProfit: null
                            }],
                            prevEmploymentInfo: [{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            currentEmployer: false
                            }],
                            prevEmploymentOutsideUS:[{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                currentEmployer: false  
                            }],
                            previousSpouse:{
                            hasOtherNames:false,
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            maidenName:'',
                            marriageEndedDueTo:null,
                            marriageEndedOtherInfo:'',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            dateOfBirth: null,
                            dateOfMarriage:null,
                            dateOfMarriageEnd:null,
    
                              //Place of Marriage
                            countryOfMarriage: '',
                            countryOfMarriageDetails: null,
                            provinceOfMarriage: '',
                            provinceOfMarriageDetails: null,
                            locationOfMarriage: '',
    
                            //Place of Termination
                            countryOfMarriageTermination: '',
                            countryOfMarriageTerminationDetails: null,
                            provinceOfMarriageTermination: '',
                            provinceOfMarriageTerminationDetails: null,
                            locationOfMarriageTermination: '',
                            obtainPermResidenceThroughSpouse:false  
                          
                            },
                            addressOfLastNYears:[{
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                            }], 
                            addressOutsideUSMoreThanYear:[{
                            
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                            }],
                            dateOfLastEntryInUS:null,
                            dateOfMarriage: null, 
                            dateOfMarriageEnd: null, 
                            countryOfMarriage: '', 
                            countryOfMarriageDetails: null, 
                            provinceOfMarriage: '', 
                            provinceOfMarriageDetails: null, 
                            locationOfMarriage: '',
                            currentSpouseName: '',
                            maritalStatus : '', 
                            maritalStatusDetails: null,
                            curNonImmigrantVisaStatus: '', 
                            associations:[ {
                                name:'', 
                                address:{
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                },
                                startDate: null,
                                endDate:null,
                                natureofAssociations:'',
                            }],

                            isVisaDenieedTOUS:null,
                            visaDeniedReason:'',
                            haveYoueverPresntUnlawfully:false,
                            presntUnlawfullyReason:'',
                            haveYouEverReceivedPublicAssistendeInUS:false,
                            haveYouEverlikelyReceivePublicAssistendeInUS:false,
                            everAppliedAOSInUS: false, 
                            appliedAOSInUSDocs:[],
                            haveYouArrestedBefore:false,
                            haveYouArrestedBeforeDocs:[], 
                            doesBirthRegistered:false, 
                            curNonImmigrantVisaNumber:'',
                            enterInUSUnderCaseWaiverProgram: false,
                            inspectedByAnyImmOfficer: false, 
                            issuedAnyEADFromUSCIS: false, 
                            hasPermResidencyInOtherCountry: false, 
                            permResidencyCountryId: '', 
                            passportIssuedDate: null,
                            permResidencyCountryDetails: null,
                            

                            h4Required: null,
                            hasSpouse:null,
                            l2Required:null,
                            h4EADRequired: null,
                            l2EADRequired:null,
                            doYouAlreadyL2EAD:null,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            email: '',
                            phoneNumber: '',
                            phoneCountryCode: {
                                countryCode: '',
                                countryCallingCode: ''
                            },
                            dateOfBirth: null,
                            countryOfBirth: null,
                            countryOfBirthDetails: null,
                            provinceOfBirth: null,
                            provinceOfBirthDetails: null,
                            locationOfBirth: '',
                            locationOfBirthDetails: null,
                            countryOfCitizenship: null,
                            countryOfCitizenshipDetails: null,
                            passportNumber: '',
                            passportExpiryNumber: null,
                            passportIssuedCountry:null,
                            passportIssuedCountryDetails:null,
                            I94: '',
                            I94ExpiryNumber: null,
                            currentStatus: null,
                            currentStatusDetails: null,
                            statusExpiryNumber: null,
                            SSN: '',
                            lastArrivalNumber: null,
                            placeOfLastEntryInUS: '',
                            applyingWithYou:false,
                            classification:'',
                            nameDiffFromBirthCert:false,
                            i140PriorityDate:null,
                            physicalAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            fatherInfo: { 
                                name: '', 
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: false, 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                                isUSCitizen: false, 
                                dateFromUSCitizen: null, //["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                            },
                            motherInfo: { 
                                name: '',                    
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: false , 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                                },
                                isUSCitizen: false, 
                                dateFromUSCitizen:null,// ["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                            }, 
                            documents: {
                                passport: [],
                                visa: [],
                                formI94: [],
                                formI797: [],
                                formI20: [],
                                payStubs: [],
                                marriageCertificate: [],
                                noticeOfApprovalOfH1Status: [],
                                approvalNoticeOfPrevH4: [],
                                other: []
                            },
                            //i140
                            adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        
    
                        },
                        childrens: [{
                            // public charge keys start
                            inadmissibility:null,
                            highestDegreeCompleted:null,
                            listOfCertifications:'',
                            SSI:null,
                            benefitsRecAmounts:[{
                                benefitReceived: '',
                                startDate: null,
                                endDate: null,
                                amount: ''
                            }],
                            longTermInstiAtGovtExpense:null,
                            periodOfInstutions:[{
                                institutionName:'',
                                stateId:'',
                                stateDetails:null,
                                locationId:'',
                                locationDetails:null,
                                dateFrom:null,
                                dateTo:null,
                                reason:'',
                                instituteLocations:[]
                            }],
                            // public charge keys end
                            gender:'',
                            doYouWantTheSsaToIssueYouSS:false,
                            ssnFather:{
                                familyName:'',
                                givenName:''
                            },
                            ssnMother:{
                                familyName:'',
                                givenName:''
                            },
                            immigStatusLastArrival:'',
                            doYouAlreadyH4EAD:false,
                            sevisNumber: null,
                            eadNumber: null,
                            haveYouEverTravelledToUS:null,
                            isDSExpiryDate:false,
                            isI94DSExpiryDate:false,
                            saved: false,
                            relationship: '',
                            currentlyInUS: null,
                            hasOtherNames: null, 
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            alienNumber: '',
                            lastArrivalNumber: null,
                            placeOfLastEntryInUS: '',
                            physicalAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: {
                                    id: null,
                                    name: null,
                                    stateId: null,
                                    countryId: null
                                },
                                stateId: null,
                                stateDetails: {
                                    id: null,
                                    name: null,
                                    countryId: null
                                },
                                countryId: null,
                                countryDetails: {
                                    id: null,
                                    name: null,
                                    shortName: null,
                                    phoneCode: null,
                                    countryId: null,
                                    currencySymbol: null,
                                    currencyCode: null,
                                    zipcodeLength: null
                                },
                                zipcode: null
                            },
                            addressOutsideUS: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: {
                                    id: null,
                                    name: null,
                                    stateId: null,
                                    countryId: null
                                },
                                stateId: null,
                                stateDetails: {
                                    id: null,
                                    name: null,
                                    countryId: null
                                },
                                countryId: null,
                                countryDetails: {
                                    id: null,
                                    name: null,
                                    shortName: null,
                                    phoneCode: null,
                                    countryId: null,
                                    currencySymbol: null,
                                    currencyCode: null,
                                    zipcodeLength: null
                                },
                                zipcode: null
                            },
                            passportIssuedNumber: null,
                            priorPeriodOfStayInUS: [{
                                _id: 0,
                                enteredNumber: null,
                                dateerror: false,
                                noOfDays: null,
                                departedNumber: null,
                                visaStatus: null
                            }],
    
                            h4Required: null,
                            hasChildren: null,
                            l2Required:null,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            dateOfBirth: null,
                            countryOfBirth: null,
                            countryOfBirthDetails: null,
                            provinceOfBirth: null,
                            provinceOfBirthDetails: null,
                            locationOfBirth: '',
                            locationOfBirthDetails: null,
                            countryOfCitizenship: null,
                            countryOfCitizenshipDetails: null,
                            passportIssuedCountry:null,
                            passportIssuedCountryDetails:null,
                            passportNumber: '',
                            passportExpiryNumber: null,
                            I94: '',
                            I94ExpiryNumber: null,
                            currentStatus: null,
                            statusExpiryNumber: null,
                            documents: {
                                passport: [],
                                visa: [],
                                formI94: [],
                                birthCertificate: [],
                                approvalNotice: [],
                                approvalNoticeOfPrevH4: [],
                                other: []
                            },
    
                             //i140
                             adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        
                        }]
                    },
                    documents: {
                        resume: [],
                        education: [],
                        expLetters: [],
                        INSNotices: [],
                        I140ApprovalNotice: [],
                        passport: [],
                        passportVisaI94: [],
                        formI20: [],
                        socialSecurityCardAndProfLicense: [],
                        other: [],
                        payStubs: [],
                        offerLetter: [],
                        clientLetter: [],
                        vendorLetter: [],
                        msa: [],
                        po: [],
                        beneficiaryDocs: [],
                        h1bRegSelectionNotice: [],
                        employmentAgreement: [],
                        primeVendor: [],
                        formI94: [],
                        priorFormI797: [],
                        I797NoticeofApprovalforI140: [],
                        ead: [],
                        slgResume: [],
                        slgCollegeDegreesCert: [],
                        slgTransScripts: [],
                        slgExpLetters: [],
                        slgPassportAndVisa: [],
                        slgI94: [],
                        slgPrevNonimmApprovalNotices: [],
                        slgI140OrPermNoties: [],
                        slgPrevLaborApplications: [],
                        slgAckOfPrevLaborApplications: [],
                        slgPaystubs: [],
                        slgI20: [],
                        slgEad: [],
                        capSelectNotice:[],
                        bnfSpouseLatestI797:[],
                        bnfSpousePassport:[],
                        bnfSpouseRecentPayStubs:[],
                        bnfSpouseFormAllI20:[],
                        slgEvalOfEduCredentials:[],
                        slgEvalOfEduExpCredentials:[],
                        //
                        sponsorSpousePassport:[],
                        sponsorSpouseMarriageCertificate: [],
                        sponsorSpouseBirthCertificate: [],
                        sponsorSpouseMarriagePhotographs: [],
                        sponsorSpouseAffidavits: [],
                        sponsorSpouseMartialRelationship:[],
                        sponsorSpousePhotographs:[],
                        sponsorFatherPassport:[],
                        sponsorFatherBirthCertificate:[],
                        sponsorFatherParentsMarriageCertificate:[],
                        sponsorMotherPassport: [],
                        sponsorMotherBirthCertificate:[],
                        sponsorSiblingPassport: [],
                        sponsorSiblingBirthCertWithParents: [],
                        sponsorSiblingBirthCertificate: [],
                        sponsorSiblingBffidavits:[],
                        sponsorChildPassport: [],
                        sponsorChildBirthCertWithParents: [],
                        sponsorChildBirthCertificate: [],
                        // case i140
                        // w2:[],
                        // slgEvalOfEduCredentials:[],
                        // slgPrevImmApprovalNotices:[],
                        // L1 case DOcs
                        last12MonthsPayslips: [], // Beneficiary’s Pay Slips (past 12 months)
                        proExecOrmanagerial: [], // Documents to prove executive or managerial functions (Ex. Email communication/Contracts Executed, etc.) (only for L1A)
                        copyOfVeriPoliBenfApproved: [], //Copies of various policies Beneficiary approved
                        copyOfContExecByBeneficiary: [], //Copies of Contracts executed by Beneficiary (only for L1A)
                        copyOfBoardMinBenfPlayRole: [], // Copies of Board Minutes where Beneficiary played a role (only for L1A)
                        payRevisionLetters: [], // Pay Revision Letters (Exhibit 14) (only for L1A)
                        leaveAppliForms: [], // Leave Application Forms (Exhibit 14) (only for L1A)
                        manageManPowerReq: [], // Manage Manpower Request (Exhibit 14) (only for L1A)
                        offerLetterFromUSComp: [], // Offer letter from the US Company
                        empAgreementFromUSComp: [], //Employment Agreement from the US Company,
                        offerLetterFromForeComp: [], // Offer letter from the Foreign Company
                        empAgreementFromForeComp: [], // Employment Agreement from the Foreign Company
                        trainingCert: [], // Training Certificate (only for L1B) optional
                        proofOfSpecKnowledge: [], // Proof of specialized knowledge (Note: Technical and functional knowledge) (only for L1B)
                    },
                    lcaRequested: false,
                    questionnaireFilled: false,
                    questionnaireFilled_temp: false,
                    lcaId: null,
                    statusId: 1,
                    status: 1,
                    questionnaireSent: true,
                    questionnaireInstructions: '',
                    assignOrSubmitRoleComment: '',
                    curWorkflowActivity: 'CREATE_PETITION',
                    nextWorkflowActivity: ['SUBMIT_BY_BENEFICIARY'],
                        //  relationships:[
                        //     {
                        //     "id":"Son",
                        //  "name":"Son"
                        //  },{
                        //     "id":"Daughter",
                        //  "name":"Daughter"
                        //  }
                        //  ]
                         relationships:['Son','Daughter']
    
                },
                marriageCertDocsList:[{
                    required: false,
                        key: 'docs_marriageCertDocs',
                        fieldName: 'marriageCertDocs',
                        label: 'Marriage Certificates'
                }],
                eadCardList:[{
                        required: false,
                        key: 'docs_eadCard',
                        fieldName: 'eadCard',
                        label: 'Please provide a copy of the EAD CARD(S), front and  back'
                }],
                haveYouArrestedBeforeDocsList:[{
                    required: false,
                        key: 'docs_haveYouArrestedBeforeDocs',
                        fieldName: 'haveYouArrestedBeforeDocs',
                        label: 'Please provide documents, if any'
                }],  
                appliedAOSInUSDocsList:[{
                        required: false,
                        key: 'docs_appliedAOSInUSDocs',
                        fieldName: 'appliedAOSInUSDocs',
                        label: 'Documents'
                }], 
                currentTab: 'casedetails',
                countries: [],
                countriesWithoutUS:[],
                bfeprovinceStates: [],
                statesOfMarriage:[],
                instituteStates:[],
                instituteLocations:[],
                usastates: [],
                visastatuses: [],
                fileredMartialList:[],
                marital_statuses: [],
                education_types: [],
                questionnaireDetails: null,
                beneFiciaryDeytailsExists:false,
                showPrefillPopup: false,
                showBenProfileSyncPopup:false,
                latestPetition: null,
                featureDates: null,
                tabslist: [{
                        key: "casedetails",
                        name: "Personal Info"
                    },
                ],
                questionnairePreview: false,
                questionnairePreviewData:null,
                SuccessQuestionnaire: false,
                h4RequiredForChild: null,
                hasChildren: null,
                l2Required:null,
                spouseModalForm: false,
                childModalForm: false,
                submiTing: false,
                comments: "",
                formerrors: {  msg: ""  },
                executionCompleted:true,
                startEligibleDate: new Date().setFullYear(new Date().getFullYear() - 18),
                childdoclist: [{
                        required: false,
                        key: 'child_docs_passport',
                        fieldName: 'passport',
                        label: 'Passport- First page with photo, Visa page and last page with address'
                    }, {
                        required: false,
                        key: 'child_docs_visa',
                        fieldName: 'visa',
                        label: 'Visa'
                    },
                    {
                        required: false,
                        key: 'child_docs_form_i94',
                        fieldName: 'formI94',
                        label: 'I94'
                    },
                    {
                        required: false,
                        key: 'child_docs_approval_notice',
                        fieldName: 'approvalNotice',
                        label: 'Approval Notice'
                    },
                    {
                        required: false,
                        key: 'child_docs_birth_certificate',
                        fieldName: 'birthCertificate',
                        label: 'Birth Certificate'
                    },
                    {
                        required: false,
                        fieldName: 'slgApprovalNoticeOfPrevH4',
                        "key": "child_docs_slgApprovalNoticeOfPrevH4",
                       "label": "Current and Previous H4 Approval Copies"
                    },
                    {
                        required: false,
                        key: 'child_docs_other',
                        fieldName: 'other',
                        label: 'Others'
                    }
                ],
                selectedchild: 0,
                spousedoclist: [{
                        required: false,
                        key: 'spouse_docs_passport',
                        fieldName: 'passport',
                        label: 'Passport- First page with photo, Visa page and last page with address'
                    },
                    {
                        required: false,
                        fieldName: 'slgApprovalNoticeOfPrevH4',
                        key: "spouse_docs_slgApprovalNoticeOfPrevH4",
                       label: "Current and Previous H4 Approval Copies"
                    },
                    {
                        required: false,
                        key: 'spouse_docs_visa',
                        fieldName: 'visa',
                        label: 'Visa'
                    }, {
                        required: false,
                        key: 'spouse_docs_formi94',
                        fieldName: 'formI94',
                        label: 'I94'
                    }, {
                        required: false,
                        key: 'spouse_docs_form_i797',
                        fieldName: 'formI797',
                        label: 'Form I-797'
                    }, {
                        required: false,
                        key: 'spouse_docs_form_i20',
                        fieldName: 'formI20',
                        label: 'Spouse’s all Form I-20s (if spouse is on F-1 status)'
                    }, {
                        required: false,
                        key: 'spouse_docs_pay_stubs',
                        fieldName: 'payStubs',
                        label: 'Three Recent Pay Stubs'
                    }, {
                        required: false,
                        key: 'spouse_docs_mrg_certificate',
                        fieldName: 'marriageCertificate',
                        label: 'Marriage Certificate (if spouse is on H-1B, L-1, or F-1 status) '
                    }, {
                        required: false,
                        key: 'spouse_docs_other',
                        fieldName: 'other',
                        label: 'Others'
                    }
    
                ],
                bendocslist: [
                    // L1 case docs starts
                    {
                        required: false,
                        fileUploading:false,
                        key: 'last12MonthsPayslips',
                        fieldName: 'last12MonthsPayslips',
                        label: 'Beneficiary’s Pay Slips'
                    }, 
                    {
                      required: false,
                      fileUploading:false,
                      key: 'proExecOrmanagerial',
                      fieldName: 'proExecOrmanagerial',
                      label: 'Documents to prove executive or managerial functions (Ex. Email communication/Contracts Executed, etc.) '
                    }, 
                    {
                      required: false,
                      fileUploading:false,
                      key: 'copyOfVeriPoliBenfApproved',
                      fieldName: 'copyOfVeriPoliBenfApproved',
                      label: 'Copies of various policies Beneficiary approved'
                    }, 
                    {
                      required: false,
                      fileUploading:false,
                      key: 'copyOfContExecByBeneficiary',
                      fieldName: 'copyOfContExecByBeneficiary',
                      label: 'Copies of Contracts executed by Beneficiary'
                    },
                    {
                      required: false,
                      fileUploading:false,
                      key: 'copyOfBoardMinBenfPlayRole',
                      fieldName: 'copyOfBoardMinBenfPlayRole',
                      label: 'Copies of Board Minutes where Beneficiary played a role'
                    }, 
                    {
                      required: false,
                      fileUploading:false,
                      key: 'payRevisionLetters',
                      fieldName: 'payRevisionLetters',
                      label: 'Pay Revision Letters (Exhibit 14)'
                    },
                    {
                      required: false,
                      fileUploading:false,
                      key: 'leaveAppliForms',
                      fieldName: 'leaveAppliForms',
                      label: 'Leave Application Forms (Exhibit 14)'
                    }, 
                    {
                      required: false,
                      fileUploading:false,
                      key: 'manageManPowerReq',
                      fieldName: 'manageManPowerReq',
                      label: 'Manage Manpower Request (Exhibit 14)'
                    },
                    {
                      required: false,
                      fileUploading:false,
                      key: 'offerLetterFromUSComp',
                      fieldName: 'offerLetterFromUSComp',
                      label: 'Offer letter from the US Company'
                    }, 
                    {
                      required: false,
                      fileUploading:false,
                      key: 'empAgreementFromUSComp',
                      fieldName: 'empAgreementFromUSComp',
                      label: 'Employment Agreement from the US Company'
                    },
                    {
                      required: false,
                      fileUploading:false,
                      key: 'offerLetterFromForeComp',
                      fieldName: 'offerLetterFromForeComp',
                      label: 'Offer letter from the Foreign Company'
                    },
                    {
                      required: false,
                      fileUploading:false,
                      key: 'empAgreementFromForeComp',
                      fieldName: 'empAgreementFromForeComp',
                      label: 'Employment Agreement from the Foreign Company'
                    }, 
                    {
                      required: false,
                      fileUploading:false,
                      key: 'trainingCert',
                      fieldName: 'trainingCert',
                      label: 'Training Certificate'
                    },
                    {
                      required: false,
                      fileUploading:false,
                      key: 'proofOfSpecKnowledge',
                      fieldName: 'proofOfSpecKnowledge',
                      label: 'Proof of specialized knowledge (Note: Technical and functional knowledge)'
                    },
                    // L1 case docs end
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_underlyingLaborApplications',
                        fieldName: 'underlyingLaborApplications',
                        label: 'Copy of the underlying Labor Certification (PERM) if applicable.'
                    },  
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_mostRecentTaxTranscrips',
                        fieldName: 'mostRecentTaxTranscrips',
                        label: 'A copy of Most Recent Year’s Tax Transcripts – can be obtained from.'
                    },  
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_passport_visa_i94',
                        fieldName: 'passportVisaI94',
                        label: 'Passport- First page with photo, Visa page and last page with address'
                    },
                    {
                        key: 'docs_passport',
                        fileUploading:false,
                        fieldName: 'passport',
                        required: false,
                        label: 'Passport- First page with photo and last page with address'
                    },
                   
                    {
                        key: 'docs_visa',
                        fileUploading:false,
                        fieldName: 'visa',
                        required: false,
                        label: 'Visa'
                    },
                    {
                        key: 'docs_formI94',
                        fileUploading:false,
                        fieldName: 'formI94',
                        required: false,
                        label: 'Copy of I-94'
                    },
                    {
                        key: 'docs_formI797',
                        fileUploading:false,
                        fieldName: 'formI797',
                        required: false,
                        label: 'Form I-797'
                    },
                    {
                        required: false,
                        key: "slgEvalOfEduCredentials",
                        fileUploading:false,
                        fieldName: 'slgEvalOfEduCredentials',
                        tooltip:' (Academic Evaluation only, cannot combine with work experience, other certificates, training, etc.)',
                        label: "Copy of Educational Evaluation, if any"
                    },
                    {
                        required: false,
                        key: "slgEvalOfEduExpCredentials",
                        fileUploading:false,
                        fieldName: 'slgEvalOfEduExpCredentials',
                        label: "Education+Experience Evaluation"
                    },
                    // {  
                    //     key: 'marriageCertificate',
                    //     fieldName: 'marriageCertificate',
                    //     required: false,
                    //     label: 'Marriage Certificate (if spouse is on H-1B, L-1, or F-1)'
                    // },
                    {
                        key: 'docs_birthCertificate',
                        fileUploading:false,
                        fieldName: 'birthCertificate',
                        required: false,
                        label: 'Birth Certificate'
                    },
                    {
                        key: 'docs_resume',
                        fileUploading:false,
                        fieldName: 'resume',
                        required: false,
                        label: 'Resume'
                    },
                    {
                        key: 'docs_education',
                        fileUploading:false,
                        fieldName: 'education',
                        required: false,
                        label: 'Master’s/ Bachelor’s degree certificate, transcripts, 12th and 10th certificates'
                    },
                    {
                        key: 'docs_expLetters',
                        fileUploading:false,
                        fieldName: 'expLetters',
                        required: false,
                        label: 'Experience Letters'
                    },
                    {
                        key: 'docs_INSNotices',
                        fileUploading:false,
                        fieldName: 'INSNotices',
                        required: false,
                        label: 'I-797, Notice of Approval granting the current nonimmigrant status (if applicable)'
                    },
                    {
                        key: 'docs_formI20',
                        fileUploading:false,
                        fieldName: 'formI20',
                        required: false,
                        label: 'All Form I-20s if applicable'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        fieldName: 'socialSecurityCardAndProfLicense',
                        key: 'docs_socialSecurityCardAndProfLicense',
                        label: 'Social Security Card'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        fieldName: 'I797NoticeofApprovalforI140',
                        key: 'docs_I797NoticeofApprovalforI140',
                        label: 'I-797, Notice of Approval for I-140 if available'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_paystubs',
                        fieldName: 'payStubs',
                        label: 'Three Recent Pay Stubs'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_offer_letters',
                        fieldName: 'offerLetter',
                        label: 'Employment Offer Letter'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_employment_agreement',
                        fieldName: 'employmentAgreement',
                        label: 'Employment Agreement'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_client_letters',
                        fieldName: 'clientLetter',
                        label: 'Client Letter'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_vendor_letters',
                        fieldName: 'vendorLetter',
                        label: 'Vendor Letter if applicable'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_msa',
                        fieldName: 'msa',
                        label: 'MSA/Service Agreement and PO/SOW'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_po',
                        fieldName: 'po',
                        label: 'PO'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_approvalNotice',
                        fieldName: 'approvalNotice',
                        label: 'Approval Notice'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_beneficiaryDocs',
                        fieldName: 'beneficiaryDocs',
                        label: 'Beneficiary Documents'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_h1bRegSelectionNotice',
                        fieldName: 'h1bRegSelectionNotice',
                        label: 'H-1B Registration Selection Notice'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_ead',
                        fieldName: 'ead',
                        label: 'EADs (if on OPT or STEM OPT Extension)'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_prime_vendor',
                        fieldName: 'primeVendor',
                        label: 'Prime Vendor Letter if applicable'
                    },
                    // {
                    //     required: false,
                    //     key: 'docs_formI94',
                    //     fieldName: 'formI94',
                    //     label: 'I-94'
                    // },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_prior_form_i797',
                        fieldName: 'priorFormI797',
                        label: 'Copy of I-797, Notice of Approvals for granting of legal status in the US'
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_noticeOfApprovalOfH1Status',
                        fieldName: 'noticeOfApprovalOfH1Status',
                        label: 'Spouse’s all Form I-20s (if spouse is on F-1 status)'
                    },
                    {
                        required: true,
                        fileUploading:false,
                        key: "slgResume",
                        fieldName: 'slgResume',
                        label: "Current Resume- Please mention the accurate names of the employer and periods of employment. Do not state the client names"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "slgCollegeDegreesCert",
                        fieldName: 'slgCollegeDegreesCert',
                        label: "All College Degrees"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "slgTransScripts",
                        fieldName: 'slgTransScripts',
                        label: "Copies of all education documents including Certificates and Transcripts/Marks Memos"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "slgExpLetters",
                        fieldName: 'slgExpLetters',
                        label: "Letters of Experience. Each experience letter on company letterhead with your professional experience and include the (1) Job title (2) Duration of employment (beginning date and ending date), (3) Full time (i.e., 40 hours) or Part time position, and (4) the Job Duties. If you had more than one position within the company, please list each position along with the Job Description. Make sure the letters are signed by Authorized representative of the company."
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "slgPassportAndVisa",
                        fieldName: 'slgPassportAndVisa',
                        label: "Copy of New and Old Passport along with Visa"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "slgI94",
                        fieldName: 'slgI94',
                        label: "I-94"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        fieldName: 'slgPrevNonimmApprovalNotices',
                        key: "slgPrevNonimmApprovalNotices",
                        label: "Copy of all Previous Nonimmigrant Approval Notices (e.g., H-1B, H-4, L-1A, L-1B, L-2 etc.,)"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "slgI140OrPermNoties",
                        fieldName: 'slgI140OrPermNoties',
                        label: "Copy of any I-140 approval notices or PERM filing Notices (if applicable)"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "slgPrevLaborApplications",
                        fieldName: 'slgPrevLaborApplications',
                        label: "Copy of the previously filed Labor Application, if applicable"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "slgAckOfPrevLaborApplications",
                        fieldName: 'slgAckOfPrevLaborApplications',
                        label: "Copy of the Acknowledgement letter for the previously filed Labor application, if applicable"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "slgPaystubs",
                        fieldName: 'slgPaystubs',
                        label: "Copies of most recent four paystubs to the present salary drawn"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "slgI20",
                        fieldName: 'slgI20',
                        label: "Copies of all I-20’s"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "slgEad",
                        fieldName: 'slgEad',
                        label: "Copies of EAD cards"
                    },
                    //Added fields
                    {
                        required: false,
                        fileUploading:false,
                        key: "w2",
                        fieldName: 'w2',
                        label: "Copy of W-2 Forms issued for all tax years till present"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "photographs",
                        fieldName: 'photographs',
                        label: "Photographs"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "medicalExamins",
                        fieldName: 'medicalExamins',
                        label: "Medical Examins"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "dependentForI134",
                        fieldName: 'dependentForI134',
                        label: "Dependent For I-134"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "dependentTaxReturns",
                        fieldName: 'dependentTaxReturns',
                        label: "Dependent Tax Returns"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "bankStatements",
                        fieldName: 'bankStatements',
                        label: "Bank Statements"
                    }, 
                    {
                        required: false,
                        fileUploading:false,
                        key: "evidenceOfContinuVisaStatus",
                        fieldName: 'evidenceOfContinuVisaStatus',
                        label: "Evidence of Continue Visa Status"
                    }, 
                    {
                        required: false,
                        fileUploading:false,
                        key: "evidenceOfFilePetitionBefore30Apr2001",
                        fieldName: 'evidenceOfFilePetitionBefore30Apr2001',
                        label: "Evidence of File Petition Before 30-Apr-2001"
                    }, 
                    {
                        required: false,
                        fileUploading:false,
                        key: "proofOfIncomeOrAsset",
                        fieldName: 'proofOfIncomeOrAsset',
                        label: "Proof of Income or Asset"
                    }, 
                    { 
                        required: false,
                        fileUploading:false,
                        key: "proofOfMedicalInsurence",
                        fieldName: 'proofOfMedicalInsurence',
                        label: "Proof of Medical Insurence"
                    }, 
                    {
                        required: false,
                        fileUploading:false,
                        key: "recentCreditReport",
                        fieldName: 'recentCreditReport',
                        label: "Recent Credit Report"
                    }, 
                    {
                        required: false,
                        fileUploading:false,
                        key: "permResidence",
                        fieldName: 'permResidence',
                        label: "Permenant Residence"
                    }, 
                    {
                        required: false,
                        fileUploading:false,
                        key: "empAuth",
                        fieldName: 'empAuth',
                        label: "Employment Auth"
                    },
                    {
                        required: false,
                        fileUploading:false,
                        key: "capSelectNotice",
                        fieldName: 'capSelectNotice',
                        label: "CAP Selection Notice",
                        callExtract:true,
                    },
                    // new Documents 04/04/2023
                    /*
                    {
                        required: false,
                        key: "formI797H4ApprovalNotice",
                        fieldName: 'formI797H4ApprovalNotice',
                        label: "Form I-797 H4 approval notice if applicable."
                    },
                    {
                        required: false,
                        key: "h4Ead",
                        fieldName: 'h4Ead',
                        label: "H4 EAD if applicable"
                    },
                    {
                        required: false,
                        key: "marriageCertificate",
                        fieldName: 'marriageCertificate',
                        label: "Marriage Certificate"
                    },
                    {
                        required: false,
                        key: "formI797H1BApprovalNoticePrinNonCtzn",
                        fieldName: 'formI797H1BApprovalNoticePrinNonCtzn',
                        label: "Form I-797 H-1B approval notice of Principal Non-citizen"
                    },
                    {
                        required: false,
                        key: "passportOfPrinNonCtzn",
                        fieldName: 'passportOfPrinNonCtzn',
                        label: "Passport of Principal Non-citizen- First page with photo, Visa page and last page with address"
                    },
                    {
                        required: false,
                        key: "last3MonthsPayslipsOfPrinNonCtzn",
                        fieldName: 'last3MonthsPayslipsOfPrinNonCtzn',
                        label: "Last 3 months pay statements of Principal Non-citizen"
                    },
                    */
                    {
                        key: 'bnfSpouseLatestI797',
                        fileUploading:false,
                        fieldName: 'bnfSpouseLatestI797',
                        required: false,
                        label: 'Latest I-797, Notice of Approval of the spouse (if spouse is on H-1B or L-1 status)'
                    },
                    {
                        key: 'bnfSpousePassport',
                        fileUploading:false,
                        fieldName: 'bnfSpousePassport',
                        required: false,
                        label: 'Spouse’s Passport- First page with photo, Visa page and last page with address'
                    },
                    {
                        key: 'bnfSpouseRecentPayStubs',
                        fileUploading:false,
                        fieldName: 'bnfSpouseRecentPayStubs',
                        required: false,
                        label: 'Three recent pay stubs (if spouse is on H-1B or L-1 status)'
                    },
                    {
                        key: 'bnfSpouseFormAllI20',
                        fileUploading:false,
                        fieldName: 'bnfSpouseFormAllI20',
                        required: false,
                        label: 'Spouse’s all Form I-20s (if spouse is on F-1 status)'
                    }, 
                    /*
                    /// sponsor spouse documents
                    {
                        key: 'sponsorSpousePassport',
                        fileUploading:false,
                        fieldName: 'sponsorSpousePassport',
                        required: false,
                        label: 'Copy of all the pages of the passport of your spouse (including the blank pages)'
                    },
                    {
                        key: 'sponsorSpouseMarriageCertificate',
                        fileUploading:false,
                        fieldName: 'sponsorSpouseMarriageCertificate',
                        required: false,
                        label: 'Copy of the Marriage Certificate'
                    },
                    {
                        key: 'sponsorSpouseBirthCertificate',
                        fileUploading:false,
                        fieldName: 'sponsorSpouseBirthCertificate',
                        required: false,
                        label: 'Copy of the Birth Certificate of the Spouse'
                    },
                    {
                        key: 'sponsorSpouseMarriagePhotographs',
                        fileUploading:false,
                        fieldName: 'sponsorSpouseMarriagePhotographs',
                        required: false,
                        label: 'Photographs of the marriage and after marriage photographs of the couples '
                    },
                    {
                        key: 'sponsorSpouseAffidavits',
                        fileUploading:false,
                        fieldName: 'sponsorSpouseAffidavits',
                        required: false,
                        label: 'Affidavits from the parents of you and your spouse confirming your bona fide marital relationship'
                    },
                    {
                        key: 'sponsorSpouseMartialRelationship',
                        fileUploading:false,
                        fieldName: 'sponsorSpouseMartialRelationship',
                        required: false,
                        label: 'Any other document that show the ongoing martial relationship'
                    },
                    {
                        key: 'sponsorSpousePhotographs',
                        fileUploading:false,
                        fieldName: 'sponsorSpousePhotographs',
                        required: false,
                        label: 'Two (2) passport sized photographs of your spouse'
                    },
                    ////sponsor father documents
                    {
                        key: 'sponsorFatherPassport',
                        fileUploading:false,
                        fieldName: 'sponsorFatherPassport',
                        required: false,
                        label: 'Copy of all the pages of the passport of your father (including the blank pages)'
                    },
                    {
                        key: 'sponsorFatherBirthCertificate',
                        fileUploading:false,
                        fieldName: 'sponsorFatherBirthCertificate',
                        required: false,
                        label: 'Copy of your birth certificate showing your name and your parents’ names'
                    },
                    {
                        key: 'sponsorFatherParentsMarriageCertificate',
                        fileUploading:false,
                        fieldName: 'sponsorFatherParentsMarriageCertificate',
                        required: false,
                        label: 'Copy of your parent’s marriage certificate establishing that your father was married to your mother before you were born.  If marriage certificate is not available, please provide affidavits from two persons who have the personal knowledge of your parents’ marriage and your birth.'
                    },
                    /////sponsor mother
                    {
                        key: 'sponsorMotherPassport',
                        fileUploading:false,
                        fieldName: 'sponsorMotherPassport',
                        required: false,
                        label: 'Copy of all the pages of the passport of your mother (including the blank pages)'
                    },
                    {
                        key: 'sponsorMotherBirthCertificate',
                        fileUploading:false,
                        fieldName: 'sponsorMotherBirthCertificate',
                        required: false,
                        label: 'Copy of your birth certificate showing your name and your mother’s'
                    },
                    ////sponsor sibiling documents
                    {
                        key: 'sponsorSiblingPassport',
                        fileUploading:false,
                        fieldName: 'sponsorSiblingPassport',
                        required: false,
                        label: 'Copy of all the pages of the passport of your sibling (including the blank pages)'
                    },
                    {
                        key: 'sponsorSiblingBirthCertWithParents',
                        fileUploading:false,
                        fieldName: 'sponsorSiblingBirthCertWithParents',
                        required: false,
                        label: 'Copy of your birth certificate showing your name and your parents’ names'
                    },
                    {
                        key: 'sponsorSiblingBirthCertificate',
                        fileUploading:false,
                        fieldName: 'sponsorSiblingBirthCertificate',
                        required: false,
                        label: 'Copy of your sibling’s birth certificate '
                    },
                    {
                        key: 'sponsorSiblingBffidavits',
                        fileUploading:false,
                        fieldName: 'sponsorSiblingBffidavits',
                        required: false,
                        label: 'Affidavits from the parents of you and your sibling confirming your relationship (format will be provided by our office)'
                    },

                    ////sponsor child documents
                    {
                        key: 'sponsorChildPassport',
                        fileUploading:false,
                        fieldName: 'sponsorChildPassport',
                        required: false,
                        label: 'Copy of all the pages of the passport of your child (including the blank pages)'
                    },
                    {
                        key: 'sponsorChildBirthCertWithParents',
                        fileUploading:false,
                        fieldName: 'sponsorChildBirthCertWithParents',
                        required: false,
                        label: 'Copy of your child’s birth certificate showing child’s name both parents’ name, and your marriage certificate to the child’s mother- if you are the child’s father'
                    },
                    {
                        key: 'sponsorChildBirthCertificate',
                        fileUploading:false,
                        fieldName: 'sponsorChildBirthCertificate',
                        required: false,
                        label: 'Copy of your sibling’s birth certificate '
                    },
                    */
                   {
                                        required: false,
                                        key: "slgPrevImmApprovalNotices",
                                        fieldName: 'slgPrevImmApprovalNotices',
                                        label: "Copy of all prior Notice of Approvals/Receipts (if any) for legal status in the US.",
                     },
                    {
                        required: false,
                        fileUploading:false,
                        key: 'docs_other',
                        fieldName: 'other',
                        label: 'Other Documents, if any'
                    },
                    {
                        required: false,
                        key: "spbAllCollegeDegree",
                        fileUploading:false,
                        fieldName: 'spbAllCollegeDegree',
                        tooltip:'Dont upload Marksheet but only Degree here',
                        label: "Masters and/or Bachelors College Diploma/Degree"
                    },
                    {
                        required: false,
                        key: "spbAllMastOrBachMarkSheets",
                        fileUploading:false,
                        fieldName: 'spbAllMastOrBachMarkSheets',
                        tooltip:'Masters and/or Bachelors marks only',
                        label: "All Marksheets/Transcripts"
                    },
                    {
                        required: false,
                        key: "spbSubmitAllI20",
                        fileUploading:false,
                        fieldName: 'spbSubmitAllI20',
                        tooltip:"Submit all I-20's, OPT EAD cards and recent pay-statements from any employer (if working on OPT)",
                        label: "Maintenance of Status - F1 Status (if on F-1 Status)"
                    },
                    {
                        required: false,
                        key: "spbSubSpouseOrI194OrlastTwoPays",
                        fileUploading:false,
                        fieldName: 'spbSubSpouseOrI194OrlastTwoPays',
                        tooltip:'Submit Spouse approval, spouse I94/approval and spouse last two pay-statements',
                        label: "Maintenance of Status - If on H4 or L2 Status"
                    },
                    {
                        required: false,
                        key: "spbSubMostRecAppOrI194OrTwoStatements",
                        fileUploading:false,
                        fieldName: 'spbSubMostRecAppOrI194OrTwoStatements',
                        tooltip:'Submit most recent approval/I94 and last two pay-statements',
                        label: "Maintenance of Status - If on  H1/B or L1 Status"
                    },

                ],
                //ignoreItems:['maritalStatusDetails'],
                ignoreItems:['secOrSubSequentExtnWithPtnr', 'stateOfLastEntryInUS','stateDetailsOfLastEntryInUS','height','firstExtnWithPtnr',"hasOtherNames",
                'otherNames','maritalStatusDetails','prevEmploymentInfo','educations','countryOfBirth','countryOfBirthDetails','immPetitionInfo','fatherInfo','motherInfo',
                'provinceOfBirth','provinceOfBirthDetails','countryOfCitizenship','countryOfCitizenshipDetails','homePhoneCountryCode','homePhoneNumber'
                ,'passportIssuedCountryDetails','passportIssuedCountry','education'
                ,'cellPhoneNumber','cellPhoneCountryCode','curNonImmigrantVisaStatus','curNonImmigrantVisaStatusDetails','capType','serviceCenterName'
                ,'countryOfMarriage','countryOfMarriageDetails','provinceOfMarriage','provinceOfMarriageDetails','previousSpouse','prevEmploymentOutsideUS','associations'
                ,'anyImmPetitionFiled','permExpiryDate', 'benfIncome', 'benfAssets', 'benefitsRecAmounts', 'periodOfInstutions','i485AdditionalInfo','i485AdditionalInfoFilled'],
                detailsItemsList:[
                {
                        key:'countryOfMarriage',
                        detailsKey:'countryOfMarriageDetails',
                        section:'beneficiaryInfo.previousSpouse',
                        type:'details'
                    },
                    {
                        key:'provinceOfMarriage',
                        detailsKey:'provinceOfMarriageDetails',
                        section:'beneficiaryInfo.previousSpouse',
                        type:'details'
                    },
                    {
                        key:'highestDegree',
                        detailsKey:'highestDegreeDetails',
                        section:'beneficiaryInfo.education',
                        type:'details'
                    },
                    {
                        key:'countryOfMarriageTermination',
                        detailsKey:'countryOfMarriageTerminationDetails',
                        section:'beneficiaryInfo.previousSpouse',
                        type:'details'
                    },
                    {
                        key:'provinceOfMarriageTermination',
                        detailsKey:'provinceOfMarriageTerminationDetails',
                        section:'beneficiaryInfo.previousSpouse',
                        type:'details'
                    },
                    {
                        key:'countryOfMarriage',
                        detailsKey:'countryOfMarriageDetails',
                        section:'dependentsInfo.spouse.previousSpouse',
                        type:'details'
                    },
                    {
                        key:'provinceOfMarriage',
                        detailsKey:'provinceOfMarriageDetails',
                        section:'dependentsInfo.spouse.previousSpouse',
                        type:'details'
                    },
                    {
                        key:'countryOfMarriageTermination',
                        detailsKey:'countryOfMarriageTerminationDetails',
                        section:'dependentsInfo.spouse.previousSpouse',
                        type:'details'
                    },
                    {
                        key:'provinceOfMarriageTermination',
                        detailsKey:'provinceOfMarriageTerminationDetails',
                        section:'dependentsInfo.spouse.previousSpouse',
                        type:'details'
                    },
                    
                    /////
                    {
                        key:'countryOfBirth',
                        detailsKey:'countryOfBirthDetails',
                        section:'fatherInfo',
                        type:'details'
                    },
                    {
                        key:'provinceOfBirth',
                        detailsKey:'provinceOfBirthDetails',
                        section:'fatherInfo',
                        type:'details'
                    },
                    {
                        key:'deceasedCity',
                        detailsKey:'deceasedCityDetails',
                        section:'fatherInfo',
                        type:'details'
                    },
                    {
                        key:'countryOfBirth',
                        detailsKey:'countryOfBirthDetails',
                        section:'motherInfo',
                        type:'details'
                    },
                    {
                        key:'provinceOfBirth',
                        detailsKey:'provinceOfBirthDetails',
                        section:'motherInfo',
                        type:'details'
                    },
                    {
                        key:'deceasedCity',
                        detailsKey:'deceasedCityDetails',
                        section:'motherInfo',
                        type:'details'
                    },
                    {
                        key:'countryOfBirth',
                        detailsKey:'countryOfBirthDetails',
                        section:'dependentsInfo.spouse.fatherInfo',
                        type:'details'
                    },
                    {
                        key:'provinceOfBirth',
                        detailsKey:'provinceOfBirthDetails',
                        section:'dependentsInfo.spouse.fatherInfo',
                        type:'details'
                    },
                    {
                        key:'deceasedCity',
                        detailsKey:'deceasedCityDetails',
                        section:'dependentsInfo.spouse.fatherInfo',
                        type:'details'
                    },
                    {
                        key:'countryOfBirth',
                        detailsKey:'countryOfBirthDetails',
                        section:'dependentsInfo.spouse.motherInfo',
                        type:'details'
                    },
                    {
                        key:'provinceOfBirth',
                        detailsKey:'provinceOfBirthDetails',
                        section:'dependentsInfo.spouse.motherInfo',
                        type:'details'
                    },
                    {
                        key:'deceasedCity',
                        detailsKey:'deceasedCityDetails',
                        section:'dependentsInfo.spouse.motherInfo',
                        type:'details'
                    },
                    ////////// 
                    {
                        key:'stateOfLastEntryInUS',
                        detailsKey:'stateDetailsOfLastEntryInUS',
                        section:'beneficiaryInfo',
                        type:'details'
                    },
                    {
                        key:'maritalStatus',
                        detailsKey:'maritalStatusDetails',
                        section:'beneficiaryInfo',
                        type:'details'
                    },
                    {
                        key:'countryOfMarriage',
                        detailsKey:'countryOfMarriageDetails',
                        section:'beneficiaryInfo',
                        type:'details'   
                    },
                    {
                        key:'provinceOfMarriage',
                        detailsKey:'provinceOfMarriageDetails',
                        section:'beneficiaryInfo',
                        type:'details'
                    },
                    {
                        key:'curNonImmigrantVisaStatus',
                        detailsKey:'curNonImmigrantVisaStatusDetails',
                        section:'beneficiaryInfo',
                        type:'details'
                    },
                    {
                        key:'countryOfBirth',
                        detailsKey:'countryOfBirthDetails',
                        section:'beneficiaryInfo',
                        type:'details'
                    },
                    {
                        key:'provinceOfBirth',
                        detailsKey:'provinceOfBirthDetails',
                        section:'beneficiaryInfo',
                        type:'details'
                    },
                    {
                        key:'countryOfCitizenship',
                        detailsKey:'countryOfCitizenshipDetails',
                        section:'beneficiaryInfo',
                        type:'details'
                    },
                    {
                        key:'homePhoneNumber',
                        detailsKey:'homePhoneCountryCode',
                        section:'beneficiaryInfo',
                        type:'phone'
                    },
                    {
                        key:'cellPhoneNumber',
                        detailsKey:'cellPhoneCountryCode',
                        section:'beneficiaryInfo',
                        type:'phone'
                    },
                    {
                        key:'passportIssuedCountry',
                        detailsKey:'passportIssuedCountryDetails', 
                        section:'dependentsInfo.spouse',
                        type:'details'
                    },
                    {
                        key:'passportIssuedCountry',
                        detailsKey:'passportIssuedCountryDetails', 
                        section:'beneficiaryInfo',
                        type:'details'
                    },
                    {
                        key:'stateOfLastEntryInUS',
                        detailsKey:'stateDetailsOfLastEntryInUS',
                        section:'dependentsInfo.spouse',
                        type:'details'
                    },
                    {
                        key:'countryOfBirth',
                        detailsKey:'countryOfBirthDetails',
                        section:'dependentsInfo.spouse',
                        type:'details'
                    },
                    {
                        key:'provinceOfBirth',
                        detailsKey:'provinceOfBirthDetails',
                        section:'dependentsInfo.spouse',
                        type:'details'
                    },
                    {
                        key:'countryOfCitizenship',
                        detailsKey:'countryOfCitizenshipDetails',
                        section:'dependentsInfo.spouse',
                        type:'details'
                    },
                    {
                        key:'phoneNumber',
                        detailsKey:'countryOfCitizenshipDetails',
                        section:'dependentsInfo.spouse',
                        type:'phone'
                    },
                    {
                        key:'maritalStatus',
                        detailsKey:'maritalStatusDetails',
                        section:'dependentsInfo.spouse',
                        type:'details'
                    },
                    {
                        key:'countryOfMarriage',
                        detailsKey:'countryOfMarriageDetails',
                        section:'dependentsInfo.spouse',
                        type:'details'
                    },
                    {
                        key:'provinceOfMarriage',
                        detailsKey:'provinceOfMarriageDetails',
                        section:'dependentsInfo.spouse',
                        type:'details'
                    },
                    {
                        key:'stateOfLastEntryInUS',
                        detailsKey:'stateDetailsOfLastEntryInUS',
                        section:'dependentsInfo.spouse',
                        type:'details'
                    },
                    
                ],
                prefillAction:false,
                spouse: {
                    // public charge keys start
                    inadmissibility:null,
                    highestDegreeCompleted:null,
                    listOfCertifications:'',
                    SSI:null,
                    benefitsRecAmounts:[{
                        benefitReceived: '',
                        startDate: null,
                        endDate: null,
                        amount: ''
                    }],
                    longTermInstiAtGovtExpense:null,
                    periodOfInstutions:[{
                        institutionName:'',
                        stateId:'',
                        stateDetails:null,
                        locationId:'',
                        locationDetails:null,
                        dateFrom:null,
                        dateTo:null,
                        reason:'',
                        instituteLocations:[]
                    }],
                    // public charge keys end
                    gender:'',
                            doYouWantTheSsaToIssueYouSS:false,
                            ssnFather:{
                                familyName:'',
                                givenName:''
                            },
                            ssnMother:{
                                familyName:'',
                                givenName:''
                            },
                            immigStatusLastArrival:'',
                            doYouAlreadyH4EAD:null,
                            sevisNumber: null,
                            eadNumber: null,
                            haveYouEverTravelledToUS:null,
                            isDSExpiryDate:false,
                            isI94DSExpiryDate:false,
                            relationship: '',
                            saved: false,
                            currentlyInUS: null,
                            hasOtherNames: null, 
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            passportIssuedNumber: null,
                            alienNumber: '',
                            prevEmploymentInfo: [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                payFrequency:null,
                                salary: null,
                                currentEmployer: null
                            }],
                            addressOutsideUS: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            priorPeriodOfStayInUS: [{
                                _id: 0,
                                enteredNumber: null,
                                departedNumber: null,
                                dateerror: false,
                                noOfDays: null,
                                visaStatus: null
                            }],
                            dateFromWhichResideInUs:null,
                            caseIssuedDate: null,
                            caseExpiryDate: null,
                            placeOfCaseIssued: '',
                            mailingAddressIsSameAsAddress:false,
                            stateOfLastEntryInUS: '',
                            stateDetailsOfLastEntryInUS: null,
                            placeOfLastEntryInUS: '',
                            firstArrivalDate: null,
                            lastArrivalDate: null,
                            allIssuedpassportData: [{
                                countryId: '',
                                countryDetails: null,
                                number: '',
                                issuedDate: null,
                                expiryDate: null 
                            }],
                            currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            height: {
                            feet: '',
                            inches: ''
                            },
                            weight: null,
                            race: [],
                            eyeColor:null,
                            hairColor: null,
                            educations: [{
                            _id: 0,
                            name: null,
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            highestDegree: null,
                            highestDegreeDetails: null,
                            majorFieldOfStudy: null,
                            attendedFrom: null,
                            attendedTo: null,
                            graduatedYear: null,
                            degreereceived: null,
                            isAccredited: null,
                            isForProfit: null
                            }],
                            prevEmploymentInfo: [{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            currentEmployer: false
                            }],
                            prevEmploymentOutsideUS:[{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                currentEmployer: false  
                            }],
                            previousSpouse:{
                            hasOtherNames:false,
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            maidenName:'',
                            marriageEndedDueTo:null,
                            marriageEndedOtherInfo:'',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            dateOfBirth: null,
                            dateOfMarriage:null,
                            dateOfMarriageEnd:null,
    
                              //Place of Marriage
                            countryOfMarriage: '',
                            countryOfMarriageDetails: null,
                            provinceOfMarriage: '',
                            provinceOfMarriageDetails: null,
                            locationOfMarriage: '',
    
                            //Place of Termination
                            countryOfMarriageTermination: '',
                            countryOfMarriageTerminationDetails: null,
                            provinceOfMarriageTermination: '',
                            provinceOfMarriageTerminationDetails: null,
                            locationOfMarriageTermination: '',
                            obtainPermResidenceThroughSpouse:false  
                          
                            },
                            addressOfLastNYears:[{
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                            }], 
                            addressOutsideUSMoreThanYear:[{
                            
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                            }],
                            dateOfLastEntryInUS:null,
                            dateOfMarriage: null, 
                            dateOfMarriageEnd: null, 
                            countryOfMarriage: '', 
                            countryOfMarriageDetails: null, 
                            provinceOfMarriage: '', 
                            provinceOfMarriageDetails: null, 
                            locationOfMarriage: '',
                            currentSpouseName: '',
                            maritalStatus : '', 
                            maritalStatusDetails: null,
                            curNonImmigrantVisaStatus: '', 
                            associations:[ {
                                name:'', 
                                address:{
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                },
                                startDate: null,
                                endDate:null,
                                natureofAssociations:'',
                            }],

                            isVisaDenieedTOUS:null,
                            visaDeniedReason:'',
                            haveYoueverPresntUnlawfully:false,
                            presntUnlawfullyReason:'',
                            haveYouEverReceivedPublicAssistendeInUS:false,
                            haveYouEverlikelyReceivePublicAssistendeInUS:false,
                            everAppliedAOSInUS: false, 
                            appliedAOSInUSDocs:[],
                            haveYouArrestedBefore:false,
                            haveYouArrestedBeforeDocs:[], 
                            doesBirthRegistered:false, 
                            curNonImmigrantVisaNumber:'',
                            enterInUSUnderCaseWaiverProgram: false,
                            inspectedByAnyImmOfficer: false, 
                            issuedAnyEADFromUSCIS: false, 
                            hasPermResidencyInOtherCountry: false, 
                            permResidencyCountryId: '', 
                            passportIssuedDate: null,
                            permResidencyCountryDetails: null,
                            

                            h4Required: null,
                            hasSpouse:null,
                            l2Required:null,
                            h4EADRequired: null,
                            l2EADRequired:null,
                            doYouAlreadyL2EAD:null,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            email: '',
                            phoneNumber: '',
                            phoneCountryCode: {
                                countryCode: '',
                                countryCallingCode: ''
                            },
                            dateOfBirth: null,
                            countryOfBirth: null,
                            countryOfBirthDetails: null,
                            provinceOfBirth: null,
                            provinceOfBirthDetails: null,
                            locationOfBirth: '',
                            locationOfBirthDetails: null,
                            countryOfCitizenship: null,
                            countryOfCitizenshipDetails: null,
                            passportNumber: '',
                            passportExpiryNumber: null,
                            passportIssuedCountry:null,
                            passportIssuedCountryDetails:null,
                            I94: '',
                            I94ExpiryNumber: null,
                            currentStatus: null,
                            currentStatusDetails: null,
                            statusExpiryNumber: null,
                            SSN: '',
                            lastArrivalNumber: null,
                            placeOfLastEntryInUS: '',
                            applyingWithYou:false,
                            classification:'',
                            nameDiffFromBirthCert:false,
                            i140PriorityDate:null,
                            physicalAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            fatherInfo: { 
                                name: '', 
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: false, 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                                isUSCitizen: false, 
                                dateFromUSCitizen: null, //["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                            },
                            motherInfo: { 
                                name: '',                    
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: false , 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                                },
                                isUSCitizen: false, 
                                dateFromUSCitizen:null,// ["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                            }, 
                            documents: {
                                passport: [],
                                visa: [],
                                formI94: [],
                                formI797: [],
                                formI20: [],
                                payStubs: [],
                                marriageCertificate: [],
                                noticeOfApprovalOfH1Status: [],
                                approvalNoticeOfPrevH4: [],
                                other: [],
                                eadCard:[]
                            },
                            //i140
                            adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        
    
                        },
                spouseIgnoreItems:['ssnFather','ssnMother','otherNames', 'maritalStatus','maritalStatusDetails','countryOfMarriage','countryOfMarriageDetails','provinceOfMarriage','provinceOfMarriageDetails',
                'height','fatherInfo','motherInfo','previousSpouse','prevEmploymentOutsideUS', 'stateOfLastEntryInUS','stateDetailsOfLastEntryInUS','countryOfBirth','prevEmploymentInfo','countryOfBirthDetails','passportIssuedCountryDetails','passportIssuedCountry','documents',
                'provinceOfBirth','provinceOfBirthDetails','countryOfCitizenship','countryOfCitizenshipDetails','phoneNumber','phoneCountryCode','associations',
                'benefitsRecAmounts', 'periodOfInstutions','i485AdditionalInfo','i485AdditionalInfoFilled'],
                previousSpouseIgnoreItems:['countryOfMarriage','countryOfMarriageDetails','provinceOfMarriage','provinceOfMarriageDetails','countryOfMarriageTermination',
                'countryOfMarriageTerminationDetails','provinceOfMarriageTermination','provinceOfMarriageTerminationDetails'],
                ignorePrefillItems:[ 
                    {
                        key:'doYouAlreadyH4EAD',
                        section:'dependentsInfo.spouse',
                    },
                    {
                        key:'isUSCitizen',
                        section:'dependentsInfo.spouse.fatherInfo',
                    },
                    {
                        key:'isUSCitizen',
                        section:'dependentsInfo.spouse.motherInfo',
                    },
                    {
                        key:'isUSCitizen',
                        section:'fatherInfo',
                    },
                    {
                        key:'isUSCitizen',
                        section:'motherInfo',
                    }, 
                    {
                        key:'hasOtherNames',
                        section:'dependentsInfo.spouse.fatherInfo',
                    },
                    {
                        key:'hasOtherNames',
                        section:'dependentsInfo.spouse.motherInfo',
                    },
                    {
                        key:'hasOtherNames',
                        section:'fatherInfo',
                    },
                    {
                        key:'hasOtherNames',
                        section:'motherInfo',
                    },                               
                    {
                        key:'obtainPermResidenceThroughSpouse',
                        section:'beneficiaryInfo.previousSpouse',
                    },
                    {
                        key:'haveYouEverEmployed',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'obtainPermResidenceThroughSpouse',
                        section:'dependentsInfo.spouse.previousSpouse',
                    },
                    {
                        key:'areYouUnderRemoveOfIndOrUscis',
                        section:'beneficiaryInfo',
                    },
                    
                    {
                        key:'anyImmPetitionFiled',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'currentlyInUS',
                        section:'beneficiaryInfo',
                        preSelect:true,
                    },
					{
                        key:'haveOwnershipInterest',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'haveYouEverAppliedH1bCase',
                        section:'beneficiaryInfo',
                    },
					{
                        key:'anyImmPetitionFiled',
                        section:'beneficiaryInfo',
                    },
					{
                        key:'anyOtherAlienFiled',
                        section:'beneficiaryInfo.immPetitionInfo',
                    },
					{
                        key:'rirOrRegularProcessing',
                        section:'beneficiaryInfo.immPetitionInfo',
                    }, 
					{
                        key:'seekingFiledDateforETA750',
                        section:'beneficiaryInfo.immPetitionInfo', 
                    }, 
					{
                        key:'anyI140Filed',
                        section:'beneficiaryInfo.immPetitionInfo',
                    }, 
					{
                        key:'hasApprovedI140',
                        section:'beneficiaryInfo',
                    },
					{
                        key:'hasPermPendingForMorethan365Days',
                        section:'beneficiaryInfo',
                    },
					{
                        key:'currentlyInUS',
                        section:'dependentsInfo.spouse',
                        preSelect:true,
                    },
                    {
                        key:'nameDiffFromBirthCert',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'have2AffidavitsOfBirthFamily',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'birthCertHaveNamePobDob',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'previouslyMarried',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'hasI140ImmPetitionFiled',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'haveYouEverTravelledToUS',
                        section:'dependentsInfo.spouse',
                        preSelect:true,
                    },
                    {
                        key:'haveYouEverTravelledToUS',
                        section:'beneficiaryInfo',
                        preSelect:true,
                    },
                   
                    {
                        key:'hasMasterDegreeInUS',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'anyOtherPersonEmployedInUS',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'hasAnyDependetsinUStoFileH4',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'h4Required',
                        section:'dependentsInfo.spouse',
                    },
                    {
                        key:'hasSpouse',
                        section:'dependentsInfo.spouse',
                    },
                    {
                        key:'l2Required',
                        section:'dependentsInfo.spouse',
                    },
                    {
                        key:'adjustmentStatusToPermResidenceI485',
                        section:'dependentsInfo.spouse',
                    },
                    {
                        key:'h4EADRequired',
                        section:'dependentsInfo.spouse',
                    },
                    {
                        key:'l2EADRequired',
                        section:'dependentsInfo.spouse',
                    },
                    {
                        key:'doYouAlreadyL2EAD',
                        section:'dependentsInfo.spouse',
                    },
                    {
                        key:'anyOtherPersonEmployedInUS',
                        section:'dependentsInfo.spouse',
                    },
                    {
                        key:'hasOtherNames',
                        section:'beneficiaryInfo',
                    },
					{
                        key:'hasOtherNames',
                        section:'dependentsInfo.spouse',
                    },
                    {
                        key:'didThisPtnrFliedImmPetitionEarlier',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'haveYouEverAppliedH1bCase',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'nameDiffFromBirthCert',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'birthCertHaveNamePobDob',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'have2AffidavitsOfBirthFamily',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'previouslyMarried',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'enterInUSUnderCaseWaiverProgram',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'inspectedByAnyImmOfficer',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'issuedAnyEADFromUSCIS',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'hasPermResidencyInOtherCountry',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'haveYouArrestedBefore',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'everAppliedAOSInUS',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'haveYouEverReceivedPublicAssistendeInUS',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'haveYouEverlikelyReceivePublicAssistendeInUS',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'isVisaDenieedTOUS',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'haveYoueverPresntUnlawfully',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'doYouHaveMarriageCert',
                        section:'beneficiaryInfo',
                    },
                    {
                        key:'have2AffidavitsAttestingToMarriage',
                        section:'beneficiaryInfo',
                    },
                    // {
                    //     key:'anyImmPetitionFiled',
                    //     section:'beneficiaryInfo',
                    // },
                    
                ],
                parentsIgnoreItems:['countryOfBirthDetails','countryOfBirth','provinceOfBirth','provinceOfBirthDetails','nameAtBirth','deceasedCityDetails','deceasedCity'],
                educationErrorMsg:"Seems you have not submitted bachelor's information. Please fill to continue",
                configDetails:null,
                prefillCountryInQuestionnaire:true,
                
            };
        },
        computed: {
            getConsentVal(){
                let returnVal = '';
                if(this.consentChecked){
                    returnVal = 'consentChecked';
                }
                return returnVal;
            },
            getTermsVal(){
                let returnVal = '';
                if(this.termsAndConditionsChecked){
                    returnVal = 'termsAndConditionsChecked';
                }
                return returnVal;
            },
            getLabelContent(){
                let returnVal = '';
                if(this.contentCategory == 'consent'){
                    returnVal = 'Consent to Process Personal Data';
                }
                if(this.contentCategory == 'termsAndConditions'){
                    returnVal = 'Terms and Conditions';
                }
                return returnVal
            },
            IsSponsorLogin(){
                let returnVal =false;
                let loginUserData = this.$store.state.loginUserData;
                if(this.checkProperty(loginUserData,'accountType') && this.checkProperty(loginUserData,'accountType')=='Individual' 
                && this.checkProperty(loginUserData,'accountSubType') && this.checkProperty(loginUserData,'accountSubType')=='Sponsor'){
                    returnVal =true
                }else{
                    returnVal =false
                }
                return returnVal;   
            },
            isI140Case(){
                let returnVal = false;
                if([3].indexOf(this.checkProperty(this.petition ,'typeDetails','id' )) >-1 && [16].indexOf(this.checkProperty(this.petition ,'subTypeDetails','id' ) )>-1 ){
                    returnVal =true;
                }
                return returnVal
            },
   
            concateName(){
                    let returnVal = ''

                        if(this.checkProperty(this.petition['beneficiaryInfo'],'firstName')){
                            returnVal = this.checkProperty(this.petition['beneficiaryInfo'],'firstName')
                        }
                        if(this.checkProperty(this.petition['beneficiaryInfo'],'middleName')){
                             returnVal = returnVal +' '+ this.checkProperty(this.petition['beneficiaryInfo'],'middleName')
                        }
                        if(this.checkProperty(this.petition['beneficiaryInfo'],'lastName')){
                            returnVal =  returnVal +' '+this.checkProperty(this.petition['beneficiaryInfo'],'lastName')
                        }
                        return returnVal
                },
            getTplSectionPrevious(){
                if(this.tplsection=='dependentsInfo.spouse'){
                return "dependentsInfo.spouse.previousSpouse"
                }else{
                    return this.tplsection;
                }
            },
            checkActiveTab(){
              return  _.findIndex(this.tabslist ,{"key":this.currentTab});
            },  
            getCaseName(){
                //petition.typeDetails.name
                let s =this.checkProperty(this.petition ,'typeDetails','name');
               if(s){
                s='Questionnaire for '+s;
                if( this.checkProperty(this.petition ,'subTypeDetails','name') ){
                    s=s+" <small>"+this.petition.subTypeDetails.name+"</small"
                }
                return s.replace(/(\d)/g, '<span class="number">$1</span>');
            }else{
                return '';
            }
    
            },
            gettotalDays() {
                var totaldays = 0;
                if(this.petition.beneficiaryInfo.priorPeriodOfStayInUS && this.checkProperty(this.petition['beneficiaryInfo'],'priorPeriodOfStayInUS','length')>0){
                    this.petition.beneficiaryInfo.priorPeriodOfStayInUS.forEach(function (item, index) {
                        if (item.noOfDays > 0) {
                            totaldays = totaldays + item.noOfDays;
        
                        }
                    })
                }
                return totaldays;
            },
            getIndexOfActivetab() {
                var $self = this;
                return _.findIndex(this.tabslist, (e) => {
                    return e.key == $self.currentTab;
                }) + 1;
            },
            actiontype() {
                if (this.getIndexOfActivetab == this.tabslist.length) {
                    if (this.petition.questionnaireFilled) { 
                        return "Update";
                    }
                    if (!this.petition.questionnaireFilled) {
                        return "Review & Submit";
                    }
                    return "Submit";
                }
                return "Next";
            }
    
        },
        methods: {
            agreeTerms(categ){
                if(categ == 'consent'){
                    this.consentChecked=true;
                }
                if(categ == 'termsAndConditions'){
                    this.termsAndConditionsChecked=true
                }
                this.$modal.hide('showConsentContentPopup');
            },
            getConsentDetails(){
                let path = '/global/get-consent-content';
                let payLoad = {
                    tenantId:this.checkProperty( this.getUserData, 'tenantId')
                };
                this.$store.dispatch('commonAction', {data:payLoad, path:path}).then((res)=>{
                    if(res){
                        if(res['consent']){
                            this.consentData = res['consent'];
                        }
                        if(res['termsAndConditions']){
                            this.termsAndConditionsData = res['termsAndConditions'];
                        }
                    }
                }).catch((err)=>{

                })
            },
            openConsentContent(category){
                this.getConsentDetails();
                let self = this;
                setTimeout(()=>{
                    self.contentCategory = category;
                    self.$modal.show('showConsentContentPopup')
                }, 1000)
                
                // this.showConsentContentPopup = true;
            },
            removeBenefitItem(inde){
                Vue.delete(this.petition['beneficiaryInfo']['benefitsRecAmounts'], inde);
            },
            addBenefitItem(){
                let obj = {
                    benefitReceived: '',
                    startDate: null,
                    endDate: null,
                    amount: ''
                };
                this.petition['beneficiaryInfo']['benefitsRecAmounts'].push(obj)
            },
            addInstituteItem(){
                let obj = {
                    institutionName:'',
                    stateId:'',
                    stateDetails:null,
                    locationId:'',
                    locationDetails:null,
                    dateFrom:null,
                    dateTo:null,
                    reason:'',
                };
                this.petition['beneficiaryInfo']['periodOfInstutions'].push(obj);
                this.petition['beneficiaryInfo']['periodOfInstutions'] = _.cloneDeep(this.petition['beneficiaryInfo']['periodOfInstutions'])
            },
            removeInstituteItem(inde){
                Vue.delete(this.petition['beneficiaryInfo']['periodOfInstutions'], inde);
            },
            getWageReturnYearDetails() {
                let postData = {
                    userId: this.checkProperty(this.petition,'userId'),
                };
                let path = '/beneficiary-profile/get-wage-received-years'
                this.$store.dispatch('commonAction', {'data':postData,'path':path}).then((res)=>{
                    if(res && res['wageReceivedYears'] && this.checkProperty(res, 'wageReceivedYears', 'length')>0){
                        this.wageInformationArray = res['wageReceivedYears'];
                    }
                }).catch((err)=>{

                })
                let payLoad = {};
                let yearPath = '/common/get-wage-tax-year'
                this.$store.dispatch('commonAction', {'data':payLoad,'path':yearPath}).then((response)=>{
                    if(_.has(response, 'year')){
                        this.wageStartingYear = response.year;
                        let difference = this.currentYear - this.wageStartingYear;
                        for (let index = 0; index <= difference; index++) {
                            let yearToAdd = this.wageStartingYear + index;
                            let obj = {
                                'year': yearToAdd,
                                'salary': "",
                                'document': [],
                                'filesAreuploading':false
                            };
                            let findObj = _.find(this.wageInformationArray, {'year':yearToAdd});
                            if(!findObj){
                                this.wageInformationArray.push(obj);
                            }
                        }
                        if(this.checkProperty(this.wageInformationArray, 'length')>0){
                            this.wageInformationArray.sort((a, b) => b.year - a.year);
                        }
                    }
                }).catch((error)=>{

                });
                
            },
            updateWagesReturn(){
                let postData = {
                    userId: this.checkProperty(this.petition,'userId'),
                    wageReceivedYears:this.wageInformationArray,
                };
                let path = '/beneficiary-profile/update-wage-received-years'
                this.$store.dispatch('commonAction', {'data':postData,'path':path}).then((res)=>{

                }).catch((err)=>{

                })
            },
            reloadSponsorQues(){
                this.$router.push("/sponsor-questionnaire/"+this.$route.params.itemId);
            },
            reloadPetitionerQues(){
                this.$router.push({ name: "petitioner-questionnaire", params: { itemId: this.$route.params.itemId, 'redirect': false } });
                //this.$router.push("/petitioner-questionnaire/"+this.$route.params.itemId);
            },
            updateEmployementUs(category){
                let cat = category // 
                if(cat == 'Spouse'){
                    let vl = this.spouse.anyOtherPersonEmployedInUS;
                    if(vl){
                        setTimeout(()=>{
                            this.$refs['spouseEmploymentRef'].updateUsaCountry(vl);
                        },100)
                    }
                }
                if(cat == 'Child'){
                    let vl = this.petition.dependentsInfo.childrens[this.selectedchild].anyOtherPersonEmployedInUS;
                    if(vl){
                        setTimeout(()=>{
                            this.$refs['childEducationForm'].updateUsaCountry(vl);
                        },100);
                    }
                }
            },
            removeConsulateAddress(){

                if(this.checkProperty(this.petition, 'beneficiaryInfo','consulateInfo') && (_.has(this.petition['beneficiaryInfo']['consulateInfo'],'stateDetails') ||
                _.has(this.petition['beneficiaryInfo']['consulateInfo'],'stateId'))){
                    if(_.has(this.petition['beneficiaryInfo']['consulateInfo'],'stateDetails')){
                        delete this.petition['beneficiaryInfo']['consulateInfo']['stateDetails'];
                    }
                    if(_.has(this.petition['beneficiaryInfo']['consulateInfo'],'stateId')){
                        delete this.petition['beneficiaryInfo']['consulateInfo']['stateId']
                    }
                   
                }
            },
            updateVerificationStatus(status=false){
                this.openGeneratePinPopUp =false;
                this.tokenVerified = status;
                this.init();

            },
            checkH4andH4eadFields(){
                if(!this.checkProperty(this.petition,'beneficiaryInfo','hasI140ImmPetitionFiled') && !this.checkProperty(this.petition,'beneficiaryInfo','anyImmPetitionFiled') ){
                    this.spouse['h4EADRequired'] =  false
                    this.spouse['doYouAlreadyH4EAD'] =  false
                    this.petition['dependentsInfo']['spouse']['h4EADRequired'] =  false
                    this.petition['dependentsInfo']['spouse']['doYouAlreadyH4EAD'] =  false
                    if(this.checkProperty(this.petition, 'dependentsInfo', 'childrens') && this.checkProperty(this.petition['dependentsInfo'], 'childrens', 'length')>0){
                        _.forEach(this.petition['dependentsInfo']['childrens'], (it)=>{
                            if(_.has(it, 'doYouAlreadyH4EAD')){
                                it['doYouAlreadyH4EAD'] = false;
                            }
                            if(_.has(it, 'h4EADRequired')){
                                it['h4EADRequired'] = false;
                            }
                        })
                    }
                }
            },
           // tempSave:false,
           //showMessage:true,
           submitCase(callFromConform=false) {
                 let self =this;
                this.$validator.validateAll(this.currentTab + "form").then((result) => {
    
                    if (result && this.customvalidations()) {
                        if(this.checkEducationTab()){
                            if (this.getIndexOfActivetab < this.tabslist.length) {
                                this.setActiveTab(this.tabslist[this.getIndexOfActivetab].key);
                                setTimeout(function () {
                                    document.getElementById("scrollableques").scrollTo({
                                        top: 0,
                                        left: 0,
                                        behavior: 'smooth'
                                    })
                                }, 500)
        
                            } 
                            else {
                                if((
                                    this.consentChecked && 
                                    this.termsAndConditionsChecked && 
                                    [50, 51].indexOf(this.getUserRoleId) > -1 && 
                                    this.checkProperty(this.configDetails, 'acceptConsentAndTAndC')
                                ) || 
                                (
                                    [50, 51].indexOf(this.getUserRoleId) <= -1 || 
                                    ( 
                                        [50, 51].indexOf(this.getUserRoleId) > -1 && 
                                        !this.checkProperty(this.configDetails, 'acceptConsentAndTAndC')
                                    )
                                )){
                                    if (this.petition.questionnaireFilled) {
                                        // this.$vs.loading();
                                        // this.saveCase(true, false);
                                        self.tempSave =true;
                                        self.showMessage = false
                                        this.benProfileDetails = _.cloneDeep(this.petition);
                                        this.toggleBenProfileCOnformPopUp(true);
                                        this.checkH4andH4eadFields();
                                    }
                                    else{          
                                        this.petition['beneficiaryInfo']['name'] = this.concateName
                                        this.removeConsulateAddress();
                                        this.setSameaddress(false);
                                        this.benProfileDetails = _.cloneDeep(this.petition);
                                        this.checkPreviousSpouse();
                                        this.callQuestionairePrefill();
                                        this.checkH4andH4eadFields();
                                        let temp_save =false;
                                        this.questionnairePreviewData = {
                                        submittedWithLink:false,
                                        petitionId: this.$route.params.itemId,
                                        userName: this.$store.state.user.name,
                                        typeName: this.petition.typeDetails.name,
                                        subTypeName: this.petition.subTypeDetails.name,
                                        subTypeDetails:this.petition.subTypeDetails,
                                        typeDetails: this.petition.typeDetails,
                                        action: temp_save ? "BENEFICIARY_INFO_UPDATE" : "SUBMIT_BY_BENEFICIARY",
                                        currentDate: moment().format("YYYY-MM-DD"),
                                        beneficiaryInfo: this.petition.beneficiaryInfo,
                                        dependentsInfo: this.petition.dependentsInfo,
                                        documents: this.petition.documents,
                                        fatherInfo: this.petition.fatherInfo,
                                        motherInfo: this.petition.motherInfo,
                                        temp_save: temp_save,
                                        questionnaireFilled: temp_save ? false : true
                                        };
                                        if( this.checkProperty(this.petition['beneficiaryInfo'], 'prevH1bCaseStatus') && this.checkProperty(this.petition['beneficiaryInfo'], 'prevH1bCaseStatus', 'id')){
                                            this.questionnairePreviewData['beneficiaryInfo']['prevH1bCaseStatus'] = this.checkProperty(this.petition['beneficiaryInfo'], 'prevH1bCaseStatus', 'id');
                                        }
                                        this.questionnairePreviewData['noOfDaysStayInUS'] = this.gettotalDays;
                                        if(!this.checkProperty(this.petition ,'permId') && this.checkProperty(this.petition ,'subTypeDetails' ,'id') ==16 && this.checkProperty(this.petition ,'jobDetails') ){
                                            this.questionnairePreviewData = Object.assign( this.questionnairePreviewData , { 'jobDetails': this.petition['jobDetails']} );
    
                                        } 
                                        if( this.checkProperty(this.petition, 'subTypeDetails', 'id') == 16 && this.wageInformationArray && this.checkProperty(this.wageInformationArray, 'length')>0 ){
                                            this.questionnairePreviewData = Object.assign( this.questionnairePreviewData , { 'wageInformationArray': this.wageInformationArray} );
                                        }
                                        if(!this.checkCurrentUrl){
                                            this.questionnairePreviewData['submittedWithLink'] =true;
                                        }
                                        this.questionnairePreview = true;
                                        
                                    
                                    }
                                }else{
                                   // console.log('consentTermsForm')
                                    this.$validator.validateAll("consentTermsForm")
                                }   
                            }
                        }
                        else{
                            this.showToster({
                                    message:  this.educationErrorMsg,
                                    isError: true,
                                });
                        }
                    } else {
                        this.validateandScroll();
                    }
                })
            },
            conformBenProfile(conform=false){
                this.toggleBenProfileCOnformPopUp(false);
                this.$vs.loading();
                if(conform){
                    this.updateBeneficiaryProfile();
                }
               
                this.saveCase(this.tempSave,this.showMessage);
            },
            toggleBenProfileCOnformPopUp(action=false){
                this.showBenProfileSyncPopup = action;

            },
            updateBeneficiaryProfile(){
                var postpetition = {
                    userId: this.checkProperty(this.petition,'userId'),
                    currentDate: moment().format("YYYY-MM-DD"),
                };
                if(_.has(this.benProfileDetails,'beneficiaryInfo')){
                    postpetition['beneficiaryInfo'] = this.benProfileDetails.beneficiaryInfo;
                }
                if(_.has(this.benProfileDetails,'dependentsInfo')){
                    postpetition['dependentsInfo'] = this.benProfileDetails.dependentsInfo;
                }
                if(_.has(this.benProfileDetails,'fatherInfo')){
                    postpetition['fatherInfo'] = this.benProfileDetails.fatherInfo;
                }
                if(_.has(this.benProfileDetails,'motherInfo')){
                    postpetition['motherInfo'] = this.benProfileDetails.motherInfo;
                }
                if(_.has(this.benProfileDetails,'documents')){
                    postpetition['documents'] = this.benProfileDetails.documents;
                }
                let path = '/beneficiary-profile/update-beneficiary-profile'
                this.$store.dispatch("commonAction", {data:postpetition,path:path}).then((res)=>{
                    this.showBenProfileSyncPopup = false;
                }).catch((err)=>{
                    
                })
            },
           
            emitUploadingAction(data){
                if(_.has(data,'docMainCategory')){
                    _.map(this[data['docMainCategory']],(item)=>{
                        if(item['fieldName'] == data['fieldName']){
                            item = Object.assign( item ,{ "fileUploading": false})
                            item['fileUploading'] = data['action'] 
                        }
                    })
                }
                if(_.has(data,'allFilesAreUploaded')){
                    if(data['allFilesAreUploaded'] && this.checkProperty(data,'uploadFIlesErrors', 'length') >0){
                        let joinedError = '';
                                if(data['uploadFIlesErrors'].length>0){
                                    joinedError = data['uploadFIlesErrors'].join(", ")
                                }
                        this.showToster({
                                        message:joinedError,
                                        isError: true,
                                    });

                    }

                }
                this.checkSubmitBtn(data)
            },
            checkSubmitBtn(data){
                this.documentUploading = false;
                if(_.has(data,'docMainCategory')){
                    _.forEach(this[data['docMainCategory']],(item)=>{
                        if(_.has(item,'fileUploading') && item['fileUploading']){
                            this.documentUploading = true;
                            return false;
                        }
                    })
                }
            },
            chnageMailingAddress(){
                if(this.checkProperty(this.petition,'beneficiaryInfo','currentlyInUS') && this.canRenderField('mailingAddressIsSameAsAddress',this.questionnaireDetails, false, 'beneficiaryInfo' ) 
                && this.canRenderField('currentAddress',this.questionnaireDetails, false, 'beneficiaryInfo' ) && this.canRenderField('address',this.questionnaireDetails, false, 'beneficiaryInfo' )
                && this.petition.beneficiaryInfo.mailingAddressIsSameAsAddress){
                    this.setSameaddress()
                }
                if(this.checkProperty(this.petition,'beneficiaryInfo','currentlyInUS')){
                    this.petition.beneficiaryInfo.address ={
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: {
                            _id: "61408c9ed01ea1248cdcf6b7",
                            id: 231,
                            name: "United States",
                            phoneCode: 1,
                            order: 1,
                            currencySymbol: "$",
                            currencyCode: "USD",
                            zipcodeLength: 5,
                            sortName: "united states",
                        },
                        zipcode: null
                        //countryDetails:this.countries[0]
                    }
                }else{
                    this.petition.beneficiaryInfo.address ={
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: null,
                        zipcode: null
                    }
                }
            },
            addNyears(){
                let obj ={
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: {
                            _id: "61408c9ed01ea1248cdcf6b7",
                            id: 231,
                            name: "United States",
                            phoneCode: 1,
                            order: 1,
                            currencySymbol: "$",
                            currencyCode: "USD",
                            zipcodeLength: 5,
                            sortName: "united states",
                        },
                        zipcode: null,
                        startDate: null,
                        endDate: null,
                }
                this.petition.beneficiaryInfo['addressOfLastNYears'].push(obj);
                this.petition.beneficiaryInfo['addressOfLastNYears'] = _.cloneDeep( this.petition.beneficiaryInfo['addressOfLastNYears']);
            },
            removeNyears: function (index) {
                Vue.delete(this.petition.beneficiaryInfo.addressOfLastNYears, index);
            },
            addLastYearItem(){
                let obj ={
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: {
                            _id: "61408c9ed01ea1248cdcf6b7",
                            id: 231,
                            name: "United States",
                            phoneCode: 1,
                            order: 1,
                            currencySymbol: "$",
                            currencyCode: "USD",
                            zipcodeLength: 5,
                            sortName: "united states",
                        },
                        zipcode: null,
                        startDate: null,
                        endDate: null,
                }
                    this.petition.beneficiaryInfo['addressOutsideUSMoreThanYear'].push(obj);
                   this.petition.beneficiaryInfo['addressOutsideUSMoreThanYear'] = _.cloneDeep( this.petition.beneficiaryInfo['addressOutsideUSMoreThanYear']); 
            },
            removeLastYearItem: function (ind) {
                Vue.delete(this.petition.beneficiaryInfo.addressOutsideUSMoreThanYear, ind);
            },
            clearStartandEnddate(val,key,inder,position){
                if( this.petition.beneficiaryInfo[key] && this.checkProperty(this.petition.beneficiaryInfo[key],'length')>0){
                    let startDate = moment(this.petition.beneficiaryInfo[key][inder]['startDate']);
                    let endDate = moment(this.petition.beneficiaryInfo[key][inder]['endDate']);
                    if(!val && position == 'start'){
                        this.petition.beneficiaryInfo[key][inder]['endDate'] = null
                    }
                    if(val && position == 'start' && ( startDate.isAfter(endDate , 'day'))){
                        this.petition.beneficiaryInfo[key][inder]['endDate'] = null
                    }
                    if(position == 'end' && ( endDate.isBefore(startDate, 'day'))){
                        this.petition.beneficiaryInfo[key][inder]['startDate'] = null
                    }
                }
            },
            clearBenefitDateField(obj, inde){
                if(_.has(obj, 'startDate') && obj['startDate'] ){
                    let startDate = moment(obj['startDate']);
                    if(_.has(obj, 'endDate') && obj['endDate'] ){
                        let endDate = moment(obj['endDate']);
                        if(startDate.isAfter(endDate , 'day')){
                            this.petition.beneficiaryInfo['benefitsRecAmounts'][inde].endDate = null;
                        }
                    }
                }else{
                    this.petition.beneficiaryInfo['benefitsRecAmounts'][inde].endDate = null;
                }
            },
            clearDependentField(obj){   
                if(_.has(obj, 'startDate') && obj['startDate'] ){
                    let startDate = moment(obj['startDate']);
                    if(_.has(obj, 'endDate') && obj['endDate'] ){
                        let endDate = moment(obj['endDate']);
                        if(startDate.isAfter(endDate , 'day')){
                            this.petition.beneficiaryInfo['associations'][0].endDate = null;
                        }
                    }
                }
                // console.log(JSON.stringify(obj))
            //    if(obj['startDate']==null){
            //        obj.endDate = null;
            //    }
            //    if(obj.startDate > obj.endDate){
            //        obj.endDate = null;
            //    }
            },
            clearEndDate(obj){
               if(obj['startDate']==null){
                   obj.endDate = null;
               }
               if(obj.startDate > obj.endDate){
                   obj.endDate = null;
               }
            },
            disableCountryUsa(){
                if(this.checkProperty(this.petition,'highestDegreeList') && this.checkProperty(this.petition,'highestDegreeList','length')>0 && this.checkProperty(this.petition,'beneficiaryInfo','educations') && this.checkProperty(this.petition['beneficiaryInfo'],'educations','length')>0
                && this.petition.beneficiaryInfo.hasMasterDegreeInUS ){
                    _.forEach(this.petition.beneficiaryInfo.educations,(item)=>{
                        if(_.has(item,'highestDegree') && this.checkProperty(item,'highestDegree') == 6 && 
                        _.has(item,'address') && _.has(item['address'],'countryId')){
                            item['address']['countryId'] = 231
                            item['address']['countryDetails'] = { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" }
                        }
                    })
                }
            },
            removeCOuntryUSA(){
                if(!this.petition.beneficiaryInfo.hasMasterDegreeInUS && this.canRenderField('hasMasterDegreeInUS', this.questionnaireDetails ,false,'beneficiaryInfo')){
                    this.$refs['beneficairy_education'].removeCountryUs();     
                }
            },
            checkPreviousSpouse(){
                if((this.petition.beneficiaryInfo.previouslyMarried == null || this.petition.beneficiaryInfo.previouslyMarried == false)  && this.checkProperty(this.petition ,'beneficiaryInfo','maritalStatus') ==1){
                    this.petition.beneficiaryInfo.previousSpouse = {
                        hasOtherNames:false,
                        otherNames: [{
                            _id: 0,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                        }],
                        maidenName:'',
                        marriageEndedDueTo:null,
                        marriageEndedOtherInfo:'',
                        firstName: '',
                        middleName: '',
                        lastName: '',
                        dateOfBirth: null,
                        dateOfMarriage:null,
                        dateOfMarriageEnd:null,
                        countryOfMarriage: '',
                        countryOfMarriageDetails: null,
                        provinceOfMarriage: '',
                        provinceOfMarriageDetails: null,
                        locationOfMarriage: '',
                        countryOfMarriageTermination: '',
                        countryOfMarriageTerminationDetails: null,
                        provinceOfMarriageTermination: '',
                        provinceOfMarriageTerminationDetails: null,
                        locationOfMarriageTermination: '',
                        obtainPermResidenceThroughSpouse:false     
                    }
                }
            },
            I94ValueCheck(val){
                if(!val){
                    this.petition.beneficiaryInfo.isI94DSExpiryDate = false;
                }
               if(val.length<=0 && this.petition.beneficiaryInfo.isI94DSExpiryDate==false){
                this.petition.beneficiaryInfo.I94ExpiryDate = null;
                this.disablefield = true;
              }
            },
            getGlobalConfigDetails(){
                let postData ={}
                let path = 'global-config/details'
                this.$store.dispatch("commonAction", {data:postData,path:path})
                .then((response) =>{   
                this.defaultCountryCode = this.countrycode;            
                    if(this.checkProperty(response ,"config" )){
                        this.configDetails = this.checkProperty(response ,"config" );
                        if(_.has(this.configDetails ,"prefillCountryInQuestionnaire" )){
                            this.prefillCountryInQuestionnaire =this.configDetails['prefillCountryInQuestionnaire']
                        }
                    
                    }
                })
            },
            removeH4Docs(){
                if(this.checkProperty( this.petition,'beneficiaryInfo','curNonImmigrantVisaStatus') && this.checkProperty( this.petition,'beneficiaryInfo','curNonImmigrantVisaStatus')!=7 ){
                    let docsList = ['formI797H4ApprovalNotice','h4Ead','marriageCertificate','formI797H1BApprovalNoticePrinNonCtzn','passportOfPrinNonCtzn','last3MonthsPayslipsOfPrinNonCtzn']
                    _.forEach(docsList,(item)=>{
                        if(_.has(this.petition['documents'],item)){
                            this.petition['documents'][item] = []
                        }
                    })
                }
            },
            removeFields(){
                
                _.forEach(this.ignorePrefillItems,(item)=>{
                    let section = item['section'];
                    let key  = item['key'];
                    _.update(this.petition,section+'.'+key, () => null);
                })
                if(this.checkProperty(this.petition,'beneficiaryInfo','prevEmploymentInfo') && this.checkProperty(this.petition['beneficiaryInfo'],'prevEmploymentInfo','length')>0){
                    _.forEach(this.petition['beneficiaryInfo']['prevEmploymentInfo'],(item)=>{
                        if(_.has(item,'currentEmployer')){
                            item['currentEmployer'] = null;
                        }
                    })
                }
                if(this.prefillCountryInQuestionnaire == false){
                    this.petition.beneficiaryInfo.address['countryId'] = null;
                    this.petition.beneficiaryInfo.consulateInfo['countryId'] =  null;
                    this.petition.beneficiaryInfo.currentAddress['countryId'] = null;  
                    this.petition.beneficiaryInfo.addressOutsideUS['countryId'] = null; 
                    if(this.petition.beneficiaryInfo && this.checkProperty(this.petition.beneficiaryInfo,'educations') && this.checkProperty(this.petition.beneficiaryInfo,'educations','length')>0){
                        this.petition.beneficiaryInfo.educations[0].address['countryId'] = null;
                    }
                    if(this.petition.beneficiaryInfo && this.checkProperty(this.petition.beneficiaryInfo,'prevEmploymentInfo') && this.checkProperty(this.petition.beneficiaryInfo,'prevEmploymentInfo','length')>0){
                        this.petition.beneficiaryInfo.prevEmploymentInfo[0].address['countryId'] = null;
                    }
                    this.petition.dependentsInfo.spouse['physicalAddress']['countryId'] = null;
                    this.petition.dependentsInfo.spouse['addressOutsideUS']['countryId'] = null;
                    if(this.petition.dependentsInfo && this.checkProperty(this.petition.dependentsInfo,'childrens') && this.checkProperty(this.petition.dependentsInfo,'childrens','length')>0){
                        this.petition.dependentsInfo.childrens[0]['physicalAddress']['countryId'] = null;
                        this.petition.dependentsInfo.childrens[0]['addressOutsideUS']['countryId'] = null;
                    }
                    
                }
                if(this.checkProperty(this.petition,'typeDetails')&& this.checkProperty(this.petition,'typeDetails','id')==1 && 
                this.checkProperty(this.petition,'subTypeDetails') && [10,8].indexOf(this.checkProperty(this.petition,'subTypeDetails','id'))>-1){
                    this.petition.beneficiaryInfo.address['countryId'] = null;
                    this.petition.dependentsInfo.spouse['physicalAddress']['countryId'] = null;
                    this.petition.dependentsInfo.childrens[0]['physicalAddress']['countryId'] = null;
                }
                if(this.checkProperty(this.petition,'typeDetails')&& this.checkProperty(this.petition,'typeDetails','id')==1 && 
                this.checkProperty(this.petition,'subTypeDetails') && [7,11].indexOf(this.checkProperty(this.petition,'subTypeDetails','id'))>-1){
                    _.forEach(this.ignorePrefillItems,(item)=>{
                        if(_.has(item,'preSelect') && this.checkProperty(item,'preSelect')){
                            let section = item['section'];
                            let key  = item['key'];
                            _.update(this.petition,section+'.'+key, () => true);
                        }
                        
                    })
                }
            },
            checkCurrentlyInUsa(){
                if(this.canRenderField('currentlyInUS',this.questionnaireDetails, false, 'beneficiaryInfo' ) && !this.checkProperty(this.petition,'beneficiaryInfo','currentlyInUS') && !this.isI140Case){
                    this.petition.beneficiaryInfo.curNonImmigrantVisaStatusDetails = null
                    this.petition.beneficiaryInfo.curNonImmigrantVisaStatus  = null
                    this.petition.beneficiaryInfo.isDSExpiryDate = null
                    this.petition.beneficiaryInfo.curVisaExpiryDate = null
                    this.petition.beneficiaryInfo.I94 = null
                    this.petition.beneficiaryInfo.isI94DSExpiryDate = null
                    this.petition.beneficiaryInfo.I94ExpiryDate = null
                    this.petition.beneficiaryInfo.sevisNumber = null
                    this.petition.beneficiaryInfo.eadNumber = null
                    this.petition.beneficiaryInfo.address ={
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: null,
                        zipcode: null
                    }
                }
            },
            checkDependentsInfo(){
                if(this.petition.beneficiaryInfo && ((_.has(this.petition['beneficiaryInfo'],'hasAnyDependetsinUStoFileH4') && this.canRenderField('hasAnyDependetsinUStoFileH4',this.questionnaireDetails,false ,'beneficiaryInfo') && !this.checkProperty(this.petition,'beneficiaryInfo','hasAnyDependetsinUStoFileH4'))||
                (!this.checkProperty(this.petition.beneficiaryInfo, 'maritalStatusDetails') || this.checkProperty(this.petition.beneficiaryInfo, 'maritalStatusDetails', 'id') == 1 )) ){
                    this.petition['dependentsInfo'] = {
                        spouse: {
                            sevisNumber: null,
                            eadNumber: null,
                            haveYouEverTravelledToUS:null,
                            isDSExpiryDate:false,
                            isI94DSExpiryDate:false,
                            relationship: '',
                            saved: false,
                            currentlyInUS: null,
                            hasOtherNames: null, 
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            passportIssuedNumber: null,
                            alienNumber: '',
                            prevEmploymentInfo: [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                payFrequency:null,
                                salary: null,
                                currentEmployer: null
                            }],
                            addressOutsideUS: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            priorPeriodOfStayInUS: [{
                                _id: 0,
                                enteredNumber: null,
                                departedNumber: null,
                                dateerror: false,
                                noOfDays: null,
                                visaStatus: null
                            }],
                            dateFromWhichResideInUs:null,
                            caseIssuedDate: null,
                            caseExpiryDate: null,
                            placeOfCaseIssued: '',
                            mailingAddressIsSameAsAddress:false,
                            stateOfLastEntryInUS: '',
                            stateDetailsOfLastEntryInUS: null,
                            placeOfLastEntryInUS: '',
                            firstArrivalDate: null,
                            lastArrivalDate: null,
                            allIssuedpassportData: [{
                                countryId: '',
                                countryDetails: null,
                                number: '',
                                issuedDate: null,
                                expiryDate: null 
                            }],
                            currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            height: {
                            feet: '',
                            inches: ''
                            },
                            weight: null,
                            race: [],
                            eyeColor:null,
                            hairColor: null,
                            educations: [{
                            _id: 0,
                            name: null,
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            highestDegree: null,
                            highestDegreeDetails: null,
                            majorFieldOfStudy: null,
                            attendedFrom: null,
                            attendedTo: null,
                            graduatedYear: null,
                            degreereceived: null,
                            isAccredited: null,
                            isForProfit: null
                            }],
                            prevEmploymentInfo: [{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            currentEmployer: false
                            }],
                            prevEmploymentOutsideUS:[{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                currentEmployer: false  
                            }],
                            previousSpouse:{
                            hasOtherNames:false,
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            maidenName:'',
                            marriageEndedDueTo:null,
                            marriageEndedOtherInfo:'',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            dateOfBirth: null,
                            dateOfMarriage:null,
                            dateOfMarriageEnd:null,
    
                              //Place of Marriage
                            countryOfMarriage: '',
                            countryOfMarriageDetails: null,
                            provinceOfMarriage: '',
                            provinceOfMarriageDetails: null,
                            locationOfMarriage: '',
    
                            //Place of Termination
                            countryOfMarriageTermination: '',
                            countryOfMarriageTerminationDetails: null,
                            provinceOfMarriageTermination: '',
                            provinceOfMarriageTerminationDetails: null,
                            locationOfMarriageTermination: '',
                            obtainPermResidenceThroughSpouse:false  
                          
                            },
                            addressOfLastNYears:[{
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                            }], 
                            addressOutsideUSMoreThanYear:[{
                            
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                            }],
                            dateOfLastEntryInUS:null,
                            dateOfMarriage: null, 
                            dateOfMarriageEnd: null, 
                            countryOfMarriage: '', 
                            countryOfMarriageDetails: null, 
                            provinceOfMarriage: '', 
                            provinceOfMarriageDetails: null, 
                            locationOfMarriage: '',
                            currentSpouseName: '',
                            maritalStatus : '', 
                            maritalStatusDetails: null,
                            curNonImmigrantVisaStatus: '', 
                            associations:[ {
                                name:'', 
                                address:{
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                },
                                startDate: null,
                                endDate:null,
                                natureofAssociations:'',
                            }],

                            isVisaDenieedTOUS:null,
                            visaDeniedReason:'',
                            haveYoueverPresntUnlawfully:false,
                            presntUnlawfullyReason:'',
                            haveYouEverReceivedPublicAssistendeInUS:false,
                            haveYouEverlikelyReceivePublicAssistendeInUS:false,
                            everAppliedAOSInUS: false, 
                            appliedAOSInUSDocs:[],
                            haveYouArrestedBefore:false,
                            haveYouArrestedBeforeDocs:[], 
                            doesBirthRegistered:false, 
                            curNonImmigrantVisaNumber:'',
                            enterInUSUnderCaseWaiverProgram: false,
                            inspectedByAnyImmOfficer: false, 
                            issuedAnyEADFromUSCIS: false, 
                            hasPermResidencyInOtherCountry: false, 
                            permResidencyCountryId: '', 
                            passportIssuedDate: null,
                            permResidencyCountryDetails: null,
                            

                            h4Required: null,
                            hasSpouse:null,
                            l2Required:null,
                            h4EADRequired: null,
                            l2EADRequired:null,
                            doYouAlreadyL2EAD:null,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            email: '',
                            phoneNumber: '',
                            phoneCountryCode: {
                                countryCode: '',
                                countryCallingCode: ''
                            },
                            dateOfBirth: null,
                            countryOfBirth: null,
                            countryOfBirthDetails: null,
                            provinceOfBirth: null,
                            provinceOfBirthDetails: null,
                            locationOfBirth: '',
                            locationOfBirthDetails: null,
                            countryOfCitizenship: null,
                            countryOfCitizenshipDetails: null,
                            passportNumber: '',
                            passportExpiryNumber: null,
                            passportIssuedCountry:null,
                            passportIssuedCountryDetails:null,
                            I94: '',
                            I94ExpiryNumber: null,
                            currentStatus: null,
                            currentStatusDetails: null,
                            statusExpiryNumber: null,
                            SSN: '',
                            lastArrivalNumber: null,
                            placeOfLastEntryInUS: '',
                            applyingWithYou:false,
                            classification:'',
                            nameDiffFromBirthCert:false,
                            i140PriorityDate:null,
                            physicalAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            fatherInfo: { 
                                name: '', 
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: false, 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                                isUSCitizen: false, 
                                dateFromUSCitizen: null, //["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                            },
                            motherInfo: { 
                                name: '',                    
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: false , 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                                },
                                isUSCitizen: false, 
                                dateFromUSCitizen:null,// ["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                            }, 
                            documents: {
                                passport: [],
                                visa: [],
                                formI94: [],
                                formI797: [],
                                formI20: [],
                                payStubs: [],
                                marriageCertificate: [],
                                noticeOfApprovalOfH1Status: [],
                                approvalNoticeOfPrevH4: [],
                                other: []
                            },
                            //i140
                            adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        
    
                        },
                        childrens: [{
                            sevisNumber: null,
                            eadNumber: null,
                            isDSExpiryDate:false,
                            isI94DSExpiryDate:false,
                            email: '',
                            phoneNumber: '',
                            phoneCountryCode: {
                            countryCode: '',
                            countryCallingCode: ''
                            },
                            saved: false,
                            relationship: '',
                            currentlyInUS: null,
                            hasOtherNames: null, 
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            alienNumber: '',
                            lastArrivalNumber: null,
                            placeOfLastEntryInUS: '',
                            physicalAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: {
                                    id: null,
                                    name: null,
                                    stateId: null,
                                    countryId: null
                                },
                                stateId: null,
                                stateDetails: {
                                    id: null,
                                    name: null,
                                    countryId: null
                                },
                                countryId: null,
                                countryDetails: {
                                    id: null,
                                    name: null,
                                    shortName: null,
                                    phoneCode: null,
                                    countryId: null,
                                    currencySymbol: null,
                                    currencyCode: null,
                                    zipcodeLength: null
                                },
                                zipcode: null
                            },
                            addressOutsideUS: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: {
                                    id: null,
                                    name: null,
                                    stateId: null,
                                    countryId: null
                                },
                                stateId: null,
                                stateDetails: {
                                    id: null,
                                    name: null,
                                    countryId: null
                                },
                                countryId: null,
                                countryDetails: {
                                    id: null,
                                    name: null,
                                    shortName: null,
                                    phoneCode: null,
                                    countryId: null,
                                    currencySymbol: null,
                                    currencyCode: null,
                                    zipcodeLength: null
                                },
                                zipcode: null
                            },
                            passportIssuedNumber: null,
                            priorPeriodOfStayInUS: [{
                                _id: 0,
                                enteredNumber: null,
                                dateerror: false,
                                noOfDays: null,
                                departedNumber: null,
                                visaStatus: null
                            }],
                            prevEmploymentInfo: [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                salary: null,
                                payFrequency:null,
                                currentEmployer: null
                            }],
                            anyOtherPersonEmployedInUS:null,
                            haveYouEverEmployed:null,
                            lastArrivalDate:null,
                            stateOfLastEntryInUS: '',
                            stateDetailsOfLastEntryInUS: null,
                            placeOfLastEntryInUS: '',
                            h4Required: null,
                            hasChildren: null,
                            l2Required:null,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            dateOfBirth: null,
                            countryOfBirth: null,
                            countryOfBirthDetails: null,
                            provinceOfBirth: null,
                            provinceOfBirthDetails: null,
                            locationOfBirth: '',
                            locationOfBirthDetails: null,
                            countryOfCitizenship: null,
                            countryOfCitizenshipDetails: null,
                            passportIssuedCountry:null,
                            passportIssuedCountryDetails:null,
                            passportNumber: '',
                            passportExpiryNumber: null,
                            I94: '',
                            I94ExpiryNumber: null,
                            currentStatus: null,
                            statusExpiryNumber: null,
                            documents: {
                                passport: [],
                                visa: [],
                                formI94: [],
                                birthCertificate: [],
                                approvalNotice: [],
                                approvalNoticeOfPrevH4: [],
                                other: []
                            },
    
                             //i140
                             adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        
                        }]
                    };
                    this.spouse = {
                            sevisNumber: null,
                            eadNumber: null,
                            isI94DSExpiryDate:false,
                            isDSExpiryDate:false,
                            anyOtherPersonEmployedInUS:null,
                            haveYouEverEmployed:null,
                            relationship: '',
                            saved: false,
                            currentlyInUS: null,
                            hasOtherNames: null, 
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            passportIssuedNumber: null,
                            alienNumber: '',
                            addressOutsideUS: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            stateDetailsOfLastEntryInUS:null,
                            stateOfLastEntryInUS:null,
                            lastArrivalDate:null,
                            prevEmploymentInfo: [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                salary: null,
                                payFrequency:null,
                                currentEmployer: null
                            }],
                            priorPeriodOfStayInUS: [{
                                _id: 0,
                                enteredNumber: null,
                                departedNumber: null,
                                dateerror: false,
                                noOfDays: null,
                                visaStatus: null
                            }],
    
                            h4Required: null,
                            hasSpouse:null,
                            l2Required:null,
                            h4EADRequired: null,
                            l2EADRequired:null,
                            doYouAlreadyL2EAD:null,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            email: '',
                            cellPhoneNumber:'',
                    cellPhoneCountryCode: {
                        countryCode: '',
                        countryCallingCode: ''
                    },
                            phoneNumber: '',
                            phoneCountryCode: {
                                countryCode: '',
                                countryCallingCode: ''
                            },
                            dateOfBirth: null,
                            countryOfBirth: null,
                            countryOfBirthDetails: null,
                            provinceOfBirth: null,
                            provinceOfBirthDetails: null,
                            locationOfBirth: '',
                            locationOfBirthDetails: null,
                            countryOfCitizenship: null,
                            countryOfCitizenshipDetails: null,
                            passportNumber: '',
                            passportExpiryNumber: null,
                            passportIssuedCountry:null,
                            passportIssuedCountryDetails:null,
                            I94: '',
                            I94ExpiryNumber: null,
                            currentStatus: null,
                            currentStatusDetails: null,
                            statusExpiryNumber: null,
                            SSN: '',
                            lastArrivalNumber: null,
                            placeOfLastEntryInUS: '',
                            physicalAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            documents: {
                                passport: [],
                                visa: [],
                                formI94: [],
                                formI797: [],
                                formI20: [],
                                payStubs: [],
                                marriageCertificate: [],
                                noticeOfApprovalOfH1Status: [],
                                approvalNoticeOfPrevH4: [],
                                other: []
                            },
                            //i140
                            adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        
    
                    }
                    this.petition['h4RequiredForChild'] = false;
                    this.petition['hasChildren'] = false;
                    this.petition['l2Required'] = false;

                }
            },
            removeDependentsInfo(){
                if(
                    (this.petition.beneficiaryInfo && _.has(this.petition['beneficiaryInfo'],'hasAnyDependetsinUStoFileH4') && !this.checkProperty(this.petition,'beneficiaryInfo','hasAnyDependetsinUStoFileH4') && this.canRenderField('hasAnyDependetsinUStoFileH4',this.questionnaireDetails,false ,'beneficiaryInfo'))||
                    (this.petition.dependentsInfo.spouse && _.has(this.petition['dependentsInfo']['spouse'],'hasSpouse') && !this.checkProperty(this.petition['dependentsInfo'],'spouse','hasSpouse') && this.canRenderField('hasSpouse',this.questionnaireDetails,false ,'dependentsInfo.spouse'))||
                    (!this.canRenderField('h4Required',this.questionnaireDetails ,false,'dependentsInfo.childrens') && !this.canRenderField('h4Required',this.questionnaireDetails ,false,'dependentsInfo.spouse'))||
                    (!this.canRenderField('hasChildren',this.questionnaireDetails ,false,'dependentsInfo.childrens') && !this.canRenderField('hasSpouse',this.questionnaireDetails ,false,'dependentsInfo.spouse'))||
                    (!this.canRenderField('l2Required',this.questionnaireDetails ,false,'dependentsInfo.childrens') && !this.canRenderField('l2Required',this.questionnaireDetails ,false,'dependentsInfo.spouse'))||
                    (this.petition.beneficiaryInfo && this.petition.beneficiaryInfo.maritalStatusDetails && this.petition.beneficiaryInfo.maritalStatusDetails.id == 1) ||
                    (this.petition.beneficiaryInfo && !this.petition.beneficiaryInfo.maritalStatusDetails)
                    ){
                    delete this.benProfileDetails['dependentsInfo']
                    this.spouse = {
                            sevisNumber: null,
                            eadNumber: null,
                            isI94DSExpiryDate:false,
                            isDSExpiryDate:false,
                            anyOtherPersonEmployedInUS:null,
                            haveYouEverEmployed:null,
                            relationship: '',
                            saved: false,
                            currentlyInUS: null,
                            hasOtherNames: null, 
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            passportIssuedNumber: null,
                            alienNumber: '',
                            addressOutsideUS: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            stateDetailsOfLastEntryInUS:null,
                            stateOfLastEntryInUS:null,
                            lastArrivalDate:null,
                            prevEmploymentInfo: [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                salary: null,
                                payFrequency:null,
                                currentEmployer: null
                            }],
                            priorPeriodOfStayInUS: [{
                                _id: 0,
                                enteredNumber: null,
                                departedNumber: null,
                                dateerror: false,
                                noOfDays: null,
                                visaStatus: null
                            }],
    
                            h4Required: null,
                            hasSpouse:null,
                            l2Required:null,
                            h4EADRequired: null,
                            l2EADRequired:null,
                            doYouAlreadyL2EAD:null,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            email: '',
                            cellPhoneNumber:'',
                    cellPhoneCountryCode: {
                        countryCode: '',
                        countryCallingCode: ''
                    },
                            phoneNumber: '',
                            phoneCountryCode: {
                                countryCode: '',
                                countryCallingCode: ''
                            },
                            dateOfBirth: null,
                            countryOfBirth: null,
                            countryOfBirthDetails: null,
                            provinceOfBirth: null,
                            provinceOfBirthDetails: null,
                            locationOfBirth: '',
                            locationOfBirthDetails: null,
                            countryOfCitizenship: null,
                            countryOfCitizenshipDetails: null,
                            passportNumber: '',
                            passportExpiryNumber: null,
                            passportIssuedCountry:null,
                            passportIssuedCountryDetails:null,
                            I94: '',
                            I94ExpiryNumber: null,
                            currentStatus: null,
                            currentStatusDetails: null,
                            statusExpiryNumber: null,
                            SSN: '',
                            lastArrivalNumber: null,
                            placeOfLastEntryInUS: '',
                            physicalAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            documents: {
                                passport: [],
                                visa: [],
                                formI94: [],
                                formI797: [],
                                formI20: [],
                                payStubs: [],
                                marriageCertificate: [],
                                noticeOfApprovalOfH1Status: [],
                                approvalNoticeOfPrevH4: [],
                                other: []
                            },
                            //i140
                            adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        
    
                    }
                }else if(
                    !this.canRenderField('h4Required',this.questionnaireDetails ,false,'dependentsInfo.childrens') || this.checkProperty(this.petition,'h4RequiredForChild') == false ||
                    this.checkProperty(this.petition,'h4RequiredForChild') == null || this.checkProperty(this.petition,'h4RequiredForChild') == '' 
                    || !this.canRenderField('hasChildren',this.questionnaireDetails ,false,'dependentsInfo.childrens') || this.checkProperty(this.petition,'hasChildren') == false ||
                    this.checkProperty(this.petition,'hasChildren') == null || this.checkProperty(this.petition,'hasChildren') == ''|| this.checkProperty(this.petition,'l2Required') == false ||
                    this.checkProperty(this.petition,'l2Required') == null || this.checkProperty(this.petition,'l2Required') == '' ){
                        delete this.benProfileDetails['dependentsInfo']['childrens']
                }else if(
                    !this.canRenderField('h4Required',this.questionnaireDetails ,false,'dependentsInfo.spouse') || this.checkProperty(this.petition['dependentsInfo'],'spouse','h4Required') == false ||
                    this.checkProperty(this.petition['dependentsInfo'],'spouse','h4Required') == null || this.checkProperty(this.petition['dependentsInfo'],'spouse','h4Required') == ''
                    ||
                    !this.canRenderField('hasSpouse',this.questionnaireDetails ,false,'dependentsInfo.spouse') || this.checkProperty(this.petition['dependentsInfo'],'spouse','hasSpouse') == false ||
                    this.checkProperty(this.petition['dependentsInfo'],'spouse','hasSpouse') == null || this.checkProperty(this.petition['dependentsInfo'],'spouse','hasSpouse') == ''
                    ||
                    !this.canRenderField('l2Required',this.questionnaireDetails ,false,'dependentsInfo.spouse') || this.checkProperty(this.petition['dependentsInfo'],'spouse','l2Required') == false ||
                    this.checkProperty(this.petition['dependentsInfo'],'spouse','l2Required') == null || this.checkProperty(this.petition['dependentsInfo'],'spouse','l2Required') == ''
                    ){
                    delete this.benProfileDetails['dependentsInfo']['spouse'];
                    this.spouse = {
                            sevisNumber: null,
                            eadNumber: null,
                            isI94DSExpiryDate:false,
                            isDSExpiryDate:false,
                            anyOtherPersonEmployedInUS:null,
                            haveYouEverEmployed:null,
                            relationship: '',
                            saved: false,
                            currentlyInUS: null,
                            hasOtherNames: null, 
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            passportIssuedNumber: null,
                            alienNumber: '',
                            addressOutsideUS: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            stateDetailsOfLastEntryInUS:null,
                            stateOfLastEntryInUS:null,
                            lastArrivalDate:null,
                            prevEmploymentInfo: [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                salary: null,
                                payFrequency:null,
                                currentEmployer: null
                            }],
                            priorPeriodOfStayInUS: [{
                                _id: 0,
                                enteredNumber: null,
                                departedNumber: null,
                                dateerror: false,
                                noOfDays: null,
                                visaStatus: null
                            }],
    
                            h4Required: null,
                            hasSpouse:null,
                            l2Required:null,
                            h4EADRequired: null,
                            l2EADRequired:null,
                            doYouAlreadyL2EAD:null,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            email: '',
                            cellPhoneNumber:'',
                    cellPhoneCountryCode: {
                        countryCode: '',
                        countryCallingCode: ''
                    },
                            phoneNumber: '',
                            phoneCountryCode: {
                                countryCode: '',
                                countryCallingCode: ''
                            },
                            dateOfBirth: null,
                            countryOfBirth: null,
                            countryOfBirthDetails: null,
                            provinceOfBirth: null,
                            provinceOfBirthDetails: null,
                            locationOfBirth: '',
                            locationOfBirthDetails: null,
                            countryOfCitizenship: null,
                            countryOfCitizenshipDetails: null,
                            passportNumber: '',
                            passportExpiryNumber: null,
                            passportIssuedCountry:null,
                            passportIssuedCountryDetails:null,
                            I94: '',
                            I94ExpiryNumber: null,
                            currentStatus: null,
                            currentStatusDetails: null,
                            statusExpiryNumber: null,
                            SSN: '',
                            lastArrivalNumber: null,
                            placeOfLastEntryInUS: '',
                            physicalAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            documents: {
                                passport: [],
                                visa: [],
                                formI94: [],
                                formI797: [],
                                formI20: [],
                                payStubs: [],
                                marriageCertificate: [],
                                noticeOfApprovalOfH1Status: [],
                                approvalNoticeOfPrevH4: [],
                                other: []
                            },
                            //i140
                            adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        
    
                    }
                }
            },
            updateEducationDegree(val){
                if(val){
                    if(this.checkProperty(this.petition,'highestDegreeList') && this.checkProperty(this.petition,'highestDegreeList','length')>0 && this.checkProperty(this.petition,'beneficiaryInfo','educations') && this.checkProperty(this.petition['beneficiaryInfo'],'educations','length')>0 ){
                        this.petition.beneficiaryInfo.educations[0]['highestDegreeDetails'] = { "id": 6, "name": "Masters" };
                        this.petition.beneficiaryInfo.educations[0]['highestDegree'] = 6
                        // this.petition.beneficiaryInfo.educations[0]['attendedFrom'] = null
                        // this.petition.beneficiaryInfo.educations[0]['attendedTo'] = null 
                        // this.petition.beneficiaryInfo.educations[0]['graduatedYear'] = null
                        this.petition.beneficiaryInfo.educations[0]['address']['countryId'] = 231
                        this.petition.beneficiaryInfo.educations[0]['address']['countryDetails'] =  { "_id": "626a8f03a972fa4d60681140", "id": 231, "name": "United States", "phoneCode": 1, "order": 1, "currencySymbol": "$", "currencyCode": "USD", "zipcodeLength": 5, "sortName": "united states" }
                    }
                }
            },
            updateBenEducation(){
                if( this.checkProperty(this.petition,'beneficiaryInfo') && this.checkProperty(this.petition,'beneficiaryInfo','educations') && this.checkProperty(this.petition['beneficiaryInfo'],'educations','length')>0 &&
                  this.canRenderField('hasMasterDegreeInUS', this.questionnaireDetails ,false,'beneficiaryInfo')){
                    let mastDExists = _.find(this.petition['beneficiaryInfo']['educations'], { 'highestDegree': 6 });
                    if(mastDExists){
                        _.forEach(this.petition['beneficiaryInfo']['educations'],(item)=>{
                            if(_.has(item,'highestDegree') && this.checkProperty(item,'highestDegree') == 6){
                                if( _.has(this.petition['beneficiaryInfo'],'hasMasterDegreeInUS') && this.checkProperty(this.petition,'beneficiaryInfo','hasMasterDegreeInUS')){
                                    item['attendedFrom'] = null
                                    item['attendedTo'] = null
                                    item['graduatedYear'] = null 
                                    
                                }else{
                                    item['graduatedDate'] = null
                                }
                            }
                            else{
                                item['graduatedDate'] = null
                            }
                            
                        })
                    }
                    
                }
            },
            checkDSExpireFields(){
                if(this.checkProperty(this.petition,'beneficiaryInfo','curNonImmigrantVisaStatusDetails') && !this.checkProperty(this.petition['beneficiaryInfo'],'curNonImmigrantVisaStatusDetails','id') ){
                    this.petition.beneficiaryInfo.isDSExpiryDate = false;
                }
            },
            checkImmpetition(){
                if(this.canRenderField('didThisPtnrFliedImmPetitionEarlier',this.questionnaireDetails,false ,'beneficiaryInfo') && _.has(this.petition['beneficiaryInfo'],'didThisPtnrFliedImmPetitionEarlier') && !this.checkProperty(this.petition['beneficiaryInfo'],'didThisPtnrFliedImmPetitionEarlier')  ){
                    this.petition['beneficiaryInfo']['firstExtnWithPtnr'] = false;
                    this.petition['beneficiaryInfo']['secOrSubSequentExtnWithPtnr'] = false; //nonImmPetitionsInfo
                    this.petition['beneficiaryInfo']['nonImmPetitionsInfo'] = [{
                        _id: 0,
                        visaStatus: null,
                        visaStatusDetails: null,
                        receiptNo: '',
                        petitionerName: '',
                        validFrom:null,
                        validTo:null
                    }]
                }
            },
            checkH1bImmPetitionsInfo(){
                if(this.canRenderField('anyImmPetitionFiled',this.questionnaireDetails,false ,'beneficiaryInfo') && _.has(this.petition['beneficiaryInfo'],'anyImmPetitionFiled') && !this.checkProperty(this.petition['beneficiaryInfo'],'anyImmPetitionFiled')  ){
                    this.petition['beneficiaryInfo']['h1bImmPetitionsInfo'] = [{
                        _id: 0,
                        typeId: null,
                        typeDetails: null,
                        receiptNo: '',
                        petitionerName: '',
                        validFrom:null,
                        validTo:null
                    }]
                }
            },
            checkDatesOfStayInUSA(){
                if(this.canRenderField('haveYouEverTravelledToUS',this.questionnaireDetails,false ,'beneficiaryInfo') && _.has(this.petition['beneficiaryInfo'],'haveYouEverTravelledToUS') && !this.checkProperty(this.petition['beneficiaryInfo'],'haveYouEverTravelledToUS')  ){
                    this.petition['beneficiaryInfo']['priorPeriodOfStayInUS'] = [{
                        _id: 0,
                        enteredNumber: null,
                        departedNumber: null,
                        visaStatus: null,
                        visaStatusDetails: null,
                        noOfDays: null,
                        dateerror: false
                    }]
                }
            },
            checkPrevEmployment(){
                if(this.canRenderField('anyOtherPersonEmployedInUS',this.questionnaireDetails,false ,'beneficiaryInfo') && _.has(this.petition['beneficiaryInfo'],'anyOtherPersonEmployedInUS') && !this.checkProperty(this.petition['beneficiaryInfo'],'anyOtherPersonEmployedInUS')  ){
                    this.petition['beneficiaryInfo']['prevEmploymentInfo'] = [{
                        _id: 0,
                        employerName: '',
                        address: {
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        businessType: null,
                        jobTitle: null,
                        jobDuties: null,
                        startDate: null,
                        endDate: null,
                        currentEmployer: false,
                        salary:null,
                        payFrequency:null,
                    }]
                }
            },
            mamageVisaStatusDocuments(){
               let tempDocs  =_.cloneDeep( this.bendocslist );
               this.bendocslist =[];

            let tpDocs = [
                {
                    required: false,
                    key: "formI797H4ApprovalNotice",
                    fieldName: 'formI797H4ApprovalNotice',
                    label: "Form I-797 H4 approval notice if applicable"
                },
                {
                    required: false,
                    key: "h4Ead",
                    fieldName: 'h4Ead',
                    label: "H4 EAD if applicable"
                },
                {
                    required: false,
                    key: "marriageCertificate",
                    fieldName: 'marriageCertificate',
                    label: "Marriage Certificate (if spouse is on H-1B, L-1, or F-1 status) "
                },
                {
                    required: false,
                    key: "formI797H1BApprovalNoticePrinNonCtzn",
                    fieldName: 'formI797H1BApprovalNoticePrinNonCtzn',
                    label: "Form I-797 H-1B approval notice of Principal Non-citizen"
                },
                {
                    required: false,
                    key: "passportOfPrinNonCtzn",
                    fieldName: 'passportOfPrinNonCtzn',
                    label: "Passport of Principal Non-citizen- First page with photo, Visa page and last page with address"
                },
                {
                    required: false,
                    key: "last3MonthsPayslipsOfPrinNonCtzn",
                    fieldName: 'last3MonthsPayslipsOfPrinNonCtzn',
                    label: "Last 3 months pay statements of Principal Non-citizen"
                },
            ];
         //5 ---H1b , H4---7
                if( this.checkProperty( this.petition,'beneficiaryInfo','curNonImmigrantVisaStatus') ==7){
                    _.forEach(tpDocs , (doc)=>{
                        let isExist = _.find(tempDocs ,{"key":doc['key']});
                        if(!isExist){
                            tempDocs.push(doc);
                        }

                    });
                }else{

                    // let isExist = _.find(tempDocs ,{"key":'marriageCertificate'});
                    // if(!isExist){

                    //     tempDocs.push( { required: false,  key: "marriageCertificate", fieldName: 'marriageCertificate', label: "Marriage Certificate (if spouse is on H-1B, L-1, or F-1 status) " });

                    // }
                   
                let its =['formI797H4ApprovalNotice','h4Ead','formI797H1BApprovalNoticePrinNonCtzn','passportOfPrinNonCtzn','last3MonthsPayslipsOfPrinNonCtzn'];
                    tempDocs = _.filter(tempDocs ,(item)=>its.indexOf(item['key'])<=-1);

                    //documents
                    _.forEach(this.petition.documents ,(documents ,category)=>{
                        if(its.indexOf(category)>-1){
                            this.petition.documents[category] = [];

                        }

                    });
                    

                } 

                this.bendocslist =[];
                this.bendocslist =tempDocs;
            },

            clearImmiputFields(){
                if(!this.checkProperty(this.petition,'beneficiaryInfo','anyImmPetitionFiled')){
                   
                    this.petition.beneficiaryInfo.immPetitionInfo = {
                        anyOtherAlienFiled: null,
                        filedNumber: null,
                        employerName: '',
                        rirOrRegularProcessing: null,
                        filedStateId: null,
                        filedStateDetails: null,
                        applCurStatus: '',
                        seekingFilednullforETA750: null,
                        anyI140Filed: null,
                        i140Info: {
                            fieldNumber: null,
                            employerName: '',
                            priorityNumber: null,
                            eb2orEb3: '',
                            currentStatus: ''
                        }
                    }
                }
            },
            questionnairePrefil(tplsection='beneficiaryInfo'){
                this.executionCompleted = false; 
                let questionnaireSection = tplsection;  //beneficiaryInfo.immPetitionInfo.i140Info majorFieldOfStudy  'beneficiaryInfo.education'       Has any I-140 Petition been filed on your behalf?
                if(questionnaireSection == 'beneficiaryInfo' ){
                    _.forEach(this.petition[questionnaireSection], (item,key)=>{
                        if(!this.canRenderField( key, this.questionnaireDetails ,false, questionnaireSection) && this.ignoreItems.indexOf(key)<=-1){
                            this.petition[questionnaireSection][key] = _.cloneDeep(this.tempPetition[questionnaireSection][key]);
                            if(_.has(this.benProfileDetails[questionnaireSection], key)){
                                delete this.benProfileDetails[questionnaireSection][key]
                            }
                        }
                    })
                }
                if(questionnaireSection == 'beneficiaryInfo.education' ){
                    if(this.checkProperty(this.petition, 'beneficiaryInfo', 'education')){
                        _.forEach(this.petition['beneficiaryInfo']['education'], (item,key)=>{
                            if(!this.canRenderField( key, this.questionnaireDetails ,false, 'beneficiaryInfo.education') && key == 'majorFieldOfStudy'){
                                if(_.has(this.benProfileDetails['beneficiaryInfo']['education'], key)){
                                    delete this.benProfileDetails['beneficiaryInfo']['education'][key]
                                }
                                this.petition['beneficiaryInfo']['education'][key] = _.cloneDeep(this.tempPetition['beneficiaryInfo']['education'][key]);
                            }
                        })
                    }
                }
                if(questionnaireSection == 'capSelectNotice' ){
                    if(!this.canRenderField('capSelectNotice', this.questionnaireDetails ,false, 'documents')){
                        this.petition['beneficiaryInfo']['beneficiaryCnfmNumber'] = null;
                        this.petition['beneficiaryInfo']['capType'] = '';
                        this.petition['beneficiaryInfo']['serviceCenterName'] = '';
                        if(_.has(this.benProfileDetails['beneficiaryInfo'], 'beneficiaryCnfmNumber')){
                            delete this.benProfileDetails['beneficiaryInfo']['beneficiaryCnfmNumber']
                        }
                        if(_.has(this.benProfileDetails['beneficiaryInfo'], 'capType')){
                            delete this.benProfileDetails['beneficiaryInfo']['capType']
                        }
                        if(_.has(this.benProfileDetails['beneficiaryInfo'], 'serviceCenterName')){
                            delete this.benProfileDetails['beneficiaryInfo']['serviceCenterName']
                        }
                    }
                }
                if(questionnaireSection == 'didThisPtnrFliedImmPetitionEarlier' ){
                    if(!this.canRenderField('didThisPtnrFliedImmPetitionEarlier', this.questionnaireDetails ,false, 'beneficiaryInfo')){
                        this.petition['beneficiaryInfo']['secOrSubSequentExtnWithPtnr'] = false;
                        this.petition['beneficiaryInfo']['firstExtnWithPtnr'] = false;
                        if(_.has(this.benProfileDetails['beneficiaryInfo'], 'firstExtnWithPtnr')){
                            delete this.benProfileDetails['beneficiaryInfo']['firstExtnWithPtnr']
                        }
                        if(_.has(this.benProfileDetails['beneficiaryInfo'], 'secOrSubSequentExtnWithPtnr')){
                            delete this.benProfileDetails['beneficiaryInfo']['secOrSubSequentExtnWithPtnr']
                        }
                    }
                }
                if(questionnaireSection == 'otherNames' ){
                    if(this.checkProperty(this.petition,'beneficiaryInfo') && this.checkProperty(this.petition,'beneficiaryInfo','otherNames')){
                        if(this.checkProperty(this.petition,'beneficiaryInfo') && this.checkProperty(this.petition,'beneficiaryInfo','otherNames') && this.checkProperty(this.petition['beneficiaryInfo'],'otherNames','length')>0 ){
                            if(!this.canRenderField( 'otherNames', this.questionnaireDetails ,false, 'beneficiaryInfo')){
                                this.petition['beneficiaryInfo']['otherNames'] = _.cloneDeep(this.tempPetition['beneficiaryInfo']['otherNames']);
                                if(_.has(this.benProfileDetails['beneficiaryInfo'], 'otherNames')){
                                    delete this.benProfileDetails['beneficiaryInfo']['otherNames']
                                }
                            }
                        }else{
                            delete this.benProfileDetails['beneficiaryInfo']['otherNames']
                            this.petition['beneficiaryInfo']['otherNames'] = _.cloneDeep(this.tempPetition['beneficiaryInfo']['otherNames']);
                        }
                    }
                    if(this.checkProperty(this.petition,'dependentsInfo') && this.checkProperty(this.petition['dependentsInfo'],'spouse') && this.checkProperty(this.petition['dependentsInfo']['spouse'],'otherNames')){
                        if( this.checkProperty(this.petition,'dependentsInfo') && this.checkProperty(this.petition['dependentsInfo'],'spouse') && this.checkProperty(this.petition['dependentsInfo']['spouse'],'otherNames') && this.checkProperty(this.petition['dependentsInfo']['spouse'],'otherNames','length')>0 ){
                            if(!this.canRenderField( 'otherNames', this.questionnaireDetails ,false, 'dependentsInfo.spouse')){
                                this.petition['dependentsInfo']['spouse']['otherNames'] = _.cloneDeep(this.tempPetition['dependentsInfo']['spouse']['otherNames']);
                                if(_.has(this.benProfileDetails['dependentsInfo']['spouse'], 'otherNames')){
                                    delete this.benProfileDetails['dependentsInfo']['spouse']['otherNames']
                                }
                            }
                        }else{
                            delete this.benProfileDetails['dependentsInfo']['spouse']['otherNames']
                            this.petition['dependentsInfo']['spouse']['otherNames'] = _.cloneDeep(this.tempPetition['dependentsInfo']['spouse']['otherNames']);
                        }
                    }
                   
                }
                if(questionnaireSection == 'beneficiaryInfo.immPetitionInfo' ){
                    if(this.checkProperty(this.petition,'beneficiaryInfo','anyImmPetitionFiled')){
                        _.forEach(this.petition['beneficiaryInfo']['immPetitionInfo'], (item,key)=>{
                            if(!this.canRenderField( key, this.questionnaireDetails ,false, 'beneficiaryInfo.immPetitionInfo') && key !='i140Info'){
                                if(_.has(this.benProfileDetails['beneficiaryInfo']['immPetitionInfo'], key)){
                                    delete this.benProfileDetails['beneficiaryInfo']['immPetitionInfo'][key]
                                }
                                this.petition['beneficiaryInfo']['immPetitionInfo'][key] = _.cloneDeep(this.tempPetition['beneficiaryInfo']['immPetitionInfo'][key]);
                            }
                        })
                        if(this.checkProperty(this.petition['beneficiaryInfo'],'immPetitionInfo','anyI140Filed')){
                            _.forEach(this.petition['beneficiaryInfo']['immPetitionInfo']['i140Info'], (item,key)=>{
                                if(!this.canRenderField( key, this.questionnaireDetails ,false, 'beneficiaryInfo.immPetitionInfo.i140Info')){
                                    if(_.has(this.benProfileDetails['beneficiaryInfo']['immPetitionInfo']['i140Info'], key)){
                                        delete this.benProfileDetails['beneficiaryInfo']['immPetitionInfo']['i140Info'][key]
                                    }
                                    this.petition['beneficiaryInfo']['immPetitionInfo']['i140Info'][key] = _.cloneDeep(this.tempPetition['beneficiaryInfo']['immPetitionInfo']['i140Info'][key]);
                                }
                            })
                        }
                    }
                }
                if(questionnaireSection == 'detailsItemsList' ){
                _.forEach(this.detailsItemsList, (item)=>{
                        let tempSection = item['section']
                        let tempKey = item['key']
                        let tempdetailsKey = item['detailsKey']
                        let tempType = item['type']
                        if(tempType == 'phone'){
                            if(tempSection == 'beneficiaryInfo'){
                                if(!this.canRenderField( tempKey, this.questionnaireDetails ,false, tempSection)){
                                    this.petition[tempSection][tempKey] = null;
                                    this.petition[tempSection][tempdetailsKey] = {
                                        countryCode: '',
                                        countryCallingCode: ''
                                    };
                                    if(_.has(this.benProfileDetails[tempSection], tempKey)){
                                        delete this.benProfileDetails[tempSection][tempKey]
                                    }
                                    if(_.has(this.benProfileDetails[tempSection], tempdetailsKey)){
                                        delete this.benProfileDetails[tempSection][tempdetailsKey]
                                    }
                                   
                                }
                            }
                            if(tempSection == 'dependentsInfo.spouse'){
                                if(!this.canRenderField( tempKey, this.questionnaireDetails ,false, tempSection)){
                                    this.petition['dependentsInfo']['spouse'][tempKey] = null;
                                    this.petition['dependentsInfo']['spouse'][tempdetailsKey] = {
                                        countryCode: '',
                                        countryCallingCode: ''
                                    };
                                    if(_.has(this.benProfileDetails['dependentsInfo']['spouse'], tempKey)){
                                        delete this.benProfileDetails['dependentsInfo']['spouse'][tempKey]
                                    }
                                    if(_.has(this.benProfileDetails['dependentsInfo']['spouse'], tempdetailsKey)){
                                        delete this.benProfileDetails['dependentsInfo']['spouse'][tempdetailsKey]
                                    }
                                }
                            }
                        }else{
                            if(tempSection == 'beneficiaryInfo'){
                                if(!this.canRenderField( tempKey, this.questionnaireDetails ,false, tempSection)){
                                    this.petition[tempSection][tempKey] = null;
                                    this.petition[tempSection][tempdetailsKey] = null;
                                    if(_.has(this.benProfileDetails[tempSection], tempKey)){
                                        delete this.benProfileDetails[tempSection][tempKey]
                                    }
                                    if(_.has(this.benProfileDetails[tempSection], tempdetailsKey)){
                                        delete this.benProfileDetails[tempSection][tempdetailsKey]
                                    }
                                }
                            }
                            if(tempSection == 'dependentsInfo.spouse'){
                                if(!this.canRenderField( tempKey, this.questionnaireDetails ,false, tempSection)){
                                    this.petition['dependentsInfo']['spouse'][tempKey] = null;
                                    this.petition['dependentsInfo']['spouse'][tempdetailsKey] = null;
                                    if(_.has(this.benProfileDetails['dependentsInfo']['spouse'], tempKey)){
                                        delete this.benProfileDetails['dependentsInfo']['spouse'][tempKey]
                                    }
                                    if(_.has(this.benProfileDetails['dependentsInfo']['spouse'], tempdetailsKey)){
                                        delete this.benProfileDetails['dependentsInfo']['spouse'][tempdetailsKey]
                                    }
                                }
                            }
                        }
                        
                        
                    })
                }
                if(questionnaireSection == 'height' ){
                    if(this.checkProperty(this.petition, 'beneficiaryInfo', 'height')){
                        _.forEach(this.petition['beneficiaryInfo']['height'], (item,key)=>{
                            if(!this.canRenderField( key, this.questionnaireDetails ,false, 'beneficiaryInfo.height')){
                                this.petition['beneficiaryInfo']['height'][key] = _.cloneDeep(this.tempPetition['beneficiaryInfo']['height'][key]);
                                if(_.has(this.benProfileDetails['beneficiaryInfo']['height'], key)){
                                    delete this.benProfileDetails['beneficiaryInfo']['height'][key]
                                }
                            }
                        })
                    }
                    if(this.checkProperty(this.petition, 'dependentsInfo', 'spouse') && this.checkProperty(this.petition['dependentsInfo'], 'spouse', 'height')){
                        _.forEach(this.petition['dependentsInfo']['spouse']['height'], (item,key)=>{
                            if(!this.canRenderField( key, this.questionnaireDetails ,false, 'dependentsInfo.spouse.height')){
                                if(_.has(this.benProfileDetails['dependentsInfo']['spouse']['height'], key)){
                                    delete this.benProfileDetails['dependentsInfo']['spouse']['height'][key]
                                }
                                this.petition['dependentsInfo']['spouse']['height'][key] = _.cloneDeep(this.tempPetition['dependentsInfo']['spouse']['height'][key]);
                            }
                        })
                    }
                  
                }
                if(questionnaireSection == 'educations' || questionnaireSection == 'prevEmploymentInfo' || questionnaireSection =='prevEmploymentOutsideUS'){
                    let tempSection = 'beneficiaryInfo.prevEmploymentInfo'
                    if(questionnaireSection == 'educations'){
                        tempSection = 'beneficiaryInfo.educations'
                    }
                    if(questionnaireSection == 'prevEmploymentOutsideUS'){
                        tempSection = 'beneficiaryInfo.prevEmploymentOutsideUS'
                    }
                    if(this.canRenderField( questionnaireSection, this.questionnaireDetails ,false, tempSection)){
                        if(this.checkProperty(this.petition['beneficiaryInfo'], questionnaireSection) && this.checkProperty(this.petition['beneficiaryInfo'], questionnaireSection, 'length')>0 ){
                            _.forEach(this.petition['beneficiaryInfo'][questionnaireSection], (item,inder)=>{
                                _.forEach(item, (obj,key)=>{
                                    if(!this.canRenderField( key, this.questionnaireDetails ,false, tempSection) && ['graduatedDate','highestDegreeDetails'].indexOf(key)<=-1){
                                        item[key] = _.cloneDeep(this.tempPetition['beneficiaryInfo'][questionnaireSection][0][key]);
                                        delete this.benProfileDetails['beneficiaryInfo'][questionnaireSection][inder][key]
                                        if(_.has(this.benProfileDetails['beneficiaryInfo'][questionnaireSection][inder], key)){
                                            delete this.benProfileDetails['beneficiaryInfo'][questionnaireSection][inder][key]
                                        }
                                        //delete item[key]
                                    }
                                })
                            }) 
                        } 
                    }else{
                        delete this.petition['beneficiaryInfo'][questionnaireSection]
                        this.benProfileDetails['beneficiaryInfo'][questionnaireSection] = _.cloneDeep(this.tempPetition['beneficiaryInfo'][questionnaireSection])
                    }  
                }
                if(questionnaireSection == 'dependentsInfo.spouse.prevEmploymentInfo' || questionnaireSection == 'dependentsInfo.spouse.prevEmploymentOutsideUS'){
                    let tempQuestionnaireSection = 'prevEmploymentInfo'
                    let tempSection = 'dependentsInfo.spouse.prevEmploymentInfo'
                    if(questionnaireSection == 'dependentsInfo.spouse.prevEmploymentOutsideUS'){
                        tempQuestionnaireSection = 'prevEmploymentOutsideUS'
                        tempSection = 'dependentsInfo.spouse.prevEmploymentOutsideUS'
                    }
                    if(this.canRenderField( tempQuestionnaireSection, this.questionnaireDetails ,false, tempSection)){
                        if(this.checkProperty(this.petition['dependentsInfo']['spouse'], tempQuestionnaireSection) && this.checkProperty(this.petition['dependentsInfo']['spouse'], tempQuestionnaireSection, 'length')>0 ){
                            _.forEach(this.petition['dependentsInfo']['spouse'][tempQuestionnaireSection], (item,inder)=>{
                                _.forEach(item, (obj,key)=>{
                                    if(!this.canRenderField( key, this.questionnaireDetails ,false, tempSection)){
                                        item[key] = _.cloneDeep(this.tempPetition['dependentsInfo']['spouse'][tempQuestionnaireSection][0][key]);
                                        if(_.has(this.benProfileDetails['dependentsInfo']['spouse'][tempQuestionnaireSection][inder], key)){
                                            delete this.benProfileDetails['dependentsInfo']['spouse'][tempQuestionnaireSection][inder][key]
                                        }
                                        delete this.benProfileDetails['dependentsInfo']['spouse'][tempQuestionnaireSection][inder][key]
                                        //delete item[key]
                                    }
                                })
                            }) 
                        } 
                    }else{
                        delete this.petition['dependentsInfo']['spouse'][tempQuestionnaireSection]
                        this.benProfileDetails['dependentsInfo']['spouse'][tempQuestionnaireSection] = _.cloneDeep(this.tempPetition['dependentsInfo']['spouse'][tempQuestionnaireSection])
                    }  
                }
                if(questionnaireSection == 'documents' || questionnaireSection == 'dependentsInfo.spouse.documents' || questionnaireSection == 'dependentsInfo.childrens.documents'){
                    if(questionnaireSection == 'dependentsInfo.spouse.documents'){
                        _.forEach(this.petition['dependentsInfo']['spouse']['documents'], (item,key)=>{
                            if(!this.canRenderField( key, this.questionnaireDetails ,false, 'dependentsInfo.spouse.documents')){
                                this.petition['dependentsInfo']['spouse']['documents'][key] = [];
                                if(_.has(this.benProfileDetails['dependentsInfo']['spouse']['documents'], key)){
                                    delete this.benProfileDetails['dependentsInfo']['spouse']['documents'][key]
                                }
                                delete this.benProfileDetails['dependentsInfo']['spouse']['documents'][key]
                                
                            }
                        })
                    }
                    if(questionnaireSection == 'documents'){
                        _.forEach(this.petition['documents'], (item,key)=>{
                            if(!this.canRenderField( key, this.questionnaireDetails ,false, 'documents')){
                                this.petition['documents'][key] = [];
                                if(_.has(this.benProfileDetails['documents'], key)){
                                    delete this.benProfileDetails['documents'][key]
                                }
                                delete this.benProfileDetails['documents'][key]
                                
                            }
                        })
                    }
                   
                }
                if(questionnaireSection == 'dependentsInfo.spouse'){
                    _.forEach(this.petition['dependentsInfo']['spouse'], (item,key)=>{
                        if(!this.canRenderField( key, this.questionnaireDetails ,false, questionnaireSection) && this.spouseIgnoreItems.indexOf(key)<=-1 ){
                            if(_.has(this.benProfileDetails['dependentsInfo']['spouse'], key)){
                                delete this.benProfileDetails['dependentsInfo']['spouse'][key]
                            }
                            this.petition['dependentsInfo']['spouse'][key] = _.cloneDeep(this.tempPetition['dependentsInfo']['spouse'][key]);
                        }
                    })
                } 
                if(questionnaireSection == 'dependentsInfo.spouse.ssnFather'){
                    if(this.checkProperty(this.petition['dependentsInfo'], 'spouse', 'ssnFather')){
                        _.forEach(this.petition['dependentsInfo']['spouse']['ssnFather'], (item,key)=>{
                            if(!this.canRenderField( key, this.questionnaireDetails ,false, questionnaireSection)){
                                if(_.has(this.benProfileDetails['dependentsInfo']['spouse']['ssnFather'], key)){
                                    delete this.benProfileDetails['dependentsInfo']['spouse']['ssnFather'][key]
                                }
                                
                                this.petition['dependentsInfo']['spouse']['ssnFather'][key] = _.cloneDeep(this.tempPetition['dependentsInfo']['spouse']['ssnFather'][key]);
                            }
                        })
                    }
                } 
                if(questionnaireSection == 'dependentsInfo.spouse.ssnMother'){
                    if(this.checkProperty(this.petition['dependentsInfo'], 'spouse', 'ssnMother')){
                        _.forEach(this.petition['dependentsInfo']['spouse']['ssnMother'], (item,key)=>{
                            if(!this.canRenderField( key, this.questionnaireDetails ,false, questionnaireSection)){
                                if(_.has(this.benProfileDetails['dependentsInfo']['spouse']['ssnMother'], key)){
                                    delete this.benProfileDetails['dependentsInfo']['spouse']['ssnMother'][key]
                                }
                                this.petition['dependentsInfo']['spouse']['ssnMother'][key] = _.cloneDeep(this.tempPetition['dependentsInfo']['spouse']['ssnMother'][key]);
                            }
                        })
                    }
                } 
                if(questionnaireSection == 'fatherInfo' || questionnaireSection == 'motherInfo' || questionnaireSection == 'dependentsInfo.spouse.motherInfo' || questionnaireSection == 'dependentsInfo.spouse.fatherInfo' ){
                    if(questionnaireSection == 'fatherInfo' || questionnaireSection == 'motherInfo'){
                        if(this.canRenderField( questionnaireSection, this.questionnaireDetails ,false, questionnaireSection)){
                            _.forEach(this.petition[questionnaireSection], (item,key)=>{
                                if(!this.canRenderField( key, this.questionnaireDetails ,false, questionnaireSection) && this.parentsIgnoreItems.indexOf(key)<=-1 ){
                                    this.petition[questionnaireSection][key] = _.cloneDeep(this.tempPetition[questionnaireSection][key]);
                                    if(_.has(this.benProfileDetails[questionnaireSection], key)){
                                        delete this.benProfileDetails[questionnaireSection][key]
                                    }
                                    
                                }
                            })
                        }else{
                            delete this.benProfileDetails[questionnaireSection]
                            this.petition[questionnaireSection] = _.cloneDeep(this.tempPetition[questionnaireSection]);
                        }
                    }
                    if(questionnaireSection == 'dependentsInfo.spouse.motherInfo' || questionnaireSection == 'dependentsInfo.spouse.fatherInfo'){
                        let tempKey = 'motherInfo'
                        if(questionnaireSection == 'dependentsInfo.spouse.fatherInfo'){
                            tempKey = 'fatherInfo'
                        }
                        if(this.canRenderField( tempKey, this.questionnaireDetails ,false, questionnaireSection)){
                            _.forEach(this.petition['dependentsInfo']['spouse'][tempKey], (item,key)=>{
                                if(!this.canRenderField( key, this.questionnaireDetails ,false, questionnaireSection) && this.parentsIgnoreItems.indexOf(key)<=-1 ){
                                    this.petition['dependentsInfo']['spouse'][tempKey][key] = _.cloneDeep(this.tempPetition['dependentsInfo']['spouse'][tempKey][key]);
                                    if(_.has(this.benProfileDetails['dependentsInfo']['spouse'][tempKey], key)){
                                        delete this.benProfileDetails['dependentsInfo']['spouse'][tempKey][key]
                                    }
                                }
                            })
                        }else{
                            delete this.benProfileDetails['dependentsInfo']['spouse'][tempKey]
                            this.petition['dependentsInfo']['spouse'][tempKey] = _.cloneDeep(this.tempPetition['dependentsInfo']['spouse'][tempKey]);
                        }
                    }
                } 
                if(questionnaireSection == 'dependentsInfo.spouse.previousSpouse' || questionnaireSection == 'beneficiaryInfo.previousSpouse'){
                    if(questionnaireSection == 'dependentsInfo.spouse.previousSpouse'){
                        if(this.checkProperty(this.petition['dependentsInfo'], 'spouse') && this.checkProperty(this.petition['dependentsInfo'], 'spouse', 'previousSpouse') ){
                            _.forEach(this.petition['dependentsInfo']['spouse']['previousSpouse'], (item,key)=>{
                                if(!this.canRenderField( key, this.questionnaireDetails ,false, questionnaireSection) && this.previousSpouseIgnoreItems.indexOf(key)<=-1 ){
                                    if(_.has(this.benProfileDetails['dependentsInfo']['spouse']['previousSpouse'], key)){
                                        delete this.benProfileDetails['dependentsInfo']['spouse']['previousSpouse'][key]
                                    }
                                    this.petition['dependentsInfo']['spouse']['previousSpouse'][key] = _.cloneDeep(this.tempPetition['dependentsInfo']['spouse']['previousSpouse'][key]);
                                }
                            })
                        }
                    }
                    if(questionnaireSection == 'beneficiaryInfo.previousSpouse'){
                        if(this.checkProperty(this.petition['beneficiaryInfo'], 'previousSpouse')){
                            _.forEach(this.petition['beneficiaryInfo']['previousSpouse'], (item,key)=>{
                                if(!this.canRenderField( key, this.questionnaireDetails ,false, questionnaireSection) && this.previousSpouseIgnoreItems.indexOf(key)<=-1 ){
                                    if(_.has(this.benProfileDetails['beneficiaryInfo']['previousSpouse'], key)){
                                        delete this.benProfileDetails['beneficiaryInfo']['previousSpouse'][key]
                                    }
                                   
                                    this.petition['beneficiaryInfo']['previousSpouse'][key] = _.cloneDeep(this.tempPetition['beneficiaryInfo']['previousSpouse'][key]);
                                }
                            })
                        }
                    }
                } 
                if((questionnaireSection == 'beneficiaryInfo.associations'||  questionnaireSection == 'dependentsInfo.spouse.associations')){
                    let tempKey = 'associations'
                    //beneficiaryInfo.associations
                    if(this.canRenderField( tempKey, this.questionnaireDetails ,false, questionnaireSection)){
                        if(questionnaireSection == 'beneficiaryInfo.associations'){
                            if(this.checkProperty(this.petition['beneficiaryInfo'], 'associations') && this.checkProperty(this.petition['beneficiaryInfo'], 'associations','length')>0){
                                _.forEach(this.petition['beneficiaryInfo']['associations'], (item,inder)=>{
                                    // console.log('fdkfnskjgbkjbgkjsb')
                                    _.forEach(item, (obj,key)=>{
                                        console.log(key)
                                        if(!this.canRenderField( key, this.questionnaireDetails ,false, questionnaireSection)){
                                            //delete item[key];  
                                            item[key] = _.cloneDeep(this.tempPetition['beneficiaryInfo']['associations'][0][key]);
                                            if(_.has(this.benProfileDetails['beneficiaryInfo']['associations'][inder], key)){
                                                delete this.benProfileDetails['beneficiaryInfo']['associations'][inder][key]
                                            }
                                           
                                            
                                        }
                                    })
                                })     
                            }
                        }
                        if(questionnaireSection == 'dependentsInfo.spouse.associations'){
                            if(this.checkProperty(this.petition['dependentsInfo'],'spouse', 'associations') && this.checkProperty(this.petition['dependentsInfo']['spouse'], 'associations','length')>0){
                                _.forEach(this.petition['dependentsInfo']['spouse']['associations'], (item,inder)=>{
                                    _.forEach(item, (obj,key)=>{
                                        if(!this.canRenderField( key, this.questionnaireDetails ,false, questionnaireSection)){
                                            item[key] = _.cloneDeep(this.tempPetition['dependentsInfo']['spouse'][tempKey][0][key]);
                                            if(_.has(this.benProfileDetails['dependentsInfo']['spouse'][tempKey][inder], key)){
                                                delete this.benProfileDetails['dependentsInfo']['spouse'][tempKey][inder][key]
                                            }
                                        }

                                    })
                                })     
                            }
                        }
                    } else{
                        if(questionnaireSection == 'beneficiaryInfo.associations'){
                            delete this.benProfileDetails['beneficiaryInfo'][tempKey];
                            this.petition['beneficiaryInfo'][tempKey] = _.cloneDeep(this.tempPetition['beneficiaryInfo'][tempKey]);
                        }
                        if(questionnaireSection == 'dependentsInfo.spouse.associations'){
                            delete this.benProfileDetails['dependentsInfo']['spouse'][tempKey];
                            this.petition['dependentsInfo']['spouse'][tempKey] = _.cloneDeep(this.tempPetition['dependentsInfo']['spouse'][tempKey]);
                        }
                    }             
                }
                this.executionCompleted = true;
            },
            checkPublicCharge(){

            },
            callQuestionairePrefill(){
                this.checkPublicCharge();
                this.checkImmpetition(); 
                this.updateBenEducation();
                this.checkCurrentlyInUsa();
                this.checkH1bImmPetitionsInfo();
                this.checkDatesOfStayInUSA();
                this.checkPrevEmployment();
                this.checkDependentsInfo();
                
                this.questionnairePrefil('didThisPtnrFliedImmPetitionEarlier');
                this.questionnairePrefil('beneficiaryInfo');   
                this.questionnairePrefil('beneficiaryInfo.education'); 
                this.questionnairePrefil('otherNames');
                // this.questionnairePrefil('capSelectNotice');
                this.questionnairePrefil('prevEmploymentOutsideUS');
                this.questionnairePrefil('dependentsInfo.spouse.prevEmploymentInfo');
                this.questionnairePrefil('dependentsInfo.spouse.prevEmploymentOutsideUS');
                this.questionnairePrefil('beneficiaryInfo.immPetitionInfo');
                this.questionnairePrefil('educations');
                this.questionnairePrefil('prevEmploymentInfo'); 
                this.questionnairePrefil('height');
                this.questionnairePrefil('documents');
                this.questionnairePrefil('fatherInfo');
                this.questionnairePrefil('motherInfo');
                this.questionnairePrefil('dependentsInfo.spouse.previousSpouse');
                this.questionnairePrefil('beneficiaryInfo.previousSpouse');
                this.questionnairePrefil('beneficiaryInfo.associations');
                this.questionnairePrefil('dependentsInfo.spouse.associations');
                this.questionnairePrefil('dependentsInfo.spouse.motherInfo');
                this.questionnairePrefil('dependentsInfo.spouse.fatherInfo');
                this.questionnairePrefil('detailsItemsList'); 
                this.questionnairePrefil('dependentsInfo.spouse');
                this.questionnairePrefil('dependentsInfo.spouse.documents');
                this.questionnairePrefil('dependentsInfo.spouse.ssnFather');
                this.questionnairePrefil('dependentsInfo.spouse.ssnMother');
                this.removeDependentsInfo();
                
            },
            formatFullname(item){
                let returnVal = ''
                if(this.checkProperty(item,'name')){
                    return returnVal = this.checkProperty(item,'name')
                }
                else{
                    if(this.checkProperty(item,'firstName')){
                        returnVal = this.checkProperty(item,'firstName')
                    }
                    if(this.checkProperty(item,'middleName')){
                         returnVal = returnVal +' '+ this.checkProperty(item,'middleName')
                    }
                    if(this.checkProperty(item,'lastName')){
                        returnVal =  returnVal +' '+this.checkProperty(item,'lastName')
                    }
                    return returnVal
                }
            },
            upload(fils,) {
           
           let  model =_.cloneDeep(fils);
           this.value =[];
           var _current = this;
           // this.$vs.loading();
     
           let efiles = [];
           efiles = _.filter(model, (e) => {
             return e.url != null && e.url != "";
           });
           let nfiles = _.filter(model, (e) => {
             return e.url == null || e.url == undefined;
           });
     
           let mapper = nfiles.map(
             (item) =>
               (item = {
                 name: item.name,
                 file: item.file ? item.file : null,
                 url: item.url ? item.url : "",
                 path: item.path ? item.path : "",
                 status: true,
                 mimetype: item.type ? item.type : item.mimetype,
               })  
           );
           let tempFiles = [];
           if (mapper.length > 0) {
             this.uploading = true;
             let count = 0;
             mapper.forEach((doc, index) => {
               let formData = new FormData();
               formData.append("files", doc.file);
               formData.append("secureType", "private");
               formData.append("getDetails", true);
               count++;
     
               this.$store.dispatch("uploadS3File", formData).then((response) => {
                 response.data.result.forEach((urlGenerated) => {
                   //alert(JSON.stringify(urlGenerated))
                   //  this.CommentPayload.documents.push(urlGenerated)
                  // if (  _.has(urlGenerated, "name") &&  tempFiles.indexOf(urlGenerated["name"]) <= -1 ) {
                    let tempUrl = urlGenerated
                    tempUrl = Object.assign(tempUrl, { uploadedBy: this.checkProperty(this.getUserData, 'userId'), uploadedByName: this.checkProperty(this.getUserData, 'name'), uploadedByRoleId: this.getUserRoleId, uploadedByRoleName: this.checkProperty(this.getUserData, 'loginRoleName') });
                     tempFiles.push(urlGenerated["name"]);
                     this.petition['beneficiaryInfo']['marriageCertDocs'].push(tempUrl);
                //   }
                   doc.url = urlGenerated;
                   doc.path = urlGenerated;
                   doc["mimetype"] = urlGenerated["mimetype"];
                   doc["type"] = urlGenerated["mimetype"];
                   delete doc.file;
                   mapper[index] = doc;
                 });
                 if (index >= mapper.length - 1) {
                   this.uploading = false;
                   // _current.$vs.loading.close();
                 }
               });
             });
             if (efiles.length > 0) efiles.push(...mapper);
             //this.CommentPayload["documents"] = efiles
           }
            },
            remove(item, data, filindex) {
                data.splice(filindex, 1);
            },
        
            changedAdjustmentOfI485Status(val){
              
            if(this.petition.beneficiaryInfo.adjustmentOfI485Status){
                this.petition.beneficiaryInfo.consularProcessing = false;
                
            }
               this.consularProcessingValidator ='';
               this.petition.beneficiaryInfo.applyI485AdjOrConsuProcess =false;
    
               if(this.petition.beneficiaryInfo.adjustmentOfI485Status || this.petition.beneficiaryInfo.consularProcessing){
                   this.consularProcessingValidator ='adjustmentOfI485Status';
                   this.petition.beneficiaryInfo.applyI485AdjOrConsuProcess =true;
               }
           
            },
          
            changedConsularProcessing(val){
           
              
              if(this.petition.beneficiaryInfo.consularProcessing){
                this.petition.beneficiaryInfo.adjustmentOfI485Status = false
              }
    
               this.consularProcessingValidator ='';
              
               if(this.petition.beneficiaryInfo.adjustmentOfI485Status || this.petition.beneficiaryInfo.consularProcessing){
                   this.consularProcessingValidator ='consularProcessingValidator';
                   this.petition.beneficiaryInfo.applyI485AdjOrConsuProcess =true;
               }
    
            },
           
            
            updatesocCode(item){ 
    
            if(_.has( item ,'id')){
                this.petition['jobDetails']['socCode'] = item['id'];
            }
            },
            getMasterSocList(){
    
                let query = {};
                query["page"] = 1;
                query["perpage"] = 10000;
                query["matcher"] = { 
                    // "getInactiveListAlso": true
                    };
                query["category"] = "soc_codes";
    
    
                this.$store
                .dispatch("getMasterData", query)
                .then((response) => {
                    this.masterSocList = response.list;
                
    
    
                //alert(this.perpage);
                })
                .catch(() => {
                this.masterSocList = [];
    
                });
    
            },
            setSameaddress(callFromChecckBox =true){
                
                    if( this.checkProperty(this.petition,'beneficiaryInfo','currentlyInUS') && this.canRenderField('mailingAddressIsSameAsAddress',this.questionnaireDetails, false, 'beneficiaryInfo' ) 
                && this.canRenderField('currentlyInUS',this.questionnaireDetails, false, 'beneficiaryInfo' ) && this.petition.beneficiaryInfo.mailingAddressIsSameAsAddress){
                        this.petition.beneficiaryInfo['currentAddress'] = _.cloneDeep(this.petition.beneficiaryInfo['address']);
                    }else{
    

                        if(callFromChecckBox){
                        this.petition.beneficiaryInfo['currentAddress'] =  {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                        }
                        this.$refs['mailingAddresscomponent'].clearStatesList();
                    }
    
                    }
    
               
                
    
            },
            updatecellPhoneCountryCode(data){
                this.petition.beneficiaryInfo.cellPhoneCountryCode =data;
               
            },
            updatehomePhoneCountryCode(data){
                this.petition.beneficiaryInfo.homePhoneCountryCode =data;
               
            },
            clearCurrentStatusField(val){
                if(val){
                    this.petition.beneficiaryInfo.curVisaExpiryDate = null;
                }
            },
            clearI94Field(val){
                if(val){
                    this.petition.beneficiaryInfo.I94ExpiryDate = null;
                }
            },
            
            sethaveYouEverTravelledToUS(val){
                this.petition.beneficiaryInfo.haveYouEverTravelledToUS = val;
                if(!val && false){
                    this.petition.beneficiaryInfo.nonImmPetitionsInfo = [{
                            _id: 0,
                            visaStatus: null,
                            visaStatusDetails: null,
                            receiptNo: '',
                            petitionerName: '',
                            validFrom:null,
                            validTo:null
                        }]
                }
                
            },
            toggleSpouseForm() {
                if (this.spouse.saved) {
    
                } else {
                    this.spouse.h4Required = false 
                    this.spouse.hasSpouse = false
                    this.spouse.l2Required = false
                    this.petition.dependentsInfo.spouse.h4Required = false;
                    this.petition.dependentsInfo.spouse.hasSpouse = false;
                    this.petition.dependentsInfo.spouse.l2Required = false;
                }
    
                // if (this.petition.dependentsInfo && this.petition.dependentsInfo.spouse.saved) {
    
                // } else { 
                //     this.petition.dependentsInfo.spouse = {
                //         h4Required: false
                //     }
                // }
    
                this.spouseModalForm = false;
    
            },
            toggleChildForm() {
                var savedone = false;
                this.petition.dependentsInfo.childrens.forEach((element, index) => {
    
                    if (element.saved) {
                        savedone = true;
                    }
    
                });
                if (!savedone) {
                    this.petition.h4RequiredForChild = false;
                    this.petition.hasChildren = false; 
                    this.petition.l2Required = false;
                    this.petition.dependentsInfo.childrens[0] = {
                        h4Required: null,
                        hasChildren:null,
                        l2Required:null
                    }
                }
    
                this.childModalForm = false;
            },
            editChildren(item, index) {
                this.childModalForm = true;
                this.selectedchild = index;
    
                         if(item){
                        var childocs = item.documents;
                        if(childocs && childocs.passport == null)  item.documents.passport =[];
                        if(childocs && childocs.visa == null)  item.documents.visa =[];
                        if(childocs && childocs.formI94 == null)  item.documents.formI94 =[];
                        if(childocs && childocs.birthCertificate == null)  item.documents.birthCertificate =[];
                        if(childocs && childocs.approvalNotice == null)  item.documents.approvalNotice =[];
                        if(childocs && childocs.approvalNoticeOfPrevH4 == null)  item.documents.approvalNoticeOfPrevH4 =[];
                        if(childocs && childocs.other == null)  item.documents.other =[];
                  }      
    
               
                this.$validator.reset();
            },
            submitChild() {
                this.$validator.validateAll("childInfoformmodal").then((result) => {
                    if (result) {
                        this.petition.dependentsInfo.childrens[this.selectedchild].saved = true;
                        this.petition.dependentsInfo.childrens[this.selectedchild].h4Required = true;
                        this.petition.dependentsInfo.childrens[this.selectedchild].hasChildren = true;
                        if(this.canRenderField('l2Required', this.questionnaireDetails ,false,'dependentsInfo.childrens')){ 
                            // l2Required:null,
                            this.petition.dependentsInfo.childrens[this.selectedchild].l2Required = true;
                        }
                        if(this.petition && this.petition.dependentsInfo && this.petition.dependentsInfo.childrens && this.petition.dependentsInfo.childrens[this.selectedchild] && this.canRenderField( 'anyOtherPersonEmployedInUS', this.questionnaireDetails ,false, 'dependentsInfo.childrens') &&    _.has(this.petition.dependentsInfo.childrens[this.selectedchild],'anyOtherPersonEmployedInUS') && !this.checkProperty(this.petition.dependentsInfo.childrens[this.selectedchild],'anyOtherPersonEmployedInUS')){
                            this.petition.dependentsInfo.childrens[this.selectedchild]['prevEmploymentInfo'] = [{
                                _id: 0,
                                employerName: '',
                                    address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                salary: null,
                                currentEmployer: true
                            }]
                        }
                        if(this.petition && this.petition.dependentsInfo && this.petition.dependentsInfo.childrens && this.petition.dependentsInfo.childrens[this.selectedchild]){
                            if((!this.petition.dependentsInfo.childrens[this.selectedchild]['h4EADRequired'] && !this.canRenderField( 'l2EADRequired', this.questionnaireDetails ,false, 'dependentsInfo.childrens') ) ||
                            (!this.petition.dependentsInfo.childrens[this.selectedchild]['l2EADRequired'] && this.canRenderField( 'l2EADRequired', this.questionnaireDetails ,false, 'dependentsInfo.childrens') )){
                                this.petition.dependentsInfo.childrens[this.selectedchild]['stateOfLastEntryInUS'] = null;
                                this.petition.dependentsInfo.childrens[this.selectedchild]['placeOfLastEntryInUS'] = null;
                                this.petition.dependentsInfo.childrens[this.selectedchild]['lastArrivalDate'] = null; 
                                this.petition.dependentsInfo.childrens[this.selectedchild]['stateDetailsOfLastEntryInUS'] = null;
                                this.petition.dependentsInfo.childrens[this.selectedchild]['anyOtherPersonEmployedInUS'] = false;
                                this.petition.dependentsInfo.childrens[this.selectedchild]['prevEmploymentInfo'] = [{
                                    _id: 0,
                                    employerName: '',
                                        address: {
                                        line1: null,
                                        line2: null,
                                        aptType: null,
                                        locationId: null,
                                        locationDetails: null,
                                        stateId: null,
                                        stateDetails: null,
                                        countryId: null,
                                        countryDetails: null,
                                        zipcode: null
                                    },
                                    businessType: null,
                                    jobTitle: null,
                                    jobDuties: null,
                                    startDate: null,
                                    endDate: null,
                                    salary: null,
                                    currentEmployer: true
                                }]
                            }
                            
                        }
                        if(this.petition && this.petition.dependentsInfo && this.petition.dependentsInfo.childrens && this.petition.dependentsInfo.childrens[this.selectedchild] &&this.canRenderField('haveYouEverTravelledToUS',this.questionnaireDetails,false ,'dependentsInfo.childrens') && _.has(this.petition.dependentsInfo.childrens[this.selectedchild],'haveYouEverTravelledToUS') && !this.checkProperty(this.petition.dependentsInfo.childrens[this.selectedchild],'haveYouEverTravelledToUS')  ){
                            this.petition.dependentsInfo.childrens[this.selectedchild]['priorPeriodOfStayInUS'] = [{
                                _id: 0,
                                enteredNumber: null,
                                departedNumber: null,
                                visaStatus: null,
                                visaStatusDetails: null,
                                noOfDays: null,
                                dateerror: false
                            }]
                        }
                        if(this.canRenderField('currentlyInUS',this.questionnaireDetails, false, 'dependentsInfo.childrens' ) && _.has(this.petition.dependentsInfo.childrens[this.selectedchild],'currentlyInUS') && !this.checkProperty(this.petition.dependentsInfo.childrens[this.selectedchild],'currentlyInUS')){
                            this.petition.dependentsInfo.childrens[this.selectedchild]['currentStatusDetails'] = null
                            this.petition.dependentsInfo.childrens[this.selectedchild]['currentStatus']  = null
                            this.petition.dependentsInfo.childrens[this.selectedchild]['isDSExpiryDate'] = null
                            this.petition.dependentsInfo.childrens[this.selectedchild]['statusExpiryDate'] = null
                            this.petition.dependentsInfo.childrens[this.selectedchild]['I94'] = null
                            this.petition.dependentsInfo.childrens[this.selectedchild]['isI94DSExpiryDate'] = null
                            this.petition.dependentsInfo.childrens[this.selectedchild]['I94ExpiryDate'] = null
                            this.petition.dependentsInfo.childrens[this.selectedchild]['physicalAddress'] = {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            }
                        }
                        var childres = []
                        this.petition.dependentsInfo.childrens.forEach((element, index) => {
    
                            if (element.saved && element.firstName != '' && element.firstName != null) {
                                childres.push(element)
                            }
    
                        });
                        this.petition.dependentsInfo.childrens = childres;
                        this.saveCase(true, true)
                    } 
                    else{
                        const $ = JQuery;
                        if($('.text-danger:visible')){
                             $('.modal_cnt').scrollTop($('.text-danger:visible').first().parent().offset().top-30);
                        }
                    }
                    // else {
    
                    //     var $self = this;
                    //     const $ = JQuery;
                    //     var el = _.find(this.errors["items"], function (item) {
                    //         return item.scope == "childInfoformmodal"
                    //     })
                    //     if (el) {
                    //         const ele = $("[name=" + el.field + "]").parents(".vx-col");
                    //         var _top = 0;
                    //         if (ele) {
                    //             _top = ele.position().top;
                    //         }
                    //     }
                    //     this.$refs["mainSidebarPschild"].scrollTo({
                    //         top: _top,
                    //         left: 0,
                    //         behavior: 'smooth'
                    //     });
    
                    // }
                })
    
            },
            addchildren() {
                this.petition.h4RequiredForChild = true;
                this.petition.hasChildren = true;
                if(this.canRenderField('l2Required', this.questionnaireDetails ,false,'dependentsInfo.childrens')){ 
                    this.petition.l2Required = true;
                    // l2Required:null,
                }
                this.childH4(true)
            },
            childH4(addmore = false) {
    
                var _child = this.getChildObject();
                
                if(this.petition.beneficiaryInfo && this.petition.beneficiaryInfo.hasAnyDependetsinUStoFileH4 && this.canRenderField('hasAnyDependetsinUStoFileH4', this.questionnaireDetails ,false,'beneficiaryInfo' )){
                    _child.currentlyInUS = true;
                    _child.haveYouEverTravelledToUS = true;
                    
                }
            
    
                if (addmore) {
    
                    var savedone = false;
                    this.petition.dependentsInfo.childrens.forEach((element, index) => {
    
                        if (element.saved) {
                            savedone = true;
                        }
    
                    });
    
                    if (savedone) {
                        /* If already saved children exists then push new object*/ 
                        var _childrens = this.petition.dependentsInfo.childrens;
                        _childrens.push(_child);
                        this.petition.dependentsInfo.childrens = _childrens;
                        this.petition.dependentsInfo.childrens[this.petition.dependentsInfo.childrens.length - 1].h4Required = false;
                        this.petition.dependentsInfo.childrens[this.petition.dependentsInfo.childrens.length - 1].hasChildren = false;
                        this.petition.dependentsInfo.childrens[this.petition.dependentsInfo.childrens.length - 1].l2Required = false;
                        this.selectedchild = this.petition.dependentsInfo.childrens.length - 1;
    
    
                        this.childModalForm = true;
                    } else {
                        var _childrens = [];
                        _childrens.push(_child)
                        this.petition.dependentsInfo.childrens = _childrens;
                        this.childModalForm = true;
                    }
                    
                } else {  
                    if ((this.petition.h4RequiredForChild && this.canRenderField('h4Required', this.questionnaireDetails ,false,'dependentsInfo.childrens')) 
                    ||(this.petition.hasChildren && this.canRenderField('hasChildren', this.questionnaireDetails ,false,'dependentsInfo.childrens'))
                    ||(this.petition.l2Required && this.canRenderField('l2Required', this.questionnaireDetails ,false,'dependentsInfo.childrens')) ) {
                        this.addchildren()
                    } else {
                        this.childModalForm = false;
                        var _childrens = [];
                        _childrens.push(_child)
                        this.petition.dependentsInfo.childrens = _childrens;
                        this.petition.dependentsInfo.childrens[0].h4Required = false;
                        this.petition.dependentsInfo.childrens[0].hasChildren = false;
                        this.petition.dependentsInfo.childrens[0].l2Required = false;
                        this.selectedchild = 0;
    
                    }
    
                }
    
                if ((!this.petition.h4RequiredForChild && this.canRenderField('h4Required', this.questionnaireDetails ,false,'dependentsInfo.childrens') )
                || (!this.petition.hasChildren && this.canRenderField('hasChildren', this.questionnaireDetails ,false,'dependentsInfo.childrens') )
                || (!this.petition.l2Required && this.canRenderField('l2Required', this.questionnaireDetails ,false,'dependentsInfo.childrens'))) {
                    this.petition.dependentsInfo.childrens = []
                    this.petition.dependentsInfo.childrens.push(_child);
                    this.selectedchild = 0;
                }
    
    
            },
            spouseH4() {
                let _spouse= {
                    // public charge keys start
                    inadmissibility:null,
                            highestDegreeCompleted:null,
                            listOfCertifications:'',
                            SSI:null,
                            benefitsRecAmounts:[{
                                benefitReceived: '',
                                startDate: null,
                                endDate: null,
                                amount: ''
                            }],
                            longTermInstiAtGovtExpense:null,
                            periodOfInstutions:[{
                                institutionName:'',
                                stateId:'',
                                stateDetails:null,
                                locationId:'',
                                locationDetails:null,
                                dateFrom:null,
                                dateTo:null,
                                reason:'',
                                instituteLocations:[]
                            }],
                            // public charge keys end
                            gender:'',
                            doYouWantTheSsaToIssueYouSS:false,
                            ssnFather:{
                                familyName:'',
                                givenName:''
                            },
                            ssnMother:{
                                familyName:'',
                                givenName:''
                            },
                            immigStatusLastArrival:'',
                            doYouAlreadyH4EAD:null,
                            sevisNumber: null,
                            eadNumber: null,
                            haveYouEverTravelledToUS:null,
                            isDSExpiryDate:false,
                            isI94DSExpiryDate:false,
                            relationship: '',
                            saved: false,
                            currentlyInUS: null,
                            hasOtherNames: null, 
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            passportIssuedNumber: null,
                            alienNumber: '',
                            prevEmploymentInfo: [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                payFrequency:null,
                                salary: null,
                                currentEmployer: null
                            }],
                            addressOutsideUS: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            priorPeriodOfStayInUS: [{
                                _id: 0,
                                enteredNumber: null,
                                departedNumber: null,
                                dateerror: false,
                                noOfDays: null,
                                visaStatus: null
                            }],
                            dateFromWhichResideInUs:null,
                            caseIssuedDate: null,
                            caseExpiryDate: null,
                            placeOfCaseIssued: '',
                            mailingAddressIsSameAsAddress:false,
                            stateOfLastEntryInUS: '',
                            stateDetailsOfLastEntryInUS: null,
                            placeOfLastEntryInUS: '',
                            firstArrivalDate: null,
                            lastArrivalDate: null,
                            allIssuedpassportData: [{
                                countryId: '',
                                countryDetails: null,
                                number: '',
                                issuedDate: null,
                                expiryDate: null 
                            }],
                            currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            height: {
                                feet: '',
                                inches: ''
                            },
                            weight: '',
                            race: [],
                            eyeColor:null,
                            hairColor: null,
                            educations: [{
                            _id: 0,
                            name: null,
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            highestDegree: null,
                            highestDegreeDetails: null,
                            majorFieldOfStudy: null,
                            attendedFrom: null,
                            attendedTo: null,
                            graduatedYear: null,
                            degreereceived: null,
                            isAccredited: null,
                            isForProfit: null
                            }],
                            prevEmploymentInfo: [{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            currentEmployer: null
                            }],
                            prevEmploymentOutsideUS:[{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                currentEmployer: null  
                            }],
                            previousSpouse:{
                            hasOtherNames:null,
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            maidenName:'',
                            marriageEndedDueTo:null,
                            marriageEndedOtherInfo:'',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            dateOfBirth: null,
                            dateOfMarriage:null,
                            dateOfMarriageEnd:null,
    
                              //Place of Marriage
                            countryOfMarriage: '',
                            countryOfMarriageDetails: null,
                            provinceOfMarriage: '',
                            provinceOfMarriageDetails: null,
                            locationOfMarriage: '',
    
                            //Place of Termination
                            countryOfMarriageTermination: '',
                            countryOfMarriageTerminationDetails: null,
                            provinceOfMarriageTermination: '',
                            provinceOfMarriageTerminationDetails: null,
                            locationOfMarriageTermination: '',
                            obtainPermResidenceThroughSpouse:null  
                          
                            },
                            addressOfLastNYears:[{
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                            }], 
                            addressOutsideUSMoreThanYear:[{
                            
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                            }],
                            dateOfLastEntryInUS:null,
                            dateOfMarriage: null, 
                            dateOfMarriageEnd: null, 
                            countryOfMarriage: '', 
                            countryOfMarriageDetails: null, 
                            provinceOfMarriage: '', 
                            provinceOfMarriageDetails: null, 
                            locationOfMarriage: '',
                            currentSpouseName: '',
                            maritalStatus : '', 
                            maritalStatusDetails: null,
                            curNonImmigrantVisaStatus: '', 
                            associations:[ {
                                name:'', 
                                address:{
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                },
                                startDate: null,
                                endDate:null,
                                natureofAssociations:'',
                            }],

                            isVisaDenieedTOUS:null,
                            visaDeniedReason:'',
                            haveYoueverPresntUnlawfully:null,
                            presntUnlawfullyReason:'',
                            haveYouEverReceivedPublicAssistendeInUS:null,
                            haveYouEverlikelyReceivePublicAssistendeInUS:null,
                            everAppliedAOSInUS: null, 
                            appliedAOSInUSDocs:[],
                            haveYouArrestedBefore:null,
                            haveYouArrestedBeforeDocs:[], 
                            doesBirthRegistered:null, 
                            curNonImmigrantVisaNumber:'',
                            enterInUSUnderCaseWaiverProgram: null,
                            inspectedByAnyImmOfficer: null, 
                            issuedAnyEADFromUSCIS: null, 
                            hasPermResidencyInOtherCountry: null, 
                            permResidencyCountryId: '', 
                            passportIssuedDate: null,
                            permResidencyCountryDetails: null,
                            

                            h4Required: null,
                            hasSpouse:null,
                            l2Required:null,
                            h4EADRequired: null,
                            l2EADRequired:null,
                            doYouAlreadyL2EAD:null,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            email: '',
                            phoneNumber: '',
                            phoneCountryCode: {
                                countryCode: '',
                                countryCallingCode: ''
                            },
                            dateOfBirth: null,
                            countryOfBirth: null,
                            countryOfBirthDetails: null,
                            provinceOfBirth: null,
                            provinceOfBirthDetails: null,
                            locationOfBirth: '',
                            locationOfBirthDetails: null,
                            countryOfCitizenship: null,
                            countryOfCitizenshipDetails: null,
                            passportNumber: '',
                            passportExpiryNumber: null,
                            passportIssuedCountry:null,
                            passportIssuedCountryDetails:null,
                            I94: '',
                            I94ExpiryNumber: null,
                            currentStatus: null,
                            currentStatusDetails: null,
                            statusExpiryNumber: null,
                            SSN: '',
                            lastArrivalNumber: null,
                            placeOfLastEntryInUS: '',
                            applyingWithYou:null,
                            classification:'',
                            nameDiffFromBirthCert:null,
                            i140PriorityDate:null,
                            physicalAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            fatherInfo: { 
                                name: '', 
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: null, 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                                isUSCitizen: null, 
                                dateFromUSCitizen: null, //["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                            },
                            motherInfo: { 
                                name: '',                    
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: null , 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                                },
                                isUSCitizen: null, 
                                dateFromUSCitizen:null,// ["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                            }, 
                            documents: {
                                passport: [],
                                visa: [],
                                formI94: [],
                                formI797: [],
                                formI20: [],
                                payStubs: [],
                                marriageCertificate: [],
                                noticeOfApprovalOfH1Status: [],
                                approvalNoticeOfPrevH4: [],
                                other: []
                            },
                            //i140
                            adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                        
    
                        };
                if(this.petition.beneficiaryInfo && this.petition.beneficiaryInfo.hasAnyDependetsinUStoFileH4 && this.canRenderField('hasAnyDependetsinUStoFileH4', this.questionnaireDetails ,false,'beneficiaryInfo' )){
                    _spouse.currentlyInUS = true;
                    _spouse.haveYouEverTravelledToUS = true;
                }
                let addBenificiaryAdd = false;
                _.forEach(_spouse['physicalAddress'],(item)=>{
                    if(item != null ){
                        addBenificiaryAdd = true;
                       return false;
                    }
                })
                if(!addBenificiaryAdd){
                    _spouse['physicalAddress'] = _.cloneDeep(this.petition.beneficiaryInfo.address)  
                }
                if ((this.petition.dependentsInfo.spouse.h4Required && this.canRenderField('h4Required', this.questionnaireDetails ,false,'dependentsInfo.spouse'))
                || (this.petition.dependentsInfo.spouse.hasSpouse && this.canRenderField('hasSpouse', this.questionnaireDetails ,false,'dependentsInfo.spouse'))
                || (this.petition.dependentsInfo.spouse.l2Required && this.canRenderField('l2Required', this.questionnaireDetails ,false,'dependentsInfo.spouse'))) { 
                
                    if(this.latestPetition && _.has(this.latestPetition,'dependentsInfo') && this.checkProperty(this.latestPetition,'dependentsInfo') && this.checkProperty(this.latestPetition,'dependentsInfo','spouse')
                         && this.checkProperty(this.latestPetition['dependentsInfo'],'spouse','firstName') && this.prefillAction){
                            // var data = _.merge(this.spouse, this.latestPetition.dependentsInfo.spouse);
                            // this.spouse = data
                            
                        this.spouse = _.cloneDeep(this.latestPetition.dependentsInfo.spouse);
                       
                        if(!_.has(this.spouse,'prevEmploymentInfo') || !this.checkProperty(this.spouse,'prevEmploymentInfo')){
                            this.spouse['prevEmploymentInfo'] = [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                salary: null,
                                currentEmployer: true
                            }]
                        }
                        if(!_.has(this.spouse,'fatherInfo') || !this.checkProperty(this.spouse,'fatherInfo')){
                            this.spouse['fatherInfo']= { 
                                name: '', 
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: null, 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                                isUSCitizen: null, 
                                dateFromUSCitizen: null, //["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                            }
                        }
                        if(!_.has(this.spouse,'motherInfo') || !this.checkProperty(this.spouse,'motherInfo')){
                            this.spouse['motherInfo']= { 
                                name: '', 
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: null, 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                                isUSCitizen: null, 
                                dateFromUSCitizen: null, //["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                            }
                        }
                        if((_.has(this.spouse,'height') && !this.checkProperty(this.spouse,'height')) || !_.has(this.spouse,'height')  ){
                            this.spouse['height']= {
                                feet: '',
                                inches: ''
                            }
                        }
                        if( (_.has(this.spouse,'associations') && !this.checkProperty(this.spouse,'associations')) || !_.has(this.spouse,'associations') ){
                            this.spouse['associations']= [{
                                name:'', 
                                address:{
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                },
                                startDate: null,
                                endDate:null,
                                natureofAssociations:'',
                            }]
                        }

                        if(!_.has(this.spouse,'prevEmploymentOutsideUS') || !this.checkProperty(this.spouse,'prevEmploymentOutsideUS')){
                            this.spouse['prevEmploymentOutsideUS'] = [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                currentEmployer: null  
                            }]
                        }
                        if(!_.has(this.spouse,'previousSpouse') || !this.checkProperty(this.spouse,'previousSpouse')){
                            this.spouse['previousSpouse'] = {
                            hasOtherNames:null,
                            otherNames: [{
                                _id: 0,
                                name: '',
                                firstName: '',
                                middleName: '',
                                lastName: '',
                            }],
                            maidenName:'',
                            marriageEndedDueTo:null,
                            marriageEndedOtherInfo:'',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                            dateOfBirth: null,
                            dateOfMarriage:null,
                            dateOfMarriageEnd:null,
    
                              //Place of Marriage
                            countryOfMarriage: '',
                            countryOfMarriageDetails: null,
                            provinceOfMarriage: '',
                            provinceOfMarriageDetails: null,
                            locationOfMarriage: '',
    
                            //Place of Termination
                            countryOfMarriageTermination: '',
                            countryOfMarriageTerminationDetails: null,
                            provinceOfMarriageTermination: '',
                            provinceOfMarriageTerminationDetails: null,
                            locationOfMarriageTermination: '',
                            obtainPermResidenceThroughSpouse:null  
                          
                            }
                        }
                        if(!_.has(this.spouse,'addressOfLastNYears') || !this.checkProperty(this.spouse,'addressOfLastNYears')){
                            this.spouse['addressOfLastNYears'] = [{
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                        }]
                        }
                        if(!_.has(this.spouse,'addressOutsideUSMoreThanYear') || !this.checkProperty(this.spouse,'addressOutsideUSMoreThanYear')){
                            this.spouse['addressOutsideUSMoreThanYear'] = [{
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                        }]
                        }
                        if((_.has(this.spouse,'ssnMother') && !this.checkProperty(this.spouse,'ssnMother')) || !_.has(this.spouse,'ssnMother')  ){
                            this.spouse['ssnMother']= {
                                familyName: '',
                                givenName: ''
                            }
                        }
                        if((_.has(this.spouse,'ssnFather') && !this.checkProperty(this.spouse,'ssnFather')) || !_.has(this.spouse,'ssnFather')  ){
                            this.spouse['ssnFather']= {
                                familyName: '',
                                givenName: ''
                            }
                        }
                        if((_.has(this.spouse,'benefitsRecAmounts') && !this.checkProperty(this.spouse,'benefitsRecAmounts')) || !_.has(this.spouse,'benefitsRecAmounts')  ){
                            this.spouse['benefitsRecAmounts']= [{
                                benefitReceived: '',
                                startDate: null,
                                endDate: null,
                                amount: ''
                            }]
                        }
                        if((_.has(this.spouse,'periodOfInstutions') && !this.checkProperty(this.spouse,'periodOfInstutions')) || !_.has(this.spouse,'periodOfInstutions')  ){
                            this.spouse['periodOfInstutions']= [{
                                institutionName:'',
                                stateId:'',
                                stateDetails:null,
                                locationId:'',
                                locationDetails:null,
                                dateFrom:null,
                                dateTo:null,
                                reason:'',
                                instituteLocations:[]
                            }]
                        }
                        if((_.has(this.spouse,'phoneCountryCode') && !this.checkProperty(this.spouse,'phoneCountryCode')) || !_.has(this.spouse,'phoneCountryCode')  ){
                            this.spouse['phoneCountryCode']= {
                                countryCode: '',
                                countryCallingCode: ''
                            }
                        }
                        if((_.has(this.spouse,'cellPhoneCountryCode') && !this.checkProperty(this.spouse,'cellPhoneCountryCode')) || !_.has(this.spouse,'cellPhoneCountryCode')  ){
                            this.spouse['cellPhoneCountryCode']= {
                                countryCode: '',
                                countryCallingCode: ''
                            };
                            this.spouse['cellPhoneNumber']= null
                        }
                    }
                    else if(this.petition && _.has(this.petition,'dependentsInfo') && this.checkProperty(this.petition,'dependentsInfo') && this.checkProperty(this.petition,'dependentsInfo','spouse')
                        && this.checkProperty(this.petition['dependentsInfo'],'spouse','firstName') && this.prefillAction == false ){
                        this.spouse = _.cloneDeep(this.petition.dependentsInfo.spouse);
                        if((_.has(this.spouse,'ssnMother') && !this.checkProperty(this.spouse,'ssnMother')) || !_.has(this.spouse,'ssnMother')  ){
                            this.spouse['ssnMother']= {
                                familyName: '',
                                givenName: ''
                            }
                        }
                        if((_.has(this.spouse,'ssnFather') && !this.checkProperty(this.spouse,'ssnFather')) || !_.has(this.spouse,'ssnFather')  ){
                            this.spouse['ssnFather']= {
                                familyName: '',
                                givenName: ''
                            }
                        }
                        if(!_.has(this.spouse,'prevEmploymentInfo') || !this.checkProperty(this.spouse,'prevEmploymentInfo')){
                            this.spouse['prevEmploymentInfo'] = [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                salary: null,
                                currentEmployer: true
                            }]
                        }
                        if(!_.has(this.spouse,'fatherInfo') || !this.checkProperty(this.spouse,'fatherInfo')){
                         
                            this.spouse['fatherInfo']= { 
                                name: '', 
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: null, 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                                isUSCitizen: null, 
                                dateFromUSCitizen: null, //["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                            }
                        }
                        if((_.has(this.spouse,'benefitsRecAmounts') && !this.checkProperty(this.spouse,'benefitsRecAmounts')) || !_.has(this.spouse,'benefitsRecAmounts')  ){
                            this.spouse['benefitsRecAmounts']= [{
                                benefitReceived: '',
                                startDate: null,
                                endDate: null,
                                amount: ''
                            }]
                        }
                        if((_.has(this.spouse,'periodOfInstutions') && !this.checkProperty(this.spouse,'periodOfInstutions')) || !_.has(this.spouse,'periodOfInstutions')  ){
                            this.spouse['periodOfInstutions']= [{
                                institutionName:'',
                                stateId:'',
                                stateDetails:null,
                                locationId:'',
                                locationDetails:null,
                                dateFrom:null,
                                dateTo:null,
                                reason:'',
                                instituteLocations:[]
                            }]
                        }
                        if(!_.has(this.spouse,'motherInfo') || !this.checkProperty(this.spouse,'motherInfo')){
                            this.spouse['motherInfo']= { 
                                name: '', 
                                firstName: '', 
                                middleName: '', 
                                lastName: '', 
                                hasOtherNames: null, 
                                otherNames: [{ 
                                    _id: 0, 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                }], 
                                dateOfBirth: null, 
                                countryOfBirth: '', 
                                countryOfBirthDetails: null, 
                                provinceOfBirth: '', 
                                provinceOfBirthDetails: null, 
                                locationOfBirth: '', 
                                currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                                isUSCitizen: null, 
                                dateFromUSCitizen: null, //["", ""],
                                nameAtBirth:{
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '',
                                },
                                deceasedCity: '',
                                deceasedCityDetails:null,
                                deceasedDate: null,
                            }
                        }
                        if((_.has(this.spouse,'height') && !this.checkProperty(this.spouse,'height')) || !_.has(this.spouse,'height')  ){
                            this.spouse['height']= {
                                feet: '',
                                inches: ''
                            }
                        }
                       
                        if(!_.has(this.spouse,'associations') || !this.checkProperty(this.spouse,'associations') ){
                            
                            this.spouse['associations']= [ {
                                name:'', 
                                address:{
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                },
                                startDate: null,
                                endDate:null,
                                natureofAssociations:'',
                            }]
                        }
                        if(!_.has(this.spouse,'addressOfLastNYears') || !this.checkProperty(this.spouse,'addressOfLastNYears')){
                            this.spouse['addressOfLastNYears'] = [{
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                            }]
                        }
                        if(!_.has(this.spouse,'addressOutsideUSMoreThanYear') || !this.checkProperty(this.spouse,'addressOutsideUSMoreThanYear')){
                            this.spouse['addressOutsideUSMoreThanYear'] = [{
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null,
                                startDate: null,
                                endDate: null,
                            }]
                        }
                        if((_.has(this.spouse,'phoneCountryCode') && !this.checkProperty(this.spouse,'phoneCountryCode')) || !_.has(this.spouse,'phoneCountryCode')  ){
                            this.spouse['phoneCountryCode']= {
                                countryCode: '',
                                countryCallingCode: ''
                            }
                            this.spouse['phoneNumber'] = null;
                        }
                        if((_.has(this.spouse,'cellPhoneCountryCode') && !this.checkProperty(this.spouse,'cellPhoneCountryCode')) || !_.has(this.spouse,'cellPhoneCountryCode')  ){
                            this.spouse['cellPhoneCountryCode']= {
                                countryCode: '',
                                countryCallingCode: ''
                            };
                            this.spouse['cellPhoneNumber']= null
                        }
                    }
                    else{
                       
                        this.spouse = _spouse;
                    }
                    
                    this.spouseModalForm = true;
    
                } else {
                    this.spouseModalForm = false;
                    this.spouse = _spouse;
                    this.petition.dependentsInfo.spouse  = _spouse;
                    this.petition.dependentsInfo.spouse.h4Required = false;
                    this.petition.dependentsInfo.spouse.hasSpouse = false;
                    this.petition.dependentsInfo.spouse.l2Required = false;
                    
    
                }
                
            },
            editSpouse(item) {
                  if(item){
                        var childocs = item.documents;
                        if(childocs && childocs.passport == null)  item.documents.passport =[];
                        if(childocs && childocs.visa == null)  item.documents.visa =[];
                        if(childocs && childocs.formI94 == null)  item.documents.formI94 =[];
                        if(childocs && childocs.formI797 == null)  item.documents.formI797 =[];
                        if(childocs && childocs.formI20 == null)  item.documents.formI20 =[];
                        if(childocs && childocs.marriageCertificate == null)  item.documents.marriageCertificate =[];
                        if(childocs && childocs.noticeOfApprovalOfH1Status == null)  item.documents.noticeOfApprovalOfH1Status =[];
                        if(childocs && childocs.approvalNoticeOfPrevH4 == null)  item.documents.approvalNoticeOfPrevH4 =[];
                        if(childocs && childocs.other == null)  item.documents.other =[];
    
                }      

                this.spouse = _.cloneDeep(item);
                this.spouseModalForm = true;
                this.$validator.reset();
            },
            checkMarriageCerti(){
                if(this.petition.beneficiaryInfo && this.petition.beneficiaryInfo.maritalStatusDetails && this.petition.beneficiaryInfo.maritalStatusDetails.id !=1){
                    let isExist = _.find(this.bendocslist ,{"key":'marriageCertificate'});
                    if(!isExist){
                        this.bendocslist.push( { required: false,  key: "marriageCertificate", fieldName: 'marriageCertificate', label: "Marriage Certificate (if spouse is on H-1B, L-1, or F-1 status) " });
                    }

                    let bnfSpouseLatestI797Exist = _.find(this.bendocslist ,{"key":'bnfSpouseLatestI797'});
                    if(!bnfSpouseLatestI797Exist){
                        this.bendocslist.push( { required: false,  key: "bnfSpouseLatestI797", fieldName: 'bnfSpouseLatestI797', label: "Latest I-797, Notice of Approval of the spouse (if spouse is on H-1B or L-1 status)" });
                    }

                    let bnfSpousePassportExist = _.find(this.bendocslist ,{"key":'bnfSpousePassport'});
                    if(!bnfSpousePassportExist){
                        this.bendocslist.push( { required: false,  key: "bnfSpousePassport", fieldName: 'bnfSpousePassport', label: "Spouse’s Passport- First page with photo, Visa page and last page with address" });
                    }

                    let bnfSpouseRecentPayStubsExist = _.find(this.bendocslist ,{"key":'bnfSpouseRecentPayStubs'});
                    if(!bnfSpouseRecentPayStubsExist){
                        this.bendocslist.push( { required: false,  key: "bnfSpouseRecentPayStubs", fieldName: 'bnfSpouseRecentPayStubs', label: "Three recent pay stubs (if spouse is on H-1B or L-1 status)" });
                    }

                    let bnfSpouseFormAllI20ExistExist = _.find(this.bendocslist ,{"key":'bnfSpouseFormAllI20'});
                    if(!bnfSpouseFormAllI20ExistExist){
                        this.bendocslist.push( { required: false,  key: "bnfSpouseFormAllI20", fieldName: 'bnfSpouseFormAllI20', label: "Spouse’s all Form I-20s (if spouse is on F-1 status)" });
                    }
                }else{
                    let isExist = _.find(this.bendocslist ,{"key":'marriageCertificate'});
                    if(isExist){
                        this.bendocslist.splice(this.bendocslist.indexOf(isExist),1)
                        if(_.has(this.petition['documents'],'marriageCertificate')){
                            this.petition.documents['marriageCertificate'] = [];
                        }                 
                    }


                    let bnfSpouseLatestI797Exist = _.find(this.bendocslist ,{"key":'bnfSpouseLatestI797'});
                    if(bnfSpouseLatestI797Exist){
                        this.bendocslist.splice(this.bendocslist.indexOf(bnfSpouseLatestI797Exist),1)
                        if(_.has(this.petition['documents'],'bnfSpouseLatestI797')){
                            this.petition.documents['bnfSpouseLatestI797'] = [];
                        }                 
                    }


                    let bnfSpousePassportExist = _.find(this.bendocslist ,{"key":'bnfSpousePassport'});
                    if(bnfSpousePassportExist){
                        this.bendocslist.splice(this.bendocslist.indexOf(bnfSpousePassportExist),1)
                        if(_.has(this.petition['documents'],'bnfSpousePassport')){
                            this.petition.documents['bnfSpousePassport'] = [];
                        }                 
                    }


                    let bnfSpouseRecentPayStubsExist = _.find(this.bendocslist ,{"key":'bnfSpouseRecentPayStubs'});
                    if(bnfSpouseRecentPayStubsExist){
                        this.bendocslist.splice(this.bendocslist.indexOf(bnfSpouseRecentPayStubsExist),1)
                        if(_.has(this.petition['documents'],'bnfSpouseRecentPayStubs')){
                            this.petition.documents['bnfSpouseRecentPayStubs'] = [];
                        }                 
                    }


                    let bnfSpouseFormAllI20Exist = _.find(this.bendocslist ,{"key":'bnfSpouseFormAllI20'});
                    if(bnfSpouseFormAllI20Exist){
                        this.bendocslist.splice(this.bendocslist.indexOf(bnfSpouseFormAllI20Exist),1)
                        if(_.has(this.petition['documents'],'bnfSpouseFormAllI20')){
                            this.petition.documents['bnfSpouseFormAllI20'] = [];
                        }                 
                    }








                }
                this.removeMarriageDocs()
            },
            removeMarriageDocs(){
                if( (this.petition.beneficiaryInfo && this.petition.beneficiaryInfo.maritalStatusDetails && this.petition.beneficiaryInfo.maritalStatusDetails.id ==1)
                    || (this.checkProperty( this.petition,'beneficiaryInfo','curNonImmigrantVisaStatus') && this.checkProperty( this.petition,'beneficiaryInfo','curNonImmigrantVisaStatus')!=7)){
                    let isExist = _.find(this.bendocslist ,{"key":'marriageCertificate'});
                    if(isExist){
                        this.bendocslist.splice(this.bendocslist.indexOf(isExist),1)
                        if(_.has(this.petition['documents'],'marriageCertificate')){
                            this.petition.documents['marriageCertificate'] = [];
                        }                 
                    }
                }
            },
            submitSpouse() {
                this.$validator.validateAll("dependentsInfoformmodal").then((result) => {
                    if (result) {
                        //this.spouse.saved = true;
                        if( (this.canRenderField( 'anyOtherPersonEmployedInUS', this.questionnaireDetails ,false, 'dependentsInfo.spouse') && _.has(this.spouse,'anyOtherPersonEmployedInUS') && !this.checkProperty(this.spouse,'anyOtherPersonEmployedInUS'))){
                            this.spouse['prevEmploymentInfo'] = [{
                                _id: 0,
                                employerName: '',
                                address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                salary: null,
                                currentEmployer: true
                            }]
                        }
                        if(this.canRenderField('haveYouEverTravelledToUS',this.questionnaireDetails,false ,'dependentsInfo.spouse') && _.has(this.spouse,'haveYouEverTravelledToUS') && !this.checkProperty(this.spouse,'haveYouEverTravelledToUS')  ){
                            this.spouse['priorPeriodOfStayInUS'] = [{
                                _id: 0,
                                enteredNumber: null,
                                departedNumber: null,
                                visaStatus: null,
                                visaStatusDetails: null,
                                noOfDays: null,
                                dateerror: false
                            }]
                        }
                        if(this.canRenderField('currentlyInUS',this.questionnaireDetails, false, 'dependentsInfo.spouse' ) && _.has(this.spouse,'currentlyInUS') && !this.checkProperty(this.spouse,'currentlyInUS')){
                            this.spouse.currentStatusDetails = null
                            this.spouse.currentStatus  = null
                            this.spouse.isDSExpiryDate = null
                            this.spouse.statusExpiryDate = null
                            this.spouse.I94 = null
                            this.spouse.isI94DSExpiryDate = null
                            this.spouse.I94ExpiryDate = null
                            this.spouse.eadNumber = null
                            this.spouse.sevisNumber = null
                            this.spouse.physicalAddress = {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            }
                        }
                        if(!this.spouse['h4EADRequired'] && !this.canRenderField( 'l2EADRequired', this.questionnaireDetails ,false, 'dependentsInfo.spouse') ){
                            this.spouse['stateOfLastEntryInUS'] = null;
                            this.spouse['placeOfLastEntryInUS'] = null;
                            this.spouse['lastArrivalDate'] = null; 
                            this.spouse['stateDetailsOfLastEntryInUS'] = null;
                            this.spouse['anyOtherPersonEmployedInUS'] = false;
                            this.spouse['prevEmploymentInfo'] = [{
                                _id: 0,
                                employerName: '',
                                    address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                salary: null,
                                currentEmployer: true
                            }]
                        }else if(!this.spouse['l2EADRequired'] && this.canRenderField( 'l2EADRequired', this.questionnaireDetails ,false, 'dependentsInfo.spouse')){
                            this.spouse['stateOfLastEntryInUS'] = null;
                            this.spouse['placeOfLastEntryInUS'] = null;
                            this.spouse['lastArrivalDate'] = null; 
                            this.spouse['stateDetailsOfLastEntryInUS'] = null;
                            this.spouse['anyOtherPersonEmployedInUS'] = false;
                            this.spouse['prevEmploymentInfo'] = [{
                                _id: 0,
                                employerName: '',
                                    address: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                businessType: null,
                                jobTitle: null,
                                jobDuties: null,
                                startDate: null,
                                endDate: null,
                                salary: null,
                                currentEmployer: true
                            }]
                        }
                        this.petition.dependentsInfo.spouse = _.cloneDeep(this.spouse)
                        this.petition.dependentsInfo.spouse.h4Required = true;
                        this.petition.dependentsInfo.spouse.hasSpouse = true;
                        this.spouse.saved = true;
                        if(this.canRenderField('l2Required',this.questionnaireDetails, false, 'dependentsInfo.spouse' )){
                            this.petition.dependentsInfo.spouse.l2Required = true;
                        }
                        this.petition.dependentsInfo.spouse.saved = true; 
                        this.saveCase(true, true)
                    } 
                    else{
                        const $ = JQuery;
                        if($('.text-danger:visible')){
                             $('.modal_cnt').scrollTop($('.text-danger:visible').first().parent().offset().top-30);
                        }
                    }
                    // else {
    
                    //     var $self = this;
                    //     const $ = JQuery;
                    //     var el = _.find(this.errors["items"], function (item) {
                    //         return item.scope == "dependentsInfoformmodal"
                    //     })
                    //     if (el) {
                    //         const ele = $("[name=" + el.field + "]").parents(".vx-col");
                    //         var _top = 0;
                    //         if (ele) {
                    //             _top = ele.position().top;
                    //         }
                    //     }
                    //     this.$refs["mainSidebarPs"].scrollTop = _top;
    
                    // }
                })
    
            },
            customvalidations() {
                var valid = true;
                if(this.petition.beneficiaryInfo.priorPeriodOfStayInUS && this.checkProperty(this.petition['beneficiaryInfo'],'priorPeriodOfStayInUS','length')>0){
                this.petition.beneficiaryInfo.priorPeriodOfStayInUS.forEach((element, index) => {
    
                    if (element.dateerror) {
                        valid = false;
                        return valid;
                    }
    
                });
            }
    
                return valid;
            },
            checkEducationTab(){
                let returnVal = true
                if(this.currentTab == 'education' && this.canRenderField('hasMasterDegreeInUS', this.questionnaireDetails ,false,'beneficiaryInfo')  && this.checkProperty(this.petition,'beneficiaryInfo','educations') &&
                this.checkProperty(this.petition['beneficiaryInfo'],'educations','length')>0){
                   let mastDExists = _.find(this.petition['beneficiaryInfo']['educations'], { 'highestDegree': 6 });
                   let bDexists = _.find(this.petition['beneficiaryInfo']['educations'], { 'highestDegree': 4 });
                   if(mastDExists ){
                    if(!bDexists){
                        this.educationErrorMsg="Seems you have not submitted Bachelor's information. Please fill to continue"
                        returnVal = false
                    }
                   }else{
                    if(this.checkProperty(this.petition,'beneficiaryInfo','hasMasterDegreeInUS')){
                        returnVal = false
                        this.educationErrorMsg="Seems you have not submitted Master's information. Please fill to continue"
                    }
                   } 
                }
                return returnVal
            },
            // submitCase() {
                
            //     this.$validator.validateAll(this.currentTab + "form").then((result) => {
    
            //         if (result && this.customvalidations()) {
            //             if(this.checkEducationTab()){
            //                 if (this.getIndexOfActivetab < this.tabslist.length) {
            //                     this.setActiveTab(this.tabslist[this.getIndexOfActivetab].key);
        
            //                     setTimeout(function () {
            //                         document.getElementById("scrollableques").scrollTo({
            //                             top: 0,
            //                             left: 0,
            //                             behavior: 'smooth'
            //                         })
            //                     }, 500)
        
            //                 } 
            //                 else {
            //                     if (this.petition.questionnaireFilled) {
            //                         this.$vs.loading();
            //                         this.saveCase(true, false);
            //                     }
            //                     else{
            //                         this.setSameaddress(false);

            //                         this.checkPreviousSpouse();
            //                         this.callQuestionairePrefill();
            //                         let temp_save =false;
            //                         this.questionnairePreviewData = {
            //                         submittedWithLink:false,
            //                         petitionId: this.$route.params.itemId,
            //                         userName: this.$store.state.user.name,
            //                         typeName: this.petition.typeDetails.name,
            //                         subTypeName: this.petition.subTypeDetails.name,
            //                         subTypeDetails:this.petition.subTypeDetails,
            //                         typeDetails: this.petition.typeDetails,
            //                         action: temp_save ? "BENEFICIARY_INFO_UPDATE" : "SUBMIT_BY_BENEFICIARY",
            //                         currentDate: moment().format("YYYY-MM-DD"),
            //                         beneficiaryInfo: this.petition.beneficiaryInfo,
            //                         dependentsInfo: this.petition.dependentsInfo,
            //                         documents: this.petition.documents,
            //                         fatherInfo: this.petition.fatherInfo,
            //                         motherInfo: this.petition.motherInfo,
            //                         temp_save: temp_save,
            //                         questionnaireFilled: temp_save ? false : true
            //                         };
            //                         this.questionnairePreviewData['noOfDaysStayInUS'] = this.gettotalDays;
            //                         if(!this.checkProperty(this.petition ,'permId') && this.checkProperty(this.petition ,'subTypeDetails' ,'id') ==16 && this.checkProperty(this.petition ,'jobDetails') ){
            //                             this.questionnairePreviewData = Object.assign( this.questionnairePreviewData , { 'jobDetails': this.petition['jobDetails']} );

            //                         }
            //                         if(!this.checkCurrentUrl){
            //                             this.questionnairePreviewData['submittedWithLink'] =true;
            //                         }
            //                         this.questionnairePreview = true;
                                
            //                     }

                                
        
            //                 }
            //             }
            //             else{
            //                 this.showToster({
            //                         message:  this.educationErrorMsg,
            //                         isError: true,
            //                     });
            //             }
            //         } else {
            //             this.validateandScroll();
            //         }
            //     })
            // },
            findNewDocs(){
                this.newDocs =[]
                _.forEach(this.petition.documents,(docs,category )=>{
                    if(docs && docs.length>0){
                        _.forEach(docs ,(document)=>{
                            if(_.has(document ,'isNew' ) && document['isNew'] ==true && _.get(document ,'path') && _.has(document ,'status' ) && document['status'] ==true ){
                                this.newDocs.push(document)
                            }

                        })

                    }

                });

            },
            saveCase(temp_save, show_message = true) {
                this.benProfileDetails = _.cloneDeep(this.petition);
                this.newDocs =[];
                this.removeConsulateAddress();
                this.findNewDocs();
               this.setSameaddress(false);
                this.callQuestionairePrefill();
                this.checkPreviousSpouse();
                //this.updateBeneficiaryProfile();
                this.$vs.loading();
                this.petition.noOfDaysStayInUS = this.gettotalDays;
               
                var postpetition = {
                    submittedWithLink:false,
                    petitionId: this.$route.params.itemId,
                    userName: this.$store.state.user.name,
                    typeName: this.petition.typeDetails.name,
                    subTypeName: this.petition.subTypeDetails.name,
                    action: temp_save ? "BENEFICIARY_INFO_UPDATE" : "SUBMIT_BY_BENEFICIARY",
                    currentDate: moment().format("YYYY-MM-DD"),
                    beneficiaryInfo: this.petition.beneficiaryInfo,
                    dependentsInfo: this.petition.dependentsInfo,
                    documents: this.petition.documents,
                    temp_save: temp_save,
                    fatherInfo: this.petition.fatherInfo,
                    motherInfo: this.petition.motherInfo,
                    questionnaireFilled: temp_save ? false : true,
                    newDocs:[],
                    consentChecked: this.consentChecked,
                    termsAndConditionsChecked: this.termsAndConditionsChecked,
                };
                if(this.checkProperty(this.petition['beneficiaryInfo'], 'prevH1bCaseStatus') && this.checkProperty(this.petition['beneficiaryInfo'], 'prevH1bCaseStatus', 'id')){
                    postpetition['beneficiaryInfo']['prevH1bCaseStatus'] = this.checkProperty(this.petition['beneficiaryInfo'], 'prevH1bCaseStatus', 'id');
                }
                
                //petition.beneficiaryInfo.haveYouEverAppliedH1bCase
                postpetition['newDocs'] = this.newDocs;

                // if(this.checkProperty(postpetition ,'beneficiaryInfo' ,'haveYouEverTravelledToUS' ) =='Yes'){
                //     postpetition['beneficiaryInfo']['haveYouEverTravelledToUS'] =true;
                // }
                // if(this.checkProperty(postpetition ,'beneficiaryInfo' ,'haveYouEverTravelledToUS' ) =='No'){
                //     postpetition['beneficiaryInfo']['haveYouEverTravelledToUS'] =false;
                // }
                if(!this.checkProperty(this.petition ,'permId') && this.checkProperty(this.petition ,'subTypeDetails' ,'id') ==16 && this.checkProperty(this.petition ,'jobDetails') ){
                    postpetition = Object.assign(postpetition , { 'jobDetails': this.petition['jobDetails']} );
    
                }
                if(!this.checkCurrentUrl){
                    postpetition['submittedWithLink'] =true;
                }
                // if(this.canRenderField('otherNames',this.questionnaireDetails, false, 'beneficiaryInfo' )){
                //     if(this.petition.beneficiaryInfo.hasOtherNames){
                       
                //         postpetition['beneficiaryInfo']['hasOtherNames'] =true;
                //     }

                // }

                this.$store.dispatch("petitioner/petitionupdate", postpetition)
                    .then((response) => {
                        if(this.checkProperty(this.petition, 'subTypeDetails', 'id') == 16){
                            this.updateWagesReturn()
                        }
                        this.showBenProfileSyncPopup = false;
                        if (this.checkProperty(response, "error")) {
    
                            if (show_message) {
    
                                this.showToster({
                                    message: response.error.message,
                                    isError: true,
                                });
                            } else {
    
                                this.$vs.loading.close();
                            }
    
                        } else {
    
                            this.spouseModalForm = false;
                            this.childModalForm = false;
                            if (show_message) {
                                
                              
                                if (!temp_save) {
                                    this.SuccessQuestionnaire = true;
                                } else {
    
                                    this.showToster({
                                        message: "Questionnaire saved successfully",
                                        isError: false,
                                    });
                                }
    
                            } else {


                                let currentRoute = this.$route;

                                if (  !this.checkCurrentUrl &&   _.get(currentRoute, "name", "") == "fill-questionnaire" &&  _.has(currentRoute, "meta.getTokenFromUrl") &&
                                _.has(currentRoute, "query.token")
                                ) {
                                    let token = _.get(currentRoute, "query.token", "");
                                     let url = "/filled-case-details/" +this.$route.params.itemId + "?token=" + token;
                                //   window.location.href = window.location.origin+'/app'+url

                                    this.showToster({  message: "Questionnaire saved successfully",  isError: false,  });
                                
                                     this.$router.push(url) //petitionId

                                }else if (this.petition.questionnaireFilled) {
                                    this.showToster({ message: "Questionnaire updated successfully",   isError: false,  });

                                    if (this.checkProperty(this.petition, "rfeCase")) {
                                        this.$router.push("/rfe-petition-details/" + this.$route.params.itemId);
                                   } else {
                                      this.$router.push("/petition-details/" + this.$route.params.itemId);
                                    }
    
                                } else {
                                    
    
                                    if (!temp_save) {
                              
                                        this.questionnairePreview = false;
                                        this.$vs.loading.close();
                                        this.SuccessQuestionnaire = true;
                                        document.addEventListener("click", this.reloadthePage);
    
                                    } else {
                                        
                                        this.questionnairePreview = false;
                                       this.showToster({ message: "Questionnaire updated successfully",   isError: false,  });
                                        this.$vs.loading.close();

                                        if (this.checkProperty(this.petition, "rfeCase")) {
                                            this.$router.push("/rfe-petition-details/" + this.$route.params.itemId);
                                        } else {
                                            this.$router.push("/petition-details/" + this.$route.params.itemId);
                                        }
                                    }
    
                                }
    
                            }
                        }
    
                        this.$vs.loading.close();
    
                })
      
            },
            reloadthePage() {
                let routeTest = this.$route.params.itemId;
    
                var _self = this;
                if (this.SuccessQuestionnaire) {
                    this.SuccessQuestionnaire = false;
                }
                setTimeout(() => {
                    let currentRoute = _self.$route;
    
                    if (
                        _.get(currentRoute, "name", "") == "fill-questionnaire" &&
                        _.has(currentRoute, "meta.getTokenFromUrl") &&
                        _.has(currentRoute, "query.token")
                    ) {
                        let token = _.get(currentRoute, "query.token", "");
                        let url = "/filled-case-details/" + routeTest + "?token=" + token;
                        //   window.location.href = window.location.origin+'/app'+url
                        _self.$router.push(url);
                    } else {
                        if (_self.checkProperty(_self.petition, "rfeCase")) {
                            _self.$router.push("/rfe-petition-details/" + routeTest);
                        } else {
                            _self.$router.push("/petition-details/" + routeTest);
                        }
                    }
                }, 10);
            },
            goBack() {
                this.setActiveTab(this.tabslist[this.getIndexOfActivetab - 2].key)
    
            },
            updateHouseHoldTab(){
                if(this.canRenderField('inadmissibility', this.questionnaireDetails ,false,'beneficiaryInfo')){
                    if(this.checkProperty(this.petition, 'beneficiaryInfo', 'inadmissibility')){
                        if (this.canRenderField('houseHoldNumber', this.questionnaireDetails ,false,'beneficiaryInfo') || this.canRenderField('houseHoldAnnualIncome', this.questionnaireDetails ,false,'beneficiaryInfo') || 
                            this.canRenderField('houseHoldAnnualAssets', this.questionnaireDetails ,false,'beneficiaryInfo') || this.canRenderField('houseHoldAnnualliabilities', this.questionnaireDetails ,false,'beneficiaryInfo')) {
                            var index = _.find(this.tabslist, function (item) {
                                return item.key == "household"
                            })
                            if (index) {
                            } else {
                                this.tabslist.push({
                                    key: "household",
                                    name: "Household Info"
                                });
                                let householdIndex = this.tabslist.findIndex(tab => tab.key === "household");
                                let householdInfo = this.tabslist.splice(householdIndex, 1)[0];
                                let personalInfoIndex = this.tabslist.findIndex(tab => tab.key === "casedetails");
                                this.tabslist.splice(personalInfoIndex + 1, 0, householdInfo);
                            }
                        }
                    }else{
                        this.tabslist = _.filter(this.tabslist, function (item) {
                            return item.key != "household"
                        });
                        this.petition['beneficiaryInfo']['houseHoldNumber'] = null;
                        this.petition['beneficiaryInfo']['houseHoldAnnualIncome'] = null;
                        this.petition['beneficiaryInfo']['houseHoldAnnualAssets'] = null;
                        this.petition['beneficiaryInfo']['houseHoldAnnualliabilities'] = null;
                    }
                }
                this.tabslist = _.cloneDeep(this.tabslist);
            },
            updateTablist() {
         if (this.petition.beneficiaryInfo && 
    this.petition.beneficiaryInfo.maritalStatusDetails && 
    this.petition.beneficiaryInfo.maritalStatusDetails.id != 1 && 
    ((this.canRenderField('h4Required', this.questionnaireDetails, false, 'dependentsInfo.childrens') || 
      this.canRenderField('h4Required', this.questionnaireDetails, false, 'dependentsInfo.spouse')) ||
     (this.canRenderField('hasChildren', this.questionnaireDetails, false, 'dependentsInfo.childrens') || 
      this.canRenderField('hasSpouse', this.questionnaireDetails, false, 'dependentsInfo.spouse')) ||
      (this.canRenderField('l2Required', this.questionnaireDetails, false, 'dependentsInfo.childrens') || 
      this.canRenderField('l2Required', this.questionnaireDetails, false, 'dependentsInfo.spouse')))) {
                    var index = _.find(this.tabslist, function (item) {
    
                        return item.key == "dependentsinfo"
                    }) 
                    if (index) {
    
                    } else {
                        var docIndex = _.find(this.tabslist, function (item) {
                            return item.key == "documents"
                        })
                        if(docIndex){
                            this.tabslist.splice(this.tabslist.indexOf(docIndex),1)
                        }
                        var secondDocIndex = _.find(this.tabslist, function (item) {
                            return item.key == "documents"
                        })
                        if(!secondDocIndex){
                            this.tabslist.push({
                                key: "dependentsinfo",
                                name: "Dependents Info"
                            },
                            {
                                key: "documents",
                                name: "Documents"
                            })
                        }else{
                            this.tabslist.push({
                                key: "dependentsinfo",
                                name: "Dependents Info"
                            })
                        }
                       
                    }

                    
                } else {

                    this.tabslist = _.filter(this.tabslist, function (item) {
                        
                        return item.key != "dependentsinfo"
                    })
                }
                if(this.checkProperty(this.petition, 'subTypeDetails', 'id') == 16){

                    let wagesIndex = _.find(this.tabslist, function (item) {
                        
                        return item.key == "wageInfo"
                    })
                    let obj = {
                        key: "wageInfo",
                        name: "Wages as per W2"
                    }
                    
                    if(wagesIndex){
                        this.tabslist.splice(this.tabslist.indexOf(wagesIndex),1)
                        this.tabslist.push(obj)
                    }else{
                        this.tabslist.push(obj)
                    }
                        
                
                    // if(!wagesIndex && this.checkProperty(this.petition, 'subTypeDetails', 'id') == 16 ){
                    //     let obj = {
                    //         key: "wageInfo",
                    //         name: "Wages as per W2"
                    //     }
                    //     this.tabslist.push(obj)
                    // }
                }
                // let isExist = _.find(this.bendocslist ,{"key":'marriageCertificate'}); 
                // if(!isExist){
                //     this.bendocslist.push( { required: false,  key: "marriageCertificate", fieldName: 'marriageCertificate', label: "Marriage Certificate (if spouse is on H-1B, L-1, or F-1 status) " });
                // }
                // console.log(JSON.stringify(this.tabslist))
            },
            updateWagesTab(){
                let wagesIndex = _.find(this.tabslist, function (item) {
                    
                    return item.key == "wageInfo"
                })
                if(!wagesIndex && this.checkProperty(this.petition, 'subTypeDetails', 'id') == 16 ){
                    let obj = {
                        key: "wageInfo",
                        name: "Wages as per W2"
                    }
                    this.tabslist.push(obj)
                }
            },
            formatName(item) {
    
                var _t = '';
                if (item.name != '' && item.name != null) return _t.name;
                if (item.first_name != null && item.first_name != '') _t = item.first_name;
                if (item.middle_name != null && item.middle_name != '') _t + " " + item.middle_name;
                if (item.last_name != null && item.last_name != '') _t + " " + item.last_name;
    
                return _t;
            },
            validateandScroll() {
                
                // console.log(JSON.stringify(this.errors));
                // // {"vmId":2164,"items":[{"id":"277","vmId":2164,"field":"resume","msg":"*Document(s) is required","rule":"required","scope":"documentsform"}]}
                // if(this.checkProperty(this.errors, 'items') && this.checkProperty(this.errors, 'items', 'length')>0){
                //     let findObj = _.find(this.errors['items'],{'rule':'required'});
                //     if(findObj ){
                //         console.log(JSON.stringify(findObj))
                //         findObj['id'].scrollIntoView({ behavior: 'smooth', block: 'start' });
                //         const firstError = document.getElementById(findObj['id']);;
                //         console.log(JSON.stringify(firstError))
                //         if(firstError){
                //             firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                //         }
                //     }
                // }
                var $self = this;
                const $ = JQuery;
                var el = _.find(this.errors["items"], function (item) {
                    return item.scope == $self.currentTab + "form"
                })
                var _top = 0;
                if (el) {
                    const ele = $("[name=" + el.field + "]").parents(".vx-col");
                    if (ele) {
                        _top = ele.position().top;
                    }
                }
                if(el&&_top<=0){
                    const ele = $("[name=" + el.field + "]").parents(".vx-row");
                    if (ele) {
                        _top = ele.position().top;
                    }
                }
                //console.log('_top',_top)
                document.getElementById("scrollableques").scrollTo({
                    top: _top,
                    left: 0,
                    behavior: 'smooth'
                })
    
            },
            setActiveTab(item, validate = false) {
                //this.currentTab = item;
                if (validate) {
                    this.$validator.validateAll(this.currentTab + "form").then((result) => {
                        if (result) {
                             if(item  == "documents"){
                                this.checkMarriageCerti();
                            }
                            if( this.checkEducationTab()){
                                this.currentTab = item;
                                document.getElementById("scrollableques").scrollTo({
                                    top: 0,
                                    left: 0,
                                    behavior: 'smooth'
                                })
                            }
                            else{
                                this.showToster({
                                    message:  this.educationErrorMsg,
                                    isError: true,
                                });
                            }
                        } else {
    
                            this.validateandScroll()
    
                        }
    
                    })
                } else {
                    this.currentTab = item;
    
                    setTimeout(function () {
                        document.getElementById("scrollableques").scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        })
                    }, 500)
    
                }
               
    
            },
            changeBfProvince(value) {
                this.petition.beneficiaryInfo.countryOfBirth = this.petition.beneficiaryInfo.countryOfBirthDetails.id;
                if(!this.firstTimeLoading){
                    this.petition.beneficiaryInfo.provinceOfBirth = null
                    this.petition.beneficiaryInfo.provinceOfBirthDetails = null;
                }
                
                this.bfeprovinceStates = [];
    
                this.loadStatesByCountry('bfeprovinceStates', value.id)
            },
            setGlobalLoadingVar(){
                let self = this;
                setTimeout(()=>{
                    self.firstTimeLoading = false
                },2000)
            },
            changeCountryMarriage(value){
    
                this.petition.beneficiaryInfo.countryOfMarriage = this.petition.beneficiaryInfo.countryOfMarriageDetails.id;
                if(this.firstTimeLoading){
                    this.petition.beneficiaryInfo.provinceOfMarriage = null;
                    this.petition.beneficiaryInfo.provinceOfMarriageDetails = null;
                }
                
                this.statesOfMarriage = [];
    
                this.loadStatesByCountry('statesOfMarriage', value.id)
            },
            setOutsideAddress() {
    
                if (this.petition.beneficiaryInfo.currentlyInUS) {
                    this.petition.beneficiaryInfo.addressOutsideUS = {
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: null,
                        zipcode: null
                    };
                } 
                // else {
    
                //     this.petition.beneficiaryInfo.addressOutsideUS = {
                //         line1: null,
                //         line2: null,
                //         aptType: null,
                //         locationId: null,
                //         locationDetails: null,
                //         stateId: null,
                //         stateDetails: null,
                //         countryId: null,
                //         countryDetails: null,
                //         zipcode: null
                //     };
                // }
    
            },
            addOtherNames() {
                let item = {
                    firstName: "",
                    middleName: "",
                    lastName: ""
                };
                this.petition.beneficiaryInfo["otherNames"].push(item);
            },
            removeOtherName(index) {
                this.petition.beneficiaryInfo["otherNames"].splice(index, 1);
            },
            resetOtherNames($event) {
                this.petition.beneficiaryInfo["otherNames"] = [];
                this.addOtherNames();
    
            },
            validateScope() {
                this.$validator.validateAll("casedetailsform").then((result) => {
    
                    this.validateandScroll();
                })
            },
            loadStatesByCountry(model, countryId) {
                this.$store.dispatch("getstates", countryId).then((response) => {
                    switch (model) {
                        case "bfeprovinceStates":
                            this.bfeprovinceStates = response;
                            break;
                        case "usastates":
                            this.usastates = response; 
                        break;
                        case "statesOfMarriage":
                            this.statesOfMarriage = response;
                        break;
                        case "instituteStates":
                            this.instituteStates = response;
                        break;    
                    }
                });
            },
            searchLocations() {
                let self = this;
                clearTimeout(this.debounce)
                this.debounce = setTimeout(() => {
                    self.loadinstitueCitiStateId(val);
                }, 900)
            },

            loadinstitueCitiStateId(val) {
                let selectedVal = this.petition['beneficiaryInfo']['periodOfInstutions'][val];
                if(selectedVal && this.checkProperty(selectedVal, 'stateDetails', 'id')){
                    let stateId = this.checkProperty(selectedVal, 'stateDetails', 'id');
                    this.$store.dispatch("getlocations", {countryId: 231, stateId: stateId})
                    .then((response) => {
                        selectedVal['instituteLocations'] = response;
                        _.forEach(this.petition['beneficiaryInfo']['periodOfInstutions'], (ite, key)=>{
                            if(key == val){
                                ite['instituteLocations'] = response;
                            }
                        })
                        this.petition['beneficiaryInfo']['periodOfInstutions'] = _.cloneDeep(this.petition['beneficiaryInfo']['periodOfInstutions'])
                    })
                    .catch(() => {});
                }

                // this.instituteLocations = [];
                // let stateId = this.checkProperty(val, 'id');
                // if(stateId){
                //     this.$store.dispatch("getlocations", {countryId: 231, stateId: stateId})
                //     .then((response) => {
                //         this.instituteLocations = response;
                //     })
                //     .catch(() => {});
                // }
            },
            setTheInitData() {
                var $self = this;
                if (this.petition.beneficiaryInfo.countryOfBirthDetails && this.petition.beneficiaryInfo.countryOfBirth != null) {
    
                    this.loadStatesByCountry('bfeprovinceStates', this.petition.beneficiaryInfo.countryOfBirth)
    
                }
                
                let provinceOfBirth = this.checkProperty(this.petition ,'beneficiaryInfo' ,'provinceOfBirth');
                   if (provinceOfBirth != null) { 
                     let provinceOfBirthDetails = _.find(this.bfeprovinceStates, function (item) {  return item.id == provinceOfBirth  })
                         if(provinceOfBirthDetails){
                             this.petition.beneficiaryInfo.provinceOfBirthDetails = provinceOfBirthDetails;
                         }
                    }
                let highestDegree = this.checkProperty(this.petition['beneficiaryInfo'],'education','highestDegree');
                if (highestDegree != null) {
                    let highestDegreeDetails  = _.find(this.petition.highestDegreeList, function (item) {return item.id == highestDegree})
                    if(highestDegreeDetails){
                        this.petition.beneficiaryInfo.education.highestDegreeDetails = highestDegreeDetails
                    }
                    
                }else{
                    this.petition.beneficiaryInfo.education.highestDegree = null;
                    this.petition.beneficiaryInfo.education.highestDegreeDetails = null
                }
                if(!this.checkProperty(this.petition['beneficiaryInfo'],'education','highestDegree')){
                    this.petition.beneficiaryInfo['education'] = {
                        highestDegree: null,
                        highestDegreeDetails: null,
                        majorFieldOfStudy: ''
                    }
                }
    
                let curNonImmigrantVisaStatus = this.petition.beneficiaryInfo.curNonImmigrantVisaStatus;
                if (curNonImmigrantVisaStatus != null) {
                    this.petition.beneficiaryInfo.curNonImmigrantVisaStatusDetails = _.find(this.petition.visaStatusList, function (item) {
    
                        return item.id == curNonImmigrantVisaStatus
                    })
                }
    
                if (this.petition.beneficiaryInfo.priorPeriodOfStayInUS && this.petition.beneficiaryInfo.priorPeriodOfStayInUS.length == 1 && this.petition.beneficiaryInfo.priorPeriodOfStayInUS[0].departedDate == null && this.petition.beneficiaryInfo.priorPeriodOfStayInUS[0].enteredDate == null) {
    
                    this.petition.beneficiaryInfo.priorPeriodOfStayInUS = [{
                        _id: 0,
                        enteredNumber: null,
                        departedNumber: null,
                        visaStatus: null,
                        visaStatusDetails: null,
                        noOfDays: null,
                        dateerror: null
                    }]
                }
                if(!_.has(this.petition.beneficiaryInfo,'previousSpouse') || (_.has(this.petition.beneficiaryInfo,'previousSpouse') && !this.checkProperty(this.petition.beneficiaryInfo,'previousSpouse'))){
                    this.petition.beneficiaryInfo['previousSpouse'] = {
                        hasOtherNames:null,
                        otherNames: [{
                            _id: 0,
                            name: '',
                            firstName: '',
                            middleName: '',
                            lastName: '',
                        }],
                        maidenName:'',
                        marriageEndedDueTo:null,
                        marriageEndedOtherInfo:'',
                        firstName: '',
                        middleName: '',
                        lastName: '',
                        dateOfBirth: null,
                        dateOfMarriage:null,
                        dateOfMarriageEnd:null,

                        //Place of Marriage
                        countryOfMarriage: '',
                        countryOfMarriageDetails: null,
                        provinceOfMarriage: '',
                        provinceOfMarriageDetails: null,
                        locationOfMarriage: '',

                        //Place of Termination
                        countryOfMarriageTermination: '',
                        countryOfMarriageTerminationDetails: null,
                        provinceOfMarriageTermination: '',
                        provinceOfMarriageTerminationDetails: null,
                        locationOfMarriageTermination: '',
                        obtainPermResidenceThroughSpouse:null  
                    }
                }
                if (this.petition.beneficiaryInfo && this.petition.beneficiaryInfo.educations == null) {
                    this.petition.beneficiaryInfo.educations = [{
                        _id: 0,
                        name: null,
                        address: {
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        highestDegree: null,
                        highestDegreeDetails: null,
                        majorFieldOfStudy: null,
                        attendedFrom: null,
                        attendedTo: null,
                        graduatedYear: null,
                        degreereceived: null,
                        isAccredited: null,
                        graduatedDate:null,
                        isForProfit: null
                    }]
                }
                if(this.petition.dependentsInfo && this.petition.dependentsInfo.spouse && this.petition.dependentsInfo.spouse.prevEmploymentInfo == null){
                    this.petition.dependentsInfo.spouse.prevEmploymentInfo = [{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null, 
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            salary: null,
                            currentEmployer: true
                        }]
                        this.spouse.prevEmploymentInfo = [{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null, 
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            salary: null,
                            currentEmployer: true
                        }]
                }
                if(!_.has(this.petition,'motherInfo') || !this.checkProperty(this.petition,'motherInfo')){
                    this.petition['motherInfo']= { 
                        name: '', 
                        firstName: '', 
                        middleName: '', 
                        lastName: '', 
                        hasOtherNames: null, 
                        otherNames: [{ 
                            _id: 0, 
                            name: '', 
                            firstName: '', 
                            middleName: '', 
                            lastName: '', 
                        }], 
                        dateOfBirth: null, 
                        countryOfBirth: '', 
                        countryOfBirthDetails: null, 
                        provinceOfBirth: '', 
                        provinceOfBirthDetails: null, 
                        locationOfBirth: '', 
                        currentAddress: {
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: null,
                        zipcode: null
                    },
                        isUSCitizen: null, 
                        dateFromUSCitizen: null, //["", ""],
                        nameAtBirth:{
                            firstName: '', 
                            middleName: '', 
                            lastName: '',
                        },
                        deceasedCity: '',
                        deceasedCityDetails:null,
                        deceasedDate: null,
                    }
                }
                if(!_.has(this.petition,'fatherInfo') || !this.checkProperty(this.petition,'fatherInfo')){
                    this.petition['fatherInfo']= { 
                        name: '', 
                        firstName: '', 
                        middleName: '', 
                        lastName: '', 
                        hasOtherNames: null, 
                        otherNames: [{ 
                            _id: 0, 
                            name: '', 
                            firstName: '', 
                            middleName: '', 
                            lastName: '', 
                        }], 
                        dateOfBirth: null, 
                        countryOfBirth: '', 
                        countryOfBirthDetails: null, 
                        provinceOfBirth: '', 
                        provinceOfBirthDetails: null, 
                        locationOfBirth: '', 
                        currentAddress: {
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: null,
                        zipcode: null
                    },
                        isUSCitizen: null, 
                        dateFromUSCitizen: null, //["", ""],
                        nameAtBirth:{
                            firstName: '', 
                            middleName: '', 
                            lastName: '',
                        },
                        deceasedCity: '',
                        deceasedCityDetails:null,
                        deceasedDate: null,
                    }
                }
                if (this.petition.beneficiaryInfo && this.petition.beneficiaryInfo.prevEmploymentInfo == null) {
                    this.petition.beneficiaryInfo.prevEmploymentInfo = [{
                        _id: 0,
                        employerName: '',
                        address: {
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        businessType: null,
                        jobTitle: null,
                        jobDuties: null,
                        startDate: null,
                        endDate: null,
                        salary:null,
                        currentEmployer: false
                    }]
                }
                if (this.petition.beneficiaryInfo && this.petition.beneficiaryInfo.consulateInfo == null) {
    
                    this.petition.beneficiaryInfo.consulateInfo = {
                        locationId: null,
                        locationDetails: null,
                        // stateId: null,
                        // stateDetails: null,
                        countryId: null,
                        countryDetails: null
                    }
    
                }
                // this.canRenderField('ben_educations', this.questionnaireDetails)
                if (false && this.canRenderField('i485AdditionalInformation', this.questionnaireDetails ,false,'beneficiaryInfo')) {
    
                    var index = _.find(this.tabslist, function (item) {

                        return item.key == "additional"
                    })
                    if (index) {

                    } else {
                        this.tabslist.push({
                            key: "additional",
                            name: "Additional Info"
                        })
                    }

                }
                if (this.canRenderField('inadmissibility', this.questionnaireDetails ,false,'beneficiaryInfo') && this.checkProperty(this.petition, 'beneficiaryInfo', 'inadmissibility') && (this.canRenderField('houseHoldNumber', this.questionnaireDetails ,false,'beneficiaryInfo') || this.canRenderField('houseHoldAnnualIncome', this.questionnaireDetails ,false,'beneficiaryInfo') || 
                this.canRenderField('houseHoldAnnualAssets', this.questionnaireDetails ,false,'beneficiaryInfo') || this.canRenderField('houseHoldAnnualliabilities', this.questionnaireDetails ,false,'beneficiaryInfo'))) {
                    var index = _.find(this.tabslist, function (item) {
                        return item.key == "household"
                    })
                    if (index) {
                    } else {
                        this.tabslist.push({
                            key: "household",
                            name: "Household Info"
                        })
                    }
                }
                if (this.canRenderField('educations', this.questionnaireDetails ,false,'beneficiaryInfo.educations')) {
    
                    var index = _.find(this.tabslist, function (item) {
    
                        return item.key == "education"
                    })
                    if (index) {
    
                    } else {
                        this.tabslist.push({
                            key: "education",
                            name: "Educational Info"
                        })
                    }
    
                }
                //this.canRenderField('ben_prevEmploymentInfo', this.questionnaireDetails)
                if (this.canRenderField('prevEmploymentInfo', this.questionnaireDetails,false,'beneficiaryInfo.prevEmploymentInfo')) {
    
                    var index = _.find(this.tabslist, function (item) {
    
                        return item.key == "employment"
                    })
                    if (index) {
    
                    } else {
                        this.tabslist.push({
                            key: "employment",
                            name: "Employment Info"
                        })
                    }
    
                }
                if (this.canRenderField('fatherInfo', this.questionnaireDetails,false,'fatherInfo') || this.canRenderField('motherInfo', this.questionnaireDetails,false,'motherInfo')) {
    
                    var index = _.find(this.tabslist, function (item) {
                    
                        return item.key == "parent"
                    })
                
                    if (index) {

                    } else {
                        this.tabslist.push({
                            key: "parent",
                            name: "Parents Info"
                        })
                    }

                }
                if (false && (this.canRenderField('benfAssets', this.questionnaireDetails ,false,'beneficiaryInfo.benfAssets') || this.canRenderField('benfIncome', this.questionnaireDetails ,false,'beneficiaryInfo.benfIncome'))) {
                    var index = _.find(this.tabslist, function (item) {
                        return item.key == "financial"
                    })
                    if (index) {
                    } else {
                        this.tabslist.push({
                            key: "financial",
                            name: "Financial Info"
                        })
                    }
                }
                if(!_.has(this.petition['beneficiaryInfo'], 'officeAddress') || !this.checkProperty(this.petition['beneficiaryInfo'], 'officeAddress') || this.checkProperty(this.petition['beneficiaryInfo'], 'officeAddress') == null){
                    this.petition['beneficiaryInfo']['officeAddress'] = {
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: null,
                        zipcode: null
                    }
                }
                // if(!_.has(this.petition['beneficiaryInfo'], 'benfIncome') || !this.checkProperty(this.petition['beneficiaryInfo'], 'benfIncome') 
                // || this.checkProperty(this.petition['beneficiaryInfo'], 'benfIncome') == [] || this.checkProperty(this.petition['beneficiaryInfo'], 'benfIncome') == null){
                //     this.petition['beneficiaryInfo']['benfIncome'] = {
                //         firstName: '',
                //         lastName: '',
                //         middleName: '',
                //         dateOfBirth: null,
                //         relToTheBenf: '',
                //         amount: ''
                //     }
                // }
                // if(!_.has(this.petition['beneficiaryInfo'], 'benfAssets') || !this.checkProperty(this.petition['beneficiaryInfo'], 'benfAssets') 
                // || this.checkProperty(this.petition['beneficiaryInfo'], 'benfAssets') == [] || this.checkProperty(this.petition['beneficiaryInfo'], 'benfAssets') == null){
                //     this.petition['beneficiaryInfo']['benfAssets'] = {
                //         firstName: '',
                //         lastName: '',
                //         middleName: '',
                //         typeOfAsset: '',
                //         amount: ''
                //     }
                // }

    
                var index = _.find(this.tabslist, function (item) {
    
                    return item.key == "documents"
                })
                if (index) {
    
                } else {
                    this.tabslist.push({
                        key: "documents",
                        name: "Documents"
                    })
                }
    
                this.updateTablist()
                this.featureDates = new Date();
    
                if (this.petition.dependentsInfo.childrens && this.petition.dependentsInfo.childrens.length > 0 && this.petition.dependentsInfo.childrens[0].firstName != '' && this.petition.dependentsInfo.childrens[0].firstName != null) {
                    this.petition.h4RequiredForChild = true;
                    this.petition.hasChildren = true;
                    if(this.canRenderField('l2Required', this.questionnaireDetails ,false,'dependentsInfo.childrens')){ 
                        this.petition.l2Required = true;
                    }
                }
    
                this.petition.dependentsInfo.childrens.forEach((element, index) => {
                    if(!_.has(element,'anyOtherPersonEmployedInUS')){
                        Object.assign(element,{'anyOtherPersonEmployedInUS':false})
                    }
                    if(!_.has(element,'prevEmploymentInfo') || (element && element['prevEmploymentInfo'] && element['prevEmploymentInfo'] == null) ){
                        Object.assign(element,{'prevEmploymentInfo':[{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null, 
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            salary: null,
                            currentEmployer: true
                        }]})
                    }
                    if (element.firstName != '' && element.firstName != null) {
                        this.petition.dependentsInfo.childrens[index].saved = true;
                    }
    
                });
    
                if (this.petition.dependentsInfo.spouse.firstName != null && this.petition.dependentsInfo.spouse.firstName != '') {
    
                    this.petition.dependentsInfo.spouse.saved = true;
                    this.spouse.saved = true;
                }
    
                  
                    if(this.checkProperty( this.petition.beneficiaryInfo ,'nonImmPetitionsInfo' ,'length')>0){
                    this.petition.beneficiaryInfo.nonImmPetitionsInfo.forEach(function (item, index) {
                        
                        $self.petition.beneficiaryInfo.nonImmPetitionsInfo[index].visaStatusDetails = _.find($self.petition.visaStatusList, function (aitem) {
    
                            return aitem.id == item.visaStatus
                        })
                        })
                   }
                   if(this.petition.beneficiaryInfo.priorPeriodOfStayInUS && this.checkProperty(this.petition['beneficiaryInfo'],'priorPeriodOfStayInUS','length')>0){
                     this.petition.beneficiaryInfo.priorPeriodOfStayInUS.forEach(function (item, index) {
                    
                   $self.petition.beneficiaryInfo.priorPeriodOfStayInUS[index].visaStatusDetails = _.find($self.petition.visaStatusList, function (aitem) {
    
                        return aitem.id == item.visaStatus
                    })
                    })
                }
                setTimeout(()=>{
                    $self.mamageVisaStatusDocuments();
                } ,500);
                this.$vs.loading.close();
                this.setGlobalLoadingVar();
                setTimeout(()=>{
                    $self.getWageReturnYearDetails();
                    $self.updateWagesTab()
                },10)
            },
            getCountries(){
                this.$store.dispatch("getcountries").then((response) => {
                    this.countries = response;
    
                });
            },
            init(callFromMounted=false) {
                
                this.$store
                    .dispatch("getpetition", this.$route.params.itemId)
                    .then((response) => {
                        if(response && response.data && response.data.result){
                            if(this.checkProperty(response.data.result['beneficiaryInfo'], 'prevH1bCaseStatus')){
                                let dtval = this.checkProperty(response.data.result['beneficiaryInfo'], 'prevH1bCaseStatus')
                                let findObj = _.find(this.prevH1bCaseStatusList,{'id':dtval});
                                response.data.result['beneficiaryInfo']['prevH1bCaseStatus']  = findObj;
                            }
                          if(this.checkProperty( response.data.result ,'subTypeDetails' ,'id') ==16){
    
                                let tempI140Data ={
                                        "beneficiaryInfo":{
    
                                            immPetitionPriorityDate: null, // list your Priority Date obtained from your previous immigrant petition
                                            applyI485AdjOrConsuProcess: false, // Would you like to apply for adjustment of status (I-485) or consular processing? { type: Boolean, default: false },
                                            adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                                            consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                                            areYouUnderRemoveOfIndOrUscis: null, // Are you currently under removal proceedings by the INS/USCIS? { type: Boolean, default: false },
                                            anyImmPetitionFiled:false,
                                        } 
                                }
    
                                var data = _.merge(this.petition, tempI140Data);
                               this.petition = data;
                               if(_.has(this.petition,'dependentsInfo') && this.checkProperty(this.petition,'dependentsInfo','spouse')){
                                this.spouse = _.cloneDeep(this.petition.dependentsInfo.spouse);
                                if((_.has(this.spouse,'phoneCountryCode') && !this.checkProperty(this.spouse,'phoneCountryCode')) || !_.has(this.spouse,'phoneCountryCode')  ){
                                    this.spouse['phoneCountryCode']= {
                                        countryCode: '',
                                        countryCallingCode: ''
                                    }
                                }
                                if((_.has(this.spouse,'height') && !this.checkProperty(this.spouse,'height')) || !_.has(this.spouse,'height')  ){
                                    this.spouse['height']= {
                                        feet: '',
                                        inches: ''
                                    }
                                }
                               }
                               setTimeout(()=>{
                                if(  this.checkProperty(this.petition ,'beneficiaryInfo' ,'adjustmentOfI485Status') || this.checkProperty(this.petition,'beneficiaryInfo','consularProcessing')){
                                   
                                    this.consularProcessingValidator ='consularProcessingValidator';
                                }
    
                               });
                              

    
                         //   alert(this.petition['beneficiaryInfo']['areYouUnderRemoveOfIndOrUscis'])
                        
                          }else{
                            this.consularProcessingValidator ='consularProcessingValidator';
                          }
                           let tempDocs=[];
                          _.forEach(this.bendocslist ,(docs)=>{
                            tempDocs.push(docs);
                          });
                          if(this.checkProperty(response['data'], 'result') && this.checkProperty(response['data']['result'], 'sponsorInfo') && this.checkProperty(response['data']['result'], 'typeDetails') 
                          && this.checkProperty(response['data']['result'], 'typeDetails', 'id') == 4 && this.checkProperty(response['data']['result'], 'subTypeDetails', 'id') == 18  ){
                            let sponsorInfoResult = this.checkProperty(response['data']['result'], 'sponsorInfo');
                            if(_.has(sponsorInfoResult, 'filingThisPetitionerFor') && this.checkProperty(sponsorInfoResult, 'filingThisPetitionerFor') ){
                                // 'Spouse','Father','Mother','Sibiling','Child'
                                if(this.checkProperty(sponsorInfoResult, 'filingThisPetitionerFor') == 'Spouse'){
                                    let spouseDocs=[
                                        {
                                            key: 'sponsorSpousePassport',
                                            fileUploading:false,
                                            fieldName: 'sponsorSpousePassport',
                                            required: false,
                                            label: 'Copy of all the pages of the passport of your spouse (including the blank pages)'
                                        },
                                        {
                                            key: 'sponsorSpouseMarriageCertificate',
                                            fileUploading:false,
                                            fieldName: 'sponsorSpouseMarriageCertificate',
                                            required: false,
                                            label: 'Copy of the Marriage Certificate'
                                        },
                                        {
                                            key: 'sponsorSpouseBirthCertificate',
                                            fileUploading:false,
                                            fieldName: 'sponsorSpouseBirthCertificate',
                                            required: false,
                                            label: 'Copy of the Birth Certificate of the Spouse'
                                        },
                                        {
                                            key: 'sponsorSpouseMarriagePhotographs',
                                            fileUploading:false,
                                            fieldName: 'sponsorSpouseMarriagePhotographs',
                                            required: false,
                                            label: 'Photographs of the marriage and after marriage photographs of the couples '
                                        },
                                        {
                                            key: 'sponsorSpouseAffidavits',
                                            fileUploading:false,
                                            fieldName: 'sponsorSpouseAffidavits',
                                            required: false,
                                            label: 'Affidavits from the parents of you and your spouse confirming your bona fide marital relationship'
                                        },
                                        {
                                            key: 'sponsorSpouseMartialRelationship',
                                            fileUploading:false,
                                            fieldName: 'sponsorSpouseMartialRelationship',
                                            required: false,
                                            label: 'Any other document that show the ongoing martial relationship'
                                        },
                                        {
                                            key: 'sponsorSpousePhotographs',
                                            fileUploading:false,
                                            fieldName: 'sponsorSpousePhotographs',
                                            required: false,
                                            label: 'Two (2) passport sized photographs of your spouse'
                                        },
                                    ];
                                    _.forEach(spouseDocs, (doc)=>{
                                        let findObj = _.find(tempDocs, {'fieldName':doc['fieldName']});
                                        if(!findObj){
                                            tempDocs.push(doc);
                                        }
                                    })
                                }
                                if(this.checkProperty(sponsorInfoResult, 'filingThisPetitionerFor') == 'Father'){
                                    let fatherDocs=[
                                        {
                                            key: 'sponsorFatherPassport',
                                            fileUploading:false,
                                            fieldName: 'sponsorFatherPassport',
                                            required: false,
                                            label: 'Copy of all the pages of the passport of your father (including the blank pages)'
                                        },
                                        {
                                            key: 'sponsorFatherBirthCertificate',
                                            fileUploading:false,
                                            fieldName: 'sponsorFatherBirthCertificate',
                                            required: false,
                                            label: 'Copy of your birth certificate showing your name and your parents’ names'
                                        },
                                        {
                                            key: 'sponsorFatherParentsMarriageCertificate',
                                            fileUploading:false,
                                            fieldName: 'sponsorFatherParentsMarriageCertificate',
                                            required: false,
                                            label: 'Copy of your parent’s marriage certificate establishing that your father was married to your mother before you were born.  If marriage certificate is not available, please provide affidavits from two persons who have the personal knowledge of your parents’ marriage and your birth.'
                                        },
                                    ]
                                    _.forEach(fatherDocs, (doc)=>{
                                        let findObj = _.find(tempDocs, {'fieldName':doc['fieldName']});
                                        if(!findObj){
                                            tempDocs.push(doc);
                                        }
                                    })
                                }
                                if(this.checkProperty(sponsorInfoResult, 'filingThisPetitionerFor') == 'Mother'){
                                    let motherDocs=[
                                        {
                                            key: 'sponsorMotherPassport',
                                            fileUploading:false,
                                            fieldName: 'sponsorMotherPassport',
                                            required: false,
                                            label: 'Copy of all the pages of the passport of your mother (including the blank pages)'
                                        },
                                        {
                                            key: 'sponsorMotherBirthCertificate',
                                            fileUploading:false,
                                            fieldName: 'sponsorMotherBirthCertificate',
                                            required: false,
                                            label: 'Copy of your birth certificate showing your name and your mother’s'
                                        },
                                    ];
                                    _.forEach(motherDocs, (doc)=>{
                                        let findObj = _.find(tempDocs, {'fieldName':doc['fieldName']});
                                        if(!findObj){
                                            tempDocs.push(doc);
                                        }
                                    })
                                }
                                if(this.checkProperty(sponsorInfoResult, 'filingThisPetitionerFor') == 'Sibling'){
                                    let sibilinDocs=[
                                        {
                                            key: 'sponsorSiblingPassport',
                                            fileUploading:false,
                                            fieldName: 'sponsorSiblingPassport',
                                            required: false,
                                            label: 'Copy of all the pages of the passport of your sibling (including the blank pages)'
                                        },
                                        {
                                            key: 'sponsorSiblingBirthCertWithParents',
                                            fileUploading:false,
                                            fieldName: 'sponsorSiblingBirthCertWithParents',
                                            required: false,
                                            label: 'Copy of your birth certificate showing your name and your parents’ names'
                                        },
                                        {
                                            key: 'sponsorSiblingBirthCertificate',
                                            fileUploading:false,
                                            fieldName: 'sponsorSiblingBirthCertificate',
                                            required: false,
                                            label: 'Copy of your sibling’s birth certificate '
                                        },
                                        {
                                            key: 'sponsorSiblingBffidavits',
                                            fileUploading:false,
                                            fieldName: 'sponsorSiblingBffidavits',
                                            required: false,
                                            label: 'Affidavits from the parents of you and your sibling confirming your relationship (format will be provided by our office)'
                                        },
                                    ];
                                    _.forEach(sibilinDocs, (doc)=>{
                                        let findObj = _.find(tempDocs, {'fieldName':doc['fieldName']});
                                        if(!findObj){
                                            tempDocs.push(doc);
                                        }
                                    })
                                }
                                if(this.checkProperty(sponsorInfoResult, 'filingThisPetitionerFor') == 'Child'){
                                    let childDocs=[
                                        {
                                            key: 'sponsorChildPassport',
                                            fileUploading:false,
                                            fieldName: 'sponsorChildPassport',
                                            required: false,
                                            label: 'Copy of all the pages of the passport of your child (including the blank pages)'
                                        },
                                        {
                                            key: 'sponsorChildBirthCertWithParents',
                                            fileUploading:false,
                                            fieldName: 'sponsorChildBirthCertWithParents',
                                            required: false,
                                            label: 'Copy of your child’s birth certificate showing child’s name both parents’ name, and your marriage certificate to the child’s mother- if you are the child’s father'
                                        },
                                        {
                                            key: 'sponsorChildBirthCertificate',
                                            fileUploading:false,
                                            fieldName: 'sponsorChildBirthCertificate',
                                            required: false,
                                            label: 'Copy of your child’s birth certificate showing child’s name and your name- if you are the child’s mother'
                                        },
                                    ]
                                    _.forEach(childDocs, (doc)=>{
                                        let findObj = _.find(tempDocs, {'fieldName':doc['fieldName']});
                                        if(!findObj){
                                            tempDocs.push(doc);
                                        }
                                    })
                                }
                            }
                          }
                            let currentRoute = this.$route;
                            let token = '';
                            if(_.get(currentRoute, "name", "") == "fill-questionnaire" &&  _.has(currentRoute, "meta.getTokenFromUrl") && _.has(currentRoute, "query.token") ) {
                                token = _.get(currentRoute, "query.token", "");
                                if(token){
                                    let payLoad = { apiToken:token };
                                    let path = '/auth/verify-token';
                                    this.$store.dispatch("commonAction", { "data": payLoad, "path": path }).then((res)=>{
                                    if(res){
                                        this.$store.commit('updateAnonymousUserData', res);
                                    }
                                    }).catch((err)=>{})
                                }
                            }
                            this.getConsentDetails();
                            if(response.data.result && this.checkProperty(response.data.result,'subTypeDetails','id') == 18 && this.checkProperty(response.data.result, 'isFillBenfQuestionnaire')&& response.data.result.isFillBenfQuestionnaire && this.checkProperty(this.$route ,'name') =='fill-questionnaire' && token !='' && token != null){
                                this.$router.push("/filled-case-details/" + this.$route.params.itemId+ "?token=" + token);              
                            }
                            if(this.checkProperty(response['data']['result'], 'questionnaireFilled') && this.checkProperty(response.data.result,'subTypeDetails','id') != 18 && this.checkProperty(this.$route ,'name') =='fill-questionnaire' && token !='' && token != null){
                                this.$router.push("/filled-case-details/" + this.$route.params.itemId+ "?token=" + token);
                            }
                          //gc 485 tabs
                          if(true){
    
                               let tempTabs = [];
                               _.forEach(this.tabslist ,(tabItem)=>{
                                 if(tabItem['key']=='casedetails'){
                                    tempTabs.push(tabItem);
                                    // if(!_.find(this.tabslist ,{'key':"address"})){
                                    //     tempTabs.push({  key: "address", name: "Address" });
                                    // }  
                                    
                                    // if(!_.find(this.tabslist ,{'key':"immigration"})){
                                    //     tempTabs.push({  key: "immigration", name: "Immigration" });
                                    // } 
                                    // if(!_.find(this.tabslist ,{'key':"assets&financials"})){
                                    //     tempTabs.push({  key: "assets&financials", name: "Assets & Financials" });
                                    // } 
                                    // if(!_.find(this.tabslist ,{'key':"parents"})){
                                    //     tempTabs.push({  key: "parents", name: "Parents" });
                                    // }
                                     if(!_.find(this.tabslist ,{'key':"parent"})){
                                        tempTabs.push({  key: "parent", name: "Parents Info" });
                                    }
                                         
                                    
                               }else{
                                tempTabs.push(tabItem);
                               }
    
    
    
                               });
                               //this.tabslist = _.cloneDeep(tempTabs)
    
                                // this.tabslist.push({
                                // key: "employment",
                                // name: "Employment Info"
                                // })
                                   
    
                          }
                          if(this.checkProperty( response.data.result ,'subTypeDetails' ,'id') ==16){
                                    // tempDocs.push({
                                    //     required: false,
                                    //     key: "w2",
                                    //     fieldName: 'w2',
                                    //     label: "Copy of W-2 Forms issued for all tax years till present.",
                                    //     display:true,
                                    //     }
                                    // );
                                    // tempDocs.push({
                                    //     required: false,
                                    //     key: "slgEvalOfEduCredentials",
                                    //     fieldName: 'slgEvalOfEduCredentials',
                                    //     label: "Education Evaluation and Education+Experience Evaluation.",
                                    //     display:true,
                                    // });
                                   // tempDocs.push();
    
    
                         }

                                                  
                        
                          this.bendocslist =[];
                          this.bendocslist =tempDocs;
    
    
                            var data = _.merge(this.petition, response.data.result);
                              
                        // if(this.checkProperty(data ,'beneficiaryInfo' ,'haveYouEverTravelledToUS' )){
                        //     data['beneficiaryInfo']['haveYouEverTravelledToUS'] ="Yes";
                        // }
                        // if(this.checkProperty(data ,'beneficiaryInfo' ,'haveYouEverTravelledToUS' ) ==false){
                        //     data['beneficiaryInfo']['haveYouEverTravelledToUS'] ="No";
                        // }
                        this.petition = data;
                        if(_.has(this.petition, 'dependentsInfo') && _.has(this.petition['dependentsInfo'], 'childrens') && this.checkProperty(this.petition, 'dependentsInfo', 'childrens')
                        && this.checkProperty(this.petition['dependentsInfo'], 'childrens','length')>0 ){
                            _.forEach(this.petition['dependentsInfo']['childrens'], (chIt)=>{
                                if(!_.has(chIt,'currentAddress')){
                                    chIt['currentAddress'] = {
                                        line1: null,
                                        line2: null,
                                        aptType: null,
                                        locationId: null,
                                        locationDetails: null,
                                        stateId: null,
                                        stateDetails: null,
                                        countryId: null,
                                        countryDetails: null,
                                        zipcode: null
                                    }
                                }
                                if(!_.has(chIt,'physicalAddress')){
                                    chIt['physicalAddress'] = {
                                        line1: null,
                                        line2: null,
                                        aptType: null,
                                        locationId: null,
                                        locationDetails: null,
                                        stateId: null,
                                        stateDetails: null,
                                        countryId: null,
                                        countryDetails: null,
                                        zipcode: null
                                    }
                                }
                            })
                        }
                        if(!_.has(this.petition['beneficiaryInfo'], 'officeAddress') || !this.checkProperty(this.petition['beneficiaryInfo'], 'officeAddress')){
                            this.petition['beneficiaryInfo']['officeAddress'] = {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            }
                        }
                        
                        if(_.has(this.petition,'dependentsInfo') && this.checkProperty(this.petition,'dependentsInfo','spouse')){
                            this.spouse = _.cloneDeep(this.petition.dependentsInfo.spouse);
                            if((_.has(this.spouse,'phoneCountryCode') && !this.checkProperty(this.spouse,'phoneCountryCode')) || !_.has(this.spouse,'phoneCountryCode')  ){
                                this.spouse['phoneCountryCode']= {
                                    countryCode: '',
                                    countryCallingCode: ''
                                }
                            }
                            if((_.has(this.spouse,'height') && !this.checkProperty(this.spouse,'height')) || !_.has(this.spouse,'height')  ){
                                this.spouse['height']= {
                                    feet: '',
                                    inches: ''
                                }
                            }
                            if(!_.has(this.spouse,'fatherInfo') || !this.checkProperty(this.spouse,'fatherInfo')){
                                this.spouse['fatherInfo']= { 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                    hasOtherNames: null, 
                                    otherNames: [{ 
                                        _id: 0, 
                                        name: '', 
                                        firstName: '', 
                                        middleName: '', 
                                        lastName: '', 
                                    }], 
                                    dateOfBirth: null, 
                                    countryOfBirth: '', 
                                    countryOfBirthDetails: null, 
                                    provinceOfBirth: '', 
                                    provinceOfBirthDetails: null, 
                                    locationOfBirth: '', 
                                    currentAddress: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                    isUSCitizen: null, 
                                    dateFromUSCitizen: null, //["", ""],
                                    nameAtBirth:{
                                        firstName: '', 
                                        middleName: '', 
                                        lastName: '',
                                    },
                                    deceasedCity: '',
                                    deceasedCityDetails:null,
                                    deceasedDate: null,
                                }
                            }
                            if(!_.has(this.spouse,'motherInfo') || !this.checkProperty(this.spouse,'motherInfo')){
                                this.spouse['motherInfo']= { 
                                    name: '', 
                                    firstName: '', 
                                    middleName: '', 
                                    lastName: '', 
                                    hasOtherNames: null, 
                                    otherNames: [{ 
                                        _id: 0, 
                                        name: '', 
                                        firstName: '', 
                                        middleName: '', 
                                        lastName: '', 
                                    }], 
                                    dateOfBirth: null, 
                                    countryOfBirth: '', 
                                    countryOfBirthDetails: null, 
                                    provinceOfBirth: '', 
                                    provinceOfBirthDetails: null, 
                                    locationOfBirth: '', 
                                    currentAddress: {
                                    line1: null,
                                    line2: null,
                                    aptType: null,
                                    locationId: null,
                                    locationDetails: null,
                                    stateId: null,
                                    stateDetails: null,
                                    countryId: null,
                                    countryDetails: null,
                                    zipcode: null
                                },
                                    isUSCitizen: null, 
                                    dateFromUSCitizen: null, //["", ""],
                                    nameAtBirth:{
                                        firstName: '', 
                                        middleName: '', 
                                        lastName: '',
                                    },
                                    deceasedCity: '',
                                    deceasedCityDetails:null,
                                    deceasedDate: null,
                                }
                            }
                            if(!_.has(this.spouse,'previousSpouse') || !this.checkProperty(this.spouse,'previousSpouse')){
                                this.spouse['previousSpouse'] = {
                                    hasOtherNames:null,
                                    otherNames: [{
                                        _id: 0,
                                        name: '',
                                        firstName: '',
                                        middleName: '',
                                        lastName: '',
                                    }],
                                    maidenName:'',
                                    marriageEndedDueTo:null,
                                    marriageEndedOtherInfo:'',
                                    firstName: '',
                                    middleName: '',
                                    lastName: '',
                                    dateOfBirth: null,
                                    dateOfMarriage:null,
                                    dateOfMarriageEnd:null,
            
                                    //Place of Marriage
                                    countryOfMarriage: '',
                                    countryOfMarriageDetails: null,
                                    provinceOfMarriage: '',
                                    provinceOfMarriageDetails: null,
                                    locationOfMarriage: '',
            
                                    //Place of Termination
                                    countryOfMarriageTermination: '',
                                    countryOfMarriageTerminationDetails: null,
                                    provinceOfMarriageTermination: '',
                                    provinceOfMarriageTerminationDetails: null,
                                    locationOfMarriageTermination: '',
                                    obtainPermResidenceThroughSpouse:null  
                                }
                            }
                        }  
                        if(!_.has(this.spouse, 'physicalAddress')){
                            this.spouse['physicalAddress'] = {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            }
                        }
                        if(!_.has(this.spouse, 'currentAddress')){
                            this.spouse['currentAddress'] = {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            }
                        }

                        // if(!_.has(this.petition['beneficiaryInfo'], 'benfIncome') || !this.checkProperty(this.petition['beneficiaryInfo'], 'benfIncome')){
                        //     this.petition['beneficiaryInfo']['benfIncome'] = {
                        //         firstName: '',
                        //         lastName: '',
                        //         middleName: '',
                        //         dateOfBirth: null,
                        //         relToTheBenf: '',
                        //         amount: ''
                        //     }
                        // }
                        // if(!_.has(this.petition['beneficiaryInfo'], 'benfAssets') || !this.checkProperty(this.petition['beneficiaryInfo'], 'benfAssets')){
                        //     this.petition['beneficiaryInfo']['benfAssets'] = {
                        //         firstName: '',
                        //         lastName: '',
                        //         middleName: '',
                        //         typeOfAsset: '',
                        //         amount: ''
                        //     }
                        // }

                        //pin verification functionality   
                       
                         if(!this.checkCurrentUrl && callFromMounted &&  this.checkProperty( this.petition ,'requiredPinForQuesSubmit')   ){
                
                            if(!this.openGeneratePinPopUp &&  this.checkProperty( this.petition ,'qstPinSet')){
                                if(!this.tokenVerified){
                                    this.openGeneratePinPopUp =true;
                                    return false;
                                }
                                
                                
                            }else{
                          
                                this.openGeneratePinPopUp =true;
                                 return false

                            }
                         }
                             
    
    
                        this.mamageVisaStatusDocuments();
                        this.$store
                            .dispatch("commonAction", {
                                data: {
                                    questionnaireId: this.petition.questionnaireTplId
                                },
                                path: "/questionnaire/details",
                            })
                            .then((res) => {
    
                                let postData = {
                                    userId: this.petition.userId,
                                    getDocuments: true,
                                };
                                let pth="petition/get-recent-by-beneficiary";
                                pth ="petition-common/get-recent-by-beneficiary";
                                //pth =  '/beneficiary-profile/get-profile-details'
                                this.$store
                                    .dispatch("commonAction", {
                                        data: postData,
                                        path: pth,
                                    })
                                    .then((response) => {
                                        // if(response.beneficiaryInfo){
                                        //     if (!this.petition.questionnaireFilled && (this.petition.beneficiaryInfo.email == null || this.petition.beneficiaryInfo.email == '')) {
                                        //         this.showPrefillPopup = true;
                                        //     }   
                                        //     let tempDetails = response;
                                        //     this.latestPetition = tempDetails;
                                        // }
                                        if (response && response.profileDetails && response.profileDetails.beneficiaryInfo  && this.checkProperty(response['profileDetails'],'beneficiaryInfo','firstName')) {
                                            if (!this.petition.questionnaireFilled && (this.petition.beneficiaryInfo.email == null || this.petition.beneficiaryInfo.email == '')) {
                                                this.showPrefillPopup = true;
                                            } 
                                            this.beneFiciaryDeytailsExists  = true;
                                            let tempDetails = response['profileDetails'];
                                            this.latestPetition = tempDetails;
                                        }
                                        else if (response && response.caseDetails && response.caseDetails.beneficiaryInfo) {
                                            if (!this.petition.questionnaireFilled && (this.petition.beneficiaryInfo.email == null || this.petition.beneficiaryInfo.email == '')) {
                                                this.showPrefillPopup = true;
                                            }
                                            this.beneFiciaryDeytailsExists  = false;   
                                            let tempDetails = response["caseDetails"];
                                            // _.forEach(this.ignorePrefillItems,(item)=>{
                                            //     let section = item['section'];
                                            //     let key  = item['key'];
                                            //     _.update(tempDetails,section+'.'+key, () => null);
                                            // })
                                            this.latestPetition = tempDetails;
                                            
                                        }else if (response && response.userDetails && response.userDetails && (!this.petition.questionnaireFilled && (this.petition.beneficiaryInfo.email == null || this.petition.beneficiaryInfo.email == ''))){
    
                                            if(this.checkProperty(response ,'userDetails' ,'email' ) && !this.checkProperty(this.petition ,'beneficiaryInfo' ,'email')){
    
                                            this.petition['beneficiaryInfo']['email'] = this.checkProperty(response ,'userDetails' ,'email' )
    
    
                                            }
                                            if(this.checkProperty(response ,'userDetails' ,'firstName' ) && !this.checkProperty(this.petition ,'beneficiaryInfo' ,'firstName')){
                                            this.petition['beneficiaryInfo']['firstName'] = this.checkProperty(response ,'userDetails' ,'firstName' );
                                            }
                                            if(this.checkProperty(response ,'userDetails' ,'middleName' )  && !this.checkProperty(this.petition ,'beneficiaryInfo' ,'middleName') ){
                                                this.petition['beneficiaryInfo']['firstName'] = this.checkProperty(response ,'userDetails' ,'middleName' );
                                            }
                                            if(this.checkProperty(response ,'userDetails' ,'lastName' ) && !this.checkProperty(this.petition ,'beneficiaryInfo' ,'lastName') ){
                                            this.petition['beneficiaryInfo']['lastName'] = this.checkProperty(response ,'userDetails' ,'lastName' );
                                            }
                                            this.removeFields()
                                        }
                                        this.questionnaireDetails = res.fields;
                                        this.setTheInitData()
                                    });
    
                            })
    
                        }else{
    
                              this.$vs.loading.close();
                        }
                      
                    })
            },

            getChildObject() {
    
                if(this.checkProperty( this.petition ,'subTypeDetails' ,'id') ==16){
    
                let childAddress={
                    // public charge keys start
                    inadmissibility:null,
                            highestDegreeCompleted:null,
                            listOfCertifications:'',
                            SSI:null,
                            benefitsRecAmounts:[{
                                benefitReceived: '',
                                startDate: null,
                                endDate: null,
                                amount: ''
                            }],
                            longTermInstiAtGovtExpense:null,
                            periodOfInstutions:[{
                                institutionName:'',
                                stateId:'',
                                stateDetails:null,
                                locationId:'',
                                locationDetails:null,
                                dateFrom:null,
                                dateTo:null,
                                reason:'',
                                instituteLocations:[]
                            }],
                            // public charge keys end
                    gender:'',
                            doYouWantTheSsaToIssueYouSS:false,
                            ssnFather:{
                                familyName:'',
                                givenName:''
                            },
                            ssnMother:{
                                familyName:'',
                                givenName:''
                            },
                            immigStatusLastArrival:'',
                            doYouAlreadyH4EAD:false,
                            maritalStatusDetails:null,
                            maritalStatus:'',
                    sevisNumber: null,
                    eadNumber: null,
                    haveYouEverTravelledToUS:null,
                    isI94DSExpiryDate:false,
                    isDSExpiryDate:false,
                    email: '',
                    phoneNumber: '',
                    phoneCountryCode: {
                        countryCode: '',
                        countryCallingCode: ''
                    },
                    relationship: '',
                    currentlyInUS: null,
                    hasOtherNames: null, 
                    otherNames: [{
                        _id: 0,
                        name: '',
                        firstName: '',
                        middleName: '',
                        lastName: '',
                    }],
                    alienNumber: '',
                    lastArrivalNumber: null,
                    lastArrivalDate:null,
                    stateOfLastEntryInUS: '',
                    stateDetailsOfLastEntryInUS: null,
                    placeOfLastEntryInUS: '',
                    currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                    physicalAddress: {
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: {
                            id: null,
                            name: null,
                            stateId: null,
                            countryId: null
                        },
                        stateId: null,
                        stateDetails: {
                            id: null,
                            name: null,
                            countryId: null
                        },
                        countryId: null,
                        countryDetails: {
                            id: null,
                            name: null,
                            shortName: null,
                            phoneCode: null,
                            countryId: null,
                            currencySymbol: null,
                            currencyCode: null,
                            zipcodeLength: null
                        },
                        zipcode: null
                    },
                    addressOutsideUS: {
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: {
                            id: null,
                            name: null,
                            stateId: null,
                            countryId: null
                        },
                        stateId: null,
                        stateDetails: {
                            id: null,
                            name: null,
                            countryId: null
                        },
                        countryId: null,
                        countryDetails: {
                            id: null,
                            name: null,
                            shortName: null,
                            phoneCode: null,
                            countryId: null,
                            currencySymbol: null,
                            currencyCode: null,
                            zipcodeLength: null
                        },
                        zipcode: null
                    },
                    passportIssuedNumber: null,
                    priorPeriodOfStayInUS: [{
                        _id: 0,
                        enteredNumber: null,
                        dateerror: false,
                        noOfDays: null,
                        departedNumber: null,
                        visaStatus: null
                    }],
                    prevEmploymentInfo: [{
                        _id: 0,
                        employerName: '',
                        address: {
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        businessType: null,
                        jobTitle: null,
                        jobDuties: null,
                        startDate: null,
                        endDate: null,
                        payFrequency:null,
                        salary: null,
                        currentEmployer: null
                    }],
                    mailingAddressIsSameAsAddress:false,
                    anyOtherPersonEmployedInUS:null,
                    haveYouEverEmployed:null,
                    h4Required: null,
                    hasChildren: null,
                    l2Required:null,
                    name: '',
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    dateOfBirth: null,
                    countryOfBirth: null,
                    countryOfBirthDetails: null,
                    provinceOfBirth: null,
                    provinceOfBirthDetails: null,
                    locationOfBirth: '',
                    locationOfBirthDetails: null,
                    countryOfCitizenship: null,
                    countryOfCitizenshipDetails: null,
                    passportNumber: '',
                    passportExpiryNumber: null,
                    I94: '',
                    I94ExpiryNumber: null,
                    currentStatus: null,
                    statusExpiryNumber: null,
                    documents: {
                        passport: [],
                        visa: [],
                        formI94: [],
                        birthCertificate: [],
                        approvalNotice: [],
                        approvalNoticeOfPrevH4: [],
                        other: []
                    },
    
                    adjustmentOfI485Status: false, //Adjustment of Status (I-485) //{ type: Boolean, default: false },
                    consularProcessing:false,// Consular Processing { type: Boolean, default: false },
                }
                let addBenificiaryAdd = false;
                _.forEach(childAddress['physicalAddress'],(item,key)=>{
                    if(this.checkProperty( childAddress['physicalAddress']  ,key) !=null && ['line1','line2','aptType' ,'stateId','countryId'  ,'locationId','zipcode'].indexOf(key)>-1){
                        addBenificiaryAdd = true;
                       return false;
                    }
                })
                if(!addBenificiaryAdd){
                    childAddress['physicalAddress'] = _.cloneDeep(this.petition.beneficiaryInfo.address)
                }
                return childAddress
            }else{
                let childAddress= {
                    // public charge keys start
                    inadmissibility:null,
                            highestDegreeCompleted:null,
                            listOfCertifications:'',
                            SSI:null,
                            benefitsRecAmounts:[{
                                benefitReceived: '',
                                startDate: null,
                                endDate: null,
                                amount: ''
                            }],
                            longTermInstiAtGovtExpense:null,
                            periodOfInstutions:[{
                                institutionName:'',
                                stateId:'',
                                stateDetails:null,
                                locationId:'',
                                locationDetails:null,
                                dateFrom:null,
                                dateTo:null,
                                reason:'',
                                instituteLocations:[]
                            }],
                            // public charge keys end
                    gender:'',
                            doYouWantTheSsaToIssueYouSS:false,
                            ssnFather:{
                                familyName:'',
                                givenName:''
                            },
                            ssnMother:{
                                familyName:'',
                                givenName:''
                            },
                            immigStatusLastArrival:'',
                            doYouAlreadyH4EAD:false,
                            maritalStatusDetails:null,
                            maritalStatus:'',
                    sevisNumber: null,
                    eadNumber: null,
                    haveYouEverTravelledToUS:null,
                    isI94DSExpiryDate:false,
                    isDSExpiryDate:false,
                    email: '',
                    phoneNumber: '',
                    phoneCountryCode: {
                        countryCode: '',
                        countryCallingCode: ''
                    },
                    relationship: '',
                    currentlyInUS: null,
                    hasOtherNames: null, 
                    otherNames: [{
                        _id: 0,
                        name: '',
                        firstName: '',
                        middleName: '',
                        lastName: '',
                    }],
                    alienNumber: '',
                    lastArrivalNumber: null,
                    lastArrivalDate:null,
                    stateOfLastEntryInUS: '',
                    stateDetailsOfLastEntryInUS: null,
                    placeOfLastEntryInUS: '',
                    mailingAddressIsSameAsAddress:false,
                    currentAddress: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                    physicalAddress: {
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: {
                            id: null,
                            name: null,
                            stateId: null,
                            countryId: null
                        },
                        stateId: null,
                        stateDetails: {
                            id: null,
                            name: null,
                            countryId: null
                        },
                        countryId: null,
                        countryDetails: {
                            id: null,
                            name: null,
                            shortName: null,
                            phoneCode: null,
                            countryId: null,
                            currencySymbol: null,
                            currencyCode: null,
                            zipcodeLength: null
                        },
                        zipcode: null
                    },
                    addressOutsideUS: {
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: {
                            id: null,
                            name: null,
                            stateId: null,
                            countryId: null
                        },
                        stateId: null,
                        stateDetails: {
                            id: null,
                            name: null,
                            countryId: null
                        },
                        countryId: null,
                        countryDetails: {
                            id: null,
                            name: null,
                            shortName: null,
                            phoneCode: null,
                            countryId: null,
                            currencySymbol: null,
                            currencyCode: null,
                            zipcodeLength: null
                        },
                        zipcode: null
                    },
                    passportIssuedNumber: null,
                    priorPeriodOfStayInUS: [{
                        _id: 0,
                        enteredNumber: null,
                        dateerror: false,
                        noOfDays: null,
                        departedNumber: null,
                        visaStatus: null
                    }],
                    prevEmploymentInfo: [{
                        _id: 0,
                        employerName: '',
                        address: {
                            line1: null,
                            line2: null,
                            aptType: null,
                            locationId: null,
                            locationDetails: null,
                            stateId: null,
                            stateDetails: null,
                            countryId: null,
                            countryDetails: null,
                            zipcode: null
                        },
                        businessType: null,
                        jobTitle: null,
                        jobDuties: null,
                        startDate: null,
                        endDate: null,
                        payFrequency:null,
                        salary: null,
                        currentEmployer: null
                    }],
                    anyOtherPersonEmployedInUS:null,
                    haveYouEverEmployed:null,
                    h4Required: null,
                    hasChildren: null,
                    l2Required:null,
                    name: '',
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    dateOfBirth: null,
                    countryOfBirth: null,
                    countryOfBirthDetails: null,
                    provinceOfBirth: null,
                    provinceOfBirthDetails: null,
                    locationOfBirth: '',
                    locationOfBirthDetails: null,
                    countryOfCitizenship: null,
                    countryOfCitizenshipDetails: null,
                    passportNumber: '',
                    passportExpiryNumber: null,
                    I94: '',
                    I94ExpiryNumber: null,
                    currentStatus: null,
                    statusExpiryNumber: null,
                    documents: {
                        passport: [],
                        visa: [],
                        formI94: [],
                        birthCertificate: [],
                        approvalNotice: [],
                        approvalNoticeOfPrevH4: [],
                        other: []
                    },
    
                   
                }
                let addBenificiaryAdd = false;
                _.forEach(childAddress['physicalAddress'],(item,key)=>{                    
                    if(this.checkProperty( childAddress['physicalAddress']  ,key) !=null && ['line1','line2','aptType' ,'stateId','countryId'  ,'locationId','zipcode'].indexOf(key)>-1){
                        addBenificiaryAdd = true;
                       return false;
                    }
                })
                if(!addBenificiaryAdd){
                    childAddress['physicalAddress'] = _.cloneDeep(this.petition.beneficiaryInfo.address)
                }
                return childAddress
    
            }
    
            },
    
            setBasicData(){
                let _self =this;
                //this.latestPetition beneficiaryInfo
                //email  firstName middleName lastName
                if(this.checkProperty(this.latestPetition ,'beneficiaryInfo' ,'email' )){
    
                    this.petition['beneficiaryInfo']['email'] = this.checkProperty(this.latestPetition ,'beneficiaryInfo' ,'email' )
                    
    
                }
                if(this.checkProperty(this.latestPetition ,'beneficiaryInfo' ,'firstName' )){
                    this.petition['beneficiaryInfo']['firstName'] = this.checkProperty(this.latestPetition ,'beneficiaryInfo' ,'firstName' );
                }
                if(this.checkProperty(this.latestPetition ,'beneficiaryInfo' ,'middleName' )){
                    this.petition['beneficiaryInfo']['middleName'] = this.checkProperty(this.latestPetition ,'beneficiaryInfo' ,'middleName' );
                }
                if(this.checkProperty(this.latestPetition ,'beneficiaryInfo' ,'lastName' )){
                    this.petition['beneficiaryInfo']['lastName'] = this.checkProperty(this.latestPetition ,'beneficiaryInfo' ,'lastName' );
                }

                setTimeout(()=>{
                    _self.mamageVisaStatusDocuments()
                } ,500);
    
    
            },
            prefilltheDeta() {
    
                var childres = []
                if(this.checkProperty(this.latestPetition['dependentsInfo'], 'childrens') && this.checkProperty(this.latestPetition['dependentsInfo'], 'childrens','length')>0 ){
                    this.latestPetition.dependentsInfo.childrens.forEach((element, index) => {
        
                        if (element.firstName != null && element.firstName != "") {
                            childres.push(element)
                        }
        
                    });
                }
                if (childres.length > 0) {
                    this.latestPetition.dependentsInfo.childrens = childres;
                } else {
                    if(this.checkProperty(this.latestPetition['dependentsInfo'], 'childrens')){
                        this.latestPetition.dependentsInfo.childrens = this.getChildObject()
                    }
                    
                }
    
                var data = _.merge(this.petition, this.latestPetition);
    
                this.petition = data;
                this.setTheInitData()
                
            },
            prefilltheDetails(){
                this.firstTimeLoading = true;
                let tempPetition = _.cloneDeep(this.latestPetition);
                if(this.checkProperty(tempPetition['beneficiaryInfo'], 'prevH1bCaseStatus')){
                    let dtval = this.checkProperty(tempPetition['beneficiaryInfo'], 'prevH1bCaseStatus')
                    let findObj = _.find(this.prevH1bCaseStatusList,{'id':dtval});
                    tempPetition['beneficiaryInfo']['prevH1bCaseStatus']  = findObj;
                }
                if(_.has(tempPetition,'dependentsInfo')){
                    delete tempPetition["dependentsInfo"]
                }
                var data = _.merge(this.petition, tempPetition);
                if(_.has(data,'beneficiaryInfo') && _.has(data['beneficiaryInfo'], 'prevEmploymentOutsideUS') && !this.checkProperty(data['beneficiaryInfo'], 'prevEmploymentOutsideUS') ){
                    data['beneficiaryInfo']['prevEmploymentOutsideUS']=[{
                            _id: 0,
                            employerName: '',
                            address: {
                                line1: null,
                                line2: null,
                                aptType: null,
                                locationId: null,
                                locationDetails: null,
                                stateId: null,
                                stateDetails: null,
                                countryId: null,
                                countryDetails: null,
                                zipcode: null
                            },
                            businessType: null,
                            jobTitle: null,
                            jobDuties: null,
                            startDate: null,
                            endDate: null,
                            currentEmployer: false  
                        }]
                }
                if(_.has(data,'beneficiaryInfo') && ((_.has(data['beneficiaryInfo'], 'addressOfLastNYears') && !this.checkProperty(data['beneficiaryInfo'], 'addressOfLastNYears'))||
                !_.has(data['beneficiaryInfo'], 'addressOfLastNYears')) ){
                    data['beneficiaryInfo']['addressOfLastNYears']=[{
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: null,
                        zipcode: null,
                        startDate: null,
                        endDate: null,
                    }]
                }
                if(_.has(data,'beneficiaryInfo') && ((_.has(data['beneficiaryInfo'], 'addressOutsideUSMoreThanYear') && !this.checkProperty(data['beneficiaryInfo'], 'addressOutsideUSMoreThanYear'))||
                !_.has(data['beneficiaryInfo'], 'addressOutsideUSMoreThanYear')) ){
                    data['beneficiaryInfo']['addressOutsideUSMoreThanYear']=[{
                        line1: null,
                        line2: null,
                        aptType: null,
                        locationId: null,
                        locationDetails: null,
                        stateId: null,
                        stateDetails: null,
                        countryId: null,
                        countryDetails: null,
                        zipcode: null,
                        startDate: null,
                        endDate: null,
                    }]
                }
                if(_.has(data,'beneficiaryInfo') && ((_.has(data['beneficiaryInfo'], 'education') && !this.checkProperty(data['beneficiaryInfo'], 'education'))||
                !_.has(data['beneficiaryInfo'], 'education')) ){
                    data['beneficiaryInfo']['education']= {
                        highestDegree: null,
                        highestDegreeDetails: null,
                        majorFieldOfStudy: ''
                    }
                }
                if(_.has(data,'beneficiaryInfo') && (!_.has(data['beneficiaryInfo'], 'height') || !this.checkProperty(data['beneficiaryInfo'], 'height'))){
                    data['beneficiaryInfo']['height']= {
                        feet: '',
                        inches: ''
                    }
                }
                this.petition = data;

                this.setTheInitData();
            }
    
        },
        beforeDestroy() {
            const $ = JQuery;
            document.removeEventListener("click", this.reloadthePage);
    
            $('body').removeClass('questionnairetpl')
        },
        mounted() {
            this.firstTimeLoading = true;
            this.formerrors = {  msg: ""  };
            this.getMasterSocList();
            const $ = JQuery;
            this.$vs.loading();
            $('body').addClass('questionnairetpl')
            this.$store.dispatch("getcountries").then((response) => {
                this.countries = response;
                if(this.checkProperty(this.countries, 'length')>0){
                    this.countriesWithoutUS = _.filter(this.countries,(item)=> {
                        return item.id != 231;
                    });
                }
            });
                this.$store.dispatch("getmasterdata", "visa_status").then((response) => {
                    this.visastatuses = response;
                });
                this.$store.dispatch("getmasterdata", "eye_colors").then((response) => {
                    this.eye_colorList = response;
                });
                this.$store.dispatch("getmasterdata", "hair_colors").then((response) => {
                    this.hair_colorsList = response;
                });
                this.$store.dispatch("getmasterdata", "races").then((response) => {
                    this.races_list = response;
                });
                this.$store.dispatch("getmasterdata", "asset_types").then((response) => {
                    this.assestsList = response;
                });
                this.$store.dispatch("getmasterdata", "liabilities_debts").then((response) => {
                    this.liability_list = response;
                });
                this.$store.dispatch("getmasterdata", "public_benefits").then((response) => {
                    let list = response;
                    _.forEach( list,(item) => {
                       item =Object.assign(item,{ 'isSelected':false});
                    });
                    this.public_benefits = _.cloneDeep(list)
                });
                this.$store
                    .dispatch("getmasterdata", "marital_status")
                    .then((response) => {
                        this.marital_statuses = response;
                        this.fileredMartialList=_.filter(response,(item)=>{
                            return item.id !=1 
                        })
                    });
    
                this.$store
                    .dispatch("getmasterdata", "education_types")
                    .then((response) => {
                        this.education_types = response;
                        // this.upDatehighestDegree();
                    });
                    this.loadStatesByCountry('instituteStates', 231)

            let localData = localStorage.getItem("pinAccessData");
            let action=true;
            if(localData){
                localData = JSON.parse(atob(localData));
            }else{
                localData =[];
            }
            let userData = this.getUserData;
            if(_.find(localData ,{ "userId":userData["userId"],"petitionId": this.$route.params.itemId })){
                action =false;
                this.tokenVerified =true;
            }        
            this.init(action);
            this.getConsentDetails();
            this.getGlobalConfigDetails();
            //this.$validator.reset();
            this.loadStatesByCountry('usastates', 231)
            this.loadStatesByCountry('bfeprovinceStates', 231);
            if(this.checkProperty(this.$route ,'query' ,'filter')){
                try{
                    //this.currentTab = "employment";
                    let filter = this.checkProperty(this.$route ,'query' ,'filter');
                    var actual = JSON.parse(atob(filter));
                    let keys = Object.keys(actual);
                    if(this.checkProperty(keys ,'length') >0){
                        _.forEach(keys,(item)=>{
                            if(item == 'currentTab'){
                                this.currentTab = actual[item]
                            }
                        })
                    }
                }
                catch(e){

                }
            }
           
    
        },
        components: {
            periodOfInstituteForm,
            w2Information,
            i485AdditionalInformation,
            fileUploadNote,
            generatePin,
            monthAndYear,
            InfoIcon,
            EyeIcon,
            FileUpload,
            Datepicker,
            immitextfield,
            XIcon,
            genderField,
            immiInput,
            addressField,
            consulateAddress,
            Trash2Icon,
            datepickerField,
            selectField,
            immiPhone,
            immiMask,
            immiyesorno,
            immiuploader,
            immipriorstay,
            immitextarea,
            immieducations,
            immiswitchyesno,
            casedocumentslist,
            immiemployment,
            PetitionDetails,
            VuePerfectScrollbar,
            petitionsinformation,
            petitionImmigranInfo,
            personalinfo,
            childpersonalinfo,
            quillTextEditor,
         // 485 Components
         previousSpouseForm ,
         immigrationForm,
        
        
         financialForm,
         assestsForm,
         liabilitiesForm,
         publicBenefitsForm,
         parentForm,
         financialInfoForm,
    
    
        },
        watch: {
    
        }
    };
    </script>